
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3vCSA", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $fgOJ7 = parcelRequire("fgOJ7");


var $l30d8 = parcelRequire("l30d8");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");

function $0c322a09d1b57883$export$a4068a52445901dc(data, props) {
    return data !== null && typeof data === 'object' && props.every((prop)=>data.hasOwnProperty(prop));
}
const $0c322a09d1b57883$export$740b9b28cb05ebd6 = 'dynamic-ui-create';
function $0c322a09d1b57883$export$6da360af78d7e3dd(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'id'
    ]);
}
function $0c322a09d1b57883$export$da7aa926fc604bd7(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'id',
        'previousMauiId',
        'contentType'
    ]) && data.previousMauiId != null;
}
function $0c322a09d1b57883$export$3147e11228ebc102(action) {
    return $0c322a09d1b57883$export$6da360af78d7e3dd(action.data);
}
const $0c322a09d1b57883$export$440c8d4309cb1c9 = (data)=>{
    if (data?.id) return `${window.location.origin}/remix/ui/${encodeURIComponent(data.id)}`;
    return null;
};
const $0c322a09d1b57883$export$4a9884303bce30ff = 'image-create';
function $0c322a09d1b57883$export$ce86c52462376ef2(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'mediaFileId'
    ]);
}
function $0c322a09d1b57883$export$3b2fa4f5aa307773(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'mediaFileId',
        'previousMediaFileId',
        'mediaCollection'
    ]) && data.previousMediaFileId != null;
}
function $0c322a09d1b57883$export$ef033f677befc7d4(action) {
    return action.key === $0c322a09d1b57883$export$4a9884303bce30ff && $0c322a09d1b57883$export$ce86c52462376ef2(action.data);
}
function $0c322a09d1b57883$export$3bb9ace6cd5cc74a(data) {
    return $0c322a09d1b57883$export$a4068a52445901dc(data, [
        'previousMediaFileId'
    ]);
}
const $0c322a09d1b57883$var$MEDIA_BASE_URL_STAGING = 'https://media.staging.atl-paas.net';
const $0c322a09d1b57883$var$MEDIA_BASE_URL_PROD = 'https://media-cdn.atlassian.com';
const $0c322a09d1b57883$export$4e8e610ccc58ae5b = ({ fileId: fileId, token: token, collection: collection, clientId: clientId, isStaging: isStaging })=>{
    const baseUrl = isStaging ? $0c322a09d1b57883$var$MEDIA_BASE_URL_STAGING : $0c322a09d1b57883$var$MEDIA_BASE_URL_PROD;
    const url = new URL(`${baseUrl}/file/${fileId}/image`);
    url.searchParams.set('token', token);
    url.searchParams.set('issuer', 'micros/convo-ai');
    url.searchParams.set('collection', collection);
    url.searchParams.set('client', clientId);
    return url.toString();
};
const $0c322a09d1b57883$export$7afb9b8acd50eb4e = 'aifc-confluence-page-create';
function $0c322a09d1b57883$export$77c5629325e9aaaf(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'adf' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$b632d4bc1af2f7d3 = 'aifc-deep-research-confluence-page-create';
function $0c322a09d1b57883$export$3bd74956949aecbc(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'content' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$d6ad19367a51fe7a(data) {
    return typeof data === 'object' && data !== null && 'contentId' in data;
}
const $0c322a09d1b57883$export$88028308fe524b8a = 'aifc-confluence-page-update';
const $0c322a09d1b57883$export$bb3d6eff667f4678 = 'aifc-adf-update';
const $0c322a09d1b57883$export$7cca3e34118747ef = 'aifc-action-classification-metadata';
function $0c322a09d1b57883$export$4f41f9d38097cf0a(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$1cf42b66f457bc6c(data) {
    return typeof data === 'object' && data !== null && 'toolCalls' in data && 'contentId' in data && typeof data.toolCalls === 'string' && typeof data.contentId === 'string';
}
function $0c322a09d1b57883$export$fbc8213fc156433a(data) {
    return typeof data === 'object' && data !== null && 'promptVersion' in data && typeof data.promptVersion === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$279c9cc61f7f510a = 'aifc-confluence-whiteboard-create';
function $0c322a09d1b57883$export$392158ed2444b56b(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$823e13f43093123d = 'aifc-confluence-slides-create';
function $0c322a09d1b57883$export$ae4ad515c9dd259d(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$49b21a7401bcc85 = 'aifc-confluence-slides-update';
function $0c322a09d1b57883$export$3d6de0a3c3e39cbf(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$d5d2204eeb3fde50 = 'aifc-confluence-whiteboard-update';
function $0c322a09d1b57883$export$35d2029c1a7b307c(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$771989b0afde4911 = 'aifc-confluence-whiteboard-to-page';
const $0c322a09d1b57883$export$325918e7af3a74aa = 'confluence-whiteboard-brainstorming';
function $0c322a09d1b57883$export$48e8bcda6802129c(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$e3c19505945cf210 = 'confluence-whiteboard-diagramming';
const $0c322a09d1b57883$export$c8f288feec1641d9 = 'aifc-confluence-whiteboard-diagramming';
function $0c322a09d1b57883$export$f3a918f4f62365b2(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'diagramType' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$9f1bd612d6abcf5c = 'aifc-confluence-database-create';
function $0c322a09d1b57883$export$4dec930442f5ade2(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$ee0a705006a79cfe = 'aifc-confluence-database-update';
function $0c322a09d1b57883$export$dbed60ca289ab1f3(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$691e9b05e574e32c = 'aifc-confluence-space-create';
function $0c322a09d1b57883$export$545244afe3ae2546(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$af91dd9bf235f890 = 'aifc-confluence-space-update';
function $0c322a09d1b57883$export$38f648644a8b3072(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$9f62c3ae716c44b2 = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3
]);
const $0c322a09d1b57883$export$aba0c096f5cdcaca = new Set([
    $0c322a09d1b57883$export$279c9cc61f7f510a
]);
const $0c322a09d1b57883$export$b9c5aef93dba02df = new Set([
    $0c322a09d1b57883$export$823e13f43093123d
]);
const $0c322a09d1b57883$export$45a7157715c10f20 = new Set([
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$var$SPACE_CREATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$691e9b05e574e32c
]);
const $0c322a09d1b57883$var$CREATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$export$9f62c3ae716c44b2,
    ...$0c322a09d1b57883$export$aba0c096f5cdcaca,
    ...$0c322a09d1b57883$export$b9c5aef93dba02df,
    ...$0c322a09d1b57883$export$45a7157715c10f20,
    ...$0c322a09d1b57883$var$SPACE_CREATE_ACTIONS
]);
const $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$88028308fe524b8a,
    $0c322a09d1b57883$export$bb3d6eff667f4678,
    $0c322a09d1b57883$export$740b9b28cb05ebd6,
    $0c322a09d1b57883$export$4a9884303bce30ff
]);
const $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$d5d2204eeb3fde50,
    $0c322a09d1b57883$export$325918e7af3a74aa,
    $0c322a09d1b57883$export$e3c19505945cf210,
    $0c322a09d1b57883$export$c8f288feec1641d9
]);
const $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$49b21a7401bcc85
]);
const $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$ee0a705006a79cfe
]);
const $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$af91dd9bf235f890
]);
const $0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS
]);
const $0c322a09d1b57883$export$6c0ed26dac146a75 = (action)=>$0c322a09d1b57883$export$9f62c3ae716c44b2.has(action.key);
const $0c322a09d1b57883$export$eac4577c3e50732a = (action)=>$0c322a09d1b57883$var$CREATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$a70db46a9e5e9e4a = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) && !!action.data?.metadata?.isExistingContent && (0, $dh538.fg)('confluence_aifc_create_on_existing');
const $0c322a09d1b57883$export$79fc6c76b9755410 = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) && !$0c322a09d1b57883$export$a70db46a9e5e9e4a(action);
const $0c322a09d1b57883$export$53f0114d9f187b14 = (action)=>action.key === $0c322a09d1b57883$export$740b9b28cb05ebd6;
const $0c322a09d1b57883$export$b3dfc475c0b1ff86 = (action)=>action.key === $0c322a09d1b57883$export$4a9884303bce30ff;
const $0c322a09d1b57883$export$dfda1ac7e19cab7b = (action)=>$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$dcbfc8a9b613cd00 = (action)=>$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$5d2d4e8984b13e00 = (action)=>$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$399c9116e9984ca3 = (action)=>$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$73dc9ed6ed2373f = (action)=>$0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$54716060fc6e52ee = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) || $0c322a09d1b57883$export$73dc9ed6ed2373f(action);
// ============================================================================
// CONFLUENCE PREVIEW CARDS
// ============================================================================
const $0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3,
    $0c322a09d1b57883$export$279c9cc61f7f510a,
    $0c322a09d1b57883$export$823e13f43093123d,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$export$5cb5e5f4b4ce0a33 = (action)=>$0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS.has(action.key) && !$0c322a09d1b57883$export$a70db46a9e5e9e4a(action);
const $0c322a09d1b57883$export$681cf9ea58de88fd = (action, selectedPreviewContentId)=>{
    if (!action?.key) return;
    switch(action.key){
        case $0c322a09d1b57883$export$279c9cc61f7f510a:
            return (0, $6nGJw.getConfluenceWhiteboardClientId)(selectedPreviewContentId);
        case $0c322a09d1b57883$export$823e13f43093123d:
        case $0c322a09d1b57883$export$49b21a7401bcc85:
            return (0, $l30d8.getConfluenceSlidesClientId)(selectedPreviewContentId);
        case $0c322a09d1b57883$export$9f1bd612d6abcf5c:
            return (0, $fgOJ7.getConfluenceDatabaseClientId)(selectedPreviewContentId);
        default:
            return (0, $eL1ct.getConfluenceEditorClientId)(selectedPreviewContentId);
    }
};
const $0c322a09d1b57883$export$bb9f6b0763834612 = (action)=>{
    const actionKey = action.key;
    if ($0c322a09d1b57883$export$9f62c3ae716c44b2.has(actionKey) || $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-page';
    if ($0c322a09d1b57883$export$aba0c096f5cdcaca.has(actionKey) || $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(actionKey)) return 'confluence-whiteboard';
    if ($0c322a09d1b57883$export$b9c5aef93dba02df.has(actionKey) || $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(actionKey)) return 'confluence-slide';
    if ($0c322a09d1b57883$export$45a7157715c10f20.has(actionKey) || $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-database';
    if ($0c322a09d1b57883$var$SPACE_CREATE_ACTIONS.has(actionKey) || $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-space';
    return undefined;
};
// This mapping should contain the type guards of those actions that support data
// accumulation as defined below in `getPrimaryAccumulatedValue`.
const $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS = {
    [$0c322a09d1b57883$export$7afb9b8acd50eb4e]: $0c322a09d1b57883$export$77c5629325e9aaaf,
    [$0c322a09d1b57883$export$b632d4bc1af2f7d3]: $0c322a09d1b57883$export$3bd74956949aecbc,
    [$0c322a09d1b57883$export$9f1bd612d6abcf5c]: $0c322a09d1b57883$export$4dec930442f5ade2,
    [$0c322a09d1b57883$export$279c9cc61f7f510a]: $0c322a09d1b57883$export$392158ed2444b56b,
    [$0c322a09d1b57883$export$823e13f43093123d]: $0c322a09d1b57883$export$ae4ad515c9dd259d
};
const $0c322a09d1b57883$export$b95f9369e33f3b4a = (key)=>{
    return key in $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS;
};
const $0c322a09d1b57883$export$898d9c03b4eb5dd5 = (key)=>{
    return $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS[key];
};
const $0c322a09d1b57883$export$240debd921ff9f65 = (action)=>{
    if (!action.data) return undefined;
    if (action.key === $0c322a09d1b57883$export$7afb9b8acd50eb4e && $0c322a09d1b57883$export$77c5629325e9aaaf(action.data)) {
        const key = 'adf';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$b632d4bc1af2f7d3 && $0c322a09d1b57883$export$3bd74956949aecbc(action.data)) {
        const key = 'content';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$279c9cc61f7f510a && $0c322a09d1b57883$export$392158ed2444b56b(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$823e13f43093123d && $0c322a09d1b57883$export$ae4ad515c9dd259d(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$9f1bd612d6abcf5c && $0c322a09d1b57883$export$4dec930442f5ade2(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    }
    return undefined;
};
const $0c322a09d1b57883$var$getAccumulatedData = (prevAction, nextAction)=>{
    const prevPrimary = $0c322a09d1b57883$export$240debd921ff9f65(prevAction);
    const nextPrimary = $0c322a09d1b57883$export$240debd921ff9f65(nextAction);
    if (!prevPrimary || !nextPrimary || prevPrimary.key !== nextPrimary.key) return undefined;
    return {
        [nextPrimary.key]: String(prevPrimary.value ?? '') + String(nextPrimary.value ?? '')
    };
};
function $0c322a09d1b57883$export$5b30faa0f696991d(data) {
    return typeof data === 'object' && data !== null && 'isRemixGenerated' in data && data.isRemixGenerated === true;
}
const $0c322a09d1b57883$var$REMIX_GENERATED_ACTION_KEYS = new Set([
    $0c322a09d1b57883$export$740b9b28cb05ebd6,
    $0c322a09d1b57883$export$4a9884303bce30ff
]);
function $0c322a09d1b57883$export$8eb2b74d04c8d455(action) {
    if ($0c322a09d1b57883$var$REMIX_GENERATED_ACTION_KEYS.has(action.key)) return true;
    if (action.key === $0c322a09d1b57883$export$279c9cc61f7f510a || action.key === $0c322a09d1b57883$export$d5d2204eeb3fde50) return $0c322a09d1b57883$export$5b30faa0f696991d(action.data);
    return false;
}
function $0c322a09d1b57883$export$31b2392386905e76(action) {
    if (!action) return undefined;
    const { key: key, data: data } = action;
    if ($0c322a09d1b57883$export$da7aa926fc604bd7(data)) return 'edit';
    if ($0c322a09d1b57883$export$6da360af78d7e3dd(data)) return 'create';
    if ($0c322a09d1b57883$export$3b2fa4f5aa307773(data)) return 'edit';
    if ($0c322a09d1b57883$export$ce86c52462376ef2(data)) return 'create';
    if (key === $0c322a09d1b57883$export$d5d2204eeb3fde50) return 'edit';
    if (key === $0c322a09d1b57883$export$279c9cc61f7f510a) return 'create';
    return undefined;
}
function $0c322a09d1b57883$export$a549b965e1dff398(action) {
    if (action?.key === $0c322a09d1b57883$export$4a9884303bce30ff) return 'infographic';
    if (action?.data?.type === 'whiteboard') return 'diagram';
    return action?.data?.contentType;
}
function $0c322a09d1b57883$export$90cf5cf844c2f3b0(action) {
    return action?.data?.dynamicUiSubtype;
}
function $0c322a09d1b57883$export$ff1c2950f6d5486f({ action: action, selectedRemixMetadata: selectedRemixMetadata }) {
    return {
        metadataActionKey: action?.key,
        metadataActionType: $0c322a09d1b57883$export$31b2392386905e76(action),
        backendDynamicUiType: $0c322a09d1b57883$export$a549b965e1dff398(action),
        backendDynamicUiSubtype: $0c322a09d1b57883$export$90cf5cf844c2f3b0(action),
        ...selectedRemixMetadata
    };
}
const $0c322a09d1b57883$export$64e13fa6a74f5f86 = (prevAction, nextAction)=>{
    if (prevAction.data && nextAction.data) {
        const accumulatedData = $0c322a09d1b57883$var$getAccumulatedData(prevAction, nextAction);
        if (accumulatedData !== undefined) {
            const updatedData = {
                ...nextAction.data,
                ...accumulatedData
            };
            return {
                ...prevAction,
                data: updatedData,
                status: nextAction.status
            };
        }
    }
    return {
        ...prevAction,
        data: nextAction.data,
        status: nextAction.status
    };
};
module.exports["DYNAMIC_UI_CREATE_KEY"] = $0c322a09d1b57883$export$740b9b28cb05ebd6;
module.exports["isDynamicUiCreateData"] = $0c322a09d1b57883$export$6da360af78d7e3dd;
module.exports["isDynamicUiUpdateActionData"] = $0c322a09d1b57883$export$da7aa926fc604bd7;
module.exports["isDynamicUiCreateAction"] = $0c322a09d1b57883$export$3147e11228ebc102;
module.exports["buildDynamicUiPageUrl"] = $0c322a09d1b57883$export$440c8d4309cb1c9;
module.exports["IMAGE_CREATE_KEY"] = $0c322a09d1b57883$export$4a9884303bce30ff;
module.exports["isImageCreateData"] = $0c322a09d1b57883$export$ce86c52462376ef2;
module.exports["isImageUpdateActionData"] = $0c322a09d1b57883$export$3b2fa4f5aa307773;
module.exports["isImageCreateAction"] = $0c322a09d1b57883$export$ef033f677befc7d4;
module.exports["isImageUpdatePrepareData"] = $0c322a09d1b57883$export$3bb9ace6cd5cc74a;
module.exports["buildImageUrl"] = $0c322a09d1b57883$export$4e8e610ccc58ae5b;
module.exports["CONFLUENCE_AIFC_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$7afb9b8acd50eb4e;
module.exports["isConfluenceAIFCPageCreateActionData"] = $0c322a09d1b57883$export$77c5629325e9aaaf;
module.exports["CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$b632d4bc1af2f7d3;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionData"] = $0c322a09d1b57883$export$3bd74956949aecbc;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionPrepare"] = $0c322a09d1b57883$export$d6ad19367a51fe7a;
module.exports["AIFC_ADF_UPDATE_KEY"] = $0c322a09d1b57883$export$bb3d6eff667f4678;
module.exports["AIFC_ACTION_CLASSIFICATION_METADATA"] = $0c322a09d1b57883$export$7cca3e34118747ef;
module.exports["isAIFCADFUpdateActionData"] = $0c322a09d1b57883$export$1cf42b66f457bc6c;
module.exports["isAIFCADFSetActionClassificationActionData"] = $0c322a09d1b57883$export$fbc8213fc156433a;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY"] = $0c322a09d1b57883$export$279c9cc61f7f510a;
module.exports["isConfluenceAIFCWhiteboardCreateActionData"] = $0c322a09d1b57883$export$392158ed2444b56b;
module.exports["CONFLUENCE_AIFC_SLIDES_CREATE_KEY"] = $0c322a09d1b57883$export$823e13f43093123d;
module.exports["isConfluenceAIFCSlidesCreateActionData"] = $0c322a09d1b57883$export$ae4ad515c9dd259d;
module.exports["CONFLUENCE_AIFC_SLIDES_UPDATE_KEY"] = $0c322a09d1b57883$export$49b21a7401bcc85;
module.exports["isConfluenceAIFCSlidesUpdateActionData"] = $0c322a09d1b57883$export$3d6de0a3c3e39cbf;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY"] = $0c322a09d1b57883$export$d5d2204eeb3fde50;
module.exports["isConfluenceAIFCWhiteboardUpdateActionData"] = $0c322a09d1b57883$export$35d2029c1a7b307c;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY"] = $0c322a09d1b57883$export$771989b0afde4911;
module.exports["CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY"] = $0c322a09d1b57883$export$325918e7af3a74aa;
module.exports["isConfluenceWhiteboardBrainstormingActionData"] = $0c322a09d1b57883$export$48e8bcda6802129c;
module.exports["LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$e3c19505945cf210;
module.exports["AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$c8f288feec1641d9;
module.exports["isConfluenceWhiteboardDiagrammingActionData"] = $0c322a09d1b57883$export$f3a918f4f62365b2;
module.exports["CONFLUENCE_AIFC_DATABASE_CREATE_KEY"] = $0c322a09d1b57883$export$9f1bd612d6abcf5c;
module.exports["isConfluenceAIFCDatabaseCreateActionData"] = $0c322a09d1b57883$export$4dec930442f5ade2;
module.exports["CONFLUENCE_AIFC_DATABASE_UPDATE_KEY"] = $0c322a09d1b57883$export$ee0a705006a79cfe;
module.exports["isConfluenceAIFCDatabaseUpdateActionData"] = $0c322a09d1b57883$export$dbed60ca289ab1f3;
module.exports["CONFLUENCE_AIFC_SPACE_CREATE_KEY"] = $0c322a09d1b57883$export$691e9b05e574e32c;
module.exports["isConfluenceAIFCSpaceCreateActionData"] = $0c322a09d1b57883$export$545244afe3ae2546;
module.exports["CONFLUENCE_AIFC_SPACE_UPDATE_KEY"] = $0c322a09d1b57883$export$af91dd9bf235f890;
module.exports["isConfluenceAIFCSpaceUpdateActionData"] = $0c322a09d1b57883$export$38f648644a8b3072;
module.exports["PAGE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$9f62c3ae716c44b2;
module.exports["WHITEBOARD_CREATE_ACTIONS"] = $0c322a09d1b57883$export$aba0c096f5cdcaca;
module.exports["SLIDES_CREATE_ACTIONS"] = $0c322a09d1b57883$export$b9c5aef93dba02df;
module.exports["DATABASE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$45a7157715c10f20;
module.exports["isConfluencePageCreateAction"] = $0c322a09d1b57883$export$6c0ed26dac146a75;
module.exports["isConfluenceCreatableAction"] = $0c322a09d1b57883$export$eac4577c3e50732a;
module.exports["isConfluenceCreateNewAction"] = $0c322a09d1b57883$export$79fc6c76b9755410;
module.exports["isDynamicUiCreatableAction"] = $0c322a09d1b57883$export$53f0114d9f187b14;
module.exports["isImageCreatableAction"] = $0c322a09d1b57883$export$b3dfc475c0b1ff86;
module.exports["isConfluencePageUpdateAction"] = $0c322a09d1b57883$export$dfda1ac7e19cab7b;
module.exports["isConfluenceWhiteboardUpdateAction"] = $0c322a09d1b57883$export$dcbfc8a9b613cd00;
module.exports["isConfluenceSlidesUpdateAction"] = $0c322a09d1b57883$export$5d2d4e8984b13e00;
module.exports["isConfluenceDatabaseUpdateAction"] = $0c322a09d1b57883$export$399c9116e9984ca3;
module.exports["isConfluenceUpdatableAction"] = $0c322a09d1b57883$export$73dc9ed6ed2373f;
module.exports["isConfluenceStreamAction"] = $0c322a09d1b57883$export$54716060fc6e52ee;
module.exports["isConfluencePreviewCardAction"] = $0c322a09d1b57883$export$5cb5e5f4b4ce0a33;
module.exports["generateRovoReceiverId"] = $0c322a09d1b57883$export$681cf9ea58de88fd;
module.exports["getConfluenceContentType"] = $0c322a09d1b57883$export$bb9f6b0763834612;
module.exports["isAccumulatedAction"] = $0c322a09d1b57883$export$b95f9369e33f3b4a;
module.exports["getAccumulatedActionTypeGuard"] = $0c322a09d1b57883$export$898d9c03b4eb5dd5;
module.exports["getPrimaryAccumulatedValue"] = $0c322a09d1b57883$export$240debd921ff9f65;
module.exports["isRemixGeneratedAction"] = $0c322a09d1b57883$export$5b30faa0f696991d;
module.exports["isRemixGeneratedFlow"] = $0c322a09d1b57883$export$8eb2b74d04c8d455;
module.exports["getDynamicUiType"] = $0c322a09d1b57883$export$a549b965e1dff398;
module.exports["getDynamicUiSubtype"] = $0c322a09d1b57883$export$90cf5cf844c2f3b0;
module.exports["getRemixMetadata"] = $0c322a09d1b57883$export$ff1c2950f6d5486f;
module.exports["customActionUpdater"] = $0c322a09d1b57883$export$64e13fa6a74f5f86;

});

parcelRegister("l30d8", function(module, exports) {

var $b9NdB = parcelRequire("b9NdB");

const $9036d8afa9b2002b$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX = 'confluence-slide';
const $9036d8afa9b2002b$export$8ad4475ac322bb70 = (contentId)=>(0, $b9NdB.client)(`${$9036d8afa9b2002b$var$CONFLUENCE_SLIDE_CLIENT_ID_PREFIX}-${contentId}`);
module.exports["getConfluenceSlidesClientId"] = $9036d8afa9b2002b$export$8ad4475ac322bb70;

});

parcelRegister("8IKbl", function(module, exports) {
const $e66d55c2753a8f61$export$4081752c8da17394 = {
    // Atlassian Projects
    CreateProjectProgressUpdate: 'atlassian-project-atlassian-atlassian-project-create-progress-up',
    // Jira
    UpdateWorkItemFields: 'jira-atlassian-work-item-update-single-field',
    UpdateWorkItemAllFieldTypes: 'jira-atlassian-work-item-update-all-field-types-bulk',
    JiraFindIssues: 'jira-find-issues',
    JiraSmartIssueCreateAllField: 'jira-atlassian-work-item-create-all-field-types',
    JiraAdminAgent: 'JiraAdminAgentActionableTool',
    JiraIssueTransition: 'jira-issue-transition-bulk',
    JiraEpicsSuggest: 'jira-epics-suggest',
    JiraIssueDelete: 'jira-issue-delete',
    JiraIssueMove: 'jira-issue-move',
    JiraIssueAssign: 'jira-issue-assign-bulk',
    JiraVersionCreate: 'jira-version-create',
    // Work organizer sprint actions
    JiraCreateSprint: 'jira-atlassian-work-item-create-sprint',
    JiraStartSprint: 'jira-atlassian-board-start-sprint',
    JiraMoveToSprint: 'jira-atlassian-workspace-move-to-sprint-work-item',
    JiraWorkflowEditor: 'jira-workflow-operations',
    // Confluence
    ConfluencePageCreate: 'confluence-page-create',
    ConfluencePageComment: 'confluence-page-comment',
    ConfluencePageAddLabel: 'confluence-label-create',
    ConfluencePageRename: 'confluence-page-rename',
    ConfluencePageMove: 'confluence-page-move',
    // JSM
    JsmJourneyBuilder: 'jsm-invoke-orchestrator-agent',
    JsmCreateRequest: 'jsm-create-request',
    JsmCreateRequestV2: 'jsm-create-request-v2',
    CreateRequest: 'create-request',
    JsmCreateEmbeddedRequest: 'help-form-submit',
    JsmCreateSurvey: 'jsm-create-survey',
    JsmLivechat: 'jsm-livechat',
    JsmSolutionComposerPlanSummary: 'jsm-solution-composer-plan-summary',
    // Deep Research
    DeepResearchCreatePageAction: 'deep-research-report-confluence-export',
    // Studio
    StudioTriggerSolutionPlan: 'studio-trigger-solution-plan',
    StudioUpdateAgentDraft: 'studio-atlassian-studio-update-agent-draft',
    StudioWorkspaceUpdateAgentDraft: 'studio-atlassian-workspace-update-draft-agent',
    StudioAutomationTriggerRuleBuild: 'studio-automation-trigger-rule-build',
    StudioAutomationCreateRule: 'automation-platform-atlassian-automation-create-rule',
    UpdateAgentConfigurationTool: 'UpdateAgentConfigurationTool',
    StudioCreateAgent: 'CreateAgentTool',
    StudioLandingPageRedirect: 'studio-landing-page-redirect',
    // Plans
    JiraPlansUpdateWorkSource: 'jira-atlassian-plan-update-work-sources',
    JiraPlansCreateProgramBoard: 'jira-plan-add-program-board-plugin',
    JiraPlansDeleteProgramBoard: 'Jira-Plan-Delete-Program-Board-Plugin',
    JiraPlansCreateWorkItem: 'jira-atlassian-plan-create-work-item',
    JiraPlansCreateRelease: 'Jira-Plan-Create-Release-Plugin',
    JiraPlansManageFeatures: 'jira-atlassian-plan-set-release-enabled',
    JiraPlansAddDependency: 'jira-atlassian-plan-add-work-item-dependencies',
    JiraPlansRemoveDependency: 'jira-atlassian-plan-remove-work-item-dependencies',
    // Capacity Planning
    ManageCapacityPlan: 'capacity-plan-update-single-action',
    // Atlassian Teams
    AtlassianTeamUpdateArchive: 'atlassian-team-atlassian-team-update-archive',
    // Focus Asks
    FocusCreateAsk: 'passionfruit-atlassian-workspace-create-asks',
    // Bitbucket
    BitbucketPullRequestComment: 'bitbucket-pull-request-comment',
    // Others
    StoreRecommendationCard: 'store-recommendation-card',
    RequireInformationTool: 'RequireInformationTool',
    HiringManagerTool: 'HiringManagerTool',
    JsmSuggestAndAddFieldsToRequestType: 'SuggestAndAddFieldsToRequestType',
    JsmAtlassianProjectCreateJsmRequestTypeWithFields: 'jsm-atlassian-project-create-jsm-request-type-with-fields',
    // Convo AI agent tools
    ExecutePython: 'execute_python',
    PlanComplete: 'plan_complete',
    AskQuestion: 'ask_question',
    JsmAtlassianProjectCreateJsmQueue: 'jsm-atlassian-project-create-jsm-queue',
    JsmAtlassianProjectCreateJsmQueueGroup: 'jsm-atlassian-project-create-jsm-queue-group',
    JsmAtlassianProjectUpdateJsmQueue: 'jsm-atlassian-project-update-jsm-queue',
    JsmAtlassianProjectUpdateJsmQueueGroup: 'jsm-atlassian-project-update-jsm-queue-group',
    JsmAtlassianProjectUpdateRequestTypePortalGroups: 'jsm-atlassian-project-update-request-type-groups',
    JsmAtlassianRequestTypeUpdateWorkflow: 'jsm-atlassian-request-type-update-workflow',
    JsmSelectHardwareTypes: 'ham-onboarding-hardware-assets-types',
    JsmSelectHardwareTypesSkill: 'ham-onboarding-hardware-assets-types-skill',
    JsmCreateSlaPlugin: 'jsm-create-sla-plugin',
    JsmUpdateSlaPlugin: 'jsm-update-sla-plugin',
    // Confluence AIFC
    AifcAdfUpdate: 'aifc-adf-update',
    // Google Calendar
    GoogleCalendarEventCreate: 'google-calendar-event-create',
    // Add other keys here as needed
    ScheduledChat: 'ScheduleRovoChatTool',
    ImageSearch: 'image-search',
    MultipleChoiceQuestionsTool: 'MultipleChoiceQuestionsTool',
    AgenticPlanTool: 'AgenticPlanTool',
    CreateKBCard: 'jsm-atlassian-jsm-kb-bulk-create-draft-topics',
    CreateKbArticlesCard: 'jsm-atlassian-jsm-kb-validate-draft-articles',
    // Custom Skills
    CreateCustomSkillTool: 'CreateCustomSkillTool',
    UpdateCustomSkillTool: 'UpdateCustomSkillTool'
};
const $e66d55c2753a8f61$export$c5959ebd02278fb3 = $e66d55c2753a8f61$export$4081752c8da17394.FocusCreateAsk;
const $e66d55c2753a8f61$export$98251f227f05fc03 = 'execute_python';
const $e66d55c2753a8f61$export$2cf48170a90af7e3 = 'plan_complete';
const $e66d55c2753a8f61$export$52c76e2fb6c72799 = 'ask_question';
const $e66d55c2753a8f61$export$d3fc7569bcc4e4e7 = new Set([
    $e66d55c2753a8f61$export$52c76e2fb6c72799,
    $e66d55c2753a8f61$export$2cf48170a90af7e3
]);
const $e66d55c2753a8f61$export$f4709e6eb43898ae = {
    DynamicAction: 'dynamicAction',
    Resumption: 'resumption'
};
const $e66d55c2753a8f61$export$dc0b7ce6d28cc1a4 = Object.values($e66d55c2753a8f61$export$4081752c8da17394);
const $e66d55c2753a8f61$export$a70752a3aa5d7b44 = 'generic-external-action-error';
const $e66d55c2753a8f61$export$4017c867f2f7bb4 = 'jira-find-issues';
const $e66d55c2753a8f61$export$d94c92560b8e6d9 = 'jira-atlassian-work-item-create-all-field-types';
const $e66d55c2753a8f61$export$ae7170c1349b8d03 = 'jsm-create-request';
const $e66d55c2753a8f61$export$bd97f2d43b42e54b = 'jsm-create-request-v2';
const $e66d55c2753a8f61$export$ce5ab65c94ba90a5 = 'create-request';
const $e66d55c2753a8f61$export$d8b6e8d910775d71 = 'help-form-submit';
const $e66d55c2753a8f61$export$63066a4ea024d6dc = 'jsm-livechat';
const $e66d55c2753a8f61$export$12df73851574d597 = 'jira-issue-transition-bulk';
const $e66d55c2753a8f61$export$3409cf7709732f7a = 'jira-epics-suggest';
const $e66d55c2753a8f61$export$28eab0a47cd4bdb7 = 'jira-issue-delete';
const $e66d55c2753a8f61$export$7814024c83fb6ff0 = 'jira-issue-move';
const $e66d55c2753a8f61$export$1621b7bb3a34aaf8 = 'jira-issue-assign-bulk';
const $e66d55c2753a8f61$export$5d140de35a141589 = 'jira-version-create';
const $e66d55c2753a8f61$export$9c43c5b52e38bd7b = 'capacity-plan-update-single-action';
const $e66d55c2753a8f61$export$7daabf9beae1e394 = 'jira-workflow-operations';
const $e66d55c2753a8f61$export$b34d7535a3731e6 = 'confluence-page-create';
const $e66d55c2753a8f61$export$5eead95dddb4d85e = 'confluence-page-comment';
const $e66d55c2753a8f61$export$dd1d4f1078af0323 = 'confluence-page-rename';
const $e66d55c2753a8f61$export$ea076e5315cd0441 = 'confluence-label-create';
const $e66d55c2753a8f61$export$2d6387634f79866d = 'confluence-page-move';
const $e66d55c2753a8f61$export$c35e156d5b3ba839 = 'deep-research-report-confluence-export';
const $e66d55c2753a8f61$export$4e69e2bf4f236f9 = 'image-search';
const $e66d55c2753a8f61$export$6509c2efb7cf2a1a = 'RequireInformationTool';
const $e66d55c2753a8f61$export$32fdd722a8ead9f4 = 'HiringManagerTool';
const $e66d55c2753a8f61$export$1b06fd861ab5ff79 = 'studio-trigger-solution-plan';
const $e66d55c2753a8f61$export$7f87d37407a70a70 = 'studio-atlassian-studio-update-agent-draft';
const $e66d55c2753a8f61$export$e118b34b65e65120 = 'studio-atlassian-workspace-update-draft-agent';
const $e66d55c2753a8f61$export$1d1c24f8fb60d008 = 'UpdateAgentConfigurationTool';
const $e66d55c2753a8f61$export$5f46fda2a8a95615 = 'jsm-invoke-orchestrator-agent';
const $e66d55c2753a8f61$export$a1766d72cd6b3386 = 'jsm-atlassian-project-create-jsm-survey';
const $e66d55c2753a8f61$export$97632a370497b953 = 'jsm-atlassian-project-create-jsm-queue';
const $e66d55c2753a8f61$export$d1d21bf838e2f79 = 'jsm-atlassian-project-create-jsm-queue-group';
const $e66d55c2753a8f61$export$7343cca51c2f764f = 'jsm-atlassian-project-update-jsm-queue';
const $e66d55c2753a8f61$export$263c9dbbd6f9736b = 'jsm-atlassian-project-update-jsm-queue-group';
const $e66d55c2753a8f61$export$f72bc47d7a557fac = 'jsm-atlassian-project-update-request-type-groups';
const $e66d55c2753a8f61$export$ccb0750b3728dfc8 = 'jsm-atlassian-request-type-update-workflow';
const $e66d55c2753a8f61$export$b26feecb387f3cdd = 'jsm-create-sla-plugin';
const $e66d55c2753a8f61$export$2ebc939020585965 = 'jsm-update-sla-plugin';
const $e66d55c2753a8f61$export$85f4644ed1882358 = 'jsm-atlassian-project-create-jsm-request-type-with-fields';
const $e66d55c2753a8f61$export$a95d95d149961c0e = 'SuggestAndAddFieldsToRequestType';
const $e66d55c2753a8f61$export$20f16b1101429bc = 'jsm-atlassian-jsm-kb-bulk-create-draft-topics';
const $e66d55c2753a8f61$export$4c4ea6fd8cbe01a5 = 'jsm-atlassian-jsm-kb-validate-draft-articles';
const $e66d55c2753a8f61$export$459b808fe2e5243c = 'studio-automation-trigger-rule-build';
const $e66d55c2753a8f61$export$a812c5f6a163b49c = 'automation-platform-atlassian-automation-create-rule';
const $e66d55c2753a8f61$export$7ec0908a542c881f = 'CreateAgentTool';
const $e66d55c2753a8f61$export$5b672baa753f5e11 = 'jira-atlassian-plan-update-work-sources';
const $e66d55c2753a8f61$export$cbc8657dfb60324e = 'jira-plan-add-program-board-plugin';
const $e66d55c2753a8f61$export$5eaeb9a94b1424d1 = 'Jira-Plan-Delete-Program-Board-Plugin';
const $e66d55c2753a8f61$export$aa0b02e94003e760 = 'jira-atlassian-plan-create-work-item';
const $e66d55c2753a8f61$export$fc48d7aa308f4ddd = 'jira-atlassian-plan-set-release-enabled';
const $e66d55c2753a8f61$export$82a76d32e0a5ed52 = 'jira-atlassian-plan-add-work-item-dependencies';
const $e66d55c2753a8f61$export$a27ffbabb22373cc = 'jira-atlassian-plan-remove-work-item-dependencies';
const $e66d55c2753a8f61$export$17ce344f9afefd3f = 'Jira-Plan-Create-Release-Plugin';
const $e66d55c2753a8f61$export$b392dc810180e703 = 'store-recommendation-card';
const $e66d55c2753a8f61$export$1d10a8f57c7c69ae = 'jira-ham-ai-insights-preview';
const $e66d55c2753a8f61$export$37572672766b68ab = 'atlassian-team-atlassian-team-update-archive';
const $e66d55c2753a8f61$export$88c32cc437966d51 = 'ScheduleRovoChatTool';
const $e66d55c2753a8f61$export$a60c2f7f22cc5a42 = 'MultipleChoiceQuestionsTool';
const $e66d55c2753a8f61$export$d4c7224b1c4ad942 = 'AgenticPlanTool';
const $e66d55c2753a8f61$export$ef8aa45067b257a9 = [
    $e66d55c2753a8f61$export$4017c867f2f7bb4,
    $e66d55c2753a8f61$export$3409cf7709732f7a,
    $e66d55c2753a8f61$export$28eab0a47cd4bdb7,
    $e66d55c2753a8f61$export$7814024c83fb6ff0
];
module.exports["ActionKeys"] = $e66d55c2753a8f61$export$4081752c8da17394;
module.exports["FOCUS_CREATE_ASK_KEY"] = $e66d55c2753a8f61$export$c5959ebd02278fb3;
module.exports["EXECUTE_PYTHON_KEY"] = $e66d55c2753a8f61$export$98251f227f05fc03;
module.exports["PLAN_COMPLETE_KEY"] = $e66d55c2753a8f61$export$2cf48170a90af7e3;
module.exports["ASK_QUESTION_KEY"] = $e66d55c2753a8f61$export$52c76e2fb6c72799;
module.exports["ACTIONS_HIDING_FOOTER_BUTTONS"] = $e66d55c2753a8f61$export$d3fc7569bcc4e4e7;
module.exports["ActionPredicateKeys"] = $e66d55c2753a8f61$export$f4709e6eb43898ae;
module.exports["JIRA_FIND_ISSUES_KEY"] = $e66d55c2753a8f61$export$4017c867f2f7bb4;
module.exports["JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY"] = $e66d55c2753a8f61$export$d94c92560b8e6d9;
module.exports["JSM_CREATE_REQUEST_KEY"] = $e66d55c2753a8f61$export$ae7170c1349b8d03;
module.exports["JSM_CREATE_REQUEST_V2_KEY"] = $e66d55c2753a8f61$export$bd97f2d43b42e54b;
module.exports["CREATE_REQUEST_KEY"] = $e66d55c2753a8f61$export$ce5ab65c94ba90a5;
module.exports["JSM_CREATE_EMBEDDED_REQUEST_KEY"] = $e66d55c2753a8f61$export$d8b6e8d910775d71;
module.exports["JIRA_ISSUE_TRANSITION_KEY"] = $e66d55c2753a8f61$export$12df73851574d597;
module.exports["JIRA_EPICS_SUGGEST_KEY"] = $e66d55c2753a8f61$export$3409cf7709732f7a;
module.exports["JIRA_ISSUE_DELETE_KEY"] = $e66d55c2753a8f61$export$28eab0a47cd4bdb7;
module.exports["JIRA_ISSUE_MOVE_KEY"] = $e66d55c2753a8f61$export$7814024c83fb6ff0;
module.exports["JIRA_ISSUE_ASSIGN_KEY"] = $e66d55c2753a8f61$export$1621b7bb3a34aaf8;
module.exports["JIRA_VERSION_CREATE_KEY"] = $e66d55c2753a8f61$export$5d140de35a141589;
module.exports["CONFLUENCE_PAGE_CREATE_KEY"] = $e66d55c2753a8f61$export$b34d7535a3731e6;
module.exports["CONFLUENCE_PAGE_COMMENT_KEY"] = $e66d55c2753a8f61$export$5eead95dddb4d85e;
module.exports["CONFLUENCE_PAGE_RENAME_KEY"] = $e66d55c2753a8f61$export$dd1d4f1078af0323;
module.exports["CONFLUENCE_PAGE_ADD_LABEL_KEY"] = $e66d55c2753a8f61$export$ea076e5315cd0441;
module.exports["CONFLUENCE_PAGE_MOVE_KEY"] = $e66d55c2753a8f61$export$2d6387634f79866d;
module.exports["IMAGE_SEARCH_KEY"] = $e66d55c2753a8f61$export$4e69e2bf4f236f9;
module.exports["REQUIRE_INFORMATION_TOOL"] = $e66d55c2753a8f61$export$6509c2efb7cf2a1a;
module.exports["HIRING_MANAGER_TOOL_KEY"] = $e66d55c2753a8f61$export$32fdd722a8ead9f4;
module.exports["STUDIO_TRIGGER_SOLUTION_PLAN_KEY"] = $e66d55c2753a8f61$export$1b06fd861ab5ff79;
module.exports["JSM_CREATE_SURVEY_KEY"] = $e66d55c2753a8f61$export$a1766d72cd6b3386;
module.exports["JSM_QUEUE_CREATE_KEY"] = $e66d55c2753a8f61$export$97632a370497b953;
module.exports["JSM_QUEUE_GROUP_CREATE_KEY"] = $e66d55c2753a8f61$export$d1d21bf838e2f79;
module.exports["JSM_QUEUE_UPDATE_KEY"] = $e66d55c2753a8f61$export$7343cca51c2f764f;
module.exports["JSM_QUEUE_GROUP_UPDATE_KEY"] = $e66d55c2753a8f61$export$263c9dbbd6f9736b;
module.exports["JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY"] = $e66d55c2753a8f61$export$f72bc47d7a557fac;
module.exports["JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY"] = $e66d55c2753a8f61$export$ccb0750b3728dfc8;
module.exports["JSM_SLA_CREATE_KEY"] = $e66d55c2753a8f61$export$b26feecb387f3cdd;
module.exports["JSM_SLA_UPDATE_KEY"] = $e66d55c2753a8f61$export$2ebc939020585965;
module.exports["JSM_REQUEST_TYPE_UPDATED_KEY"] = $e66d55c2753a8f61$export$85f4644ed1882358;
module.exports["JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY"] = $e66d55c2753a8f61$export$a95d95d149961c0e;
module.exports["JSM_CREATE_KB_TOPICS_KEY"] = $e66d55c2753a8f61$export$20f16b1101429bc;
module.exports["JSM_CREATE_KB_ARTICLES_KEY"] = $e66d55c2753a8f61$export$4c4ea6fd8cbe01a5;
module.exports["STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY"] = $e66d55c2753a8f61$export$459b808fe2e5243c;
module.exports["JIRA_PLANS_UPDATE_WORK_SOURCE_KEY"] = $e66d55c2753a8f61$export$5b672baa753f5e11;
module.exports["JIRA_PLANS_ADD_PROGRAM_BOARD_KEY"] = $e66d55c2753a8f61$export$cbc8657dfb60324e;
module.exports["JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY"] = $e66d55c2753a8f61$export$5eaeb9a94b1424d1;
module.exports["JIRA_PLANS_CREATE_WORK_ITEM_KEY"] = $e66d55c2753a8f61$export$aa0b02e94003e760;
module.exports["JIRA_PLANS_MANAGE_FEATURES_KEY"] = $e66d55c2753a8f61$export$fc48d7aa308f4ddd;
module.exports["JIRA_PLANS_ADD_DEPENDENCY_KEY"] = $e66d55c2753a8f61$export$82a76d32e0a5ed52;
module.exports["JIRA_PLANS_REMOVE_DEPENDENCY_KEY"] = $e66d55c2753a8f61$export$a27ffbabb22373cc;
module.exports["JIRA_PLANS_CREATE_RELEASE_KEY"] = $e66d55c2753a8f61$export$17ce344f9afefd3f;
module.exports["STORE_RECOMMENDATION_ACTION_KEY"] = $e66d55c2753a8f61$export$b392dc810180e703;
module.exports["JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY"] = $e66d55c2753a8f61$export$1d10a8f57c7c69ae;
module.exports["ATLASSIAN_TEAM_UPDATE_ARCHIVE_KEY"] = $e66d55c2753a8f61$export$37572672766b68ab;
module.exports["SCHEDULED_CHAT_KEY"] = $e66d55c2753a8f61$export$88c32cc437966d51;
module.exports["MULTIPLE_CHOICE_QUESTIONS_TOOL_KEY"] = $e66d55c2753a8f61$export$a60c2f7f22cc5a42;
module.exports["AGENTIC_PLAN_TOOL_KEY"] = $e66d55c2753a8f61$export$d4c7224b1c4ad942;

});

parcelRegister("5vtU3", function(module, exports) {
//list from https://hello.atlassian.net/wiki/spaces/rocx/pages/6474505700/Knowledge+Sources+list+connectors
const $f7a6f138216459ea$var$products1PListKnowleage = [
    'Atlassian Support Docs',
    'Confluence Data Centre',
    'Jira Data Center'
];
// platform/packages/search/search-ai/src/ai-answer-dialog/analytics-helpers.tsx
// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $f7a6f138216459ea$var$products1PList = new Set([
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Goals',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Projects',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator',
    ...$f7a6f138216459ea$var$products1PListKnowleage
]);
const $f7a6f138216459ea$export$2777e093c10fa93d = (productName)=>!$f7a6f138216459ea$var$products1PList.has(productName);
module.exports["is3pApp"] = $f7a6f138216459ea$export$2777e093c10fa93d;

});

parcelRegister("jEzab", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9823ae60ddf75b10$var$store = (0, $1P1Tu.createStore)({
    name: 'chatUseMessages',
    initialState: {},
    actions: {
        setMessages: (conversationId, messages)=>({ setState: setState })=>{
                setState({
                    [conversationId]: messages
                });
            },
        getMessages: (conversationId)=>({ getState: getState })=>{
                return getState()[conversationId] ?? [];
            }
    }
});
const $9823ae60ddf75b10$export$d5c60118ea64ef24 = (0, $9zUhf.createHook)($9823ae60ddf75b10$var$store, {
    selector: (state, { conversationId: conversationId })=>state[conversationId] ?? []
});
const $9823ae60ddf75b10$export$fcbbecdca7d55350 = (0, $9zUhf.createActionsHook)($9823ae60ddf75b10$var$store);
module.exports["useChatMessages"] = $9823ae60ddf75b10$export$d5c60118ea64ef24;
module.exports["useChatMessagesActions"] = $9823ae60ddf75b10$export$fcbbecdca7d55350;

});

parcelRegister("72hrp", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $3wgAM = parcelRequire("3wgAM");


var $dh538 = parcelRequire("dh538");


var $deF0K = parcelRequire("deF0K");


var $htiKQ = parcelRequire("htiKQ");


var $8IKbl = parcelRequire("8IKbl");


var $bPHr8 = parcelRequire("bPHr8");

function $f56e0f5c5904b36b$export$17828fb10c7c5928(messages, messageId) {
    return messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content.message.message.id === messageId);
}
function $f56e0f5c5904b36b$export$c5f84c389beb0191(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((action)=>(0, $deF0K.isCreatableAction)(action) || (0, $htiKQ.isJiraPreviewableAction)(action) && (0, $dh538.fg)('ham-ai-insights'))) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$551dda091e9d40ca(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((0, $deF0K.isAIFCAction))) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$6f9d326b409b8a89(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg)) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$ae4c648272f0b05(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg) && msg.content.message.message.actions?.length) return msg.content.message.message.actions.some((action)=>action.key === (0, $8IKbl.ASK_QUESTION_KEY));
    }
    return false;
}
function $f56e0f5c5904b36b$export$e839ab847bfd35fb(message) {
    const action = message.content.message.message.actions?.find((0, $deF0K.isCreatableAction));
    const contentId = action?.data?.contentId;
    // always make it a string since the final response sometimes returns a number and re-renders the iframe.
    return contentId === undefined ? undefined : String(contentId);
}
function $f56e0f5c5904b36b$export$460905b2c4dc18c9(message) {
    return message?.content?.message?.message?.actions?.[0];
}
function $f56e0f5c5904b36b$export$b05803156e5015b6(message) {
    const action = message?.content?.message?.message?.actions?.find((0, $deF0K.isCreatableAction));
    return action?.data?.title;
}
function $f56e0f5c5904b36b$export$4382776317fc294f(message) {
    if (!message) return undefined;
    const aifcAction = message?.content?.message?.message?.actions?.find((0, $deF0K.isAIFCAction));
    if (aifcAction) {
        const status = aifcAction?.status?.toLowerCase();
        if (status === 'preparing' || status === 'streaming') return status;
        // 'Planned' is the same as a final response. If we see it, assume streaming is complete.
        if (status === 'planned' || status === 'finished' || status === 'cancelled' || message.content.streamingComplete) return 'complete';
    }
    return undefined;
}
function $f56e0f5c5904b36b$var$getStableMessageParts(message) {
    const action = message.content.message.message.actions?.find((0, $deF0K.isCreatableAction));
    const actionData = action?.data;
    // We just pick the parts we care about directly from the message
    // We avoid ADF since that is streamed and changes all the time.
    return {
        messageId: message.content.message.message.id,
        streamingComplete: message.content.streamingComplete,
        action: actionData ? (0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(actionData, [
            'contentId',
            'title',
            'mediaFileId'
        ]) : undefined,
        status: action?.status
    };
}
function $f56e0f5c5904b36b$export$c90c71e0e0065a6(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))($f56e0f5c5904b36b$var$getStableMessageParts(a), $f56e0f5c5904b36b$var$getStableMessageParts(b));
}
module.exports["findMessageById"] = $f56e0f5c5904b36b$export$17828fb10c7c5928;
module.exports["findLastMessageWithCreateAction"] = $f56e0f5c5904b36b$export$c5f84c389beb0191;
module.exports["findLastMessageWithAIFCAction"] = $f56e0f5c5904b36b$export$551dda091e9d40ca;
module.exports["findLastAssistantMessage"] = $f56e0f5c5904b36b$export$6f9d326b409b8a89;
module.exports["isLatestActionMessageAskQuestion"] = $f56e0f5c5904b36b$export$ae4c648272f0b05;
module.exports["extractContentId"] = $f56e0f5c5904b36b$export$e839ab847bfd35fb;
module.exports["getFirstMessageAction"] = $f56e0f5c5904b36b$export$460905b2c4dc18c9;
module.exports["extractTitle"] = $f56e0f5c5904b36b$export$b05803156e5015b6;
module.exports["getAIFCActionStatus"] = $f56e0f5c5904b36b$export$4382776317fc294f;
module.exports["areMessagesEqual"] = $f56e0f5c5904b36b$export$c90c71e0e0065a6;

});

parcelRegister("deF0K", function(module, exports) {
// ============================================================================
// ACTIONS that are shared between Confluence and Jira
// ============================================================================

var $dh538 = parcelRequire("dh538");


var $8IKbl = parcelRequire("8IKbl");


var $bPHr8 = parcelRequire("bPHr8");


var $cBrev = parcelRequire("cBrev");


var $3vCSA = parcelRequire("3vCSA");


var $htiKQ = parcelRequire("htiKQ");


var $9bF5n = parcelRequire("9bF5n");

const $665803f9684f4c9f$export$992a8e659d5a1252 = (action)=>typeof action === 'object' && action !== null && 'key' in action;
const $665803f9684f4c9f$export$74f7c5137689c9a9 = (action)=>(0, $3vCSA.isConfluenceCreateNewAction)(action) || (0, $htiKQ.isJiraCreatableAction)(action) || (0, $9bF5n.isJsmCreatableAction)(action) || (0, $3vCSA.isDynamicUiCreatableAction)(action) || (0, $3vCSA.isImageCreatableAction)(action) || (0, $cBrev.isAvpPreviewCardAction)(action);
const $665803f9684f4c9f$export$8244c8e5412f2a57 = (message)=>(0, $3vCSA.isDynamicUiCreatableAction)(message) && !(0, $3vCSA.isDynamicUiUpdateActionData)(message.data) || (0, $3vCSA.isImageCreatableAction)(message) && !(0, $3vCSA.isImageUpdateActionData)(message.data);
const $665803f9684f4c9f$export$95acec44a3c80403 = (action)=>(0, $3vCSA.isConfluenceUpdatableAction)(action) || (0, $htiKQ.isJiraUpdatableAction)(action) || (0, $9bF5n.isJsmUpdatableAction)(action);
const $665803f9684f4c9f$export$473ed8cdfdfcd6f4 = (action)=>$665803f9684f4c9f$export$74f7c5137689c9a9(action) || $665803f9684f4c9f$export$95acec44a3c80403(action);
const $665803f9684f4c9f$export$a4e95791cb217646 = (action)=>{
    return (0, $3vCSA.getConfluenceContentType)(action) ?? (0, $htiKQ.getJiraContentType)(action) ?? (0, $9bF5n.getJsmContentType)(action) ?? 'unknown';
};
const $665803f9684f4c9f$export$29736db3162547c8 = (action)=>(0, $8IKbl.ACTIONS_HIDING_FOOTER_BUTTONS).has(action.key);
/**
 * Action keys that require explicit user input before the turn is functionally
 * complete — e.g. clarifying questions, multi-choice pickers, or agent plans
 * awaiting confirmation. Display-only preview cards (AIFC create/update,
 * suggestions) are intentionally NOT included — those let the user
 * publish/dismiss at their leisure and shouldn't block follow-up UX
 * (e.g. the CSAT survey).
 */ const $665803f9684f4c9f$var$ACTIONS_AWAITING_USER_INPUT = new Set([
    (0, $8IKbl.ASK_QUESTION_KEY),
    (0, $8IKbl.AGENTIC_PLAN_TOOL_KEY),
    (0, $8IKbl.MULTIPLE_CHOICE_QUESTIONS_TOOL_KEY),
    (0, $8IKbl.REQUIRE_INFORMATION_TOOL),
    (0, $8IKbl.JIRA_ISSUE_DELETE_KEY),
    (0, $8IKbl.JIRA_ISSUE_MOVE_KEY),
    (0, $8IKbl.HIRING_MANAGER_TOOL_KEY),
    (0, $8IKbl.PLAN_COMPLETE_KEY),
    (0, $8IKbl.EXECUTE_PYTHON_KEY),
    (0, $8IKbl.ActionKeys).JsmSolutionComposerPlanSummary
]);
const $665803f9684f4c9f$export$8e599432707b812c = (action)=>$665803f9684f4c9f$var$ACTIONS_AWAITING_USER_INPUT.has(action.key);
const $665803f9684f4c9f$export$83f1ae88eb290a18 = (action)=>action.key === (0, $8IKbl.IMAGE_SEARCH_KEY);
const $665803f9684f4c9f$export$154eb84770532af2 = (action)=>(0, $3vCSA.isConfluenceStreamAction)(action) || (0, $htiKQ.isJiraStreamAction)(action) || (0, $9bF5n.isJsmStreamAction)(action) || (0, $cBrev.isAvpStreamAction)(action) || $665803f9684f4c9f$export$83f1ae88eb290a18(action) && (0, $dh538.fg)('rovo_chat_image_search_fe');
const $665803f9684f4c9f$export$1382aef9948f8fc7 = (action)=>(0, $3vCSA.isConfluencePreviewCardAction)(action) || (0, $htiKQ.isJiraPreviewCardAction)(action) || (0, $9bF5n.isJsmPreviewCardAction)(action) || (0, $3vCSA.isDynamicUiCreatableAction)(action) || (0, $3vCSA.isImageCreatableAction)(action) || (0, $cBrev.isAvpPreviewCardAction)(action);
const $665803f9684f4c9f$export$681cf9ea58de88fd = (action, identifier)=>{
    if (!(0, $dh538.fg)('jira_aifc_enabled')) return (0, $3vCSA.generateRovoReceiverId)(action, identifier ?? '');
    if (!$665803f9684f4c9f$export$992a8e659d5a1252(action)) return undefined;
    if ((0, $htiKQ.isJiraAction)(action)) return (0, $htiKQ.generateJiraReceiverId)(action);
    if ((0, $9bF5n.isJsmAction)(action) && (0, $dh538.fg)('surveys-aifc')) return (0, $9bF5n.generateJsmReceiverId)(action);
    return (0, $3vCSA.generateRovoReceiverId)(action, identifier ?? '');
};
const $665803f9684f4c9f$export$ea699f0d7930d4d4 = ({ action: action, isContentPreviewSupported: isContentPreviewSupported })=>{
    if ((0, $dh538.fg)('aifc_create_enabled')) return !$665803f9684f4c9f$export$154eb84770532af2({
        key: action.key
    }) && !(0, $htiKQ.isJiraCreatableAction)({
        key: action.key
    }) && !(0, $9bF5n.isJsmCreatableAction)({
        key: action.key
    }) && !(0, $cBrev.isAvpPreviewCardAction)({
        key: action.key
    });
    if (!isContentPreviewSupported && !(0, $dh538.fg)('aifc_create_enabled')) return !$665803f9684f4c9f$export$1382aef9948f8fc7(action);
    return true;
};
function $665803f9684f4c9f$export$d94ea083820ef679(messages, invocationId) {
    return messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && !!msg.content.message.message.actions?.some((action)=>action.invocationId === invocationId));
}
module.exports["isCreatableAction"] = $665803f9684f4c9f$export$74f7c5137689c9a9;
module.exports["isEphemeralCreateAction"] = $665803f9684f4c9f$export$8244c8e5412f2a57;
module.exports["isUpdatableAction"] = $665803f9684f4c9f$export$95acec44a3c80403;
module.exports["isAIFCAction"] = $665803f9684f4c9f$export$473ed8cdfdfcd6f4;
module.exports["getAIFCContentType"] = $665803f9684f4c9f$export$a4e95791cb217646;
module.exports["isActionHidingFooterButtons"] = $665803f9684f4c9f$export$29736db3162547c8;
module.exports["isActionAwaitingUserInput"] = $665803f9684f4c9f$export$8e599432707b812c;
module.exports["isSupportedStreamAction"] = $665803f9684f4c9f$export$154eb84770532af2;
module.exports["isPreviewCardAction"] = $665803f9684f4c9f$export$1382aef9948f8fc7;
module.exports["generateRovoReceiverId"] = $665803f9684f4c9f$export$681cf9ea58de88fd;
module.exports["findMessageByInvocationId"] = $665803f9684f4c9f$export$d94ea083820ef679;

});

parcelRegister("cBrev", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $a881abcb3d17fd39$export$3e0063b4c9eccd95 = 'avp_chart_create';
function $a881abcb3d17fd39$export$144269edab6271d9(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof d.dashboardAri === 'string' && typeof cd.chart === 'object' && cd.chart !== null && typeof cd.canvasLayout === 'object' && cd.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$2faa8f3a24d96e39 = 'avp_chart_delete';
function $a881abcb3d17fd39$export$9f17310825a1a178(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.chartId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$a01e31e7aead77c1 = 'avp_chart_update';
function $a881abcb3d17fd39$export$db13f09592330b3b(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    if (typeof d.dashboardAri !== 'string' || typeof d.chartId !== 'string') return false;
    const chartData = d.chartData;
    if (typeof chartData !== 'object' || chartData === null) return false;
    const cd = chartData;
    return typeof cd.chart === 'object' && cd.chart !== null;
}
const $a881abcb3d17fd39$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
const $a881abcb3d17fd39$var$isAvpFilterExpressionPayload = (data)=>{
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && (d.filterExpression === null || typeof d.filterExpression === 'object' && d.filterExpression !== null);
};
const $a881abcb3d17fd39$export$37d8bc8514392efa = 'avp_dashboard_create_filter';
function $a881abcb3d17fd39$export$a21637e45432b3cd(data) {
    if (!$a881abcb3d17fd39$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return d.expressionIds === undefined || $a881abcb3d17fd39$var$isStringArray(d.expressionIds);
}
const $a881abcb3d17fd39$export$1e6353bd95c91843 = 'avp_dashboard_delete_filter';
function $a881abcb3d17fd39$export$9a3f223399a3708c(data) {
    if (!$a881abcb3d17fd39$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return $a881abcb3d17fd39$var$isStringArray(d.expressionIds);
}
const $a881abcb3d17fd39$export$72caf49a260f725e = 'avp_dashboard_update_filter';
function $a881abcb3d17fd39$export$c6efee5e04349169(data) {
    if (!$a881abcb3d17fd39$var$isAvpFilterExpressionPayload(data)) return false;
    const d = data;
    return typeof d.expressionId === 'string';
}
const $a881abcb3d17fd39$export$e36a63f9bc6ec9d9 = 'avp_dashboard_remove_row';
function $a881abcb3d17fd39$export$b8981fb8c2b2ceae(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.rowId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$e21300173aaa5a75 = 'avp_dashboard_remove_element';
function $a881abcb3d17fd39$export$393c0a783fee1203(data) {
    if (typeof data !== 'object' || data === null || !(0, $dh538.fg)('platform_avp_aifc_enabled')) return false;
    const d = data;
    return typeof d.dashboardAri === 'string' && typeof d.elementId === 'string' && typeof d.canvasLayout === 'object' && d.canvasLayout !== null;
}
const $a881abcb3d17fd39$export$5860e19fc7aa5d00 = 'avp_dashboard_create';
function $a881abcb3d17fd39$export$eca0d9c93fb8ccc3(data) {
    if (typeof data !== 'object' || data === null) return false;
    const d = data;
    return typeof d.dashboardUrl === 'string' && typeof d.dashboardAri === 'string';
}
// ============================================================================
// AVP ACTION CLASSIFICATION
// ============================================================================
const $a881abcb3d17fd39$var$AVP_CREATABLE_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$3e0063b4c9eccd95,
    $a881abcb3d17fd39$export$5860e19fc7aa5d00,
    $a881abcb3d17fd39$export$37d8bc8514392efa
]);
const $a881abcb3d17fd39$var$AVP_PREVIEW_CARD_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$5860e19fc7aa5d00
]);
const $a881abcb3d17fd39$export$6b9e1da20a0f005c = (action)=>$a881abcb3d17fd39$var$AVP_PREVIEW_CARD_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$var$AVP_DELETABLE_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$2faa8f3a24d96e39,
    $a881abcb3d17fd39$export$e21300173aaa5a75,
    $a881abcb3d17fd39$export$e36a63f9bc6ec9d9,
    $a881abcb3d17fd39$export$1e6353bd95c91843
]);
const $a881abcb3d17fd39$var$AVP_UPDATABLE_ACTION_KEYS = new Set([
    $a881abcb3d17fd39$export$a01e31e7aead77c1,
    $a881abcb3d17fd39$export$72caf49a260f725e
]);
const $a881abcb3d17fd39$export$d69ccc6d462afdf8 = (action)=>$a881abcb3d17fd39$var$AVP_CREATABLE_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$export$edc9f9dece97635 = (action)=>$a881abcb3d17fd39$var$AVP_DELETABLE_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$export$a2d39e4b08e0e68d = (action)=>$a881abcb3d17fd39$var$AVP_UPDATABLE_ACTION_KEYS.has(action.key);
const $a881abcb3d17fd39$export$ebb904732b24f004 = (action)=>$a881abcb3d17fd39$export$d69ccc6d462afdf8(action) || $a881abcb3d17fd39$export$edc9f9dece97635(action) || $a881abcb3d17fd39$export$a2d39e4b08e0e68d(action);
module.exports["AVP_CHART_CREATE_KEY"] = $a881abcb3d17fd39$export$3e0063b4c9eccd95;
module.exports["isAvpChartCreateActionData"] = $a881abcb3d17fd39$export$144269edab6271d9;
module.exports["AVP_CHART_DELETE_KEY"] = $a881abcb3d17fd39$export$2faa8f3a24d96e39;
module.exports["isAvpChartDeleteActionData"] = $a881abcb3d17fd39$export$9f17310825a1a178;
module.exports["AVP_CHART_UPDATE_KEY"] = $a881abcb3d17fd39$export$a01e31e7aead77c1;
module.exports["isAvpChartUpdateActionData"] = $a881abcb3d17fd39$export$db13f09592330b3b;
module.exports["AVP_FILTER_EXPRESSION_CREATE_KEY"] = $a881abcb3d17fd39$export$37d8bc8514392efa;
module.exports["isAvpFilterExpressionCreateActionData"] = $a881abcb3d17fd39$export$a21637e45432b3cd;
module.exports["AVP_FILTER_EXPRESSION_DELETE_KEY"] = $a881abcb3d17fd39$export$1e6353bd95c91843;
module.exports["isAvpFilterExpressionDeleteActionData"] = $a881abcb3d17fd39$export$9a3f223399a3708c;
module.exports["AVP_FILTER_EXPRESSION_UPDATE_KEY"] = $a881abcb3d17fd39$export$72caf49a260f725e;
module.exports["isAvpFilterExpressionUpdateActionData"] = $a881abcb3d17fd39$export$c6efee5e04349169;
module.exports["AVP_DASHBOARD_REMOVE_ROW_KEY"] = $a881abcb3d17fd39$export$e36a63f9bc6ec9d9;
module.exports["isAvpDashboardRemoveRowActionData"] = $a881abcb3d17fd39$export$b8981fb8c2b2ceae;
module.exports["AVP_DASHBOARD_REMOVE_ELEMENT_KEY"] = $a881abcb3d17fd39$export$e21300173aaa5a75;
module.exports["isAvpDashboardRemoveElementActionData"] = $a881abcb3d17fd39$export$393c0a783fee1203;
module.exports["AVP_DASHBOARD_CREATE_KEY"] = $a881abcb3d17fd39$export$5860e19fc7aa5d00;
module.exports["isAvpDashboardCreateActionData"] = $a881abcb3d17fd39$export$eca0d9c93fb8ccc3;
module.exports["isAvpPreviewCardAction"] = $a881abcb3d17fd39$export$6b9e1da20a0f005c;
module.exports["isAvpStreamAction"] = $a881abcb3d17fd39$export$ebb904732b24f004;

});

parcelRegister("htiKQ", function(module, exports) {
// ============================================================================
// JIRA SMART ISSUE CREATE
// ============================================================================

var $8IKbl = parcelRequire("8IKbl");


var $eX3ET = parcelRequire("eX3ET");

const $97b023c268fae936$export$5f099b7754a7652a = [
    (0, $8IKbl.JIRA_FIND_ISSUES_KEY),
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_V2_KEY),
    (0, $8IKbl.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $8IKbl.JIRA_ISSUE_TRANSITION_KEY),
    (0, $8IKbl.JIRA_EPICS_SUGGEST_KEY),
    (0, $8IKbl.JIRA_ISSUE_DELETE_KEY),
    (0, $8IKbl.JIRA_ISSUE_MOVE_KEY),
    (0, $8IKbl.JIRA_ISSUE_ASSIGN_KEY),
    (0, $8IKbl.JIRA_VERSION_CREATE_KEY),
    (0, $8IKbl.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
];
const $97b023c268fae936$export$29b82f3d15178d30 = new Set($97b023c268fae936$export$5f099b7754a7652a);
const $97b023c268fae936$export$211f4719f56285e9 = new Set([
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $97b023c268fae936$export$d75519ce8257cbe3 = new Set([
    (0, $8IKbl.JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY)
]);
const $97b023c268fae936$export$530aa0daf5811c30 = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && $97b023c268fae936$export$29b82f3d15178d30.has(action?.['key']);
};
const $97b023c268fae936$export$b4d5023312147fc4 = (action)=>$97b023c268fae936$export$530aa0daf5811c30(action) && $97b023c268fae936$export$211f4719f56285e9.has(action.key);
const $97b023c268fae936$export$69c28e373f39b349 = (action)=>$97b023c268fae936$export$530aa0daf5811c30(action) && $97b023c268fae936$export$d75519ce8257cbe3.has(action.key);
const $97b023c268fae936$export$b5050b797265a8be = (action)=>false;
const $97b023c268fae936$export$a1a30289a72c78b1 = (action)=>false;
const $97b023c268fae936$export$6fe601f4a243e8f4 = (action)=>{
    if (!$97b023c268fae936$export$530aa0daf5811c30(action)) return undefined;
    if ($97b023c268fae936$export$b4d5023312147fc4(action)) return 0, $eX3ET.JIRA_SMART_CREATE_TABLE_CLIENT_ID;
    return undefined;
};
const $97b023c268fae936$export$1643c639e4c073b8 = (action)=>{
    const actionKey = action.key;
    if ($97b023c268fae936$export$211f4719f56285e9.has(actionKey)) return 'jira-issue-table';
    return undefined;
};
// ============================================================================
// JIRA PREVIEW CARDS
// ============================================================================
const $97b023c268fae936$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $97b023c268fae936$export$4a1398b92436f797 = (action)=>$97b023c268fae936$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJiraAction"] = $97b023c268fae936$export$530aa0daf5811c30;
module.exports["isJiraCreatableAction"] = $97b023c268fae936$export$b4d5023312147fc4;
module.exports["isJiraPreviewableAction"] = $97b023c268fae936$export$69c28e373f39b349;
module.exports["isJiraUpdatableAction"] = $97b023c268fae936$export$b5050b797265a8be;
module.exports["isJiraStreamAction"] = $97b023c268fae936$export$a1a30289a72c78b1;
module.exports["generateJiraReceiverId"] = $97b023c268fae936$export$6fe601f4a243e8f4;
module.exports["getJiraContentType"] = $97b023c268fae936$export$1643c639e4c073b8;
module.exports["isJiraPreviewCardAction"] = $97b023c268fae936$export$4a1398b92436f797;

});

parcelRegister("9bF5n", function(module, exports) {
// ============================================================================
// JSM CREATE SURVEY
// ============================================================================

var $dh538 = parcelRequire("dh538");


var $8IKbl = parcelRequire("8IKbl");


var $62lkj = parcelRequire("62lkj");


var $b9NdB = parcelRequire("b9NdB");

const $b06f6240a2781a94$export$4d5c499af23159fb = (0, $b9NdB.client)('jsm-queue-settings');





const $53c66121daab2d4a$export$c1a656e72d7a4bcc = (0, $b9NdB.client)('jsm-request-type-settings');





const $35e6ac4d589373ac$export$bd769f5be4601367 = (0, $b9NdB.client)('jsm-sla-settings');



var $3OJcK = parcelRequire("3OJcK");

const $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP = {
    [(0, $8IKbl.JSM_QUEUE_CREATE_KEY)]: {
        clientId: (0, $b06f6240a2781a94$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $8IKbl.JSM_QUEUE_UPDATE_KEY)]: {
        clientId: (0, $b06f6240a2781a94$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $8IKbl.JSM_QUEUE_GROUP_CREATE_KEY)]: {
        clientId: (0, $b06f6240a2781a94$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $8IKbl.JSM_QUEUE_GROUP_UPDATE_KEY)]: {
        clientId: (0, $b06f6240a2781a94$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    },
    [(0, $8IKbl.JSM_REQUEST_TYPE_UPDATED_KEY)]: {
        clientId: (0, $53c66121daab2d4a$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $8IKbl.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY)]: {
        clientId: (0, $53c66121daab2d4a$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $8IKbl.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY)]: {
        clientId: (0, $53c66121daab2d4a$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    },
    [(0, $8IKbl.JSM_SLA_CREATE_KEY)]: {
        clientId: (0, $35e6ac4d589373ac$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $8IKbl.JSM_SLA_UPDATE_KEY)]: {
        clientId: (0, $35e6ac4d589373ac$export$bd769f5be4601367),
        contentType: 'jsm-sla-updated'
    },
    [(0, $8IKbl.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)]: {
        clientId: (0, $53c66121daab2d4a$export$c1a656e72d7a4bcc),
        contentType: 'jsm-request-type-updated'
    }
};
const $7fdb7cabde039026$export$fd2af7ce2e351879 = [
    (0, $8IKbl.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_V2_KEY),
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY),
    (0, $8IKbl.JSM_QUEUE_CREATE_KEY),
    (0, $8IKbl.JSM_QUEUE_GROUP_CREATE_KEY),
    (0, $8IKbl.JSM_QUEUE_GROUP_UPDATE_KEY),
    (0, $8IKbl.JSM_QUEUE_UPDATE_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY),
    (0, $8IKbl.JSM_SLA_CREATE_KEY),
    (0, $8IKbl.JSM_SLA_UPDATE_KEY),
    (0, $8IKbl.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
];
const $7fdb7cabde039026$export$7b875f28b9805c0c = new Set($7fdb7cabde039026$export$fd2af7ce2e351879);
const $7fdb7cabde039026$export$3fcc5475955435c4 = new Set([
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY),
    (0, $8IKbl.JSM_QUEUE_CREATE_KEY),
    (0, $8IKbl.JSM_QUEUE_GROUP_CREATE_KEY),
    (0, $8IKbl.JSM_QUEUE_GROUP_UPDATE_KEY),
    (0, $8IKbl.JSM_QUEUE_UPDATE_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_UPDATED_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_PORTAL_GROUPS_UPDATE_KEY),
    (0, $8IKbl.JSM_REQUEST_TYPE_WORKFLOW_UPDATE_KEY),
    (0, $8IKbl.JSM_SUGGEST_AND_ADD_FIELDS_TO_REQUEST_TYPE_KEY)
]);
const $7fdb7cabde039026$var$isKbFromScratchActionKey = (actionKey)=>(actionKey === (0, $8IKbl.JSM_CREATE_KB_TOPICS_KEY) || actionKey === (0, $8IKbl.JSM_CREATE_KB_ARTICLES_KEY)) && (0, $dh538.fg)('jsm_kb_from_scratch');
const $7fdb7cabde039026$export$98885adfb17a807b = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && ($7fdb7cabde039026$export$7b875f28b9805c0c.has(action?.['key']) || $7fdb7cabde039026$var$isKbFromScratchActionKey(action?.['key']));
};
const $7fdb7cabde039026$export$29f39e9429d6b955 = (action)=>$7fdb7cabde039026$export$98885adfb17a807b(action) && ($7fdb7cabde039026$export$3fcc5475955435c4.has(action.key) || $7fdb7cabde039026$var$isKbFromScratchActionKey(action.key));
const $7fdb7cabde039026$export$ae7904ebe7bd5bb0 = (action)=>false;
const $7fdb7cabde039026$export$f4d25026329e5a91 = (action)=>false;
const $7fdb7cabde039026$export$af2b121ccb8f1449 = (action)=>{
    if (!$7fdb7cabde039026$export$98885adfb17a807b(action)) return undefined;
    if ((0, $dh538.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP[action.key];
        if (embedView) return embedView.clientId;
    }
    if ($7fdb7cabde039026$var$isKbFromScratchActionKey(action.key)) return 0, $62lkj.JSM_CREATE_KB_STAGING_AREA_CLIENT_ID;
    if ($7fdb7cabde039026$export$29f39e9429d6b955(action)) return 0, $3OJcK.JSM_CREATE_SURVEY_CLIENT_ID;
    return undefined;
};
const $7fdb7cabde039026$export$292f03726a3f6528 = (action)=>{
    const actionKey = action.key;
    if ((0, $dh538.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP[actionKey];
        if (embedView) return embedView.contentType;
    }
    if ($7fdb7cabde039026$export$3fcc5475955435c4.has(actionKey) || $7fdb7cabde039026$var$isKbFromScratchActionKey(actionKey)) return 'jsm-create-survey';
    return undefined;
};
// ============================================================================
// JSM PREVIEW CARDS
// ============================================================================
const $7fdb7cabde039026$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY)
]);
const $7fdb7cabde039026$export$c8683ba29b03d037 = (action)=>$7fdb7cabde039026$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJsmAction"] = $7fdb7cabde039026$export$98885adfb17a807b;
module.exports["isJsmCreatableAction"] = $7fdb7cabde039026$export$29f39e9429d6b955;
module.exports["isJsmUpdatableAction"] = $7fdb7cabde039026$export$ae7904ebe7bd5bb0;
module.exports["isJsmStreamAction"] = $7fdb7cabde039026$export$f4d25026329e5a91;
module.exports["generateJsmReceiverId"] = $7fdb7cabde039026$export$af2b121ccb8f1449;
module.exports["getJsmContentType"] = $7fdb7cabde039026$export$292f03726a3f6528;
module.exports["isJsmPreviewCardAction"] = $7fdb7cabde039026$export$c8683ba29b03d037;

});

parcelRegister("62lkj", function(module, exports) {

var $b9NdB = parcelRequire("b9NdB");

const $2517e7f57717d029$export$91e704c2411cb3f5 = (0, $b9NdB.client)('jsm-create-kb');
const $2517e7f57717d029$export$ee04bc09e7068b43 = (0, $b9NdB.client)('jsm-create-kb-staging-area');
const $2517e7f57717d029$export$c608186adcac93ad = (0, $b9NdB.client)('jsm-create-kb-card');
module.exports["JSM_CREATE_KB_CLIENT_ID"] = $2517e7f57717d029$export$91e704c2411cb3f5;
module.exports["JSM_CREATE_KB_STAGING_AREA_CLIENT_ID"] = $2517e7f57717d029$export$ee04bc09e7068b43;
module.exports["JSM_KB_CARD_CLIENT_ID"] = $2517e7f57717d029$export$c608186adcac93ad;

});

parcelRegister("ajfvU", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing chat-store actions gate feature behavior from runtime flags. */ 
var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $cbc8g = parcelRequire("cbc8g");


var $6FQwA = parcelRequire("6FQwA");


var $1oCLl = parcelRequire("1oCLl");


var $4pEXC = parcelRequire("4pEXC");


var $16lEl = parcelRequire("16lEl");


var $1yaYZ = parcelRequire("1yaYZ");


var $8IKbl = parcelRequire("8IKbl");


var $5MO1q = parcelRequire("5MO1q");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $99vXA = parcelRequire("99vXA");


var $2CHXX = parcelRequire("2CHXX");




const $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0 = (agentId)=>{
    if (!agentId) return undefined;
    return {
        agent_id: agentId,
        agent_named_id: agentId,
        agent_name: '',
        creator_type: ''
    };
};
const $ce0ec8f0bfa0c691$export$9e56ee965c896858 = ({ conversation: conversation, fallbackAgentId: fallbackAgentId })=>{
    const storedConversationAgentId = conversation?.agent?.agent_id || undefined;
    return storedConversationAgentId && (0, $dh538.fg)('rovo_chat_agent_selection') ? storedConversationAgentId : fallbackAgentId;
};



var $bPHr8 = parcelRequire("bPHr8");


var $40OEo = parcelRequire("40OEo");


var $G375e = parcelRequire("G375e");


var $cBi7Q = parcelRequire("cBi7Q");


var $1n44H = parcelRequire("1n44H");


var $7UNrw = parcelRequire("7UNrw");

const $a37fef51f047b95d$export$bac56f3fc527f04b = (min, max)=>{
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
};





const $e81fd5fde2bdb998$export$c9b02612b90eeb6c = (agentId)=>{
    if (!agentId) return false;
    return agentId !== (0, $cBi7Q.DEFAULT_AGENT_NAMED_ID) && agentId !== (0, $cBi7Q.DEFAULT_AGENT_UUID);
};


const $7d5fb3e4ab5c45a6$var$MCP_TOOL_SOURCE = 'MCP_TOOL';
const $7d5fb3e4ab5c45a6$export$af4bad69aa3a06c5 = ({ toolDefinitionSource: toolDefinitionSource, key: key })=>toolDefinitionSource === $7d5fb3e4ab5c45a6$var$MCP_TOOL_SOURCE ? undefined : key;


const $af163ae683530e0f$var$UNKNOWN_TOOL_ID = 'UNKNOWN_TOOL_ID';
const $af163ae683530e0f$var$buildBaseToolAttribute = ({ toolId: toolId, toolKey: toolKey, toolDefinitionSource: toolDefinitionSource })=>({
        toolId: toolId ?? $af163ae683530e0f$var$UNKNOWN_TOOL_ID,
        toolKey: (0, $7d5fb3e4ab5c45a6$export$af4bad69aa3a06c5)({
            toolDefinitionSource: toolDefinitionSource,
            key: toolKey
        }),
        toolDefinitionSource: toolDefinitionSource ?? null
    });
const $af163ae683530e0f$export$376e622a1b976e6e = (confirmedTools)=>confirmedTools.tools.map((tool)=>({
            ...$af163ae683530e0f$var$buildBaseToolAttribute({
                toolId: tool.tool_id,
                toolKey: tool.key,
                toolDefinitionSource: tool.tool_source
            }),
            resolutionType: tool.resolution?.type ?? 'UNKNOWN_RESOLUTION_TYPE'
        }));






const $9963cc910aac4af3$export$1afac255ab1e880e = ()=>{
    const lastMessageSentAt = localStorage.getItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT));
    if (!lastMessageSentAt) return null;
    const timestamp = parseInt(lastMessageSentAt);
    if (isNaN(timestamp)) return null;
    return timestamp;
};
const $9963cc910aac4af3$export$589976df4d188aac = (timestamp)=>{
    if (timestamp === null) {
        localStorage.removeItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT));
        return;
    }
    localStorage.setItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT), timestamp.toString());
};



var $9TBZq = parcelRequire("9TBZq");


var $3HubT = parcelRequire("3HubT");

class $0244aa38c72c69e0$export$cdcaebd3b25a3ac3 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            traceId: params.traceId ?? `NoFinalResponse-${(0, $3HubT.generateTraceId)()}`
        };
    }
}



var $eu7N9 = parcelRequire("eu7N9");


var $jJK7o = parcelRequire("jJK7o");

const $4bca5e7215eb7baa$export$89a4ab1dea43d7ee = ({ conversationId: conversationId, taskMessage: taskMessage, messageId: messageId, target: target })=>{
    const executionSegments = (0, $jJK7o.parseExecutionSegments)(taskMessage.execution_segments);
    switch(taskMessage.status){
        case 'DRAFT':
            target.createTaskFromStream({
                conversationId: conversationId,
                taskId: taskMessage.task_id,
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'COMPLETED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Completed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                seekingCompletedAck: true,
                completionMessageId: taskMessage.completion_message_id ?? messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'FAILED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Failed',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'CANCELLED':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Cancelled',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'RUNNING':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'Running',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        case 'AWAITING_ACTION_CONFIRMATION':
            target.setTaskProgressState({
                conversationId: conversationId,
                progressState: 'AwaitingActionConfirmation',
                title: taskMessage.title,
                updatedAt: taskMessage.updated_at,
                messageId: messageId,
                currentMessageId: taskMessage.current_message_id,
                createdAt: taskMessage.created_at,
                startedAt: taskMessage.started_at,
                completedAt: taskMessage.completed_at,
                executionSegments: executionSegments
            });
            break;
        default:
            break;
    }
};
const $4bca5e7215eb7baa$export$6b58e85d865a8eef = (unifiedTasksActions)=>({
        createTaskFromStream: (args)=>unifiedTasksActions.createTaskFromStream(args),
        setTaskProgressState: (args)=>unifiedTasksActions.setTaskProgressState(args)
    });



var $9likX = parcelRequire("9likX");










const $90c63f46323387a6$export$60a662127f30e1e1 = (remoteConversation, localConversation)=>{
    return {
        id: remoteConversation.id,
        // Prioritize API data if present, otherwise use local or generate new
        name: remoteConversation.name ?? localConversation?.name ?? (0, $99vXA.generateConversationName)(),
        timeCreated: remoteConversation.time_created ?? localConversation?.timeCreated,
        lastMessage: remoteConversation.last_message ?? localConversation?.lastMessage ?? undefined,
        lastMessageType: remoteConversation.last_message_type ?? localConversation?.lastMessageType ?? [],
        lastMessageTimestamp: remoteConversation.last_message_timestamp ?? localConversation?.lastMessageTimestamp,
        lastAgentMessageStatus: remoteConversation.last_agent_message_status ?? localConversation?.lastAgentMessageStatus,
        readStatus: remoteConversation.readStatus ?? localConversation?.readStatus,
        isPinned: remoteConversation.isPinned ?? localConversation?.isPinned,
        pinnedAt: remoteConversation.pinnedAt ?? localConversation?.pinnedAt,
        tags: remoteConversation.tags ?? localConversation?.tags,
        // Use local state data if it exists (messages, status are maintained locally)
        messages: localConversation?.messages ?? [],
        status: localConversation?.status ?? (0, $bPHr8.CHAT_STORE_STATUS).idle,
        traces: localConversation?.traces ?? [],
        ...localConversation?.sourceAgentId ? {
            sourceAgentId: localConversation.sourceAgentId
        } : {},
        ...localConversation?.sourceId ? {
            sourceId: localConversation.sourceId
        } : {},
        // Preserve runtime abort controller so Stop button works after channels rehydration (e.g. refocus)
        ...localConversation?.storeAbortController != null ? {
            storeAbortController: localConversation.storeAbortController
        } : {},
        ...localConversation?.rovoSpaceId ? {
            rovoSpaceId: localConversation.rovoSpaceId
        } : {},
        // `agent` is optional on ConversationChannel, so the server-sourced channel can
        // omit it. Under rovo_chat_agent_selection the header derives its displayed
        // agent (name/avatar) ONLY from `conversation.agent`, so taking the remote
        // agent verbatim would overwrite a locally-seeded agent with `undefined` and
        // drop a specialist back to default Rovo (e.g. opening an existing chat with a
        // specific agent via URL params, then a channel rehydration on init/refocus).
        // Gate-on therefore falls back to the locally-seeded agent when the remote has
        // none; gate-off keeps the master baseline of taking the remote agent verbatim.
        // Cleanup: drop the gate when launched.
        agent: (0, $dh538.fg)('rovo_chat_agent_selection') ? remoteConversation.agent ?? localConversation?.agent : remoteConversation.agent,
        scopes: remoteConversation.scopes ?? localConversation?.scopes
    };
};









var $deF0K = parcelRequire("deF0K");


var $3vCSA = parcelRequire("3vCSA");











var $28y4B = parcelRequire("28y4B");


var $dqGqE = parcelRequire("dqGqE");

const $35034bc3bb470a3a$export$3ba003c3111d103f = ()=>{
    const subExperienceCollect = (0, $28y4B.collectAllWithSubExperienceAttributes)([
        (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER
    ]);
    return (events, experience)=>{
        // these experiences only run if the user chooses to open the preview while streaming is in progress. if they fail, bubble it up, but we dont rely on them for success/abort, because they may not even start
        (0, $dqGqE.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED, experience, events);
        (0, $dqGqE.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).PREVIEW_CONTENT, experience, events);
        subExperienceCollect(events, experience);
    };
};









var $4eSde = parcelRequire("4eSde");

const $bdb6804a1ebe4c48$export$95d2102da86339f1 = ({ experienceTracker: experienceTracker, conversationId: conversationId, rootExperienceName: rootExperienceName, commonExperienceAttributes: commonExperienceAttributes })=>{
    experienceTracker.start({
        name: rootExperienceName,
        id: conversationId,
        collect: (0, $4eSde.createAifcExperienceCollect)(),
        attributes: commonExperienceAttributes
    });
    // Start AIFC_ALL_DATA_HANDLED - this replaces all explicit AIFC_UPDATE_CONTENT succeed/fail/abort calls
    // Product AIFC integration is responsible for succeeding this experience.
    experienceTracker.start({
        name: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    experienceTracker.start({
        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        id: conversationId,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
    if ((0, $dh538.fg)('aifc-experience-timeout')) experienceTracker.start({
        name: (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        id: `${conversationId}-initial`,
        attributes: {
            ...commonExperienceAttributes,
            parentExperienceId: rootExperienceName
        }
    });
};



var $cteoa = parcelRequire("cteoa");

const $aa1291e40260ba05$export$baa645f348bcec07 = ({ streamMessage: streamMessage, conversationId: conversationId, tmpAssistantMessageId: tmpAssistantMessageId, traceId: traceId, productKey: productKey, deepResearchEnabled: deepResearchEnabled, storeUserMessages: storeUserMessages, streamActionInfo: streamActionInfo, trackingAttributes: trackingAttributes, experienceTracker: experienceTracker, chatContextStoreActions: chatContextStoreActions, getMessages: getMessages, setMessages: setMessages, sendAnalyticsEvent: sendAnalyticsEvent, getIsChatMounted: getIsChatMounted, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, promptStreamHook: promptStreamHook, openChat: openChat, messageSources: messageSources, creationContextParams: creationContextParams, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart })=>{
    let hasReceivedActionClassification = false;
    let hasReceivedActionComplete = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let commonExperienceAttributes = {
        llmDebugLogsEnabled: storeUserMessages
    };
    if ((0, $ljUdP.isStreamActionClassification)(streamMessage)) {
        promptStreamHook?.onActionClassification?.(streamMessage, tmpAssistantMessageId, conversationId);
        const actionKey = streamMessage.message.action_key;
        hasReceivedActionClassification = true;
        const actualContentType = (0, $deF0K.getAIFCContentType)({
            key: actionKey
        });
        commonExperienceAttributes = {
            ...commonExperienceAttributes,
            actionKey: actionKey,
            contentType: actualContentType,
            isStagingArea: chatContextStoreActions.getIsStagingArea(),
            humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
            product: productKey
        };
        if (trackingAttributes.forcedContentType) sendAnalyticsEvent({
            eventType: 'track',
            action: 'compared',
            actionSubject: 'forcedContentType',
            actionSubjectId: 'contentTypeMatch',
            attributes: {
                forcedContentType: trackingAttributes.forcedContentType,
                actualContentType: actualContentType,
                matched: actualContentType.endsWith(`-${trackingAttributes.forcedContentType}`),
                actionKey: actionKey
            }
        });
        const isUpdateAction = (0, $deF0K.isUpdatableAction)({
            key: actionKey
        });
        if (isUpdateAction && (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1)) {
            const rootExperienceName = commonExperienceAttributes.isStagingArea ? (0, $16lEl.ExperienceName).AIFC_UPDATE_CONTENT : (0, $16lEl.ExperienceName).UPDATE_CONTENT_IN_CHAT;
            (0, $bdb6804a1ebe4c48$export$95d2102da86339f1)({
                experienceTracker: experienceTracker,
                conversationId: conversationId,
                rootExperienceName: rootExperienceName,
                commonExperienceAttributes: commonExperienceAttributes
            });
        }
        const isCreateAction = (0, $deF0K.isCreatableAction)({
            key: actionKey
        });
        if (isCreateAction) {
            // initial prompt from staging area has its own AIFC_GENERATE_CONTENT experience - dont start this one
            if (!commonExperienceAttributes.isStagingArea || commonExperienceAttributes.humanMessageCount > 1) {
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
                    id: conversationId,
                    collect: (0, $35034bc3bb470a3a$export$3ba003c3111d103f)(),
                    attributes: commonExperienceAttributes
                });
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                    id: conversationId,
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                    }
                });
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER,
                    id: conversationId,
                    timeout: deepResearchEnabled ? undefined : 60000,
                    // 60 second timeout
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                    }
                });
                // Product AIFC integration is responsible for succeeding this experience.
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
                    id: conversationId,
                    attributes: {
                        ...commonExperienceAttributes,
                        parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                    }
                });
            } else {
                // update AIFC_GENERATE_CONTENT now that intent detection is complete. This experience starts as the user sends the message on the initial prompt screen
                experienceTracker.updateAttributes({
                    name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                    attributes: commonExperienceAttributes
                });
                experienceTracker.updateAttributes({
                    name: (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                    attributes: commonExperienceAttributes
                });
            }
        }
    }
    if (((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) && (0, $dh538.fg)('aifc_create_enabled')) {
        // Update action tracking info
        if (!streamActionInfo.isAction) {
            streamActionInfo.isAction = true;
            streamActionInfo.actionKey = streamMessage.message.key;
        }
        // track attribute for action prepare
        if ((0, $ljUdP.isStreamActionPrepare)(streamMessage) && (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            const actionData = streamMessage.message.data;
            experienceTracker.updateAttributes({
                name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                attributes: {
                    dynamicUiSubtype: actionData?.dynamicUiSubtype
                }
            });
            // Remix flows skip ACTION_CLASSIFICATION and go straight to ACTION_PREPARE,
            // so we start PREVIEW_CARD_RENDER here for remix flows.
            // Only start when rovo chat is mounted/visible to the user.
            if (getIsChatMounted?.() && (0, $3vCSA.isRemixGeneratedFlow)({
                key: streamMessage.message.key,
                data: streamMessage.message.data
            })) {
                const remixActionKey = streamMessage.message.key;
                const actualContentType = (0, $deF0K.getAIFCContentType)({
                    key: remixActionKey
                });
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER,
                    id: conversationId,
                    timeout: 60000,
                    attributes: {
                        ...commonExperienceAttributes,
                        actionKey: remixActionKey,
                        contentType: actualContentType,
                        isStagingArea: chatContextStoreActions.getIsStagingArea(),
                        humanMessageCount: getMessages(conversationId).filter((m)=>m.type === 'HUMAN').length,
                        product: productKey,
                        featureArea: 'remix',
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        remixType: (0, $3vCSA.getDynamicUiType)(streamMessage.message)
                    }
                });
            }
        }
        if ((0, $ljUdP.isStreamActionPart)(streamMessage)) {
            const actionData = streamMessage.message.data;
            stopInteractionMetricsTimeToFirstActionPart('stop', {
                actionType: 'action-part',
                conversationId: conversationId,
                actionPartKey: (0, $cteoa.getActionPartKeyForMetrics)(streamMessage.message.key, creationContextParams?.source, actionData?.dynamicUiSubtype),
                interactionSource: messageSources?.interactionSource,
                remixType: creationContextParams?.dynamicUiType
            });
        }
        if ((0, $dh538.fg)('aifc_set_accumulated_data_on_message')) {
            const actionKey = streamMessage.message.key;
            const lastAction = (0, $cteoa.findLastAssistantAction)(getMessages(conversationId), (action)=>action.key === actionKey);
            if (lastAction && (0, $3vCSA.isAccumulatedAction)(actionKey)) {
                const isAccumulatedActionType = (0, $3vCSA.getAccumulatedActionTypeGuard)(actionKey);
                if (isAccumulatedActionType(streamMessage.message.data)) {
                    const primaryAccumulatedData = (0, $3vCSA.getPrimaryAccumulatedValue)(lastAction);
                    if (primaryAccumulatedData?.value) streamMessage.message.data.previousAccumulatedData = primaryAccumulatedData.value;
                }
            }
        }
        processMessageStreamAction?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, undefined, {
            singleInstrumentationId: trackingAttributes.instrumentationId
        }, agentId ? {
            id: agentId,
            name: agentName ?? '',
            identityAccountId: agentIdentityAccountId ?? null
        } : undefined);
        promptStreamHook?.onActionPart?.(streamMessage, tmpAssistantMessageId, conversationId, openChat);
        const updatedMessages = (0, $cteoa.addActionPart)({
            chat: getMessages(conversationId),
            messageId: tmpAssistantMessageId,
            actionPart: streamMessage,
            ...(0, $dh538.fg)('aifc_set_accumulated_data_on_message') ? {
                actionUpdaterOverride: (0, $3vCSA.customActionUpdater)
            } : {}
        });
        if ((0, $ljUdP.isStreamActionPrepare)(streamMessage)) {
            const actionMessage = streamMessage.message;
            // Abort the remix-edit-existing UFO experience if the streamed action is not remix.
            if (!(0, $3vCSA.isRemixGeneratedFlow)(actionMessage)) (0, $16lEl.remixEditExistingExperience).abort({
                metadata: {
                    reason: 'non-remix-action'
                }
            });
            setMessages(conversationId, [
                ...updatedMessages,
                {
                    type: 'ACTION_PREPARE',
                    action: actionMessage
                }
            ]);
        } else setMessages(conversationId, updatedMessages);
    }
    const isAIFCEnabled = (0, $dh538.fg)('aifc_create_enabled');
    const canHandleStreamActionClassification = (0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics');
    if ((0, $ljUdP.isStreamActionClassification)(streamMessage) && isAIFCEnabled && canHandleStreamActionClassification && streamMessage.message.metadata) // Send ACTION_CLASSIFICATION metadata to the Editor Rovo bridge
    processMessageStreamActionClassification?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, {
        singleInstrumentationId: trackingAttributes.instrumentationId
    });
    if ((0, $ljUdP.isStreamActionComplete)(streamMessage) && (0, $dh538.fg)('aifc_create_enabled')) {
        hasReceivedActionComplete = true;
        processMessageStreamComplete?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, {
            singleInstrumentationId: trackingAttributes.instrumentationId
        });
        const actionMessage = streamMessage.message;
        setMessages(conversationId, [
            ...getMessages(conversationId),
            {
                type: 'ACTION_COMPLETE',
                action: actionMessage
            }
        ]);
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).AIFC_MESSAGE
        });
    }
    return {
        hasReceivedActionClassification: hasReceivedActionClassification,
        hasReceivedActionComplete: hasReceivedActionComplete
    };
};


/* eslint-disable @atlaskit/platform/no-preconditioning, @atlaskit/platform/one-value-export-per-file -- no-preconditioning: Existing stream processing gates feature behavior from runtime flags. one-value-export-per-file: This file predates the rule and splitting is out of bounds for this change. */ 



var $5vtU3 = parcelRequire("5vtU3");














var $kyiqo = parcelRequire("kyiqo");

const $6d2a116062e20cc1$export$72bdd99dfc759d06 = (baseName, { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isRovoCustomAgent: isRovoCustomAgent })=>{
    if (isRovoCustomAgent) return `${baseName}.rovo-custom-agent`;
    if (deepResearchEnabled) return `${baseName}.deep-research`;
    if (thinkDeeperEnabled) return `${baseName}.think-deeper`;
    return baseName;
};


// Reconnection metrics
const $11331e08595d7087$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY = 'ai-mate.reconnect.time-to-connect-to-stream';
const $11331e08595d7087$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY = 'ai-mate.reconnect.time-to-first-chunk-received';
const $11331e08595d7087$export$924cdb4a6542ccd = {
    createTimeToConnectToStreamMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: (0, $6d2a116062e20cc1$export$72bdd99dfc759d06)($11331e08595d7087$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY, params)
        });
    },
    createTimeToResumeStreamMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: (0, $6d2a116062e20cc1$export$72bdd99dfc759d06)($11331e08595d7087$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY, params)
        });
    }
};








var $5yETg = parcelRequire("5yETg");




const $452e4ba611b5dc40$export$6f349e5fd508c97f = (onMergedEvent)=>{
    const buffers = new Map();
    const bufferEvent = (event)=>{
        const stepId = event.message.stepId;
        if (!stepId) return false;
        const existing = buffers.get(stepId);
        if (existing) {
            existing.chunks.push(event.message.content);
            existing.lastEvent = event;
        } else buffers.set(stepId, {
            chunks: [
                event.message.content
            ],
            lastEvent: event
        });
        return true;
    };
    const flush = ()=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [, { chunks: chunks, lastEvent: lastEvent }] of entries)onMergedEvent({
            ...lastEvent,
            message: {
                ...lastEvent.message,
                content: chunks.join('')
            }
        });
    };
    const flushFiltered = (predicate)=>{
        if (buffers.size === 0) return;
        // Snapshot + clear before invoking the callback so re-entrant flushes are safe.
        const entries = Array.from(buffers.entries());
        buffers.clear();
        for (const [stepId, { chunks: chunks, lastEvent: lastEvent }] of entries){
            if (!predicate(stepId)) continue;
            onMergedEvent({
                ...lastEvent,
                message: {
                    ...lastEvent.message,
                    content: chunks.join('')
                }
            });
        }
    };
    return {
        bufferEvent: bufferEvent,
        flush: flush,
        flushFiltered: flushFiltered,
        size: ()=>buffers.size
    };
};









var $fFa3V = parcelRequire("fFa3V");

/**
 * Abort-aware sleep that resolves after `ms` or rejects early if the signal is aborted.
 * Falls back to a regular setTimeout when no signal is provided.
 */ const $92b0a6aa5f3cefb4$var$abortableSleep = (ms, signal)=>new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        let cleanup = ()=>{};
        const timer = setTimeout(()=>{
            cleanup();
            resolve();
        }, ms);
        if (signal) {
            const onAbort = ()=>{
                clearTimeout(timer);
                cleanup();
                reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            };
            cleanup = (0, $fFa3V.bind)(signal, {
                type: 'abort',
                listener: onAbort,
                options: {
                    once: true
                }
            });
        }
    });
/**
 * Resolves when the browser reports it is online.
 * Returns immediately if already online, otherwise waits for the 'online' event.
 * Rejects if the signal is aborted while waiting.
 * @returns true if it had to wait for the 'online' event, false if already online.
 * Useful to distinguish between "was offline and recovered" vs "was already online".
 */ const $92b0a6aa5f3cefb4$var$waitForOnline = (signal)=>{
    if (typeof navigator === 'undefined' || navigator.onLine) return Promise.resolve(false);
    return new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        const onOnline = ()=>{
            cleanup();
            resolve(true);
        };
        const onAbort = ()=>{
            cleanup();
            reject(signal?.reason ?? new DOMException('Aborted', 'AbortError'));
        };
        const unbindOnline = (0, $fFa3V.bind)(window, {
            type: 'online',
            listener: onOnline,
            options: {
                once: true
            }
        });
        const unbindAbort = signal ? (0, $fFa3V.bind)(signal, {
            type: 'abort',
            listener: onAbort,
            options: {
                once: true
            }
        }) : ()=>{};
        const cleanup = ()=>{
            unbindOnline();
            unbindAbort();
        };
    });
};
const $92b0a6aa5f3cefb4$export$4dfcad98182a1ece = async ({ fn: fn, maxRetries: maxRetries = 3, retryCount: retryCount = 0, delay: delay = 1000, jitter: jitter = false, minDelay: minDelay = 500, pauseWhileOffline: pauseWhileOffline = false, postOnlineDelay: postOnlineDelay = 0, errorFilter: errorFilter, signal: signal, onRetry: onRetry })=>{
    // Mutable counter shared across recursive calls so that resetRetries() can
    // reset it from within fn() without needing to re-enter the call stack.
    const counter = {
        retryCount: retryCount,
        delay: delay
    };
    const resetRetries = ()=>{
        counter.retryCount = 0;
        counter.delay = delay;
    };
    const attempt = async ()=>{
        try {
            return await fn(resetRetries);
        } catch (error) {
            if (errorFilter && !errorFilter(error)) throw error;
            if (counter.retryCount >= maxRetries) throw error;
            onRetry?.(counter.retryCount + 1, error);
            if (pauseWhileOffline) {
                const recoveredFromOffline = await $92b0a6aa5f3cefb4$var$waitForOnline(signal);
                if (recoveredFromOffline && postOnlineDelay > 0) await $92b0a6aa5f3cefb4$var$abortableSleep(postOnlineDelay, signal);
            }
            const effectiveDelay = typeof jitter === 'number' ? counter.delay + Math.random() * jitter : jitter ? Math.max(minDelay, Math.random() * counter.delay) : counter.delay;
            await $92b0a6aa5f3cefb4$var$abortableSleep(effectiveDelay, signal);
            counter.delay *= 2;
            counter.retryCount += 1;
            return attempt();
        }
    };
    return attempt();
};






const $be423051027308ae$var$MAX_RECONNECT_ATTEMPTS = 5;
const $be423051027308ae$var$RETRY_BASE_DELAY_MS = 1000;
const $be423051027308ae$var$RECONNECT_JITTER_MS = 500;
const $be423051027308ae$var$POST_ONLINE_DELAY_MS = 2000;
const $be423051027308ae$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
async function* $be423051027308ae$export$a802bb7fa59dba39({ initialGenerator: initialGenerator, canReconnect: canReconnect, getReconnectGenerator: getReconnectGenerator, getEventId: getEventId, onBeforeFirstReconnect: onBeforeFirstReconnect, onReconnecting: onReconnecting, onReconnected: onReconnected, onFirstChunkAfterReconnect: onFirstChunkAfterReconnect, onStreamCompleted: onStreamCompleted, onStreamFailed: onStreamFailed, signal: signal, maxAttempts: maxAttempts = $be423051027308ae$var$MAX_RECONNECT_ATTEMPTS, shouldContinueRetrying: shouldContinueRetrying }) {
    let currentGenerator = initialGenerator;
    let lastEventId;
    let reconnectCount = 0;
    let reconnectionAttempted = false;
    let awaitingFirstChunkAfterReconnect = false;
    while(true)try {
        for await (const chunk of currentGenerator){
            if (signal?.aborted) return;
            const eventId = getEventId(chunk);
            if (eventId) lastEventId = eventId;
            if (awaitingFirstChunkAfterReconnect) {
                awaitingFirstChunkAfterReconnect = false;
                onFirstChunkAfterReconnect?.();
            }
            yield chunk;
        }
        if (reconnectionAttempted) onStreamCompleted?.();
        return;
    } catch (error) {
        if (error instanceof (0, $eu7N9.StreamErrorException)) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (!(0, $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8)(error) || !canReconnect() || reconnectCount >= maxAttempts || signal?.aborted) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (shouldContinueRetrying && !shouldContinueRetrying()) {
            if (reconnectionAttempted) onStreamFailed?.(error);
            throw error;
        }
        if (!reconnectionAttempted) {
            onBeforeFirstReconnect?.();
            reconnectionAttempted = true;
        }
        reconnectCount++;
        onReconnecting?.(reconnectCount, maxAttempts, lastEventId);
        currentGenerator = await (0, $92b0a6aa5f3cefb4$export$4dfcad98182a1ece)({
            fn: async ()=>getReconnectGenerator(lastEventId),
            maxRetries: 2,
            delay: $be423051027308ae$var$RETRY_BASE_DELAY_MS,
            jitter: $be423051027308ae$var$RECONNECT_JITTER_MS,
            pauseWhileOffline: true,
            postOnlineDelay: $be423051027308ae$var$POST_ONLINE_DELAY_MS,
            errorFilter: (0, $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8),
            signal: signal
        });
        onReconnected?.();
        awaitingFirstChunkAfterReconnect = true;
    }
}
function $be423051027308ae$export$29bad1ab941da7cb({ generator: generator, conversationId: conversationId, abortController: abortController, assistanceService: assistanceService, sendAnalyticsEvent: sendAnalyticsEvent, experienceTracker: experienceTracker, getMessageId: getMessageId, canReconnect: canReconnect, updateCurrentConversation: updateCurrentConversation, getIsChatMounted: getIsChatMounted, analyticsAttributes: analyticsAttributes, onBeforeFirstReconnect: callerOnBeforeFirstReconnect, onReconnecting: callerOnReconnecting, onReconnected: callerOnReconnected, onFirstChunkAfterReconnect: callerOnFirstChunkAfterReconnect }) {
    let totalAttempts = 0;
    let perfMetrics;
    return $be423051027308ae$export$a802bb7fa59dba39({
        initialGenerator: generator,
        canReconnect: ()=>!!getMessageId() && canReconnect(),
        getReconnectGenerator: (lastEventId)=>{
            const messageId = getMessageId();
            if (!messageId) return Promise.reject(new Error('Cannot reconnect: messageId is not available'));
            return assistanceService.reconnectToMessageStream({
                conversationId: conversationId,
                messageId: messageId,
                lastEventId: lastEventId,
                controller: abortController
            }).then((r)=>r.generator);
        },
        getEventId: (chunk)=>(0, $ljUdP.isSSEMessage)(chunk) && chunk.id ? chunk.id : undefined,
        onBeforeFirstReconnect: ()=>{
            perfMetrics = (0, $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98)({
                isDeepResearchEnabled: analyticsAttributes?.isDeepResearch,
                thinkDeeperEnabled: analyticsAttributes?.thinkDeeperEnabled,
                fastModeEnabled: analyticsAttributes?.fastModeEnabled
            });
            perfMetrics.timeToConnectToStreamMetrics.start();
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                id: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: {
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
            callerOnBeforeFirstReconnect?.();
        },
        onReconnecting: (attempt, maxAttempts, lastEventId)=>{
            totalAttempts = attempt;
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'retrying',
                actionSubject: 'rovoChatReconnection',
                attributes: {
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    attempt: attempt,
                    maxAttempts: maxAttempts,
                    hasLastEventId: !!lastEventId,
                    ...analyticsAttributes
                }
            });
            updateCurrentConversation({
                traces: [
                    {
                        messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                        status: 'loading'
                    }
                ]
            });
            callerOnReconnecting?.(attempt, maxAttempts);
        },
        onReconnected: ()=>{
            perfMetrics?.timeToConnectToStreamMetrics.stop();
            perfMetrics?.timeToResumeStreamMetrics.start();
            callerOnReconnected?.();
        },
        onFirstChunkAfterReconnect: ()=>{
            perfMetrics?.timeToResumeStreamMetrics.stop();
            callerOnFirstChunkAfterReconnect?.();
        },
        onStreamCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                attributes: {
                    totalAttempts: totalAttempts,
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
        },
        onStreamFailed: (error)=>{
            perfMetrics?.timeToConnectToStreamMetrics.cancel();
            perfMetrics?.timeToResumeStreamMetrics.cancel();
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                reason: 'Aborted'
            });
            else experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                error: error instanceof Error ? error : new Error(String(error)),
                attributes: {
                    totalAttempts: totalAttempts,
                    conversationId: conversationId,
                    messageId: getMessageId(),
                    ...analyticsAttributes
                }
            });
        },
        shouldContinueRetrying: getIsChatMounted ? ()=>{
            if (!getIsChatMounted()) {
                abortController.abort($be423051027308ae$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                return false;
            }
            return true;
        } : undefined,
        signal: abortController.signal
    });
}





function $f0fdaf1fd06efef8$export$76ef465f684cfb18({ conversationId: conversationId, reconnectTimestamp: reconnectTimestamp, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, updateCurrentConversation: updateCurrentConversation, onFlush: onFlush }) {
    // Lazily initialised on first setMessages write — avoids copying the full
    // messages array upfront when multiple tabs reconnect simultaneously.
    // replayBuffering=true + replayBuffer=null → buffering, no write yet
    // replayBuffering=false + replayBuffer=null → flushed
    let replayBuffer = null;
    let replayBuffering = true;
    // Pre-seeded with { traces: [] } so flush always clears "Resuming response..."
    // even if no clearTracesIfNotEmpty call fires during replay.
    // null means flushed.
    let conversationPatch = {
        traces: []
    };
    // null means flushed.
    let researchQueue = [];
    // Per-step tracking for reconnect replay. Keyed by stepId.
    // stepTitleEvents: first STEP_TITLE seen (provides title + roundId).
    // stepCompletedEvents: last STEP_COMPLETED seen (marks step done).
    // Used by getCollapsedStepEvents() and getCompletedStepIds().
    const stepTitleEvents = new Map();
    const stepCompletedEvents = new Map();
    const trackStepEvent = (params)=>{
        const msg = params.streamMessage;
        if ((0, $ljUdP.isStreamResearchStepTitle)(msg) || (0, $ljUdP.isStreamResearchStepTitleShort)(msg)) {
            if (!stepTitleEvents.has(msg.message.stepId)) stepTitleEvents.set(msg.message.stepId, params);
        } else if ((0, $ljUdP.isStreamResearchStepCompleted)(msg)) stepCompletedEvents.set(msg.message.stepId, params);
    };
    const getCollapsedStepEvents = ()=>{
        const result = [];
        const allStepIds = new Set([
            ...Array.from(stepTitleEvents.keys()),
            ...Array.from(stepCompletedEvents.keys())
        ]);
        allStepIds.forEach((stepId)=>{
            const titleEvent = stepTitleEvents.get(stepId);
            const completedEvent = stepCompletedEvents.get(stepId);
            if (titleEvent) result.push(titleEvent);
            if (completedEvent) result.push(completedEvent);
        });
        return result;
    };
    const isBuffering = ()=>replayBuffering;
    const parseEventTime = (id)=>Number(id.split('-')[0]);
    const flush = ()=>{
        if (!isBuffering()) return;
        const buffered = replayBuffer;
        const patch = conversationPatch;
        const queued = researchQueue;
        // Mark flushed before dispatching so re-entrant calls go live.
        replayBuffering = false;
        replayBuffer = null;
        conversationPatch = null;
        researchQueue = null;
        if (buffered !== null) setMessages(conversationId, buffered);
        if (patch !== null) updateCurrentConversation(patch);
        // onFlush runs BEFORE the queued research dispatch so caller-side
        // buffers (e.g. reasoning chunks) populate step content first; the
        // collapse signals (ANSWER_PART, FINAL_RESPONSE) then fire on
        // already-populated steps, matching the source event order.
        onFlush?.();
        // react-sweet-state setState is synchronous — the research store reaches
        // its final state before React re-renders, giving one render with
        // researchCompleted=true and skipping intermediate spinner states.
        queued.forEach((params)=>processStreamResearch(params));
    };
    const batchedSetMessages = (convId, msgs)=>{
        if (replayBuffering && convId === conversationId) {
            replayBuffer = msgs;
            return;
        }
        setMessages(convId, msgs);
    };
    const batchedGetMessages = (convId)=>{
        if (replayBuffering && convId === conversationId) // Fall through to real store if no write has arrived yet.
        return replayBuffer ?? getMessages(convId);
        return getMessages(convId);
    };
    const batchedUpdateCurrentConversation = (patch)=>{
        if (conversationPatch !== null) {
            conversationPatch = {
                ...conversationPatch,
                ...patch
            };
            return;
        }
        updateCurrentConversation(patch);
    };
    const batchedProcessStreamResearch = (params)=>{
        if (researchQueue !== null) {
            if ((0, $ljUdP.isStreamResponse)(params.streamMessage)) {
                // Preserve ANSWER_PART if already queued so both hasReceivedAnswerPart
                // and researchCompleted are set at flush.
                const hasAnswerPart = researchQueue.some((p)=>(0, $ljUdP.isStreamAnswerPart)(p.streamMessage));
                researchQueue = hasAnswerPart ? [
                    ...researchQueue,
                    params
                ] : [
                    params
                ];
                return;
            }
            if ((0, $ljUdP.isStreamAnswerPart)(params.streamMessage)) {
                // Collapse to [STEP_TITLE, STEP_COMPLETED per step, ANSWER_PART] so
                // past rounds have steps in the store after flush — prevents "Rovo is
                // thinking" for completed rounds during mid-stream reload.
                researchQueue = [
                    ...getCollapsedStepEvents(),
                    params
                ];
                return;
            }
            trackStepEvent(params);
            researchQueue.push(params);
            return;
        }
        processStreamResearch(params);
    };
    async function* replayFlushGenerator(source) {
        let replayEventCount = 0;
        for await (const chunk of source){
            if (isBuffering() && chunk.id) {
                const eventTime = parseEventTime(chunk.id);
                if (!isNaN(eventTime) && eventTime >= reconnectTimestamp) flush();
            }
            // During replay, yield the event loop periodically to prevent the tab
            // from becoming unresponsive when processing large streams (e.g. 6K+ events).
            // This gives the browser a chance to handle user interactions and GC between batches.
            if (isBuffering()) {
                replayEventCount++;
                if (replayEventCount % 200 === 0) await new Promise((resolve)=>setTimeout(resolve, 0));
            }
            yield chunk;
        }
        // Stream ended while still in replay (response was complete on reconnect).
        flush();
    }
    return {
        wrapGenerator: replayFlushGenerator,
        batchedSetMessages: batchedSetMessages,
        batchedGetMessages: batchedGetMessages,
        batchedProcessStreamResearch: batchedProcessStreamResearch,
        batchedUpdateCurrentConversation: batchedUpdateCurrentConversation,
        getIsReplaying: isBuffering,
        getCompletedStepIds: ()=>new Set(stepCompletedEvents.keys())
    };
}


/* eslint-disable @atlaskit/platform/no-preconditioning -- Existing stream processing gates feature behavior from runtime flags. */ 
var $hTKp4 = parcelRequire("hTKp4");



































const $3e5408ba1f60d629$var$getSelectedAgentIdForSend = (inputSelectedAgentIds, allowSelectedAgentOverride = false)=>{
    const activeSelectedAgentDraftId = inputSelectedAgentIds?.at(-1)?.trim();
    if (activeSelectedAgentDraftId && allowSelectedAgentOverride && (0, $dh538.fg)('rovo_chat_agent_selection')) return activeSelectedAgentDraftId;
    return undefined;
};
const $3e5408ba1f60d629$export$4413981bab4da984 = ({ conversationAgent: conversationAgent, defaultAgent: defaultAgent, explicitAgentId: explicitAgentId, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields = false, inputSelectedAgentIds: inputSelectedAgentIds, allowSelectedAgentOverride: allowSelectedAgentOverride = false })=>{
    // rovo_chat_agent_selection cleanup: delete this gate-off branch when the flag
    // is removed. This branch keys off `explicitAgentId !== undefined` (matching the
    // pre-feature behavior, including empty/whitespace-only values), whereas the
    // gate-on path treats an empty explicit id as "no explicit agent".
    if (!(0, $dh538.fg)('rovo_chat_agent_selection') && explicitAgentId !== undefined) {
        const isExplicitDefaultAgent = explicitAgentId === defaultAgent.id;
        return {
            routedSelectedAgentId: undefined,
            routingAgentId: explicitAgentId,
            agentIdForRequest: isExplicitDefaultAgent ? undefined : explicitAgentId,
            agentNamedIdForRequest: isExplicitDefaultAgent ? undefined : conversationAgent.named_id
        };
    }
    const normalizedExplicitAgentId = explicitAgentId || undefined;
    const routedSelectedAgentId = normalizedExplicitAgentId ? undefined : $3e5408ba1f60d629$var$getSelectedAgentIdForSend(inputSelectedAgentIds, allowSelectedAgentOverride);
    const routingAgentId = normalizedExplicitAgentId ?? routedSelectedAgentId ?? conversationAgent.id;
    if (normalizedExplicitAgentId) {
        // Explicit caller-provided agent id wins so non-chat flows are not
        // regressed by stored selected-agent state. Preserve the conversation agent's
        // named id for callers that still rely on named-id semantics.
        // rovo_chat_agent_selection cleanup: keep default-agent collapse after the
        // flag is removed; it matches the pre-feature default-Rovo wire contract.
        const isExplicitDefaultAgent = normalizedExplicitAgentId === defaultAgent.id;
        return {
            routedSelectedAgentId: undefined,
            routingAgentId: routingAgentId,
            agentIdForRequest: isExplicitDefaultAgent ? undefined : normalizedExplicitAgentId,
            agentNamedIdForRequest: isExplicitDefaultAgent ? undefined : conversationAgent.named_id
        };
    }
    if (routedSelectedAgentId) {
        // Selected-agent override is sent for routing; if the user explicitly
        // selected default Rovo we omit request fields so the backend treats
        // it as a normal default Rovo send.
        const isSelectedDefaultAgent = routedSelectedAgentId === defaultAgent.id;
        return {
            routedSelectedAgentId: routedSelectedAgentId,
            routingAgentId: routingAgentId,
            agentIdForRequest: isSelectedDefaultAgent ? undefined : routedSelectedAgentId,
            agentNamedIdForRequest: isSelectedDefaultAgent ? undefined : routedSelectedAgentId
        };
    }
    // No override preserves the caller/conversation request identity. The
    // `omitConversationDefaultAgentRequestFields` option is compatibility for the main
    // conversation-assistant wire contract and should remain when the flag is removed.
    const shouldOmitConversationDefaultAgentRequestFields = omitConversationDefaultAgentRequestFields && conversationAgent.id === defaultAgent.id;
    return {
        routedSelectedAgentId: undefined,
        routingAgentId: routingAgentId,
        agentIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.id,
        agentNamedIdForRequest: shouldOmitConversationDefaultAgentRequestFields ? undefined : conversationAgent.named_id
    };
};






var $52Fo2 = parcelRequire("52Fo2");





const $0e7d0025813be8f5$var$SEND_MESSAGE_METRICS_KEY = 'ai-mate.send-message';
const $0e7d0025813be8f5$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY = 'ai-mate.time-to-first-answer-part';
const $0e7d0025813be8f5$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY = 'ai-mate.time-to-first-action-part';
const $0e7d0025813be8f5$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY = 'ai-mate.time-to-action-completion';
const $0e7d0025813be8f5$export$1e4d1659c4209dbf = {
    createSendMessageMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: (0, $6d2a116062e20cc1$export$72bdd99dfc759d06)($0e7d0025813be8f5$var$SEND_MESSAGE_METRICS_KEY, params)
        });
    },
    createTimeToFirstAnswerPartMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: (0, $6d2a116062e20cc1$export$72bdd99dfc759d06)($0e7d0025813be8f5$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY, params)
        });
    },
    createTimeToFirstActionPartMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: (0, $6d2a116062e20cc1$export$72bdd99dfc759d06)($0e7d0025813be8f5$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY, params)
        });
    },
    createTimeToActionCompletionMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: (0, $6d2a116062e20cc1$export$72bdd99dfc759d06)($0e7d0025813be8f5$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY, params)
        });
    }
};



var $gdLsu = parcelRequire("gdLsu");


var $cWLC4 = parcelRequire("cWLC4");


var $9lwku = parcelRequire("9lwku");


var $eSGKy = parcelRequire("eSGKy");


var $iX75u = parcelRequire("iX75u");


var $gFVEK = parcelRequire("gFVEK");


var $eku5V = parcelRequire("eku5V");

const $5dfb4fd04d2ab8e2$export$a100e5b47ee5ac9a = ()=>{
    const cur = (0, $gFVEK.readFromStorage)();
    if ((0, $eSGKy.isInCooldown)(cur)) return;
    if (cur.qualifyingConversations >= (0, $iX75u.MIN_QUALIFYING_CONVERSATIONS)) return;
    (0, $eku5V.writeToStorage)({
        ...cur,
        qualifyingConversations: cur.qualifyingConversations + 1
    });
};





var $1cjt9 = parcelRequire("1cjt9");


var $eWKku = parcelRequire("eWKku");








const $3a8fc1613a6284be$export$4841ee9a7190fdf6 = {
    createDeadAirIntervalMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.dead-air-interval'
        });
    },
    createDeadAirMaxMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.dead-air-max'
        });
    }
};



var $ceMRi = parcelRequire("ceMRi");

const $33eac1626c414e6d$export$4a48e8ee48123078 = (config)=>{
    let previousMessageTimestamp = performance.now();
    let previousMessageTemplate;
    let previousMessageType;
    let maxDeadAirMs = 0;
    let totalDeadAirMs = 0;
    let maxPreviousMessageTemplate;
    let maxCurrentMessageTemplate;
    let maxPreviousMessageType;
    let maxCurrentMessageType;
    let deadAirIntervalsMs = [];
    const shouldIgnoreMessage = (message)=>{
        return (0, $ljUdP.isConversationChannelDataMessage)(message) || (0, $ljUdP.isStreamHeartbeat)(message) || (0, $ljUdP.isStreamDynamicLayoutSubAgent)(message) || (0, $ljUdP.isStreamAnswerGenerationType)(message);
    };
    const shouldCountMessage = (message)=>{
        return (0, $ljUdP.isStreamResearchPayload)(message) || (0, $ljUdP.isStreamResearchPlan)(message) || (0, $ljUdP.isStreamTrace)(message) || (0, $ljUdP.isStreamThinkDeeperTriggered)(message) || (0, $ljUdP.isStreamAnswerPart)(message) || (0, $ljUdP.isStreamReasoningPart)(message) || (0, $ljUdP.isStreamActionPart)(message) || (0, $ljUdP.isStreamResponse)(message) || (0, $ljUdP.isFollowUpMessage)(message) || (0, $ljUdP.isStreamActionClassification)(message) || (0, $ljUdP.isStreamActionPrepare)(message) || (0, $ljUdP.isStreamActionComplete)(message) || (0, $ljUdP.isStreamActionError)(message) || (0, $ljUdP.isStreamError)(message) || (0, $ljUdP.isStreamTodoSnapshot)(message);
    };
    const getMessageTemplate = (message)=>{
        return 'message' in message && message.message?.message_template;
    };
    const commonMetadata = {
        messageId: config.messageId,
        conversationId: config.conversationId,
        traceId: config.traceId,
        productKey: config.productKey,
        isExplicitDeepResearchEnabled: config.deepResearchEnabled,
        isExplicitThinkDeeperEnabled: config.thinkDeeperEnabled,
        isExplicitFastModeEnabled: config.fastModeEnabled,
        isWebSearchEnabled: config.webSearchEnabled,
        isAIFC: config.isAIFC,
        isExplicitThinkFasterEnabled: false,
        isImplicitThinkDeeper: false,
        hasSwitchedToFastThinking: false
    };
    const trackDeadAir = (deadAirMs, previousTemplate, currentTemplate, previousType, currentType)=>{
        const intervalMetric = (0, $3a8fc1613a6284be$export$4841ee9a7190fdf6).createDeadAirIntervalMetrics();
        const now = performance.now();
        intervalMetric.start({
            startTime: now - deadAirMs
        });
        intervalMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                previousMessageTemplate: previousTemplate ?? '',
                messageTemplate: currentTemplate ?? '',
                previousMessageType: previousType ?? '',
                messageType: currentType ?? ''
            }
        });
        totalDeadAirMs += deadAirMs;
        deadAirIntervalsMs.push(Math.round(deadAirMs)); // integer ms is enough accuray
        if (deadAirMs > maxDeadAirMs) {
            maxDeadAirMs = deadAirMs;
            maxPreviousMessageTemplate = previousTemplate;
            maxCurrentMessageTemplate = currentTemplate;
            maxPreviousMessageType = previousType;
            maxCurrentMessageType = currentType;
        }
    };
    const update = (streamMessage)=>{
        if (shouldIgnoreMessage(streamMessage)) return;
        if (!shouldCountMessage(streamMessage)) {
            config.sendAnalyticsEvent({
                eventType: 'operational',
                action: 'unrecognized',
                actionSubject: 'deadAirTrackerMessage',
                attributes: {
                    messageType: streamMessage.type ?? 'unknown',
                    messageTemplate: getMessageTemplate(streamMessage) ?? 'unknown',
                    conversationId: config.conversationId,
                    traceId: config.traceId
                }
            });
            return;
        }
        const currentTimestamp = performance.now();
        const currentTemplate = getMessageTemplate(streamMessage);
        if (currentTemplate === 'THINK_DEEPER_TRIGGERED') commonMetadata.isImplicitThinkDeeper = true;
        const currentMessageType = streamMessage.type;
        // Skip consecutive streaming messages (continuous token/content generation)
        // ANSWER_PART: Standard LLM response tokens
        // REASONING_PART: Think deeper extended reasoning phases (streamed thinking)
        // ACTION_PART: AIFC content generation chunks (whiteboards, documents, etc.)
        const isConsecutiveAnswerPart = previousMessageType === 'ANSWER_PART' && currentMessageType === 'ANSWER_PART';
        const isConsecutiveReasoningPart = previousMessageType === 'REASONING_PART' && currentMessageType === 'REASONING_PART';
        const isConsecutiveActionPart = previousMessageType === 'ACTION_PART' && currentMessageType === 'ACTION_PART';
        if (isConsecutiveAnswerPart || isConsecutiveReasoningPart || isConsecutiveActionPart) {
            previousMessageTimestamp = currentTimestamp;
            previousMessageTemplate = currentTemplate;
            previousMessageType = currentMessageType;
            return;
        }
        const deadAirMs = currentTimestamp - previousMessageTimestamp;
        // Skip negligible intervals (noise)
        if (!(0, $ceMRi.shouldExcludeInterval)(deadAirMs)) trackDeadAir(deadAirMs, previousMessageTemplate, currentTemplate, previousMessageType, currentMessageType);
        previousMessageTimestamp = currentTimestamp;
        previousMessageTemplate = currentTemplate;
        previousMessageType = currentMessageType;
    };
    const emitMaxDeadAir = ()=>{
        if (maxDeadAirMs === 0) return;
        const maxDeadAirMetric = (0, $3a8fc1613a6284be$export$4841ee9a7190fdf6).createDeadAirMaxMetrics();
        const now = performance.now();
        maxDeadAirMetric.start({
            startTime: now - maxDeadAirMs
        });
        maxDeadAirMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                maxDeadAirMs: maxDeadAirMs,
                totalDeadAirMs: Math.round(totalDeadAirMs),
                // integer ms is enough accuray
                deadAirIntervalsMs: JSON.stringify(deadAirIntervalsMs),
                previousMessageTemplate: maxPreviousMessageTemplate ?? '',
                messageTemplate: maxCurrentMessageTemplate ?? '',
                previousMessageType: maxPreviousMessageType ?? '',
                messageType: maxCurrentMessageType ?? ''
            }
        });
    };
    const complete = ()=>{
        emitMaxDeadAir();
    };
    const cancel = ()=>{
        emitMaxDeadAir();
    };
    return {
        update: update,
        complete: complete,
        cancel: cancel,
        resetTimestamp: ()=>{
            previousMessageTimestamp = performance.now();
        }
    };
};



var $lgNBC = parcelRequire("lgNBC");








/**
 * Util function to determine the page context where Rovo chat is being used.
 *
 * This uses the existing context objects (editorContext, whiteboardContext, databaseContext)
 * and AI feature context to determine the surface, and falls back to the browser URL when no
 * context is available.
 *
 * This attribute is used on unified AI events (aiResult viewed, aiInteraction initiated)
 * to distinguish which surface Rovo chat was used on (e.g. edit page, view page, whiteboard, database).
 *
 * This is exported only for testing purposes.
 */ const $bb60cdbb8ebc402b$export$1303843c2f44065a = ({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, aiFeatureContext: aiFeatureContext, browserUrl: browserUrl })=>{
    // Priority 1: Use existing context objects for reliable detection
    if (editorContext) return editorContext.isViewMode ? 'confluence-page-view' : 'confluence-page-edit';
    if (whiteboardContext) return whiteboardContext.isViewMode ? 'whiteboard-view' : 'whiteboard-edit';
    if (databaseContext) return 'database';
    if (aiFeatureContext?.jira_view_context) {
        const jiraContext = aiFeatureContext.jira_view_context;
        return typeof jiraContext.viewType === 'string' ? `jira-view-${jiraContext.viewType}` : 'jira-view';
    }
    // Priority 2: Fall back to URL-based detection when no context is available
    const url = browserUrl ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (url.includes('/wiki/') && url.includes('/edit')) return 'confluence-page-edit';
    if (url.includes('/wiki/')) return 'confluence-page-view';
    if (url.includes('/whiteboard/')) return 'whiteboard';
    if (url.includes('/database/')) return 'database';
    return 'unknown';
};


/**
 * Util function to derive a generic view context attribute for analytics.
 *
 * Reads the AI feature context (populated by product-specific publishers, e.g. the Jira
 * Issue Navigator and Backlog views) and returns a flat record of scalar values that can
 * be attached to unified AI events (e.g. aiInteraction initiated) without leaking any
 * product-specific nested shape.
 *
 * Returns `undefined` when no known view context is available, in which case no
 * `viewContext` attribute is attached to the event.
 *
 * This is exported only for testing purposes.
 */ const $d097db038375fc24$export$20af16720c0f9c71 = ({ aiFeatureContext: aiFeatureContext })=>{
    if (!aiFeatureContext?.jira_view_context) return undefined;
    const jiraCtx = aiFeatureContext.jira_view_context;
    const ids = jiraCtx.selectedIssueIdentifiers;
    const projects = jiraCtx.projectIdentifiers;
    const filters = jiraCtx.filterIdentifiers;
    const jqlStrings = jiraCtx.jqlStrings;
    return {
        numberOfWorkItems: Array.isArray(ids) ? ids.length : 0,
        numberOfProjects: Array.isArray(projects) ? projects.length : 0,
        numberOfFilters: Array.isArray(filters) ? filters.length : 0,
        numberOfJqlStrings: Array.isArray(jqlStrings) ? jqlStrings.length : 0,
        viewType: typeof jiraCtx.viewType === 'string' ? jiraCtx.viewType : 'unknown'
    };
};









// The General Agent runtime UUID (DEFAULT_AGENT_UUID) doubles as the Solution Architect Agent
// runtime identity, which is currently the only agent with minion verification implemented. Minion
// verification analytics are gated to this identity (and the default named-id) for that reason.
const $bd83b455fe877f94$var$possible_agents = [
    (0, $cBi7Q.DEFAULT_AGENT_UUID),
    (0, $cBi7Q.DEFAULT_AGENT_NAMED_ID)
];
const $bd83b455fe877f94$var$MINION_VERIFICATION_ITEMS = [
    {
        alias: 'design-solution',
        minionId: 'SolutionArchitectMinion'
    },
    {
        alias: 'rovo-agent-builder',
        minionId: 'AgentBuilderMinion'
    },
    {
        alias: 'build-automation',
        minionId: 'AutomationWorkflowBuilderMinion'
    }
];
const $bd83b455fe877f94$export$8bfbf77736e8f6e2 = ({ minionAlias: minionAlias, agentId: agentId, minionsOutput: minionsOutput, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    if (!minionAlias) return;
    if (agentId && !$bd83b455fe877f94$var$possible_agents.includes(agentId)) return;
    $bd83b455fe877f94$var$MINION_VERIFICATION_ITEMS.forEach(({ alias: alias, minionId: minionId })=>{
        if (alias !== minionAlias) return;
        const hasAliasMatch = minionsOutput.some((output)=>output.minion_id === minionId);
        sendAnalyticsEvent({
            eventType: 'track',
            action: hasAliasMatch ? 'matched' : 'mismatched',
            actionSubject: 'aiMateMinionVerification',
            attributes: {
                name: minionId
            }
        });
    });
};




const $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    let resolveAbort;
    const confirmAbort = ()=>{
        resolveAbort();
    };
    const abort = ()=>{
        abortController.abort();
        return new Promise((resolve)=>{
            resolveAbort = resolve;
        });
    };
    return {
        abortController: abortController,
        storeAbortController: {
            abort: abort
        },
        confirmAbort: confirmAbort
    };
};


const $77299565342080aa$export$e3d8e4fb1ec788d1 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseMessages__ = [];
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
const $77299565342080aa$export$7d55b756f7f2ed43 = (message)=>{
    try {
        if (window.top) {
            if (!window.top.__rovoStreamResponseMessages__) window.top.__rovoStreamResponseMessages__ = [];
            const serialised = JSON.stringify(message);
            window.top.__rovoStreamResponseMessages__.push(serialised);
        }
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
const $77299565342080aa$export$e884abe68ebbc0aa = ()=>{
    try {
        const messages = window.top?.__rovoStreamResponseMessages__ ?? [];
        return messages.join('\n');
    } catch  {
        // Ignore cross-origin frame access errors
        return '';
    }
};
const $77299565342080aa$export$a50d66ef75a63fe5 = ()=>{
    try {
        if (window.top) window.top.__rovoStreamResponseOutput__ = $77299565342080aa$export$e884abe68ebbc0aa;
    } catch  {
    // Ignore cross-origin frame access errors
    }
};
$77299565342080aa$export$a50d66ef75a63fe5();





const $54793c520b6b8872$var$getSendMessageExperienceName = (params)=>{
    if (params.isCustomRovoAgent) return (0, $16lEl.ExperienceName).SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (params.deepResearchEnabled) return (0, $16lEl.ExperienceName).SEND_DR_MESSAGE;
    if (params.thinkDeeperEnabled) return (0, $16lEl.ExperienceName).SEND_TD_MESSAGE;
    if (params.taskModeEnabled) return (0, $16lEl.ExperienceName).SEND_TASK_MODE_MESSAGE;
    return (0, $16lEl.ExperienceName).SEND_MESSAGE;
};
/**
 * Helper function to stop/end metrics, that can only be called once
 */ const $54793c520b6b8872$var$getRequestedModeAttributes = (trackingAttributes)=>({
        ...(0, $9likX.interactionModeRequestedAttributes)(trackingAttributes.interactionModeRequested),
        ...trackingAttributes.aiFeatureName && {
            aiFeatureName: trackingAttributes.aiFeatureName
        }
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $54793c520b6b8872$var$getMetricEndHelper = (metrics)=>{
    let called = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (result, customData)=>{
        if (!called) {
            if (result === 'stop') metrics.stop({
                customData: customData
            });
            else metrics.cancel();
            called = true;
        }
    };
};
function $54793c520b6b8872$export$7459a30868c458f({ routedSelectedAgentId: routedSelectedAgentId, value: value }) {
    return routedSelectedAgentId ? undefined : value;
}
const $54793c520b6b8872$var$getInitialTrackingAttributes = (agentId, instrumentationId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, template, forcedContentType)=>{
    return {
        pluginsInvoked: new Set(),
        skillsInvoked: [],
        executedStratusSkill: false,
        hasSources: false,
        messageId: '',
        humanMessageId: '',
        requestId: undefined,
        messageActions: [],
        messageDynamicUIData: [],
        invokedFrom: undefined,
        instrumentationId: instrumentationId,
        messageSentTimeStamp: new Date().toISOString(),
        citedProductList: {},
        sourceProducts: {},
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        taskModeEnabled: taskModeEnabled,
        webSearchEnabled: webSearchEnabled,
        interactionSource: messageSources?.interactionSource,
        followUpSource: messageSources?.followUpSource ?? 'none',
        aiFeatureName: messageSources?.aiFeatureName,
        isFirstPrompt: isFirstPrompt,
        promptFeatures: (0, $cWLC4.extractContentFeatures)(prompt),
        fileCount: files?.length ?? 0,
        appFilters: appFilters ?? [],
        appFilterCount: appFilters?.length ?? 0,
        template: template,
        deepResearchInvoked: false,
        forcedContentType: forcedContentType,
        interactionModeRequested: (0, $9likX.getInteractionModeRequested)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        })
    };
};
const $54793c520b6b8872$var$getOptimisticMessageTypes = (deepResearchEnabled, webSearchEnabled)=>{
    const messageType = [];
    if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) {
        if (deepResearchEnabled) messageType.push('DEEP_RESEARCH');
        if (webSearchEnabled) messageType.push('WEB_SEARCH');
    }
    return {
        messageType: messageType
    };
};
const $54793c520b6b8872$var$initLatencyMetrics = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, agentId: agentId })=>{
    const rovoCustomAgent = (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId);
    const sendMessageLatencyMetrics = (0, $0e7d0025813be8f5$export$1e4d1659c4209dbf).createSendMessageMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstAnswerPartLatencyMetrics = (0, $0e7d0025813be8f5$export$1e4d1659c4209dbf).createTimeToFirstAnswerPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstActionPartLatencyMetrics = (0, $0e7d0025813be8f5$export$1e4d1659c4209dbf).createTimeToFirstActionPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToActionCompletionLatencyMetrics = (0, $0e7d0025813be8f5$export$1e4d1659c4209dbf).createTimeToActionCompletionMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const metricsStartTime = window.performance.now();
    sendMessageLatencyMetrics.start({
        startTime: metricsStartTime
    });
    timeToFirstAnswerPartLatencyMetrics.start({
        startTime: metricsStartTime
    });
    if ((0, $dh538.fg)('aifc_create_enabled') || (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
        timeToFirstActionPartLatencyMetrics.start();
        timeToActionCompletionLatencyMetrics.start();
    }
    const stopInteractionMetricsTimeToFirstAnswerPart = $54793c520b6b8872$var$getMetricEndHelper(timeToFirstAnswerPartLatencyMetrics);
    const stopInteractionMetricsTimeToFirstActionPart = $54793c520b6b8872$var$getMetricEndHelper(timeToFirstActionPartLatencyMetrics);
    const stopInteractionMetricsTimeToActionCompletion = $54793c520b6b8872$var$getMetricEndHelper(timeToActionCompletionLatencyMetrics);
    const cancelStreamingMetrics = ()=>{
        stopInteractionMetricsTimeToFirstAnswerPart('cancel');
        stopInteractionMetricsTimeToFirstActionPart('cancel');
        stopInteractionMetricsTimeToActionCompletion('cancel');
    };
    return {
        sendMessageLatencyMetrics: sendMessageLatencyMetrics,
        timeToFirstAnswerPartLatencyMetrics: timeToFirstAnswerPartLatencyMetrics,
        timeToFirstActionPartLatencyMetrics: timeToFirstActionPartLatencyMetrics,
        timeToActionCompletionLatencyMetrics: timeToActionCompletionLatencyMetrics,
        stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
        stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
        stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
        cancelStreamingMetrics: cancelStreamingMetrics,
        metricsStartTime: metricsStartTime
    };
};
const $54793c520b6b8872$var$hydrateStoreWithNewMessage = (dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, routedSelectedAgentId)=>{
    const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
    const updateCurrentConversation = (data)=>{
        dispatch(setConversationData({
            conversationId: conversationId,
            data: data
        }));
    };
    // Author the optimistic assistant by per-turn override (`routedSelectedAgentId`),
    // else caller intent (`sourceAgentIdForTemporaryLocalConversation` = explicit/default
    // agent) — never the routing fallback, which would resolve to the conversation agent
    // and mis-author a cross-surface default-Rovo "ask Rovo". See ai-mate AGENTS.md
    // "Rovo Chat agent identity, routing, and display". Gate-off keeps caller intent;
    // on flag cleanup keep the `routedSelectedAgentId ?? sourceAgentId...` form.
    const normalizedRoutedSelectedAgentId = routedSelectedAgentId || undefined;
    const optimisticAssistantAuthorNamedId = (0, $dh538.fg)('rovo_chat_agent_selection') && normalizedRoutedSelectedAgentId ? normalizedRoutedSelectedAgentId : sourceAgentIdForTemporaryLocalConversation;
    updateCurrentConversation({
        status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
        storeAbortController: storeAbortController,
        lastMessageType: messageType,
        lastAgentMessageStatus: 'IN_PROGRESS'
    });
    dispatch(addHumanMessage({
        id: tmpHumanMessageId,
        content: prompt,
        conversationId: conversationId,
        fileUploads: files
    }));
    dispatch(addAssistantMessage({
        id: tmpAssistantMessageId,
        content: '',
        conversationId: conversationId,
        // Authored by the routed agent (see derivation above) so the per-turn
        // "{agent} is thinking" indicator reflects it.
        agentNamedId: optimisticAssistantAuthorNamedId,
        agentAuthorId: (0, $dh538.fg)('rovo_chat_agent_selection') && normalizedRoutedSelectedAgentId ? normalizedRoutedSelectedAgentId : undefined
    }));
    dispatch(clearFollowUpMessages({
        conversationId: conversationId
    }));
    return {
        abortController: abortController,
        storeAbortController: storeAbortController,
        confirmAbort: confirmAbort,
        updateCurrentConversation: updateCurrentConversation
    };
};
const $54793c520b6b8872$var$handleEditorContextAnalytics = ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, userPreference: userPreference, sendAnalyticsEvent: sendAnalyticsEvent, activeTargetId: activeTargetId, isStagingArea: stagingAreaFromStore })=>{
    // If AIFC is not enabled, we should not send analytics
    if (!(0, $dh538.fg)('aifc_create_enabled')) return;
    const inStagingArea = contentContext === 'staging-area';
    // Source values for Inline Rovo
    const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    const shouldProvideContext = // Inline Rovo
    sourceEligible || // Within staging area & not the first prompt
    inStagingArea && !isFirstPrompt || // Not within staging area, default to user preference
    !inStagingArea && !!userPreference;
    // If there's no editor context when we should be providing it,
    // something went wrong so send analytics to track
    if (shouldProvideContext) sendAnalyticsEvent({
        eventType: 'operational',
        action: 'missing',
        actionSubject: 'editorContext',
        attributes: {
            contentContext: contentContext,
            source: source,
            userPreference: userPreference,
            isFirstPrompt: isFirstPrompt,
            activeTargetId: activeTargetId,
            isStagingArea: stagingAreaFromStore
        }
    });
};
function $54793c520b6b8872$export$780f1f00b9b71ec({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, slidesContext: slidesContext }) {
    if (editorContext) return 'page';
    if (whiteboardContext) return 'whiteboard';
    if (databaseContext) return 'database';
    if (slidesContext) return 'slide';
    return undefined;
}
function $54793c520b6b8872$export$e5ce245ce709fc21({ contentContextValue: contentContextValue, isFirstPrompt: isFirstPrompt, source: source, creationContextSource: creationContextSource, existingExperience: existingExperience, existingContentTypes: existingContentTypes, chatContextContentType: chatContextContentType, isRemixAction: isRemixAction, isViewMode: isViewMode, contentMauiId: contentMauiId, mediaFileId: mediaFileId, isRemixExperienceContextEnabled: isRemixExperienceContextEnabled = true }) {
    const resolvedContentTypes = existingContentTypes && existingContentTypes.length > 0 ? existingContentTypes : chatContextContentType ? [
        chatContextContentType
    ] : undefined;
    if (isRemixExperienceContextEnabled && existingExperience === 'inline_edit' && (contentMauiId || mediaFileId)) return resolvedContentTypes ? {
        experience: 'remix_edit',
        contentTypes: resolvedContentTypes
    } : undefined;
    if (existingExperience === 'cwr_edit') {
        if (resolvedContentTypes) return {
            experience: 'cwr_edit',
            contentTypes: resolvedContentTypes
        };
        return {
            experience: 'cwr'
        };
    }
    if (existingExperience) return undefined;
    const isCwrStagingAreaFollowUp = contentContextValue === 'staging-area' && !isFirstPrompt && source !== 'remix' && creationContextSource !== 'remix' && !isRemixAction;
    if (isCwrStagingAreaFollowUp) {
        if (chatContextContentType) return {
            experience: 'cwr_edit',
            contentTypes: [
                chatContextContentType
            ]
        };
        return {
            experience: 'cwr'
        };
    }
    if (contentContextValue === 'global' && chatContextContentType) return {
        experience: isViewMode ? 'chat_view' : 'chat_edit',
        contentTypes: [
            chatContextContentType
        ]
    };
    return undefined;
}
function $54793c520b6b8872$export$e1dc015944c90cb9({ existingBlocks: existingBlocks, experience: experience, source: source, mediaFileId: mediaFileId, isRemixExperienceContextEnabled: isRemixExperienceContextEnabled = true }) {
    if (!isRemixExperienceContextEnabled) return undefined;
    if (existingBlocks && existingBlocks.length > 0) return existingBlocks;
    if (source === 'remix' && experience === 'remix_edit' && mediaFileId) return [
        'image'
    ];
    return undefined;
}
const $54793c520b6b8872$var$populateSendMessageContext = async (chatContextStoreActions, isFirstPrompt, source, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, activeTargetId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixAction, searchArtifact)=>{
    const editorContext = skipEditorContext ? undefined : await chatContextStoreActions.getEditorContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const shouldUseCurrentTarget = contentContextValue === 'staging-area' || addCurrentPageAsContextUserPreference !== false;
    const currentTarget = shouldUseCurrentTarget ? chatContextStoreActions.getTarget(contentContextValue, activeTargetId) : undefined;
    const currentTargetContentType = currentTarget?.type === 'page' || currentTarget?.type === 'whiteboard' || currentTarget?.type === 'database' || currentTarget?.type === 'slide' ? currentTarget.type : undefined;
    const currentTargetViewMode = currentTarget?.isViewMode;
    // If there's no editor context available and the current target CAN
    // provide context, send analytics to track this error state
    if (!editorContext && !skipEditorContext && currentTarget?.canProvideContext) $54793c520b6b8872$var$handleEditorContextAnalytics({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        userPreference: !!addCurrentPageAsContextUserPreference,
        sendAnalyticsEvent: sendAnalyticsEvent,
        activeTargetId: !!activeTargetId,
        isStagingArea: chatContextStoreActions.getIsStagingArea()
    });
    const whiteboardContext = await chatContextStoreActions.getWhiteboardContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const slidesContext = await chatContextStoreActions.getSlidesContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const databaseContext = await chatContextStoreActions.getDatabaseContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const dashboardEditorContext = await chatContextStoreActions.getDashboardEditorContext({
        contentContext: contentContextValue,
        activeTargetId: activeTargetId
    });
    const browserContext = await chatContextStoreActions.getBrowserContext({
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig config is not registered in platform feature flags/editor experiments; keep existing no-exposure behavior.
        enabled: (0, $c6GJD.default).getExperimentValue('rovo_extension_dom_improvement', 'rovo_extension_dom_context_improvement_enabled', false, {
            fireExperimentExposure: false
        })
    });
    const jiraContext = await (async ()=>{
        // Only fetch Jira context when in staging area and product is Jira
        // and not the first prompt (refinement messages)
        if (!isFirstPrompt && (contentContextValue === 'staging-area' || (0, $dh538.fg)('jira-aifc-enable-preview-card-in-chat-v2')) && productKey === 'jira' && (0, $dh538.fg)('jira_aifc_enabled')) return chatContextStoreActions.getJiraContext?.();
        return undefined;
    })();
    const additionalCreationContext = editorContext?.additionalContext;
    const additionalCreationContextParams = creationContextParams?.additionalContext;
    if (editorContext && editorContext.additionalContext) delete editorContext.additionalContext;
    const useGenericEditorSkill = editorContext?.useGenericEditorSkill;
    if (editorContext && 'useGenericEditorSkill' in editorContext) delete editorContext.useGenericEditorSkill;
    const hasRichContentContext = editorContext !== undefined && editorContext !== null || whiteboardContext !== undefined && whiteboardContext !== null || slidesContext !== undefined && slidesContext !== null || databaseContext !== undefined && databaseContext !== null;
    const contextViewMode = hasRichContentContext ? !!(editorContext?.isViewMode || whiteboardContext?.isViewMode || slidesContext?.isViewMode || databaseContext?.isViewMode) : undefined;
    const isViewMode = contentContextValue === 'staging-area' ? !!editorContext?.isViewMode : contextViewMode ?? !!currentTargetViewMode;
    // On a Confluence page in view mode, the editor bridge is not active so editorContext
    // is undefined. We detect this case by checking that productKey is 'confluence', that
    // skipEditorContext is false (we did try to fetch context), and that no other Confluence
    // doc-type context (whiteboard, slides, database) is present — meaning this is a page.
    const isConfluencePageViewMode = productKey === 'confluence' && !skipEditorContext && !whiteboardContext && !slidesContext && !databaseContext ? editorContext === undefined : false;
    const creationContextIsViewMode = (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? creationContextParams?.isViewMode !== undefined ? creationContextParams.isViewMode : isViewMode || isConfluencePageViewMode : isViewMode;
    const isDraftLockedForEditing = !!editorContext?.isDraftLockedForEditing;
    const editorContentType = $54793c520b6b8872$export$780f1f00b9b71ec({
        editorContext: editorContext,
        whiteboardContext: whiteboardContext,
        databaseContext: databaseContext,
        slidesContext: slidesContext
    }) ?? currentTargetContentType;
    const contentMauiId = editorContext?.contentMauiId ?? creationContextParams?.contentMauiId;
    const mediaFileId = editorContext?.mediaFileId ?? creationContextParams?.mediaFileId;
    const creationContextSource = contentMauiId || mediaFileId ? 'remix' : // If source is explicitly passed, use that, otherwise rely on creationContextParams.source which is set at creation entry point (e.g. 'remix', 'ai-first-creation')
    source ?? creationContextParams?.source;
    const isRemixExperienceContextEnabled = (0, $1oCLl.expValEquals)('rovo_remix_experience_context', 'isEnabled', true);
    // The context store returns the raw content context; the outbound
    // creationContext experience/contentTypes are attached here when the request is built.
    const creationContextExperience = $54793c520b6b8872$export$e5ce245ce709fc21({
        contentContextValue: contentContextValue,
        isFirstPrompt: isFirstPrompt,
        source: source,
        creationContextSource: creationContextParams?.source,
        existingExperience: creationContextParams?.experience,
        existingContentTypes: creationContextParams?.contentTypes,
        chatContextContentType: editorContentType,
        isRemixAction: isRemixAction,
        isViewMode: creationContextIsViewMode,
        contentMauiId: contentMauiId,
        mediaFileId: mediaFileId,
        isRemixExperienceContextEnabled: isRemixExperienceContextEnabled
    });
    const creationContextBlocks = $54793c520b6b8872$export$e1dc015944c90cb9({
        existingBlocks: creationContextParams?.blocks,
        experience: creationContextExperience?.experience ?? creationContextParams?.experience,
        source: creationContextSource,
        mediaFileId: mediaFileId,
        isRemixExperienceContextEnabled: isRemixExperienceContextEnabled
    });
    const shouldOmitRichContentContext = (0, $dh538.fg)('aifc_chat_view_context_viewonly') && (creationContextExperience?.experience ?? creationContextParams?.experience) === 'chat_view';
    const sendableEditorContext = shouldOmitRichContentContext ? undefined : editorContext;
    const sendableWhiteboardContext = shouldOmitRichContentContext ? undefined : whiteboardContext;
    const sendableSlidesContext = shouldOmitRichContentContext ? undefined : slidesContext;
    const sendableDatabaseContext = shouldOmitRichContentContext ? undefined : databaseContext;
    // Bookmark
    return {
        browserContext: browserContext,
        editorContext: sendableEditorContext,
        whiteboardContext: sendableWhiteboardContext,
        slidesContext: sendableSlidesContext,
        databaseContext: sendableDatabaseContext,
        dashboardEditorContext: dashboardEditorContext,
        additionalContext: {
            spaceCreateContext: await chatContextStoreActions.getSpaceCreateContext({
                isFirstPrompt: isFirstPrompt,
                contentContext: contentContextValue
            }),
            creationContext: {
                ...creationContextParams ? creationContextParams : {},
                isStagingArea: contentContextValue === 'staging-area',
                productKey: productKey,
                // When `contentMauiId` or `mediaFileId` is present, we don't need to send the source
                // Ideally we want to set it upstream, but we need to ensure we don't break existing functionality
                source: creationContextSource,
                isViewMode: creationContextIsViewMode,
                isDraftLockedForEditing: isDraftLockedForEditing,
                ...creationContextIsViewMode && (editorContext?.isViewMode || isConfluencePageViewMode) && !creationContextParams?.experience ? {
                    experience: 'inline_view',
                    contentTypes: [
                        'page'
                    ]
                } : {},
                useGenericEditorSkill: useGenericEditorSkill,
                additionalContext: additionalCreationContext || additionalCreationContextParams ? {
                    ...additionalCreationContext,
                    ...additionalCreationContextParams
                } : undefined,
                ...jiraContext && {
                    jiraContext: jiraContext
                },
                ...(0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) && {
                    ...editorContext?.dynamicUiSource && {
                        dynamicUiSource: {
                            ...editorContext.dynamicUiSource,
                            ...creationContextParams?.dynamicUiSource?.fragmentAdf && {
                                fragmentAdf: creationContextParams.dynamicUiSource.fragmentAdf
                            }
                        }
                    },
                    ...(isRemixAction || source === 'remix' || creationContextParams?.source === 'remix') && {
                        dynamicUiType: editorContext?.dynamicUiType || creationContextParams?.dynamicUiType || lastAssistantMessageDynamicUiType
                    },
                    contentMauiId: contentMauiId,
                    mediaFileId: mediaFileId
                },
                ...creationContextBlocks && {
                    blocks: creationContextBlocks
                },
                // Derive experience and contentTypes for CWR staging-area follow-ups and global chat context.
                ...creationContextExperience
            },
            userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            search_artifact: searchArtifact
        },
        aiFeatureContext: chatContextStoreActions.getAIFeatureContext(),
        jiraWorkflowContext: chatContextStoreActions.getJiraWorkflowContext(),
        dashboardContext: chatContextStoreActions.getDashboardContext(),
        useCurrentBrowsingContext: chatContextStoreActions.useCurrentBrowsingContext(!!addCurrentPageAsContextUserPreference)
    };
};
const $54793c520b6b8872$export$32a54ad404e10819 = async (chatContextStoreActions, isFirstPrompt, addCurrentPageAsContextUserPreference, contentContextValue, productKey, sendAnalyticsEvent, isEmptyStagingArea)=>{
    const context = await $54793c520b6b8872$var$populateSendMessageContext(chatContextStoreActions, isEmptyStagingArea || isFirstPrompt, undefined, addCurrentPageAsContextUserPreference, contentContextValue, isEmptyStagingArea ? {
        experience: 'cwr'
    } : undefined, productKey, sendAnalyticsEvent);
    return {
        editorContext: context.editorContext,
        whiteboardContext: context.whiteboardContext,
        slidesContext: context.slidesContext,
        databaseContext: context.databaseContext,
        dashboardEditorContext: context.dashboardEditorContext,
        browserContext: context.browserContext,
        additionalContext: context.additionalContext,
        jiraWorkflowContext: context.jiraWorkflowContext,
        dashboardContext: context.dashboardContext,
        useCurrentBrowsingContext: context.useCurrentBrowsingContext
    };
};
const $54793c520b6b8872$var$handleSendMessageServiceCallFailure = (error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages)=>{
    // Convert deep research related errors to DeepResearchError when deep research is enabled
    let convertedError = error;
    if (deepResearchEnabled) convertedError = new (0, $lgNBC.DeepResearchError)(error.message, {
        traceId: error.errorAttributes?.traceId,
        requestId: error.errorAttributes?.requestId
    });
    // Returns bad request error because agent is deactivated or user has no permission
    const isAgentDeactivated = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
    const isNoAgentPermission = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
    if (isAgentDeactivated || isNoAgentPermission) {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: error,
            attributes: {
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: $54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
        });
        updateCurrentConversation({
            status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
            traces: [],
            errorCode: (0, $dh538.fg)('convo-ai-enable-agents-use-permission') ? error.errorAttributes.errorCode : undefined
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        return;
    } else if (error instanceof Error && error.name === 'AbortError') {
        // Check if the abort was programmatic or not. `abortController.signal.aborted` is a readonly field that is only set to true when called programmatically
        // The browser can abort requests to free up resources & save power (esp. on background tabs). When it does this, it **does not** set `abortController.signal.aborted` to true
        const isProgrammaticAbort = abortController.signal.aborted;
        experienceTracker.abort({
            name: sendMessageExperienceNameCompiled,
            reason: 'Aborted',
            attributes: {
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                isProgrammaticAbort: isProgrammaticAbort
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
            }
        });
        trackAIMAUEvent({
            type: 'dismissed',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            subjectId: trackingAttributes.interactionSource,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: $54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
        });
        updateCurrentConversation((0, $cteoa.clearStatus)({
            lastAgentMessageStatus: isProgrammaticAbort ? 'CANCELLED' : 'FAILED'
        }));
        (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
        clearMessageResearch({
            messageId: tmpAssistantMessageId
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ABORTED);
        confirmAbort();
        return;
    } else {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: error,
            attributes: {
                deepResearchEnabled: deepResearchEnabled,
                fastModeEnabled: fastModeEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                webSearchEnabled: webSearchEnabled,
                llmDebugLogsEnabled: storeUserMessages,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: false,
            userGenerated: true,
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext,
            viewContext: trackingAttributes.viewContext,
            attributes: {
                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
            }
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            attributes: $54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        throw convertedError;
    }
};
const $54793c520b6b8872$export$5a07e6227eed9665 = ({ streamMessage: streamMessage, tmpAssistantMessageId: tmpAssistantMessageId, conversationId: conversationId, deepResearchEnabled: deepResearchEnabled, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, researchState: researchState })=>{
    let deepResearchInvoked = false;
    if ((0, $ljUdP.isStreamResearchStart)(streamMessage) && // The same message_template is used for thinking deeper + deep research
    // so we need to check the specific trace message to differentiate them
    streamMessage.message.content === 'Starting deep research execution') deepResearchInvoked = true;
    // Implicit round detection for think deeper:
    // When answer content has accumulated (from ANSWER_PART messages) and new
    // research step information arrives, we know a new round is starting.
    // We retroactively create a research plan for the completed round using
    // the accumulated answer content, clear the streamed content, and increment
    // the round counter so subsequent steps are grouped under the new round.
    if (researchState.hasAccumulatedAnswerContent && (0, $ljUdP.isStreamResearchPayload)(streamMessage)) {
        // Read the accumulated answer content from the assistant message
        const accumulatedContent = (0, $cteoa.getStoreAssistantMessageContent)(getMessages(conversationId), tmpAssistantMessageId);
        // Create a research plan for the completed round with the accumulated content
        addImplicitResearchPlan({
            messageId: tmpAssistantMessageId,
            content: accumulatedContent,
            roundId: researchState.clientRoundCounter
        });
        // Increment round counter for the new incoming steps
        researchState.clientRoundCounter++;
        // Clear the assistant message content so the new round starts fresh
        const clearedMessages = (0, $cteoa.clearStoreAssistantMessageContent)(getMessages(conversationId), tmpAssistantMessageId);
        setMessages(conversationId, clearedMessages);
        // Reset tracking flags
        researchState.hasAccumulatedAnswerContent = false;
        resetHasReceivedAnswerPart({
            messageId: tmpAssistantMessageId
        });
    }
    if ((0, $ljUdP.isStreamResearchPayload)(streamMessage) || (0, $ljUdP.isStreamResponse)(streamMessage) || (0, $ljUdP.isStreamAnswerPart)(streamMessage) || (0, $ljUdP.isStreamReasoningPart)(streamMessage) || (0, $ljUdP.isStreamSkill)(streamMessage) || (0, $ljUdP.isStreamThinkDeeperTriggered)(streamMessage)) {
        // When implicit rounds are active, override roundId on research step messages
        // so they are grouped under the current client-managed round
        if (researchState.clientRoundCounter > 0 && (0, $ljUdP.isStreamResearchPayload)(streamMessage) && 'message' in streamMessage && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        'roundId' in streamMessage.message) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        streamMessage.message.roundId = researchState.clientRoundCounter;
        processStreamResearch({
            messageId: tmpAssistantMessageId,
            streamMessage: streamMessage,
            isDeepResearch: deepResearchEnabled ?? false
        });
    }
    if ((0, $ljUdP.isStreamResearchPlan)(streamMessage)) processStreamResearch({
        messageId: tmpAssistantMessageId,
        streamMessage: streamMessage,
        isDeepResearch: deepResearchEnabled ?? false
    });
    // Track that answer content has accumulated so implicit round detection
    // can detect a new round starting when the next research payload arrives
    if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) researchState.hasAccumulatedAnswerContent = true;
    return {
        deepResearchInvoked: deepResearchInvoked
    };
};
const $54793c520b6b8872$export$efb69f1fe7577739 = async ({ prompt: prompt, generator: generator, productKey: productKey, answerIndex: answerIndex, tmpHumanMessageId: tmpHumanMessageId, tmpAssistantMessageId: tmpAssistantMessageId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled, traceId: traceId, updateCurrentConversation: updateCurrentConversation, trackingAttributes: trackingAttributes, conversationId: conversationId, getState: getState, promptStreamHook: promptStreamHook, openChat: openChat, openChatOnError: openChatOnError, experienceTracker: experienceTracker, setMessages: setMessages, getMessages: getMessages, onSpaceSourceRecommendations: onSpaceSourceRecommendations, processStreamResearch: processStreamResearch, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced, updateResearchMessageId: updateResearchMessageId, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, broadcastStreamLifecycle: broadcastStreamLifecycle, sendMessageLatencyMetrics: sendMessageLatencyMetrics, cancelStreamingMetrics: cancelStreamingMetrics, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, streamActionInfo: streamActionInfo, trackAIMAUEvent: trackAIMAUEvent, messageSources: messageSources, additionalAnalyticAttributes: additionalAnalyticAttributes, hasLoggedInitiatedEvent: hasLoggedInitiatedEvent, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, viewDeadAirBroker: viewDeadAirBroker, minionAlias: minionAlias, agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, creationContextParams: creationContextParams, storeUserMessages: storeUserMessages, skillSelectionSource: skillSelectionSource, assistanceService: assistanceService, abortController: abortController, getIsChatMounted: getIsChatMounted, metricsStartTime: metricsStartTime, onTaskStatusUpdate: onTaskStatusUpdate, onTodoSnapshot: onTodoSnapshot, onPromptRedacted: onPromptRedacted, onPromptBlocked: onPromptBlocked, onResponseRedacted: onResponseRedacted, onResponseBlocked: onResponseBlocked, onAttachmentBlocked: onAttachmentBlocked })=>{
    updateCurrentConversation({
        traces: []
    });
    // Set to true when a guard event (PROMPT_REDACTION or PROMPT_BLOCKED) is received.
    // The backend always follows these events with an ERROR event to terminate the stream,
    // which should be treated as a successful end of the guard flow, not a real error.
    let guardEventReceived = false;
    let hasReceivedFinalResponse = false;
    let hasReceivedFollowUp = false;
    let hasReceivedActionComplete = false;
    let hasReceivedActionClassification = false;
    let isLuminaAnswerGenerationType = false;
    let agentMessageId;
    let isReconnectSupported = false;
    // Guards against repeated metric switches if multiple REASONING_PART messages arrive.
    let hasAbortedForImplicitThinkDeeper = false;
    // Think-deeper metrics started when implicit think-deeper is detected mid-stream. Null otherwise.
    let implicitThinkDeeperSendMessageMetrics = null;
    let implicitThinkDeeperTimeToFirstAnswerPartMetrics = null;
    // The experience name for the reliability SLO when implicit think-deeper is detected. Null otherwise.
    let implicitThinkDeeperExperienceName = null;
    // Client-side implicit round tracking for think deeper.
    // Passed by reference into processResearchStreamMessage so state is shared.
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    // Lazily initialised on the first chunk: the conversation's agent metadata
    // is set by `createConversationOptimistically` which may run after this
    // function is defined but before the first chunk arrives.
    let processStreamMarkdownMultiTagInstance = null;
    const getShouldPreprocessDetails = ()=>(0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId);
    const getProcessStreamMarkdownMultiTag = ()=>{
        if (!processStreamMarkdownMultiTagInstance) processStreamMarkdownMultiTagInstance = (0, $cteoa.createStreamMarkdownMultiTagProcessor)({
            shouldPreprocessDetails: getShouldPreprocessDetails()
        });
        return processStreamMarkdownMultiTagInstance;
    };
    let latestStreamMessage;
    const streamStats = $54793c520b6b8872$var$getStreamStats();
    // Between-chunks inactivity watchdog (logs once per stall, re-arms on chunks)
    const inactivity = $54793c520b6b8872$export$23f1f8f522f4bdd({
        baseMs: 90000,
        sendAnalyticsEvent: (event)=>{
            sendAnalyticsEvent({
                ...event,
                attributes: {
                    ...event.attributes,
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent
                }
            });
        }
    });
    // Dead air tracking - monitors gaps between meaningful stream messages
    const deadAirTracker = (0, $33eac1626c414e6d$export$4a48e8ee48123078)({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        deepResearchEnabled: deepResearchEnabled ?? false,
        thinkDeeperEnabled: thinkDeeperEnabled ?? false,
        fastModeEnabled: fastModeEnabled ?? false,
        webSearchEnabled: webSearchEnabled ?? false,
        isAIFC: streamActionInfo.isAction,
        sendAnalyticsEvent: sendAnalyticsEvent
    });
    viewDeadAirBroker?.start({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        reasoningMode: deepResearchEnabled ? 'deep-research' : thinkDeeperEnabled ? 'think-deeper' : fastModeEnabled ? 'fast' : 'auto',
        isAIFCEnabled: streamActionInfo.isAction,
        isWebSearchEnabled: webSearchEnabled ?? false
    });
    // Reset the stream response recording for a new stream session.
    // Recording is always enabled so that network responses can be captured by default.
    const canRecordStreamResponses = true;
    if (canRecordStreamResponses) (0, $77299565342080aa$export$e3d8e4fb1ec788d1)();
    // Arm the inactivity watchdog
    inactivity?.arm();
    /*****************************
   *
   * Stream processing START
   *
   *****************************/ const streamToIterate = (0, $be423051027308ae$export$29bad1ab941da7cb)({
        generator: generator,
        conversationId: conversationId,
        abortController: abortController,
        assistanceService: assistanceService,
        sendAnalyticsEvent: sendAnalyticsEvent,
        experienceTracker: experienceTracker,
        getMessageId: ()=>agentMessageId,
        canReconnect: ()=>!!(agentMessageId && isReconnectSupported),
        updateCurrentConversation: updateCurrentConversation,
        getIsChatMounted: getIsChatMounted,
        analyticsAttributes: {
            isDeepResearch: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled
        },
        onBeforeFirstReconnect: ()=>{
            const chat = getMessages(conversationId);
            const alreadySwapped = (0, $cteoa.findStoreMessageIndex)(chat, agentMessageId) >= 0;
            if (!alreadySwapped) {
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                    chat: chat,
                    oldId: tmpAssistantMessageId,
                    newId: agentMessageId
                }));
                updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
            }
            tmpAssistantMessageId = agentMessageId;
        },
        onReconnected: ()=>{
            inactivity?.arm();
        },
        onFirstChunkAfterReconnect: ()=>{
            deadAirTracker?.resetTimestamp();
        }
    });
    try {
        for await (const streamObj of streamToIterate){
            const streamMessage = (0, $ljUdP.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
            // Record the raw stream message for debugging purposes
            // This allows developers to copy/paste SSE responses for examples/tests
            if (canRecordStreamResponses) (0, $77299565342080aa$export$7d55b756f7f2ed43)(streamMessage);
            latestStreamMessage = streamMessage;
            deadAirTracker?.update(streamMessage);
            streamStats.update(streamMessage);
            // any chunk = proof of life
            inactivity?.onChunk();
            // Note: We do NOT skip stream messages during SWITCHING.
            // Stream processing continues normally until FAST_MODE_ENABLED is received,
            // at which point research steps are cleared and status is set to SWITCHED.
            // Usually the first stream part
            if ((0, $ljUdP.isConversationChannelDataMessage)(streamMessage)) {
                agentMessageId = streamMessage.assistant_message_id;
                updateCurrentConversation({
                    name: streamMessage.name,
                    lastMessageTimestamp: streamMessage.last_message_timestamp ?? new Date().toISOString(),
                    timeCreated: streamMessage.time_created,
                    ...streamMessage.scopes && {
                        scopes: streamMessage.scopes
                    }
                });
                trackingAttributes.instrumentationId = agentMessageId;
                trackingAttributes.messageId = agentMessageId;
                if (agentMessageId && agentMessageId !== tmpAssistantMessageId && (0, $dh538.fg)('cc-cwr-fix-finalizing-cancelled-request')) {
                    const oldTmpId = tmpAssistantMessageId;
                    setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                        chat: getMessages(conversationId),
                        oldId: oldTmpId,
                        newId: agentMessageId
                    }));
                    updateResearchMessageId({
                        messageId: oldTmpId,
                        newMessageId: agentMessageId
                    });
                    tmpAssistantMessageId = agentMessageId;
                    (onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced)?.(oldTmpId, agentMessageId);
                }
                trackingAttributes.invokedFrom = creationContextParams?.source === 'remix' ? 'remix' : (0, $cteoa.getInvokedFromInteractionSource)(messageSources?.interactionSource);
                const remixNodeTypes = creationContextParams?.dynamicUiSource ? (0, $9lwku.getTopLevelNodeTypes)(creationContextParams.dynamicUiSource.fullAdf, creationContextParams.dynamicUiSource.startLocalId ?? '', creationContextParams.dynamicUiSource.endLocalId ?? '') : undefined;
                const remixWordCount = creationContextParams?.dynamicUiSource?.fragmentAdf ? (0, $gdLsu.countFragmentWords)(creationContextParams.dynamicUiSource.fragmentAdf) : undefined;
                if (remixNodeTypes) trackingAttributes.remixNodeTypes = remixNodeTypes;
                if (remixWordCount !== undefined) trackingAttributes.remixWordCount = remixWordCount;
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: streamMessage.last_message_timestamp,
                    singleInstrumentationID: agentMessageId,
                    deepResearchEnabled: deepResearchEnabled ?? false,
                    thinkDeeperEnabled: thinkDeeperEnabled ?? false,
                    fastModeEnabled: fastModeEnabled ?? false,
                    webSearchEnabled: webSearchEnabled ?? false,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    invokedFrom: trackingAttributes.invokedFrom,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes),
                        ...additionalAnalyticAttributes && additionalAnalyticAttributes,
                        ...remixNodeTypes !== undefined && {
                            remixNodeTypes: remixNodeTypes
                        },
                        ...remixWordCount !== undefined && {
                            remixWordCount: remixWordCount
                        }
                    }
                });
                hasLoggedInitiatedEvent = true;
            } else if ((0, $ljUdP.isScopeDeterminedMessage)(streamMessage)) updateCurrentConversation({
                scopes: streamMessage.scopes
            });
            else if ((0, $ljUdP.isSpaceSourceRecommendationsMessage)(streamMessage)) // No analytics event here by design: this stream message only forwards
            // recommendations to the host via a generic callback. Surfacing/interaction
            // analytics are owned by the recommendations banner UI that consumes them.
            onSpaceSourceRecommendations?.(streamMessage.message.space_id, streamMessage.message.recommendations);
            else {
                const conversation = getState().conversations[getState().currentConversationId];
                if (conversation) {
                    if (conversation.status !== (0, $bPHr8.CHAT_STORE_STATUS).typingResponse) updateCurrentConversation({
                        status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse
                    });
                }
            }
            if ((0, $ljUdP.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
            if ((0, $ljUdP.isStreamAnswerGenerationType)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) {
                isLuminaAnswerGenerationType = streamMessage.message.answer_generation_type === 'LUMINA';
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerGenerationType)(getMessages(conversationId), tmpAssistantMessageId, streamMessage.message.answer_generation_type));
            }
            {
                const { deepResearchInvoked: deepResearchInvoked } = $54793c520b6b8872$export$5a07e6227eed9665({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                if (deepResearchInvoked) trackingAttributes.deepResearchInvoked = true;
            }
            // The backend autonomously triggered thinking mode (implicit think-deeper) even though
            // the user did not explicitly enable it. Cancel the auto-mode browser metrics so these
            // slow requests don't count against the <16s/<30s SLOs, and re-attribute them to the
            // think-deeper metrics instead.
            if (!thinkDeeperEnabled && !hasAbortedForImplicitThinkDeeper && (0, $ljUdP.isStreamThinkDeeperTriggered)(streamMessage)) {
                hasAbortedForImplicitThinkDeeper = true;
                // Cancel auto-mode metrics so they are not recorded in the SLOs
                stopInteractionMetricsTimeToFirstAnswerPart('cancel');
                sendMessageLatencyMetrics.cancel();
                // Re-attribute to think-deeper metrics (100s SLO target)
                implicitThinkDeeperSendMessageMetrics = (0, $0e7d0025813be8f5$export$1e4d1659c4209dbf).createSendMessageMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics = (0, $0e7d0025813be8f5$export$1e4d1659c4209dbf).createTimeToFirstAnswerPartMetrics({
                    thinkDeeperEnabled: true
                });
                implicitThinkDeeperSendMessageMetrics.start({
                    startTime: metricsStartTime
                });
                implicitThinkDeeperTimeToFirstAnswerPartMetrics.start({
                    startTime: metricsStartTime
                });
                // Abort the auto-mode reliability SLO experience and start the think-deeper one
                // so implicit think-deeper requests don't count against the auto-mode reliability SLO.
                implicitThinkDeeperExperienceName = (0, $16lEl.sendMessageExperienceName)({
                    thinkDeeperEnabled: true
                });
                experienceTracker.abort({
                    name: sendMessageExperienceNameCompiled,
                    reason: 'Re-attributed to think-deeper reliability SLO'
                });
                experienceTracker.start({
                    name: implicitThinkDeeperExperienceName,
                    id: conversationId,
                    startTime: metricsStartTime,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: trackingAttributes.interactionSource,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                    }
                });
            }
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!trackingAttributes.requestId && 'metadata' in streamMessage) trackingAttributes.requestId = streamMessage.metadata?.request_id ?? undefined;
            if ((0, $ljUdP.isStreamResponse)(streamMessage)) trackingAttributes.interactionModeExecuted = (0, $9likX.getInteractionModeExecutedFromStreamResponse)(streamMessage);
            // Handle MEMORY_UPDATE trace messages - create a persistent StoreMemoryUpdate message
            if ((0, $ljUdP.isStreamMemoryUpdate)(streamMessage) && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- This Statsig experiment is not registered in platform feature flags/editor experiments.
            (0, $c6GJD.default).getExperimentValue('memory_management_ux', 'isEnabled', false)) {
                const originalContent = streamMessage.message.content;
                const isMemoryTraceContentEmpty = !originalContent;
                let memoryContent = originalContent;
                let isMemoryContentAfterParsingEmpty = false;
                // Parse memory content: remove "Update memory:" prefix and trim
                if (memoryContent) {
                    memoryContent = memoryContent.replace(/^update\s+memory:\s*/i, '').trim();
                    isMemoryContentAfterParsingEmpty = !memoryContent;
                }
                const memoryUpdateMessage = {
                    type: 'MEMORY_UPDATE',
                    content: memoryContent || undefined // Use undefined instead of empty string
                };
                // Track memory update parsing events
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'parsed',
                    actionSubject: 'memoryUpdate',
                    attributes: {
                        isMemoryTraceContentEmpty: isMemoryTraceContentEmpty,
                        isMemoryContentAfterParsingEmpty: isMemoryContentAfterParsingEmpty,
                        conversationId: conversationId
                    }
                });
                setMessages(conversationId, (0, $cteoa.addMemorytoLatestAssistantMessage)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    memory: memoryUpdateMessage,
                    useIndex: answerIndex
                }));
            }
            // Usually the second stream part, before anything else occurs
            if ((0, $ljUdP.isStreamTrace)(streamMessage)) {
                if (!deepResearchEnabled) // we do not want traces that are not marked for deep research to be accumulated when starting research,
                // the ones that are marked are processed above in processResearchStreamMessage
                updateCurrentConversation({
                    traces: (0, $cteoa.dedupeTraceMessagesWithLatest)([
                        ...(0, $cteoa.getConversationTraces)(getState(), conversationId),
                        (0, $cteoa.getTraceFromStreamMessage)(streamMessage)
                    ])
                });
                promptStreamHook?.onTraceMessage?.(streamMessage, tmpAssistantMessageId, openChat);
                setMessages(conversationId, (0, $cteoa.addRequestIdToLatestHumanMessage)(getMessages(conversationId), trackingAttributes.requestId));
            }
            // Handle Answer Now fast mode traces for extended thinking
            // Answer Now feature - handle fast mode traces
            if ((0, $ljUdP.isStreamFastModeResponseAvailable)(streamMessage) && agentMessageId) // Fast mode response is available - show Answer Now button
            // Store both IDs in AVAILABLE status:
            // - tmpMessageId: for store operations (finding/updating the message)
            // - remoteMessageId: for the Answer Now API call
            setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                type: (0, $bPHr8.AnswerNowStatusType).AVAILABLE,
                tmpMessageId: tmpAssistantMessageId,
                remoteMessageId: agentMessageId
            }));
            if ((0, $ljUdP.isStreamFastModeEnabled)(streamMessage)) {
                // Fast mode has been enabled:
                // 1. Set status to SWITCHED (hides button)
                // 2. Clear research steps for this message
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).SWITCHED
                }));
                // Clear research steps when switching to fast mode
                clearMessageResearch({
                    messageId: tmpAssistantMessageId
                });
            }
            if ((0, $ljUdP.isStreamRemoveAnswerNow)(streamMessage)) (0, $cteoa.clearAnswerNowStatusForMessageIfSet)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
            // isStreamResearchPlan is handled by processResearchStreamMessage (called earlier in this loop)
            const aifcActionResult = (0, $aa1291e40260ba05$export$baa645f348bcec07)({
                streamMessage: streamMessage,
                conversationId: conversationId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                traceId: traceId,
                productKey: productKey,
                deepResearchEnabled: deepResearchEnabled,
                storeUserMessages: storeUserMessages,
                streamActionInfo: streamActionInfo,
                trackingAttributes: trackingAttributes,
                experienceTracker: experienceTracker,
                chatContextStoreActions: chatContextStoreActions,
                getMessages: getMessages,
                setMessages: setMessages,
                sendAnalyticsEvent: sendAnalyticsEvent,
                getIsChatMounted: getIsChatMounted,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                promptStreamHook: promptStreamHook,
                openChat: openChat,
                messageSources: messageSources,
                creationContextParams: creationContextParams,
                agentId: agentId,
                agentName: agentName,
                agentIdentityAccountId: agentIdentityAccountId,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart
            });
            hasReceivedActionClassification || (hasReceivedActionClassification = aifcActionResult.hasReceivedActionClassification);
            hasReceivedActionComplete || (hasReceivedActionComplete = aifcActionResult.hasReceivedActionComplete);
            if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                stopInteractionMetricsTimeToFirstAnswerPart('stop', {
                    answerType: 'stream-answer-part',
                    conversationId: conversationId
                });
                // Stop the implicit think-deeper time-to-first-answer-part metric if active
                implicitThinkDeeperTimeToFirstAnswerPartMetrics?.stop({
                    customData: {
                        answerType: 'stream-answer-part',
                        conversationId: conversationId
                    }
                });
                // Clear Answer Now status when ANSWER_PART is received
                // This handles the case where the stream starts answering without user clicking Answer Now
                (0, $cteoa.clearAnswerNowStatusForMessageIfSet)(conversationId, tmpAssistantMessageId, getMessages, setMessages);
                // Sometimes an ANSWER_PART arrives with empty content, which clears traces
                // prematurely and makes the live "thinking" steps flash and disappear. Skip the
                // clear for empty answer parts so traces persist until real content arrives.
                const isEmptyAnswerPart = typeof streamMessage.message.content === 'string' && streamMessage.message.content.length === 0;
                const skipClearForEmptyAnswerPart = (0, $dh538.fg)('rovo_chat_skip_trace_clear_on_empty_answer_part') && isEmptyAnswerPart;
                if (!skipClearForEmptyAnswerPart) {
                    (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    // Mark hasReceivedAnswerPart on the chat store message atomically with the
                    // trace clear. This avoids a cross-store render gap (chat store vs research
                    // store) where the thinking indicator would briefly re-appear.
                    setMessages(conversationId, (getMessages(conversationId) ?? []).map((msg)=>{
                        if (msg.type === 'ASSISTANT' && msg.content.message?.message?.id === tmpAssistantMessageId) return {
                            ...msg,
                            hasReceivedAnswerPart: true
                        };
                        return msg;
                    }));
                }
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                if (!isLuminaAnswerGenerationType) {
                    const result = getProcessStreamMarkdownMultiTag()(processedStreamMessage);
                    processedStreamMessage = result.processedStreamMessage;
                    if (Object.keys(result.markdownData).length > 0) {
                        hasMarkdownData = true;
                        setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownDataMap)({
                            chat: getMessages(conversationId),
                            answerId: tmpAssistantMessageId,
                            answerPart: processedStreamMessage,
                            markdownData: result.markdownData,
                            useIndex: answerIndex
                        }));
                    }
                }
                if (!isLuminaAnswerGenerationType) promptStreamHook?.onAnswerPart?.(processedStreamMessage, tmpAssistantMessageId, conversationId);
                if (!hasMarkdownData) setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    answerPart: streamMessage,
                    useIndex: answerIndex
                }));
            // hasAccumulatedAnswerContent tracking is handled by processResearchStreamMessage
            }
            /**********************************************************
       *
       * FINAL_RESPONSE processing
       *
       **********************************************************/ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                const humanMessage = streamMessage?.message?.human_message;
                const humanMessageId = humanMessage?.id?.toString();
                const agentMessageId = streamMessage?.message?.message?.id.toString();
                // Record the backend-assigned conversation ID on the optimistic entry so the
                // space sidenav merge logic can dedupe between the local optimistic entry
                // (client UUID) and the API-returned entry (backend ID), and display the
                // correct name from the chat store rather than the timestamp fallback.
                const backendConversationId = streamMessage?.message?.message?.conversation_channel_id;
                if (backendConversationId) updateCurrentConversation({
                    backendConversationId: backendConversationId
                });
                const minionOrchestrationOutputs = streamMessage?.message?.message?.minion_outputs;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                // INVARIANT: updateResearchMessageId MUST be called before replaceAnswerData (and the
                // setMessages call that wraps it). Both stores must agree on the same messageId key
                // before React re-renders — if the chat store ID flips to agentMessageId first,
                // the next render will call getMessageResearchById(agentMessageId) and get undefined
                // because the research store is still keyed under tmpAssistantMessageId, causing
                // completed traces to disappear.
                //
                // Nothing between this call and replaceAnswerData below should read the research
                // store using tmpAssistantMessageId (markdown processing and clearTracesIfNotEmpty
                // above do not touch the research store after this point).
                if (tmpAssistantMessageId !== agentMessageId) updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = !isLuminaAnswerGenerationType ? (0, $cteoa.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: agentMessageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
                }) : {
                    processedStreamMessage: streamMessage,
                    markdownData: {}
                };
                // Finish view dead air tracking before rendering final response
                // This ensures the last tracked interval is up to FINAL_RESPONSE arrival,
                // and any DOM updates from replaceAnswerData are not tracked
                viewDeadAirBroker?.finish('completed');
                promptStreamHook?.onFinalResponse?.(processedStreamMessage, tmpAssistantMessageId);
                setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                    onMessageIdChanged: onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced
                }));
                if (humanMessageId) setMessages(conversationId, (0, $cteoa.updateHumanMessageId)({
                    chat: getMessages(conversationId),
                    oldId: tmpHumanMessageId,
                    newId: humanMessageId,
                    parentMessageId: humanMessage?.parent_message_id
                }));
                if ((0, $dh538.fg)('aifc_create_enabled')) {
                    const allMessages = getMessages(conversationId);
                    const isValidAction = (0, $cteoa.handleStagingAreaActionValidation)(allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, {
                        llmDebugLogsEnabled: storeUserMessages
                    }, productKey, minionOrchestrationOutputs);
                    if (!isValidAction) return {
                        hasReceivedFinalResponse: hasReceivedFinalResponse,
                        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                        guardEventReceived: guardEventReceived
                    };
                    const finalActions = processedStreamMessage.message.message.actions || [];
                    if (finalActions.length > 0) {
                        const firstActionData = finalActions[0]?.data;
                        stopInteractionMetricsTimeToActionCompletion('stop', {
                            conversationId: conversationId,
                            actionType: 'final-actions',
                            actionCount: finalActions.length,
                            actionKeys: finalActions.map((a)=>a.key),
                            actionPartKey: (0, $cteoa.getActionPartKeyForMetrics)(streamActionInfo.actionKey, creationContextParams?.source, firstActionData?.dynamicUiSubtype),
                            interactionSource: messageSources?.interactionSource,
                            remixType: creationContextParams?.dynamicUiType
                        });
                    } else stopInteractionMetricsTimeToActionCompletion('cancel');
                }
                // Update tracking attributes from FINAL_RESPONSE using the shared extractor.
                const streamMeta = (0, $cteoa.extractStreamMeta)(streamMessage, skillSelectionSource, (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true));
                if (!hasLoggedInitiatedEvent) {
                    trackingAttributes.messageId = agentMessageId;
                    trackingAttributes.instrumentationId = agentMessageId;
                }
                trackingAttributes.humanMessageId = streamMeta.humanMessageId;
                trackingAttributes.hasSources = streamMeta.hasSources;
                trackingAttributes.citedProductList = streamMeta.citedProductList;
                trackingAttributes.sourceProducts = streamMeta.sourceProducts;
                trackingAttributes.messageActions = streamMeta.messageActions;
                trackingAttributes.messageDynamicUIData = streamMeta.messageDynamicUIData;
                trackingAttributes.invokedFrom = streamMeta.invokedFrom;
                trackingAttributes.scenarioId = streamMeta.scenarioId;
                trackingAttributes.sources = streamMeta.responseSources;
                trackingAttributes.usesJsm = streamMeta.usesJsm;
                // Keep Set type for compatibility with downstream consumers that call Array.from()
                trackingAttributes.pluginsInvoked = new Set(streamMeta.pluginsInvoked);
                trackingAttributes.skillsInvoked = streamMeta.skillsInvoked;
                trackingAttributes.executedStratusSkill = streamMeta.executedStratusSkill;
                const flatMinionOutputs = minionOrchestrationOutputs?.flat() ?? [];
                // Analytics: Verify if minion alias matches minion id
                (0, $bd83b455fe877f94$export$8bfbf77736e8f6e2)({
                    minionAlias: minionAlias,
                    agentId: agentId,
                    minionsOutput: flatMinionOutputs,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
            }
            if ((0, $ljUdP.isStreamDynamicLayoutSubAgent)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) setMessages(conversationId, (0, $cteoa.addSubAgentMessageToStoreAssistantMessage)(getMessages(conversationId), tmpAssistantMessageId, streamMessage));
            if ((0, $ljUdP.isStreamAgenticUi)(streamObj) && (0, $dh538.fg)('jira_ai_rendering_a2ui')) {
                const normalizedAgenticUiMessage = {
                    ...streamObj.data,
                    type: 'AGENTIC_UI'
                };
                setMessages(conversationId, (0, $cteoa.addAgenticUiMessage)(getMessages(conversationId), tmpAssistantMessageId, normalizedAgenticUiMessage));
            }
            if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                hasReceivedFollowUp = true;
                const messages = getMessages(conversationId);
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                const augmentedFollowUp = (0, $cteoa.appendCreatePageFollowUpIfNeeded)(messages, streamMessage, productKey, chatContextStoreActions.getIsStagingArea());
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: augmentedFollowUp,
                        id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                        humanMessageId: trackingAttributes.humanMessageId
                    }
                ]);
            }
            /**
       * Task status processing
       */ if ((0, $ljUdP.isStreamTaskStatus)(streamMessage)) onTaskStatusUpdate?.(streamMessage);
            /**
       * Todo snapshot processing
       */ if ((0, $ljUdP.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            if ((0, $ljUdP.isStreamActionError)(streamMessage)) {
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamMessage?.message?.key,
                    errorMessage: streamMessage?.message?.data?.message,
                    traceId: traceId
                });
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                const actionError = new (0, $eu7N9.StreamErrorException)(streamMessage.message.data?.message || 'Action execution failed', {
                    detail: {
                        message: {
                            content: streamMessage?.message?.data?.message || 'Action execution failed',
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: chatContextStoreActions.getIsStagingArea(),
                            productKey: productKey
                        }
                    },
                    traceId: traceId
                });
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: actionError,
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isDeepResearchEnabled: deepResearchEnabled,
                        isThinkDeeperEnabled: thinkDeeperEnabled,
                        isFastModeEnabled: fastModeEnabled,
                        isWebSearchEnabled: webSearchEnabled,
                        llmDebugLogsEnabled: storeUserMessages,
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey
                    }
                });
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                    error: actionError,
                    attributes: {
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey,
                        llmDebugLogsEnabled: storeUserMessages,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        latestStreamMessageMillisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                        latestStreamMessageType: latestStreamMessage?.type
                    }
                });
                if ((0, $dh538.fg)('aifc-experience-timeout')) {
                    const reason = streamActionInfo.isAction ? 'action_error_while_executing_action' : 'action_error_without_classification';
                    for (const name of [
                        (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                        (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
                    ])experienceTracker.fail({
                        name: name,
                        error: actionError,
                        attributes: {
                            productKey: productKey,
                            actionKey: streamActionInfo.actionKey,
                            reason: reason
                        }
                    });
                }
                throw actionError;
            }
            if ((0, $ljUdP.isStreamPromptRedaction)(streamMessage)) {
                const redactingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) // Do NOT set guardEventReceived — the stream continues with the actual response after redaction.
                onPromptRedacted?.(streamMessage);
            }
            if ((0, $ljUdP.isStreamPromptBlock)(streamMessage)) {
                const blockingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onPromptBlocked?.(streamMessage);
                }
            }
            if ((0, $ljUdP.isStreamResponseRedaction)(streamMessage)) {
                const redactingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_redacting_guard_config').value?.value ?? [];
                if (redactingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) // Do NOT set guardEventReceived — stream continues after response redaction.
                onResponseRedacted?.(streamMessage);
            }
            if ((0, $ljUdP.isStreamResponseBlock)(streamMessage)) {
                const blockingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onResponseBlocked?.(streamMessage);
                }
            }
            if ((0, $ljUdP.isStreamAttachmentBlock)(streamMessage)) {
                const blockingTypes = (0, $c6GJD.default).getExperiment('rovo_chat_blocking_guard_config').value?.value ?? [];
                if (blockingTypes.includes(streamMessage.type) && (0, $dh538.fg)('rovo-guard-ui-redaction-and-blocking')) {
                    guardEventReceived = true;
                    onAttachmentBlocked?.(streamMessage);
                }
            }
            if ((0, $ljUdP.isStreamError)(streamMessage)) {
                processMessageStreamError?.({
                    actionKey: streamActionInfo.actionKey,
                    errorType: streamMessage?.message?.message_template,
                    errorMessage: streamMessage?.message?.content,
                    traceId: traceId
                });
                // If a guard event (PROMPT_REDACTION, PROMPT_BLOCKED, RESPONSE_BLOCKED, or ATTACHMENT_BLOCKED) was
                // already received, the backend always follows with an ERROR to terminate the stream.
                // Treat it as a normal end of the guard flow — break without throwing.
                if (guardEventReceived) break;
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                // AUP violations are still considered successful
                if ((0, $ljUdP.isStreamAUPError)(streamMessage)) {
                    experienceTracker.succeed({
                        name: sendMessageExperienceNameCompiled
                    });
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE
                    });
                }
                sendMessageLatencyMetrics.cancel();
                deadAirTracker?.cancel();
                viewDeadAirBroker?.finish('errored');
                cancelStreamingMetrics();
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                throw new (0, $eu7N9.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
    } catch (error) {
        /* for await catch block */ const err = error instanceof Error ? error : new Error(String(error));
        if (err instanceof (0, $eu7N9.StreamErrorException)) throw err;
        // this is for any errors that happening during processing the stream
        // e.g. BE terminates streaming suddenly
        sendMessageLatencyMetrics.cancel();
        deadAirTracker?.cancel();
        viewDeadAirBroker?.finish('aborted');
        cancelStreamingMetrics();
        if ((0, $cteoa.isClientSideStreamingError)(err)) {
            const isReconnectable = !!(agentMessageId && isReconnectSupported);
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'rovoChatStream',
                attributes: {
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    isReconnectable: isReconnectable,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent,
                    error: err.message
                }
            });
        }
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        // When reconnect attempt fails
        if (!deepResearchEnabled && (0, $dh538.fg)('aifc-experience-timeout')) {
            const reason = streamActionInfo.isAction ? 'stream_error_during_action' : 'stream_error_before_classification';
            for (const name of [
                (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
            ])experienceTracker.fail({
                name: name,
                error: err,
                attributes: {
                    productKey: productKey,
                    actionKey: streamActionInfo.actionKey,
                    reason: reason
                }
            });
        }
        throw new (0, $5yETg.StreamGeneratorError)(err.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, err);
    } finally{
        inactivity?.stop();
        deadAirTracker?.complete();
        viewDeadAirBroker?.finish('completed');
    }
    /**********************************************************
   *
   * Stream processing END
   *
   **********************************************************/ if (hasReceivedActionClassification && !hasReceivedActionComplete && hasReceivedFinalResponse) // In the case ACTION_COMPLETE was never sent, it's likely that `AdfEditorMinion` early-exits with "no operations returned by LLM". So we abort the experiences rather than letting them timeout. This can potentially happen when LLM needs clarification.
    (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, 'stream_completed_without_action_complete', {
        actionKey: streamActionInfo.actionKey,
        productKey: productKey
    });
    if (!hasReceivedFollowUp && hasReceivedFinalResponse) {
        const messages = getMessages(conversationId);
        if ((0, $cteoa.shouldAppendCreatePageFollowUp)(messages, productKey, chatContextStoreActions.getIsStagingArea())) setMessages(conversationId, [
            ...messages,
            {
                type: 'FOLLOW_UP',
                content: (0, $cteoa.createSyntheticCreatePageFollowUp)(),
                id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                humanMessageId: trackingAttributes.humanMessageId
            }
        ]);
    }
    updateCurrentConversation({
        sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
    });
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse,
        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
        hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper,
        implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics,
        implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName,
        guardEventReceived: guardEventReceived
    };
};
/**
 * Compute the per-send routing identity for a send.
 *
 * Wraps `deriveAgentSendRequestIdentity` with the shared inputs (default agent,
 * explicit caller agent id, and the draft-only-on-chatInput override rule) so the
 * outer early-handler fallback and the inner per-send path stay in lockstep.
 *
 * The no-override wire/routing fallback follows the CALLER's agent intent
 * (`conversationAgentForRequest`), not necessarily the stored conversation agent:
 * in-sidebar sends pass the conversation's own agent, a cross-surface pass-over
 * passes default Rovo. This keeps author and wire consistent for the turn and
 * matches gate-off. See ai-mate AGENTS.md "Rovo Chat agent identity, routing, and
 * display".
 */ const $54793c520b6b8872$var$deriveSendRoutingIdentity = ({ conversationAgentForRequest: conversationAgentForRequest, agentIdParam: agentIdParam, inputSelectedAgentIds: inputSelectedAgentIds, messageSources: messageSources, omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields })=>(0, $3e5408ba1f60d629$export$4413981bab4da984)({
        conversationAgent: conversationAgentForRequest,
        defaultAgent: (0, $1cjt9.DEFAULT_AGENT),
        explicitAgentId: agentIdParam,
        omitConversationDefaultAgentRequestFields: omitConversationDefaultAgentRequestFields,
        inputSelectedAgentIds: inputSelectedAgentIds,
        // The unsent agent-selector draft only routes when the send originates with
        // `messageSources.interactionSource === 'chatInput'`; cross-surface handoffs
        // (e.g. the Confluence inline Rovo input) must not inherit the sidebar's draft.
        allowSelectedAgentOverride: messageSources?.interactionSource === 'chatInput'
    });
/**
 * Build the optimistic `conversation.agent` metadata used when a send creates the
 * conversation. Prefers the already-stored conversation agent, then the caller's
 * rich agent metadata when it matches the resolved conversation agent id, then a
 * provisional placeholder built from that id (the header hydrates the rest).
 */ const $54793c520b6b8872$var$buildOptimisticConversationAgent = ({ agent: agent, currentConversation: currentConversation, conversationAgentId: conversationAgentId })=>{
    const callerAgentMatchesConversation = agent.id === conversationAgentId;
    const callerAgentConversationMetadata = callerAgentMatchesConversation ? {
        agent_id: agent.id,
        agent_named_id: agent.external_config_reference ?? agent.named_id,
        agent_name: agent.name,
        creator_type: agent.creator_type,
        identity_account_id: agent.identity_account_id ?? undefined,
        is_default: agent.is_default,
        forge_url: agent.icon ?? undefined
    } : undefined;
    return currentConversation?.agent ?? callerAgentConversationMetadata ?? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(conversationAgentId);
};
const $54793c520b6b8872$export$9558791053c77c34 = ({ prompt: prompt, agent: /*
  As of RAGE-60 the default agent is no longer required to be sent to the backend, however
  it is still required for other local logic
  TODO: https://product-fabric.atlassian.net/browse/RAGE-418
  */ agent = (0, $1cjt9.DEFAULT_AGENT), agentId: agentIdParam, conversationId: conversationIdParam, storeUserMessages: storeUserMessages, messageSources: messageSources, files: files, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, webSearchEnabled: webSearchEnabled, appFilters: appFilters, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, productKey: productKey, source: source, promptStreamHook: promptStreamHook, creationContextParams: creationContextParams, additionalAnalyticAttributes: additionalAnalyticAttributes, contentContext: contentContext, minionAlias: minionAlias, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, contentId: contentId, openChat: openChat, openChatOnError: openChatOnError, agentVersion: agentVersion, spaceId: spaceId, searchArtifact: searchArtifact, skillSelectionSource: skillSelectionSource, skipEditorContext: skipEditorContext, shouldExtractConversationScopes: shouldExtractConversationScopes, parentMessageId: parentMessageId, editRollback: editRollback, inputSelectedAgentIds: inputSelectedAgentIds, setConversationData: setConversationData, createConversationOptimistically: createConversationOptimistically, addHumanMessage: addHumanMessage, addAssistantMessage: addAssistantMessage, clearFollowUpMessages: clearFollowUpMessages, setSelectedConversation: setSelectedConversation, reconnectToInProgressStream: reconnectToInProgressStream })=>async ({ dispatch: dispatch, getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, markIncompleteResearchesErrored: markIncompleteResearchesErrored, updateResearchMessageId: updateResearchMessageId, clearMessageResearch: clearMessageResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, getChatInitiator: getChatInitiator, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamError: processMessageStreamError, processMessageStreamActionClassification: processMessageStreamActionClassification, broadcastStreamStatus: broadcastStreamStatus, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage, onTempMessageIdReplaced: containerOnTempMessageIdReplaced, browserContextSanitizer: browserContextSanitizer, viewDeadAirBroker: viewDeadAirBroker, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions, onSpaceSourceRecommendations: onSpaceSourceRecommendations })=>{
        const initialConversationForRouting = (0, $cteoa.getConversation)(getState(), conversationIdParam ?? getState().currentConversationId);
        const conversationAgentIdForRoutingFallback = (0, $ce0ec8f0bfa0c691$export$9e56ee965c896858)({
            conversation: initialConversationForRouting,
            fallbackAgentId: agent.id
        });
        // `sourceAgentId` for the temporary local conversation; per-turn routing is computed by `deriveSendRoutingIdentity`.
        const sourceAgentIdForTemporaryLocalConversation = agentIdParam ?? agent.id;
        const { messageType: messageType } = $54793c520b6b8872$var$getOptimisticMessageTypes(deepResearchEnabled, webSearchEnabled);
        (0, $9963cc910aac4af3$export$589976df4d188aac)(Date.now());
        let pageContext;
        // Snapshot captured right before the optimistic add when `editRollback` is set,
        // so that a terminal failure can restore the conversation to its pre-edit state
        // by slicing back to this length and re-appending `editRollback.restoreMessages`.
        let rollbackSnapshot;
        const performEditRollback = ()=>{
            if (!editRollback || !rollbackSnapshot) return;
            const { conversationId: rollbackConvId, lengthBeforeOptimistic: lengthBeforeOptimistic } = rollbackSnapshot;
            const current = getMessages(rollbackConvId);
            setMessages(rollbackConvId, [
                ...current.slice(0, lengthBeforeOptimistic),
                ...editRollback.restoreMessages
            ]);
        };
        const sendMessageFn = async ({ conversationId: conversationId })=>{
            const currentConversation = (0, $cteoa.getConversation)(getState(), conversationId);
            const currentConversationAgentId = (0, $ce0ec8f0bfa0c691$export$9e56ee965c896858)({
                conversation: currentConversation,
                fallbackAgentId: conversationAgentIdForRoutingFallback
            });
            const conversationAgentForOptimisticCreation = $54793c520b6b8872$var$buildOptimisticConversationAgent({
                agent: agent,
                currentConversation: currentConversation,
                conversationAgentId: currentConversationAgentId
            });
            const { routedSelectedAgentId: routedSelectedAgentId, routingAgentId: routingAgentId, agentIdForRequest: agentIdForRequest, agentNamedIdForRequest: agentNamedIdForRequest } = $54793c520b6b8872$var$deriveSendRoutingIdentity({
                conversationAgentForRequest: {
                    id: agent.id,
                    named_id: agent.named_id
                },
                agentIdParam: agentIdParam,
                inputSelectedAgentIds: inputSelectedAgentIds,
                messageSources: messageSources,
                omitConversationDefaultAgentRequestFields: true
            });
            const sendMessageExperienceNameCompiled = $54793c520b6b8872$var$getSendMessageExperienceName({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                taskModeEnabled: taskModeEnabled,
                fastModeEnabled: fastModeEnabled,
                isCustomRovoAgent: (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(routingAgentId)
            });
            const resolvedAgentVersion = agentVersion ?? currentConversation?.agentVersion;
            if (currentConversation?.storeAbortController) // Silently aborting if there is another operation in progress
            return;
            const tmpHumanMessageId = (0, $cteoa.generateId)();
            const tmpAssistantMessageId = (0, $cteoa.generateTmpMessageId)(conversationId);
            let generator;
            let responseData;
            let hasLoggedInitiatedEvent = false;
            const isFirstPrompt = (0, $cteoa.isEmptyConversation)(conversationId);
            const contentContextFromStore = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
            const contentContextValue = contentContext ?? contentContextFromStore;
            let trackingAttributes = $54793c520b6b8872$var$getInitialTrackingAttributes(routingAgentId, tmpAssistantMessageId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, taskModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, {
                templateId: creationContextParams?.templateInput?.templateId,
                templateType: creationContextParams?.templateInput?.templateType
            }, creationContextParams?.forcedContentType);
            // Prepare fields for the temporary local conversation created before the backend returns one.
            const conversationAgentForTemporaryLocalConversation = (0, $dh538.fg)('rovo_chat_agent_selection') ? conversationAgentForOptimisticCreation : undefined;
            const conversationAgentFieldsForTemporaryLocalConversation = conversationAgentForTemporaryLocalConversation ? {
                agent: conversationAgentForTemporaryLocalConversation
            } : {};
            if (isFirstPrompt) {
                conversationId = crypto.randomUUID();
                onNewConversationStartingWithSendMessage(conversationId, {
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    ...taskModeEnabled ? {
                        planModeEnabled: taskModeEnabled
                    } : {},
                    webSearchEnabled: webSearchEnabled,
                    useCurrentPageContext: addCurrentPageAsContextUserPreference,
                    appFilters: appFilters
                });
                // Create the conversation with its initial identity; first-turn routing may
                // refine `conversation.agent` below.
                dispatch(createConversationOptimistically({
                    id: conversationId,
                    status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
                    sourceAgentId: currentConversation?.sourceAgentId ?? sourceAgentIdForTemporaryLocalConversation,
                    lastMessageType: messageType,
                    lastAgentMessageStatus: 'IN_PROGRESS',
                    // Immediately scope the optimistic conversation to the space so it
                    // appears under the space in the sidenav rather than the regular list.
                    ...spaceId && (0, $dh538.fg)('rovo_chat_spaces_fe') ? {
                        rovoSpaceId: spaceId
                    } : {},
                    ...resolvedAgentVersion && (0, $dh538.fg)('rovo_agent_versioning_enabled') ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...conversationAgentFieldsForTemporaryLocalConversation
                }));
                (0, $5dfb4fd04d2ab8e2$export$a100e5b47ee5ac9a)();
                // First-turn routing can refine display identity; keep `sourceAgentId` as history.
                const normalizedRoutingAgentId = routingAgentId || undefined;
                const routedConversationAgent = (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(normalizedRoutingAgentId);
                if ((0, $dh538.fg)('rovo_chat_agent_selection') && routedConversationAgent && normalizedRoutingAgentId !== currentConversationAgentId) dispatch(setConversationData({
                    conversationId: conversationId,
                    data: {
                        agent: routedConversationAgent
                    }
                }));
            }
            const { sendMessageLatencyMetrics: sendMessageLatencyMetrics, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, cancelStreamingMetrics: cancelStreamingMetrics, metricsStartTime: metricsStartTime } = $54793c520b6b8872$var$initLatencyMetrics({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                agentId: routingAgentId
            });
            experienceTracker.start({
                name: sendMessageExperienceNameCompiled,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    interactionSource: messageSources?.interactionSource,
                    featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                }
            });
            const chatInitiator = getChatInitiator();
            const { isRemixFollowUp: isRemixFollowUp, lastAssistantMessageDynamicUiType: lastAssistantMessageDynamicUiType } = (()=>{
                const lastAction = (0, $cteoa.findLastAssistantAction)(getMessages(conversationId), ()=>true);
                if (!lastAction || !(0, $3vCSA.isRemixGeneratedFlow)(lastAction)) return {
                    isRemixFollowUp: false,
                    lastAssistantMessageDynamicUiType: undefined
                };
                // BE stores dynamicUiType under `contentType` in action data
                const contentType = lastAction.data?.contentType;
                return {
                    isRemixFollowUp: true,
                    lastAssistantMessageDynamicUiType: contentType
                };
            })();
            let sendMessageContext;
            try {
                sendMessageContext = await $54793c520b6b8872$var$populateSendMessageContext(chatContextStoreActions, isFirstPrompt, source, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, contentId, lastAssistantMessageDynamicUiType, skipEditorContext, isRemixFollowUp, searchArtifact);
            } catch (error) {
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: error,
                    attributes: {
                        deepResearchEnabled: deepResearchEnabled,
                        fastModeEnabled: fastModeEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        webSearchEnabled: webSearchEnabled,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        failureSource: 'populateSendMessageContext'
                    }
                });
                // Note: We don't track error in error event as discussed here:
                // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/341408/overview#comment-2004687398
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                return;
            }
            // spaceId comes from the emptyChatLaunch projectContext (e.g. rovo-for-you space card chat button).
            const resolvedSpaceId = spaceId ?? sendMessageContext.aiFeatureContext?.projectContext?.spaceId;
            const storeState = chatContextStoreActions.getAllContext();
            trackingAttributes.contextProvided = Object.entries(storeState).reduce((acc, [key, value])=>{
                acc[key] = Boolean(value);
                return acc;
            }, {});
            trackingAttributes.contextProvided.editorContext = Boolean(sendMessageContext.editorContext);
            trackingAttributes.contextProvided.whiteboardContext = Boolean(sendMessageContext.whiteboardContext);
            trackingAttributes.contextProvided.slidesContext = Boolean(sendMessageContext.slidesContext);
            trackingAttributes.contextProvided.databaseContext = Boolean(sendMessageContext.databaseContext);
            trackingAttributes.contextProvided.browserContext = Boolean(sendMessageContext.browserContext);
            trackingAttributes.contextProvided.dashboardContext = Boolean(sendMessageContext.dashboardContext);
            trackingAttributes.contextProvided.aiFeatureContext = Boolean(sendMessageContext.aiFeatureContext);
            trackingAttributes.contextProvided.jiraWorkflowContext = Boolean(sendMessageContext.jiraWorkflowContext);
            trackingAttributes.contextProvided.domContext = Boolean(sendMessageContext.browserContext?.context?.htmlBody);
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    timestamp: undefined,
                    messageId: trackingAttributes.humanMessageId,
                    interactionSource: trackingAttributes.interactionSource,
                    followUpSource: trackingAttributes.followUpSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    maxModeEnabled: trackingAttributes.taskModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    contextProvided: trackingAttributes.contextProvided,
                    initiator: chatInitiator,
                    isFirstPrompt: trackingAttributes.isFirstPrompt,
                    promptFeatures: trackingAttributes.promptFeatures,
                    fileCount: trackingAttributes.fileCount,
                    appFilters: trackingAttributes.appFilters,
                    appFilterCount: trackingAttributes.appFilterCount,
                    has3pApps: trackingAttributes.appFilters?.some((app)=>(0, $5vtU3.is3pApp)(app.friendlyName)),
                    template: trackingAttributes.template,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    conversationChannelId: conversationId
                }
            });
            if (editRollback && !rollbackSnapshot) rollbackSnapshot = {
                conversationId: conversationId,
                lengthBeforeOptimistic: getMessages(conversationId).length
            };
            const { abortController: abortController, confirmAbort: confirmAbort, updateCurrentConversation: updateCurrentConversation } = $54793c520b6b8872$var$hydrateStoreWithNewMessage(dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, sourceAgentIdForTemporaryLocalConversation, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages, routedSelectedAgentId);
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Broadcast stream status to content targets for state sharing
            const broadcastStreamLifecycle = (0, $cteoa.createBroadcastStreamLifecycle)({
                broadcastStreamStatus: broadcastStreamStatus,
                chatContextStoreActions: chatContextStoreActions,
                contentContextValue: contentContextValue,
                targetId: contentId,
                assistantMessageId: tmpAssistantMessageId
            });
            if ((0, $dh538.fg)('rovo_chat_send_context_ready_event')) broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).SEND_CONTEXT_READY);
            // Initialize action tracking
            let streamActionInfo = {
                isAction: false
            };
            // Create message stream
            try {
                // Derive page context for analytics from the available context objects
                pageContext = (0, $bb60cdbb8ebc402b$export$1303843c2f44065a)({
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    databaseContext: sendMessageContext.databaseContext,
                    aiFeatureContext: sendMessageContext.aiFeatureContext,
                    browserUrl: sendMessageContext.browserContext?.context?.browserUrl
                });
                trackingAttributes.pageContext = pageContext;
                trackingAttributes.viewContext = (0, $d097db038375fc24$export$20af16720c0f9c71)({
                    aiFeatureContext: sendMessageContext.aiFeatureContext
                });
                trackingAttributes.invokedFrom = (0, $cteoa.getInvokedFrom)({
                    messageActionKey: streamActionInfo?.actionKey
                });
                // Check if the Jira refresh experiment is enabled but default is set to `true` to pass all non-Jira products
                // Omit caller source controls only for sends routed by `routedSelectedAgentId`;
                // see `getSourceControlValueForBackend`.
                const webSearchEnabledForBackend = $54793c520b6b8872$export$7459a30868c458f({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: webSearchEnabled
                });
                const appFiltersForBackend = $54793c520b6b8872$export$7459a30868c458f({
                    routedSelectedAgentId: routedSelectedAgentId,
                    value: appFilters
                });
                const agentNamedIdForBackend = (0, $dh538.fg)('rovo_chat_agent_selection') ? agentNamedIdForRequest : undefined;
                const result = await assistanceService.sendMessageStream({
                    message: prompt,
                    agentId: agentIdForRequest,
                    // Gate-off must not introduce `recipient_agent_named_id` on the wire.
                    agentNamedId: agentNamedIdForBackend,
                    controller: abortController,
                    conversationId: conversationId,
                    storeMessage: storeUserMessages,
                    citationsEnabled: true,
                    fileIds: files?.map((file)=>file.id),
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    planModeEnabled: taskModeEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabledForBackend,
                    appFilters: appFiltersForBackend?.map((app)=>app.source),
                    browserContext: sendMessageContext.browserContext,
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    slidesContext: sendMessageContext.slidesContext,
                    databaseContext: sendMessageContext.databaseContext,
                    additionalContext: sendMessageContext.additionalContext,
                    aiFeatureContext: sendMessageContext.aiFeatureContext,
                    jiraWorkflowContext: sendMessageContext.jiraWorkflowContext,
                    dashboardContext: sendMessageContext.dashboardContext,
                    dashboardEditorContext: sendMessageContext.dashboardEditorContext,
                    useCurrentBrowsingContext: sendMessageContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer,
                    optInToDeepResearchV2: true,
                    optInThinkDeeperMessages: true,
                    optInAnsNow: true,
                    optInNewToolTraces: true,
                    optInNewTeamworkTraceIcons: (0, $dh538.fg)('rovo_chat_enable_twg_trace_team26'),
                    optInSSEStream: true,
                    ...resolvedAgentVersion ? {
                        agentVersion: resolvedAgentVersion
                    } : {},
                    ...resolvedSpaceId ? {
                        spaceId: resolvedSpaceId
                    } : {},
                    capabilities: capabilities,
                    shouldExtractConversationScopes: shouldExtractConversationScopes,
                    parentMessageId: parentMessageId
                });
                generator = result.generator;
                responseData = result.responseData;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $dh538.fg)('aifc_show_error_ui_for_inline_rovo')) promptStreamHook?.onError?.(error, tmpAssistantMessageId, {
                    openChatOnError: openChatOnError,
                    conversationId: conversationId
                });
                performEditRollback();
                $54793c520b6b8872$var$handleSendMessageServiceCallFailure(error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId, storeUserMessages);
                return;
            }
            const { hasReceivedFinalResponse: hasReceivedFinalResponse, hasLoggedInitiatedEvent: hasLoggedInitiatedEventForStream, hasAbortedForImplicitThinkDeeper: hasAbortedForImplicitThinkDeeper, implicitThinkDeeperSendMessageMetrics: implicitThinkDeeperSendMessageMetrics, implicitThinkDeeperExperienceName: implicitThinkDeeperExperienceName, guardEventReceived: wasGuardTerminated } = await $54793c520b6b8872$export$efb69f1fe7577739({
                prompt: prompt,
                generator: generator,
                productKey: productKey,
                answerIndex: answerIndex,
                tmpHumanMessageId: tmpHumanMessageId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                deepResearchEnabled: deepResearchEnabled,
                webSearchEnabled: webSearchEnabled,
                sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled,
                traceId: responseData?.traceId,
                updateCurrentConversation: updateCurrentConversation,
                trackingAttributes: trackingAttributes,
                conversationId: conversationId,
                getState: getState,
                promptStreamHook: promptStreamHook,
                openChat: openChat,
                openChatOnError: openChatOnError,
                experienceTracker: experienceTracker,
                setMessages: setMessages,
                getMessages: getMessages,
                processStreamResearch: processStreamResearch,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamError: processMessageStreamError,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                onSpaceSourceRecommendations: onSpaceSourceRecommendations,
                containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced,
                updateResearchMessageId: updateResearchMessageId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                chatContextStoreActions: chatContextStoreActions,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
                stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
                stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
                broadcastStreamLifecycle: broadcastStreamLifecycle,
                sendMessageLatencyMetrics: sendMessageLatencyMetrics,
                cancelStreamingMetrics: cancelStreamingMetrics,
                onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride,
                streamActionInfo: streamActionInfo,
                trackAIMAUEvent: trackAIMAUEvent,
                messageSources: messageSources,
                additionalAnalyticAttributes: additionalAnalyticAttributes,
                hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                clearMessageResearch: clearMessageResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                viewDeadAirBroker: viewDeadAirBroker,
                creationContextParams: creationContextParams,
                minionAlias: assistanceService.getConfig().minionAlias,
                agentId: routingAgentId,
                agentName: agent?.name,
                agentIdentityAccountId: agent?.identity_account_id,
                storeUserMessages: storeUserMessages,
                skillSelectionSource: skillSelectionSource,
                assistanceService: assistanceService,
                abortController: abortController,
                getIsChatMounted: getIsChatMounted,
                metricsStartTime: metricsStartTime,
                onTaskStatusUpdate: (streamMessage)=>{
                    if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                    (0, $4bca5e7215eb7baa$export$89a4ab1dea43d7ee)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $4bca5e7215eb7baa$export$6b58e85d865a8eef)(unifiedTasksActions)
                    });
                },
                onTodoSnapshot: ({ todos: todos })=>{
                    if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: todos
                        }
                    });
                },
                onPromptBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onPromptRedacted: (streamMessage)=>{
                    // Only update the human message with the redacted prompt.
                    // Keep the assistant placeholder — the stream continues with the actual response.
                    const chat = getMessages(conversationId);
                    let lastHumanIdx = -1;
                    chat.forEach((m, i)=>{
                        if ((0, $bPHr8.isStoreHuman)(m)) lastHumanIdx = i;
                    });
                    if (lastHumanIdx === -1) return;
                    const newChat = [
                        ...chat
                    ];
                    newChat[lastHumanIdx] = {
                        ...chat[lastHumanIdx],
                        redactedPrompt: streamMessage.message.redacted_prompt
                    };
                    setMessages(conversationId, newChat);
                },
                onResponseRedacted: (streamMessage)=>{
                    // Set redactedResponse on the latest assistant message so the scribble UI renders.
                    // Do NOT set guardEventReceived — the stream continues after response redaction.
                    const chat = getMessages(conversationId);
                    let lastAssistantIdx = -1;
                    chat.forEach((m, i)=>{
                        if ((0, $bPHr8.isStoreAssistant)(m)) lastAssistantIdx = i;
                    });
                    if (lastAssistantIdx === -1) return;
                    const newChat = [
                        ...chat
                    ];
                    newChat[lastAssistantIdx] = {
                        ...chat[lastAssistantIdx],
                        redactedResponse: streamMessage.message.redacted_response
                    };
                    setMessages(conversationId, newChat);
                },
                onResponseBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                },
                onAttachmentBlocked: (streamMessage)=>{
                    const chat = getMessages(conversationId);
                    const withoutPlaceholder = chat.filter((_, idx)=>idx !== answerIndex);
                    const guardBlock = {
                        type: 'GUARD_BLOCK',
                        id: String((0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000)),
                        time_created: new Date().toISOString(),
                        traceId: streamMessage.metadata?.request_id ?? undefined,
                        blockType: streamMessage.type
                    };
                    setMessages(conversationId, [
                        ...withoutPlaceholder,
                        guardBlock
                    ]);
                }
            });
            hasLoggedInitiatedEvent = hasLoggedInitiatedEventForStream;
            // TODO: This should be behind the !aborted logic, but due to a bug in the BE service, aborted requests
            // will client connection with the server yet still complete in the background. This results in the UI showing
            // no message updates, until reload when the actual resolved message can be sesen.
            // Once that is fixed, we can place this behind the !aborted logic.
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    // messageId must remain the ID received from the server in the FINAL_RESPONSE
                    // in order to map correctly to our event funnel, e.g `agentMessage received` -> `agentResponse content copied`
                    messageId: trackingAttributes.messageId,
                    humanMessageId: trackingAttributes.humanMessageId,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    requestId: trackingAttributes.requestId,
                    hasSources: trackingAttributes.hasSources,
                    citedProductList: trackingAttributes.citedProductList,
                    sourceProducts: trackingAttributes.sourceProducts,
                    has3pApps: Object.keys(trackingAttributes.sourceProducts ?? {}).some((0, $5vtU3.is3pApp)),
                    timestamp: new Date().toISOString(),
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    initiator: chatInitiator,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    scenarioId: trackingAttributes.scenarioId
                }
            });
            const wasProgrammaticallyAborted = abortController.signal.aborted;
            updateCurrentConversation((0, $cteoa.clearStatus)({
                lastAgentMessageStatus: wasProgrammaticallyAborted ? 'CANCELLED' : 'SUCCESSFUL'
            }));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
            if (abortController.signal.aborted) {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                    }
                });
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    subjectId: trackingAttributes.interactionSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes),
                        ...messageSources?.entryPoint && {
                            entryPoint: messageSources.entryPoint
                        }
                    }
                });
                confirmAbort();
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ABORTED);
                // Call the cancel API if we have a message ID
                if (trackingAttributes.messageId) assistanceService.cancelMessageStream({
                    conversationId: conversationId,
                    messageId: trackingAttributes.messageId
                })// eslint-disable-next-line @typescript-eslint/no-explicit-any
                .catch((error)=>{
                    // Log but don't throw - the abort is already happening
                    (0, $1yaYZ.logException)({
                        name: 'rovoCancelMessageStream',
                        exception: error,
                        tags: {
                            conversationId: conversationId,
                            messageId: trackingAttributes.messageId
                        }
                    });
                });
                // For implicit think-deeper, the auto-mode experience was already aborted inside processStream;
                // abort the re-attributed think-deeper experience instead.
                experienceTracker.abort({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $16lEl.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled,
                    reason: 'Aborted',
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isProgrammaticAbort: true // always true because we're within abortController.signal.aborted (further explained in similar abort for AbortError case)
                    }
                });
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                    reason: 'stream aborted'
                });
                // Always mark incomplete researches as errored on abort — the backend can
                // autonomously trigger think-deeper even in auto mode
                markIncompleteResearchesErrored({
                    messageId: tmpAssistantMessageId
                });
                // Clear research data to remove lingering think deeper state
                clearMessageResearch({
                    messageId: tmpAssistantMessageId
                });
                return;
            } else {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext,
                    viewContext: trackingAttributes.viewContext,
                    attributes: {
                        ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                    }
                });
                //If we're done processing the stream and no answer part has been processed, then it means that the BE is hanging. Throw an error
                if (!hasReceivedFinalResponse && !wasGuardTerminated) {
                    const agentDetails = await assistanceService.getAgentDetails(routingAgentId);
                    if (agentDetails.deactivated) {
                        // If agent is deactivated, throw correct error
                        const agentError = new (0, $0244aa38c72c69e0$export$cdcaebd3b25a3ac3)('The selected agent may no longer be available.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: agentError,
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                            }
                        });
                        updateCurrentConversation({
                            status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
                            traces: []
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                        return;
                    } else {
                        // Agent is active, BE hanging
                        const timeoutError = new (0, $0244aa38c72c69e0$export$cdcaebd3b25a3ac3)('The response took too long and timed out. Try refreshing the page.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: timeoutError,
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                llmDebugLogsEnabled: storeUserMessages,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled,
                            attributes: {
                                ...creationContextParams?.dynamicUiType && {
                                    dynamicUiType: creationContextParams.dynamicUiType
                                },
                                ...creationContextParams?.dynamicUiSubtype && {
                                    dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                                },
                                ...trackingAttributes?.invokedFrom && {
                                    invokedFrom: trackingAttributes.invokedFrom
                                },
                                ...streamActionInfo?.actionKey && {
                                    actionKey: streamActionInfo.actionKey
                                },
                                ...$54793c520b6b8872$var$getRequestedModeAttributes(trackingAttributes)
                            }
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                        throw timeoutError;
                    }
                }
                /**
       * IMPORTANT: CRITICAL ANALYTICS EVENT
       *
       * This event is essential for business metrics and monitoring.
       *
       * DO NOT MODIFY the structure, content, or emission logic of this event without:
       *   - Careful review of potential impacts on data quality, privacy, and business reporting.
       *   - Explicit approval from both analytics and security stakeholders.
       *
       * Reference: Incident HOT-120175 (UGC page title and URLs leak)
       * Event Registry: https://data-portal.internal.atlassian.com/analytics/registry/68936?tabIndex=Details
       */ const dynamicUiType = creationContextParams?.dynamicUiType ?? sendMessageContext?.editorContext?.dynamicUiType;
                trackAIMAUEvent({
                    type: 'viewed',
                    subjectId: messageSources?.followUpSource,
                    messageId: trackingAttributes.messageId,
                    source: messageSources?.interactionSource,
                    messageActions: trackingAttributes.messageActions,
                    messageDynamicUIData: trackingAttributes.messageDynamicUIData,
                    invokedFrom: trackingAttributes.invokedFrom,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    citedProductList: trackingAttributes.citedProductList,
                    sourceProducts: trackingAttributes.sourceProducts,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    skillsInvoked: trackingAttributes.skillsInvoked,
                    executedStratusSkill: trackingAttributes.executedStratusSkill,
                    responseSources: trackingAttributes.sources,
                    usesJsm: trackingAttributes.usesJsm,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    conversationChannelId: conversationId,
                    scenarioId: trackingAttributes.scenarioId,
                    pageContext: trackingAttributes.pageContext,
                    attributes: {
                        ...(0, $9likX.interactionModeExecutedAttributes)(trackingAttributes.interactionModeExecuted),
                        ...dynamicUiType && {
                            dynamicUiType: dynamicUiType
                        },
                        ...creationContextParams?.dynamicUiSubtype && {
                            dynamicUiSubtype: creationContextParams.dynamicUiSubtype
                        },
                        isTabVisible: (0, $hTKp4.getDocument)()?.visibilityState === 'visible',
                        ...additionalAnalyticAttributes && additionalAnalyticAttributes,
                        ...creationContextParams?.dynamicUiSource && {
                            remixNodeTypes: trackingAttributes.remixNodeTypes,
                            ...trackingAttributes.remixWordCount !== undefined && {
                                remixWordCount: trackingAttributes.remixWordCount
                            }
                        },
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        },
                        ...messageSources?.entryPoint && {
                            entryPoint: messageSources.entryPoint
                        }
                    }
                });
                // Experience is aborted in `abortRequests`
                // For implicit think-deeper, succeed the re-attributed think-deeper reliability SLO instead
                experienceTracker.succeed({
                    name: hasAbortedForImplicitThinkDeeper ? implicitThinkDeeperExperienceName ?? (0, $16lEl.ExperienceName).SEND_TD_MESSAGE : sendMessageExperienceNameCompiled
                });
                // Broadcast that the stream has completed successfully
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).COMPLETED);
                if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
                {
                    if (getState().currentConversationId !== conversationId) dispatch(setConversationData({
                        conversationId: conversationId,
                        data: {
                            readStatus: false
                        }
                    }));
                }
            }
            // For implicit think-deeper, stop the re-attributed think-deeper metric instead
            if (!hasAbortedForImplicitThinkDeeper) sendMessageLatencyMetrics.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
            else implicitThinkDeeperSendMessageMetrics?.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
        };
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        try {
            await sendMessageFn({
                conversationId: conversationId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if ((0, $ljUdP.isChannelNotFoundError)(error)) {
                const createdChannel = await assistanceService.createConversationChannel();
                setState({
                    conversations: {
                        ...getState().conversations,
                        [createdChannel.id]: {
                            id: createdChannel.id,
                            name: createdChannel.name,
                            timeCreated: createdChannel.time_created,
                            status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                            traces: [],
                            messages: [],
                            ...createdChannel.agent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? {
                                agent: createdChannel.agent
                            } : {}
                        }
                    }
                });
                setMessages(createdChannel.id, []);
                dispatch(setSelectedConversation({
                    conversationId: createdChannel.id
                }));
                await sendMessageFn({
                    conversationId: createdChannel.id
                });
            } else {
                performEditRollback();
                throw error;
            }
        }
    };
const $54793c520b6b8872$var$getStreamStats = ()=>{
    const stats = {
        totalChunks: 0,
        traceChunks: 0,
        answerChunks: 0,
        actionChunks: 0,
        researchChunks: 0,
        otherChunks: 0,
        firstChunkAt: undefined,
        lastChunkAt: undefined,
        sumInterChunkMs: 0,
        pluginsObserved: new Set()
    };
    const update = (streamMessage)=>{
        const now = performance.now();
        stats.totalChunks += 1;
        if (stats.firstChunkAt === undefined) stats.firstChunkAt = now;
        if (stats.lastChunkAt !== undefined) stats.sumInterChunkMs += now - stats.lastChunkAt;
        stats.lastChunkAt = now;
        if ((0, $ljUdP.isStreamTrace)(streamMessage)) stats.traceChunks += 1;
        else if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) stats.answerChunks += 1;
        else if ((0, $ljUdP.isStreamResearchPayload)(streamMessage)) stats.researchChunks += 1;
        else if ((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) // Count action-related chunks (prepare/part)
        stats.actionChunks += 1;
        else // Count unknown chunks
        stats.otherChunks += 1;
        // Observe plugin names if present early (often only present on final response)
        const invocations = (0, $ljUdP.isStreamResponse)(streamMessage) ? streamMessage.message?.message?.plugin_invocations : [];
        if (Array.isArray(invocations)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        invocations.forEach((p)=>p?.plugin_name && stats.pluginsObserved.add(p.plugin_name));
    };
    const getStats = ()=>{
        const avgGapMs = stats.totalChunks > 1 ? Math.round(stats.sumInterChunkMs / (stats.totalChunks - 1)) : 0;
        return {
            ...stats,
            pluginsObserved: Array.from(stats.pluginsObserved),
            averageGapMs: avgGapMs
        };
    };
    return {
        update: update,
        getStats: getStats
    };
};
const $54793c520b6b8872$export$23f1f8f522f4bdd = (config)=>{
    let armed = false;
    let firstChunkArrived = false;
    let timer;
    let stallCount = 0;
    const clearTimer = ()=>{
        if (timer !== undefined) {
            clearTimeout(timer);
            timer = undefined;
        }
    };
    const schedule = (stage)=>{
        clearTimer();
        const timeoutMs = config.baseMs;
        timer = setTimeout(()=>{
            stallCount += 1;
            config.sendAnalyticsEvent({
                eventType: 'track',
                action: 'timeout',
                actionSubject: 'rovoChatStream',
                attributes: {
                    stallCount: stallCount,
                    stage: stage,
                    timeoutMs: timeoutMs
                }
            });
            // Keep armed so we continue to detect subsequent stalls until chunks resume
            schedule('betweenChunks');
        }, timeoutMs);
    };
    return {
        arm: ()=>{
            if (armed) return;
            armed = true;
            // Start pre-first-chunk watchdog waiting for the first stream event
            schedule('newResponse');
        },
        onChunk: ()=>{
            if (!armed) return;
            if (firstChunkArrived === false) {
                firstChunkArrived = true;
                // After the first chunk, schedule timeout waiting for the next event
                schedule('firstGap');
                return;
            }
            // For subsequent chunks, re-arm the between-chunks watchdog
            schedule('betweenChunks');
        },
        stop: ()=>{
            clearTimer();
            armed = false;
        }
    };
};






const $f0918ff6cbefa0f7$export$f74ad34bb7f49ad1 = async ({ generator: generator, messageId: messageId, conversationId: conversationId, isDeepResearch: isDeepResearch, isStagingArea: isStagingArea, answerIndex: answerIndex, traceId: traceId, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, getState: getState, updateCurrentConversation: updateCurrentConversation, sendAnalyticsEvent: sendAnalyticsEvent, onStreamEvent: onStreamEvent, getIsReplaying: getIsReplaying, reasoningChunkBuffer: reasoningChunkBuffer, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, onStreamEnd: onStreamEnd, onTaskStatusDraft: onTaskStatusDraft, onTaskStatusCompleted: onTaskStatusCompleted, onTodoSnapshot: onTodoSnapshot, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification })=>{
    // Gate the details-tag preprocessor to 3P-agent conversations only.
    const shouldPreprocessDetails = (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId);
    const processStreamMarkdownMultiTag = (0, $cteoa.createStreamMarkdownMultiTagProcessor)({
        shouldPreprocessDetails: shouldPreprocessDetails
    });
    let latestStreamMessage;
    let hasReceivedFinalResponse = false;
    // Research store state shared across stream messages
    const researchState = {
        clientRoundCounter: 0,
        hasAccumulatedAnswerContent: false
    };
    let requestId;
    try {
        for await (const streamObj of generator){
            const streamMessage = streamObj.data;
            latestStreamMessage = streamMessage;
            onStreamEvent('chunk', streamMessage, streamObj.id);
            // TRACE events are not handled in reconnect; drop early to skip
            // the remaining type-checks below.
            if ((0, $ljUdP.isStreamTrace)(streamMessage)) continue;
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!requestId && 'metadata' in streamMessage) requestId = streamMessage.metadata?.request_id ?? undefined;
            // Buffer REASONING_PART during replay; bufferEvent returns false for
            // orphan chunks (no stepId) so they fall through.
            if (reasoningChunkBuffer && getIsReplaying?.() && (0, $ljUdP.isStreamReasoningPart)(streamMessage) && reasoningChunkBuffer.bufferEvent(streamMessage)) continue;
            /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $54793c520b6b8872$export$5a07e6227eed9665)({
                streamMessage: streamMessage,
                tmpAssistantMessageId: messageId,
                conversationId: conversationId,
                deepResearchEnabled: isDeepResearch ?? false,
                getMessages: getMessages,
                setMessages: setMessages,
                processStreamResearch: processStreamResearch,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                researchState: researchState
            });
            /**
       * Task status processing
       */ if ((0, $ljUdP.isStreamTaskStatus)(streamMessage)) {
                const taskMessage = streamMessage.message;
                if (taskMessage.status === 'DRAFT') onTaskStatusDraft?.({
                    taskId: taskMessage.task_id,
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    messageId: messageId
                });
                else if (taskMessage.status === 'COMPLETED') onTaskStatusCompleted?.({
                    title: taskMessage.title,
                    updatedAt: taskMessage.updated_at,
                    completionMessageId: messageId
                });
            }
            /**
       *  snapshot processing
       */ if ((0, $ljUdP.isStreamTodoSnapshot)(streamMessage)) onTodoSnapshot?.({
                todos: streamMessage.message.todos
            });
            /**
       *  ANSWER_PART  processing
       */ if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                let processedStreamMessage = streamMessage;
                let hasMarkdownData = false;
                const result = processStreamMarkdownMultiTag(processedStreamMessage);
                processedStreamMessage = result.processedStreamMessage;
                if (Object.keys(result.markdownData).length > 0) {
                    hasMarkdownData = true;
                    setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownDataMap)({
                        chat: getMessages(conversationId),
                        answerId: messageId,
                        answerPart: processedStreamMessage,
                        markdownData: result.markdownData,
                        useIndex: answerIndex
                    }));
                }
                if (!hasMarkdownData) setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    answerPart: streamMessage,
                    useIndex: answerIndex
                }));
            }
            if ((0, $ljUdP.isStreamAnswerGenerationType)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerGenerationType)(getMessages(conversationId), messageId, streamMessage.message.answer_generation_type));
            if (((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) && (0, $dh538.fg)('aifc_create_enabled')) {
                const updatedMessages = (0, $cteoa.addActionPart)({
                    chat: getMessages(conversationId),
                    messageId: messageId,
                    actionPart: streamMessage,
                    useIndex: answerIndex
                });
                if ((0, $ljUdP.isStreamActionPrepare)(streamMessage)) {
                    const actionMessage = streamMessage.message;
                    setMessages(conversationId, [
                        ...updatedMessages,
                        {
                            type: 'ACTION_PREPARE',
                            action: actionMessage
                        }
                    ]);
                } else setMessages(conversationId, updatedMessages);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $dh538.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) processMessageStreamAction?.(messageId, streamMessage, traceId, requestId, undefined, {
                        singleInstrumentationId: messageId
                    });
                    else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionPart',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: (0, $ljUdP.isStreamActionPart)(streamMessage) ? streamMessage.message?.key : 'prepare'
                            }
                        }
                    });
                } else processMessageStreamAction?.(messageId, streamMessage, traceId, requestId, undefined, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $ljUdP.isStreamActionComplete)(streamMessage) && (0, $dh538.fg)('aifc_create_enabled')) {
                const actionMessage = streamMessage.message;
                setMessages(conversationId, [
                    ...getMessages(conversationId),
                    {
                        type: 'ACTION_COMPLETE',
                        action: actionMessage
                    }
                ]);
                // Gated behind aifc_fix_reconnect_stream_overlap so rollback is safe.
                if ((0, $dh538.fg)('aifc_fix_reconnect_stream_overlap')) {
                    if (!getIsReplaying?.()) processMessageStreamComplete?.(messageId, streamMessage, traceId, requestId, {
                        singleInstrumentationId: messageId
                    });
                    else sendAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'suppressed',
                            actionSubject: 'streamActionComplete',
                            actionSubjectId: 'reconnectReplay',
                            source: 'reconnectToInProgressStreamProvider',
                            attributes: {
                                messageId: messageId,
                                conversationId: conversationId,
                                reason: 'replay',
                                key: actionMessage?.key
                            }
                        }
                    });
                } else processMessageStreamComplete?.(messageId, streamMessage, traceId, requestId, {
                    singleInstrumentationId: messageId
                });
            }
            if ((0, $ljUdP.isStreamActionClassification)(streamMessage) && (0, $dh538.fg)('aifc_create_enabled')) {
                if ((0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics')) // Only call during live phase. If ACTION_CLASSIFICATION arrives during
                // replay it means the editor already received it before disconnect.
                {
                    if (!getIsReplaying?.()) processMessageStreamActionClassification?.(messageId, streamMessage, traceId, requestId, {
                        singleInstrumentationId: messageId
                    });
                }
            }
            /**
       * FINAL_RESPONSE processing
       */ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $cteoa.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: messageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    shouldPreprocessDetails: shouldPreprocessDetails
                });
                setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined
                }));
                // Update the StoreHuman entry's ID from the temporary client-generated ID
                // to the real server-assigned ID. After a page reload this is a no-op because
                // the store already contains the real ID.
                if (humanMessageId) {
                    const currentHumanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
                    if (currentHumanMessageId && currentHumanMessageId !== humanMessageId) setMessages(conversationId, (0, $cteoa.updateHumanMessageId)({
                        chat: getMessages(conversationId),
                        oldId: currentHumanMessageId,
                        newId: humanMessageId
                    }));
                }
            }
            /**
       * Follow up processing
       */ if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                const messages = getMessages(conversationId);
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: streamMessage,
                        id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages)
                    }
                ]);
            }
            /**
       * Action error processing
       */ if ((0, $ljUdP.isStreamActionError)(streamMessage)) {
                const actionError = new (0, $eu7N9.StreamErrorException)(streamMessage.message.data?.message || 'Action execution failed', {
                    detail: {
                        message: {
                            content: streamMessage?.message?.data?.message || 'Action execution failed',
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: isStagingArea
                        }
                    },
                    traceId: traceId
                });
                throw actionError;
            }
            if ((0, $ljUdP.isStreamError)(streamMessage)) {
                onStreamEvent('error', streamMessage, streamObj.id);
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                throw new (0, $eu7N9.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
        // Drain any remaining buffered chunks and clear the periodic timer.
        //cancelReasoningFlush();
        onStreamEnd?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error instanceof (0, $eu7N9.StreamErrorException)) throw error;
        throw new (0, $5yETg.StreamGeneratorError)(error.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, error);
    }
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse
    };
};
const $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98 = (params)=>{
    const timeToConnectToStreamMetrics = (0, $11331e08595d7087$export$924cdb4a6542ccd).createTimeToConnectToStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    const timeToResumeStreamMetrics = (0, $11331e08595d7087$export$924cdb4a6542ccd).createTimeToResumeStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    return {
        timeToConnectToStreamMetrics: timeToConnectToStreamMetrics,
        timeToResumeStreamMetrics: timeToResumeStreamMetrics
    };
};
const $f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
const $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8 = (error)=>{
    if (error instanceof Error && error.name === 'AbortError') return false;
    // StreamGeneratorError wraps the original error as `cause` — check the underlying error
    if (error instanceof (0, $5yETg.StreamGeneratorError)) return (0, $cteoa.isClientSideStreamingError)(error.cause ?? error);
    return (0, $cteoa.isClientSideStreamingError)(error);
};
const $f0918ff6cbefa0f7$export$d8454bf5b2ffdf29 = ({ conversationId: conversationId, messageId: messageId, answerIndex: _answerIndex, isDeepResearch: isDeepResearch, lastEventId: lastEventId, setConversationData: setConversationData, abortCurrentRequest: abortCurrentRequest, onComplete: onComplete })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, chatContextStoreActions: chatContextStoreActions, markIncompleteResearchesErrored: markIncompleteResearchesErrored, endReconnection: endReconnection, startReconnection: startReconnection, isReconnecting: isReconnecting, getIsChatMounted: getIsChatMounted, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, unifiedTasksActions: unifiedTasksActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (abortCurrentRequest && currentConversation?.storeAbortController) currentConversation.storeAbortController.abort();
        // Skip reconnection if there is another operation in progress
        if (currentConversation?.storeAbortController && !abortCurrentRequest || isReconnecting(conversationId)) return;
        startReconnection(conversationId, messageId);
        const reconnectionPerformanceMetrics = $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98({
            isDeepResearchEnabled: isDeepResearch,
            thinkDeeperEnabled: false,
            fastModeEnabled: false
        });
        let totalAttempts = 0;
        const reconnectStartedAt = new Date().toISOString();
        // TODO not complete information, ideally the message in progress should indicate what was the requested mode even before message is completed
        const requestedModeAttributes = (0, $9likX.interactionModeRequestedAttributes)(isDeepResearch ? 'deep_research' : 'auto');
        const metrics = {
            // Reconnection metrics
            onReconnectStarted: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.start();
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    id: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: true
                    }
                });
                trackAIMAUEvent({
                    type: 'initiated',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: reconnectStartedAt,
                    attributes: requestedModeAttributes
                });
            },
            // Was able to connect to active stream
            onReconnectEstablished: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.stop();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.start();
            },
            onReconnectFailed: (error)=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    error: error,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        totalAttempts: totalAttempts
                    }
                });
                trackAIMAUEvent({
                    type: 'error',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectChunkReceived: ()=>{
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.stop();
            },
            onReconnectAborted: ()=>{
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    reason: 'Aborted'
                });
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
            },
            onReconnectSucceeded: ()=>{
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        totalAttempts: totalAttempts,
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        isAutoReconnect: true
                    }
                });
                trackAIMAUEvent({
                    type: 'viewed',
                    userGenerated: true,
                    proactive: false,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    citedProductList: streamMeta?.citedProductList ?? {},
                    sourceProducts: streamMeta?.sourceProducts ?? {},
                    pluginsInvoked: streamMeta?.pluginsInvoked,
                    skillsInvoked: streamMeta?.skillsInvoked,
                    executedStratusSkill: streamMeta?.executedStratusSkill,
                    responseSources: streamMeta?.responseSources,
                    usesJsm: streamMeta?.usesJsm,
                    messageActions: streamMeta?.messageActions,
                    conversationChannelId: conversationId,
                    timestamp: new Date().toISOString(),
                    attributes: {
                        ...streamMeta?.interactionModeExecuted ? {
                            interactionModeExecuted: streamMeta.interactionModeExecuted
                        } : {}
                    }
                });
                // Fire agentMessage received for funnel parity with processStream.
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'received',
                    actionSubject: 'agentMessage',
                    attributes: {
                        messageId: messageId,
                        humanMessageId: streamMeta?.humanMessageId,
                        pluginsInvoked: streamMeta?.pluginsInvoked ?? [],
                        citedProductList: streamMeta?.citedProductList,
                        sourceProducts: streamMeta?.sourceProducts,
                        has3pApps: Object.keys(streamMeta?.sourceProducts ?? {}).some((0, $5vtU3.is3pApp)),
                        timestamp: new Date().toISOString(),
                        messageActions: streamMeta?.messageActions,
                        deepResearchEnabled: isDeepResearch ?? false,
                        initiator: 'rovoChat',
                        deepResearchInvoked: isDeepResearch ?? false,
                        scenarioId: streamMeta?.scenarioId,
                        isReconnect: true
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch(setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const cancelMessageStream = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: messageId
            }).catch((err)=>{
                (0, $1yaYZ.logException)({
                    name: 'rovoCancelMessageStream',
                    exception: err,
                    tags: {
                        conversationId: conversationId,
                        messageId: messageId
                    }
                });
            });
        };
        const messages = getMessages(conversationId);
        const answerIndex = _answerIndex ?? (0, $cteoa.findStoreMessageIndex)(messages, messageId);
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
        let traceId;
        let streamMeta;
        const currentLastEventId = lastEventId;
        let reconnectSucceeded = false;
        //** CONNECT TO STREAM (with retry) */
        try {
            metrics.onReconnectStarted();
            updateCurrentConversation({
                status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse,
                traces: [
                    {
                        messageContent: 'Resuming response...',
                        status: 'loading'
                    }
                ],
                storeAbortController: storeAbortController
            });
            const reconnect = (eventId)=>assistanceService.reconnectToMessageStream({
                    conversationId: conversationId,
                    messageId: messageId,
                    lastEventId: eventId,
                    controller: abortController
                });
            // Capture timestamp BEFORE the API call so that any live chunks
            // still in-flight during the round-trip are correctly identified
            // as live rather than replay.
            const reconnectTimestamp = Date.now();
            const { generator: initialGenerator, responseData: responseData } = await reconnect(currentLastEventId);
            traceId = responseData?.traceId;
            metrics.onReconnectEstablished();
            const wrappedGenerator = (0, $be423051027308ae$export$a802bb7fa59dba39)({
                initialGenerator: initialGenerator,
                canReconnect: ()=>!abortController.signal.aborted,
                getReconnectGenerator: (eventId)=>reconnect(eventId).then((r)=>r.generator),
                getEventId: (chunk)=>chunk.id ? chunk.id : undefined,
                onReconnecting: (attempt, maxAttempts, eventId)=>{
                    totalAttempts = attempt;
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'retrying',
                        actionSubject: 'rovoChatReconnection',
                        attributes: {
                            conversationId: conversationId,
                            messageId: messageId,
                            isDeepResearch: isDeepResearch,
                            attempt: attempt,
                            maxAttempts: maxAttempts,
                            hasLastEventId: !!eventId
                        }
                    });
                    updateCurrentConversation({
                        traces: [
                            {
                                messageContent: `Connection lost. Retrying... (${attempt}/${maxAttempts})`,
                                status: 'loading'
                            }
                        ]
                    });
                },
                onReconnected: ()=>{
                    metrics.onReconnectEstablished();
                },
                shouldContinueRetrying: ()=>{
                    if (!getIsChatMounted()) {
                        abortController.abort($f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                        return false;
                    }
                    return true;
                },
                signal: abortController.signal
            });
            // Batch store updates and chunk-merge REASONING_PART during replay;
            // both flushed together via onFlush at the replay→live boundary.
            const reasoningChunkBuffer = (0, $452e4ba611b5dc40$export$6f349e5fd508c97f)((mergedEvent)=>{
                processStreamResearch({
                    messageId: messageId,
                    streamMessage: mergedEvent,
                    isDeepResearch: isDeepResearch ?? false
                });
            });
            const { wrapGenerator: wrapGenerator, batchedSetMessages: batchedSetMessages, batchedGetMessages: batchedGetMessages, batchedProcessStreamResearch: batchedProcessStreamResearch, batchedUpdateCurrentConversation: batchedUpdateCurrentConversation, getIsReplaying: getIsReplaying, getCompletedStepIds: getCompletedStepIds } = (0, $f0fdaf1fd06efef8$export$76ef465f684cfb18)({
                conversationId: conversationId,
                reconnectTimestamp: reconnectTimestamp,
                getMessages: getMessages,
                setMessages: setMessages,
                processStreamResearch: processStreamResearch,
                updateCurrentConversation: updateCurrentConversation,
                // Use flushFiltered so reasoning chunks for already-completed steps
                // are dropped — this prevents spurious "Rovo is thinking" rounds
                // from appearing in the research expandable after reconnect replay.
                // Steps that are still in-progress (no STEP_COMPLETED seen) are
                // flushed normally so live streaming continues correctly.
                onFlush: ()=>reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId))
            });
            const { hasReceivedFinalResponse: hasReceivedFinalResponse } = await $f0918ff6cbefa0f7$export$f74ad34bb7f49ad1({
                generator: wrapGenerator(wrappedGenerator),
                traceId: responseData?.traceId,
                messageId: messageId,
                conversationId: conversationId,
                answerIndex: answerIndex,
                isStagingArea: chatContextStoreActions.getIsStagingArea(),
                isDeepResearch: isDeepResearch,
                getState: getState,
                setMessages: batchedSetMessages,
                getMessages: batchedGetMessages,
                processStreamResearch: batchedProcessStreamResearch,
                processMessageStreamAction: // skip batching for Stream Actions for now, since string accumulation is not guarnateed and vary based on the action type.
                // TODO: should be imrpoved in future snapshot event support.
                processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                processMessageStreamActionClassification: processMessageStreamActionClassification,
                sendAnalyticsEvent: sendAnalyticsEvent,
                updateCurrentConversation: batchedUpdateCurrentConversation,
                getIsReplaying: getIsReplaying,
                reasoningChunkBuffer: reasoningChunkBuffer,
                addImplicitResearchPlan: addImplicitResearchPlan,
                resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                onStreamEnd: ()=>{
                    // Mirror onFlush: drop reasoning for completed steps.
                    reasoningChunkBuffer.flushFiltered((stepId)=>!getCompletedStepIds().has(stepId));
                },
                onTaskStatusDraft: ({ taskId: taskId, title: title, updatedAt: updatedAt, messageId: msgId })=>{
                    if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.createTaskFromStream({
                        conversationId: conversationId,
                        taskId: taskId,
                        title: title,
                        updatedAt: updatedAt,
                        messageId: msgId
                    });
                },
                onTaskStatusCompleted: ({ title: title, updatedAt: updatedAt, completionMessageId: completionMessageId })=>{
                    if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskProgressState({
                        conversationId: conversationId,
                        progressState: 'Completed',
                        title: title,
                        updatedAt: updatedAt,
                        seekingCompletedAck: true,
                        completionMessageId: completionMessageId
                    });
                },
                onTodoSnapshot: ({ todos: todos })=>{
                    if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
                    unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: todos
                        }
                    });
                },
                onStreamEvent: (event, streamMessage, eventId)=>{
                    if (event === 'chunk') {
                        metrics.onReconnectChunkReceived();
                        if (streamMessage && (0, $ljUdP.isStreamResponse)(streamMessage)) streamMeta = (0, $cteoa.extractStreamMeta)(streamMessage);
                    }
                    if (event === 'error') {
                        if ((0, $ljUdP.isStreamAUPError)(streamMessage)) {
                            reconnectSucceeded = true;
                            metrics.onReconnectSucceeded();
                        }
                    }
                }
            });
            if (abortController.signal.aborted) throw new DOMException('Reconnect aborted', 'AbortError');
            if (!hasReceivedFinalResponse) throw new (0, $0244aa38c72c69e0$export$cdcaebd3b25a3ac3)('The response took too long and timed out. Try refreshing the page.', {
                traceId: traceId
            });
            metrics.onReconnectSucceeded();
            onComplete?.({
                success: true,
                streamMeta: streamMeta
            });
        } catch (error) {
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) {
                confirmAbort();
                updateCurrentConversation({
                    lastAgentMessageStatus: 'FAILED'
                });
                metrics.onReconnectAborted();
                // Only cancel the message stream if the abort reason is not the chat unmounted reason
                if (abortController.signal.reason !== $f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED) cancelMessageStream();
                return;
            }
            if (!reconnectSucceeded) metrics.onReconnectFailed(error);
            if (isDeepResearch) markIncompleteResearchesErrored({
                messageId: messageId
            });
            onComplete?.({
                success: reconnectSucceeded,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        } finally{
            endReconnection(conversationId);
            updateCurrentConversation((0, $cteoa.clearStatus)({}));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
    };





























const $434fbbd3906b07f0$var$getErrorReason = ({ error: error, storeError: storeError, currentConversationId: currentConversationId, conversations: conversations })=>{
    if ((0, $ljUdP.isHipaaError)(error)) return 'hipaa';
    if ((0, $ljUdP.isAUPViolationError)(error)) return 'aupViolation';
    if ((0, $ljUdP.isChannelNotFoundError)(error)) return 'channelNotFound';
    if (!conversations?.[currentConversationId] || (0, $cteoa.isEmptyConversation)(currentConversationId)) return 'noActiveConversation';
    if (storeError.status_code === 429 || (0, $ljUdP.isRateLimitedError)(error)) return 'rateLimited';
    return 'generic';
};
const $434fbbd3906b07f0$var$reportChatError = (sendAnalyticsEvent, reason, storeError)=>{
    if (!(0, $dh538.fg)('ai_mate_unhandled_error_reporting')) return;
    sendAnalyticsEvent({
        eventType: 'operational',
        action: 'unhandledError',
        actionSubject: 'aiMate',
        attributes: {
            reason: reason,
            statusCode: storeError.status_code,
            messageTemplate: storeError.message_template,
            errorType: storeError.errorType,
            traceId: storeError.traceId,
            errorContent: storeError.content,
            ...storeError.storeActionExecutionError ? {
                actionLoggableName: storeError.storeActionExecutionError.actionLoggableName
            } : {}
        }
    });
};
const $434fbbd3906b07f0$export$769f721a7d2183c3 = (props)=>{
    const { args: args, api: api, actionLoggableName: actionLoggableName, error: error, containerProps: containerProps, actionErrorHandler: actionErrorHandler, setConversationData: setConversationData } = props;
    const { getState: getState, setState: setState, dispatch: dispatch } = api;
    (0, $1yaYZ.addSentryBreadcrumb)(`createSafeAction: ${actionLoggableName} errored`);
    const storeError = (0, $cteoa.createStoreError)(error, undefined, actionLoggableName);
    const errorReason = $434fbbd3906b07f0$var$getErrorReason({
        error: error,
        storeError: storeError,
        currentConversationId: getState().currentConversationId,
        conversations: getState().conversations
    });
    // ============================================
    // PHASE 1: Mandatory checks (cannot be overridden)
    // ============================================
    // Handle experience tracking
    // Rate limits are ignored because they trigger a retry, not an experience termination
    if (props?.experienceName && errorReason !== 'rateLimited') {
        if (errorReason === 'aupViolation') {
            const aupError = error;
            containerProps.experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                reason: aupError.detail.message.message_template,
                attributes: {
                    ...aupError.errorAttributes,
                    errorType: error instanceof (0, $eu7N9.StreamErrorException) ? 'StreamErrorException' : ''
                }
            });
        } else containerProps.experienceTracker.fail({
            name: props.experienceName(args),
            error: error instanceof Error ? error : new Error(String(error))
        });
    }
    // Handle restricted use errors
    if (errorReason === 'hipaa') {
        containerProps.setConversationError({
            type: 'hipaa',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'hipaa', storeError);
        return;
    }
    // ============================================
    // PHASE 2: Action-specific error handling (optional)
    // ============================================
    if (actionErrorHandler) {
        const result = actionErrorHandler({
            args: args,
            error: error,
            storeError: storeError,
            containerProps: containerProps,
            errorReason: errorReason
        });
        if (!result?.proceedToDefaultHandling) return;
    }
    // ============================================
    // PHASE 3: Default error handlers
    // ============================================
    if (errorReason === 'channelNotFound') {
        containerProps.setConversationError({
            type: 'conversationNotFound',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'channelNotFound', storeError);
        return;
    }
    if (errorReason === 'noActiveConversation') {
        containerProps.setConversationError({
            type: 'conversationEmptyOrNotPresentInStore',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'noActiveConversation', storeError);
        if (storeError.message_template === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).ROVO_PRODUCT_NOT_ACTIVE) containerProps.setRovoEnabled(false, storeError.message_template);
        return;
    }
    const currentConversationId = getState().currentConversationId;
    if (errorReason === 'rateLimited') {
        const rateLimitState = props?.getRateLimitState?.(args) ?? {};
        setState({
            conversations: {
                ...getState().conversations,
                [currentConversationId]: {
                    ...getState().conversations[currentConversationId],
                    ...(0, $cteoa.clearStatus)({
                        lastAgentMessageStatus: 'FAILED'
                    })
                }
            }
        });
        containerProps.setConversationError({
            type: 'rateLimited',
            underlyingError: storeError,
            rateLimitedActionType: rateLimitState.isDeepResearchAttempt ? 'deep-research' : 'generic'
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'rateLimited', storeError);
        return;
    }
    dispatch(setConversationData({
        conversationId: currentConversationId,
        data: {
            ...(0, $cteoa.clearStatus)({
                lastAgentMessageStatus: 'FAILED'
            })
        }
    }));
    const currentMessages = containerProps.getMessages(currentConversationId);
    const lastMessage = currentMessages[currentMessages.length - 1];
    const isDuplicateError = lastMessage && (0, $bPHr8.isStoreError)(lastMessage) && lastMessage.content === storeError.content;
    if (!isDuplicateError) containerProps.setMessages(currentConversationId, [
        ...currentMessages,
        storeError
    ]);
    const errorAttributes = error?.errorAttributes;
    containerProps.experienceTracker.fail({
        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        error: error instanceof Error ? error : new Error(String(error)),
        attributes: {
            latestStreamMessageType: errorAttributes?.latestStreamMessageType,
            latestStreamMessageMillisOffset: errorAttributes?.latestStreamMessageMillisOffset
        }
    });
    $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'generic', storeError);
};





const $0b6866794de633f9$var$getSendMessageExperienceName = (params)=>{
    if (params.isCustomRovoAgent) return (0, $16lEl.ExperienceName).SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (params.deepResearchEnabled) return (0, $16lEl.ExperienceName).SEND_DR_MESSAGE;
    if (params.thinkDeeperEnabled) return (0, $16lEl.ExperienceName).SEND_TD_MESSAGE;
    if (params.taskModeEnabled) return (0, $16lEl.ExperienceName).SEND_TASK_MODE_MESSAGE;
    return (0, $16lEl.ExperienceName).SEND_MESSAGE;
};
// eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing chat-store baseline: narrow inline-view page params are adapted to the shared creation context type.
const $0b6866794de633f9$var$HIGHLIGHT_ACTION_INLINE_VIEW_PAGE_CREATION_CONTEXT_PARAMS = {
    experience: 'inline_view',
    contentTypes: [
        'page'
    ]
};
const $0b6866794de633f9$var$CONVERSATION_LIST_PAGE_SIZE = 25;
const $0b6866794de633f9$var$CONVERSATION_LIST_PAGINATION_EXPERIMENT = 'rovo_chat_conversation_list_pagination';
const $0b6866794de633f9$var$isConversationListPaginationEnabled = ()=>(0, $c6GJD.default).getExperimentValue($0b6866794de633f9$var$CONVERSATION_LIST_PAGINATION_EXPERIMENT, 'isEnabled', false);
/**
 * Resolve the agent to seed into `conversation.agent` for optimistic/seeded
 * conversation creation. Precedence:
 * - Under `rovo_chat_agent_selection`: the backend-returned agent if present,
 *   otherwise a provisional agent built from the known agent id (so the header,
 *   which reads only `conversation.agent.agent_id`, can hydrate it).
 * - Otherwise (legacy): the backend agent only when `rovo_chat_chat_history_refresh`
 *   is on; else no seed.
 *
 * rovo_chat_agent_selection cleanup: drop the gate and always seed from
 * `backendAgent ?? createProvisionalConversationAgent(agentId)`.
 */ const $0b6866794de633f9$var$resolveConversationSeedAgent = ({ backendAgent: backendAgent, agentId: agentId, legacyAgent: legacyAgent })=>{
    if ((0, $dh538.fg)('rovo_chat_agent_selection')) return backendAgent ?? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(agentId);
    return legacyAgent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? legacyAgent : undefined;
};
/**
 * Util action to initialize conversation with conversationId
 */ const $0b6866794de633f9$var$initializeConversationData = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    ...data
                }
            }
        });
    };
/**
 * Util action to allow updating the conversation based on `conversationId`
 * without needing to keep spreading the existing
 *
 * Similar to `initializeConversationData`, the difference is, it will not allow the the data to be updated if there is no existing conversation
 */ const $0b6866794de633f9$var$setConversationData = ({ conversationId: conversationId, data: data })=>({ getState: getState, setState: setState })=>{
        if (!getState().conversations[conversationId]) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    ...data
                }
            }
        });
    };
/**
 * Reset an existing conversation into the loading state ahead of a (re)fetch.
 *
 * This is a partial patch of only the fields the loading reset actually changes:
 * status, messages, traces and sourceAgentId. Every other field —
 * notably `conversation.agent` (the header's display identity), `name`, `id` and
 * `timeCreated` — is preserved automatically by the shallow merge, so callers do not
 * need to re-copy carry-over fields or special-case agent preservation behind a gate.
 *
 * No-ops if the conversation does not exist (callers always guard for an existing,
 * non-empty, idle conversation before resetting).
 */ const $0b6866794de633f9$var$resetConversationForLoading = ({ conversationId: conversationId, traces: traces, sourceAgentId: sourceAgentId })=>({ getState: getState, setState: setState })=>{
        const existing = getState().conversations[conversationId];
        if (!existing) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...existing,
                    status: (0, $bPHr8.CHAT_STORE_STATUS).loadingChat,
                    messages: [],
                    traces: traces,
                    sourceAgentId: sourceAgentId
                }
            }
        });
    };
/**
 * Utils function to remove conversation from store
 */ const $0b6866794de633f9$var$removeConversationFromStore = ({ conversationId: conversationId })=>({ getState: getState, setState: setState })=>{
        const { [conversationId]: _, ...otherConversations } = getState().conversations;
        setState({
            conversations: otherConversations
        });
    };
const $0b6866794de633f9$export$f65ce059a9114838 = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(actionLoggableName, actionHOF, props)=>(...args)=>async (api, containerProps)=>{
            /*
   Add custom logic here
  */ // General try/catch statement to handle unexpected errors
            try {
                (0, $1yaYZ.addSentryBreadcrumb)(`createSafeAction: executing ${actionLoggableName}`);
                // Here we call the action callback
                // Same as dispatch(actionHOF)
                const action = actionHOF(...args);
                // Here we execute the action i.e. what happens internally when the action is dispatched
                const result = await action(api, containerProps);
                return result;
            } catch (error) {
                (0, $434fbbd3906b07f0$export$769f721a7d2183c3)({
                    args: args,
                    api: api,
                    actionLoggableName: actionLoggableName,
                    error: error,
                    containerProps: containerProps,
                    setConversationData: $0b6866794de633f9$var$setConversationData,
                    experienceName: props?.experienceName,
                    getRateLimitState: props?.getRateLimitState,
                    actionErrorHandler: props?.actionErrorHandler
                });
                return undefined;
            }
        };
/**
 * ************************************************************
 * Private Actions
 * ************************************************************
 */ const $0b6866794de633f9$var$addStoreChatItem = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addStoreChatItem, ({ message: message, conversationId: conversationIdParam })=>({ getState: getState }, { setMessages: setMessages, getMessages: getMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        setMessages(conversationId, [
            ...getMessages(conversationId),
            message
        ]);
    });
const $0b6866794de633f9$var$addHumanMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addHumanMessage, ({ id: id, content: content, conversationId: conversationIdParam, isFromSeededConversation: isFromSeededConversation = false, requestId: requestId, fileUploads: fileUploads })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreHuman)(id, content, isFromSeededConversation, requestId, fileUploads),
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$addAssistantMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addAssistantMessage, ({ id: id, content: content, conversationId: conversationIdParam, agentNamedId: agentNamedId, agentAuthorId: agentAuthorId })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const assistantMessageParams = {
            id: id,
            content: content,
            agentNamedId: agentNamedId,
            agentAuthorId: agentAuthorId,
            conversationId: conversationId
        };
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreAssistant)(assistantMessageParams),
            conversationId: conversationId
        }));
    });
/**
 * ************************************************************
 * Public Actions
 * ************************************************************
 */ const $0b6866794de633f9$var$clearFollowUpMessages = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).clearFollowUpMessages, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>!(0, $bPHr8.isStoreFollowUp)(message));
        setMessages(conversationId, filteredMessages);
    });
/**
 * Send a message to the assistant and add it to react-sweet-state
 *
 * @param agentId -- this parameter will be prioritised over agent.id
 */ const $0b6866794de633f9$var$sendMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).sendMessage, (props)=>(0, $54793c520b6b8872$export$9558791053c77c34)({
        ...props,
        setConversationData: $0b6866794de633f9$var$setConversationData,
        createConversationOptimistically: $0b6866794de633f9$var$createConversationOptimistically,
        addHumanMessage: $0b6866794de633f9$var$addHumanMessage,
        addAssistantMessage: $0b6866794de633f9$var$addAssistantMessage,
        clearFollowUpMessages: $0b6866794de633f9$var$clearFollowUpMessages,
        setSelectedConversation: $0b6866794de633f9$var$setSelectedConversation,
        reconnectToInProgressStream: $0b6866794de633f9$var$reconnectToInProgressStream
    }), {
    experienceName: (args)=>$0b6866794de633f9$var$getSendMessageExperienceName({
            deepResearchEnabled: args[0]?.deepResearchEnabled,
            thinkDeeperEnabled: args[0]?.thinkDeeperEnabled,
            taskModeEnabled: args[0]?.taskModeEnabled,
            fastModeEnabled: args[0]?.fastModeEnabled
        }),
    getRateLimitState: (args)=>({
            isDeepResearchAttempt: args[0]?.deepResearchEnabled
        })
});
/**
 * Similar action to `sendMessage` with the barebone functionalities to confirm tools/skills/actions
 *
 * Initially this will assume that this function only created on existing conversation
 */ const $0b6866794de633f9$var$sendMessageConfirmedTools = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).sendMessageConfirmedTools, ({ conversationId: conversationIdParam, agentId: agentId, confirmed_tools: confirmed_tools, messageSources: messageSources, storeUserMessages: storeUserMessages = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, includeAIFeatureContext: includeAIFeatureContext, agentVersion: agentVersion, actionedAnalyticsAttributes: actionedAnalyticsAttributes, resolutionType: resolutionType, productKey: productKey, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, browserContextSanitizer: browserContextSanitizer, hasStagedContent: hasStagedContent })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, chatContextStoreActions: chatContextStoreActions, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages, trackAIMAUEvent: trackAIMAUEvent, trackAgentEvent: trackAgentEvent, processStreamResearch: processStreamResearch, addImplicitResearchPlan: addImplicitResearchPlan, resetHasReceivedAnswerPart: resetHasReceivedAnswerPart, clearMessageResearch: clearMessageResearch, updateResearchMessageId: updateResearchMessageId, markIncompleteResearchesErrored: markIncompleteResearchesErrored, sendAnalyticsEvent: sendAnalyticsEvent, getIsChatMounted: getIsChatMounted, capabilities: capabilities, unifiedTasksActions: unifiedTasksActions, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, processMessageStreamActionClassification: processMessageStreamActionClassification, onTempMessageIdReplaced: onTempMessageIdReplaced })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const resolvedAgentVersion = agentVersion ?? getState().conversations[conversationId]?.agentVersion;
        const confirmedToolsExperienceName = taskModeEnabled ? (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE : (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE;
        // Collection of callbacks for experience and performance tracking
        const expAndPerfTrackers = {
            start: ()=>{
                experienceTracker.start({
                    name: confirmedToolsExperienceName,
                    id: conversationId,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: messageSources?.interactionSource
                    }
                });
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFinishStream.start();
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.start();
            },
            firstAnswerPartReceived: ()=>{
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            succeed: ()=>{
                experienceTracker.succeed({
                    name: confirmedToolsExperienceName
                });
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
            },
            aupError: ()=>{
                experienceTracker.succeed({
                    name: confirmedToolsExperienceName
                });
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            agentDeactivated: ({ error: error })=>{
                experienceTracker.fail({
                    name: confirmedToolsExperienceName,
                    error: error
                });
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            abort: ()=>{
                experienceTracker.abort({
                    name: confirmedToolsExperienceName,
                    reason: 'Aborted'
                });
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            fail: ({ error: error })=>{
                experienceTracker.fail({
                    name: confirmedToolsExperienceName,
                    error: error
                });
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $7UNrw.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            }
        };
        const requestedModeAttributes = (0, $9likX.interactionModeRequestedAttributes)((0, $9likX.getInteractionModeRequested)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            taskModeEnabled: taskModeEnabled
        }));
        const trackingAttributes = {
            isRovoCustomAgent: (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId),
            sendMessageReason: 'TOOLS_CONFIRMATION',
            aiFeatureName: messageSources?.aiFeatureName
        };
        // Source executed mode from the originating assistant message (the one this
        // confirmed-tools action is being executed against). `confirmed_tools.message_id`
        // is the assistant message id whose tool calls the user just confirmed.
        const originatingAssistantMessage = getMessages(conversationId).find((item)=>(0, $bPHr8.isStoreAssistant)(item) && item.content?.message?.message?.id === confirmed_tools.message_id);
        const interactionModeExecutedFromOriginatingAssistantMessage = (0, $9likX.getInteractionModeExecutedFromStoreAssistant)(originatingAssistantMessage);
        const isCancelled = resolutionType === 'cancelled';
        const tools = (0, $af163ae683530e0f$export$376e622a1b976e6e)(confirmed_tools);
        const agentAnalyticsAttributes = {
            touchPoint: 'chatSendMessageConfirmedTools',
            tools: tools
        };
        // Collection of callbacks for analytics tracking
        const analyticsTrackers = {
            /**
     * There are 2 AIMAU events here, because in resumption we're doing 2 things
     * 1. We're confirming the previous tools result
     * 2. And the confirmation triggers a LLM chat streaming
     */ initiated: ({ timestamp: timestamp })=>{
                const actionKey = (0, $7d5fb3e4ab5c45a6$export$af4bad69aa3a06c5)({
                    toolDefinitionSource: confirmed_tools.tools[0]?.tool_source,
                    key: confirmed_tools.tools[0]?.key
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'actioned',
                    actionResult: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    proactive: false,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    attributes: {
                        ...(0, $dh538.fg)('jira-ai-agentic-planning-technical-changes') ? actionedAnalyticsAttributes : {},
                        ...interactionModeExecutedFromOriginatingAssistantMessage ? {
                            interactionModeExecuted: interactionModeExecutedFromOriginatingAssistantMessage
                        } : {},
                        ...actionKey ? {
                            actionKey: actionKey
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        }
                    },
                    // override the messageId to the confirmed_tools.message_id and not what's in trackingAttributes,
                    // because action is on the original message not this message
                    messageId: confirmed_tools.message_id
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: timestamp,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: isCancelled ? 'toolsExecutionCancelled' : 'toolsExecutionConfirmed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        ...(0, $dh538.fg)('jira-ai-agentic-planning-technical-changes') && actionedAnalyticsAttributes
                    }
                });
            },
            aborted: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'dismissed',
                    subjectId: messageSources?.interactionSource,
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionStreamStopped',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            },
            viewed: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'viewed',
                    proactive: false,
                    userGenerated: true,
                    source: messageSources?.interactionSource,
                    messageId: trackingAttributes.messageId,
                    subjectId: messageSources?.followUpSource,
                    citedProductList: {},
                    sourceProducts: {},
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: {
                        ...trackingAttributes.interactionModeExecuted ? {
                            interactionModeExecuted: trackingAttributes.interactionModeExecuted
                        } : {},
                        ...trackingAttributes.aiFeatureName && {
                            aiFeatureName: trackingAttributes.aiFeatureName
                        }
                    }
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultViewed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        scenarioId: trackingAttributes.scenarioId
                    }
                });
            },
            error: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'error',
                    proactive: false,
                    userGenerated: true,
                    messageId: trackingAttributes.requestId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    attributes: requestedModeAttributes
                });
                // @deprecated kept for Data Science (DS) consumers. Replaced by backend unified instrumentation: https://hello.atlassian.net/wiki/spaces/DATA/pages/7037248568/Backend+Unified+Instrumentation+for+Skills+Tools+Subagents
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultError',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
        let hasReceivedFinalResponse = false;
        let generator;
        let responseData;
        let hasLoggedInitiatedEvent = false;
        // Hoisted so it is accessible in the catch block for clearMessageResearch
        let tmpAssistantMessageId = (0, $cteoa.generateTmpMessageId)(conversationId);
        // Reconnect state — populated once we receive the conversation channel data message
        let agentMessageId;
        let isReconnectSupported = false;
        const handleAbort = ()=>{
            expAndPerfTrackers.abort();
            confirmAbort();
            clearMessageResearch({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.aborted();
            // Call the cancel API to stop backend processing
            if (trackingAttributes.messageId && trackingAttributes.messageId !== tmpAssistantMessageId) assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: trackingAttributes.messageId
            }).catch(()=>{
                // Log but don't throw - the abort is already happening
                (0, $1yaYZ.addSentryBreadcrumb)({
                    message: 'Failed to cancel message stream after abort in sendMessageConfirmedTools',
                    data: {
                        conversationId: conversationId,
                        messageId: trackingAttributes.messageId
                    }
                });
            });
        };
        try {
            expAndPerfTrackers.start();
            // change the conversation status
            updateCurrentConversation({
                storeAbortController: storeAbortController,
                status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
                lastAgentMessageStatus: 'IN_PROGRESS'
            });
            if (unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) {
                // Optimistic update goes directly to the tasks store. Explicitly clears
                // current_step / result_summary / error_message so the row resets to a
                // fresh "now running" state.
                const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
                if (activeTask?.taskId) unifiedTasksActions.setTaskProgressState({
                    taskId: activeTask.taskId,
                    progressState: 'Running',
                    title: activeTask.title ?? '',
                    updatedAt: new Date().toISOString(),
                    currentStep: null,
                    resultSummary: null,
                    errorMessage: null
                });
            }
            // Only add assistant message
            dispatch($0b6866794de633f9$var$addAssistantMessage({
                id: tmpAssistantMessageId,
                content: '',
                conversationId: conversationId,
                agentNamedId: agentId
            }));
            dispatch($0b6866794de633f9$var$clearFollowUpMessages({
                conversationId: conversationId
            }));
            trackingAttributes.messageId = tmpAssistantMessageId;
            trackingAttributes.instrumentationId = tmpAssistantMessageId;
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Behind the `rovo-include-full-context-on-confirmed-tools` experiment, build the
            // same full request context that `sendMessage` sends (creationContext +
            // page/whiteboard/slides/database/dashboard/browser/jira context) so the backend
            // routes tool confirmation through the same code paths as a regular send.
            // Derived to mirror a regular follow-up send: existing conversation
            // (`isFirstPrompt: false`) with content context resolved from the staging-area
            // signal. Failures degrade gracefully to the slim context below.
            let fullConfirmedToolsContext;
            if ((0, $c6GJD.default).getExperimentValue('rovo-include-full-context-on-confirmed-tools', 'isEnabled', false)) try {
                const isFirstPrompt = (0, $cteoa.isEmptyConversation)(conversationId);
                const contentContextValue = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
                const isEmptyStagingArea = contentContextValue === 'staging-area' && hasStagedContent === false && (0, $1oCLl.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true);
                fullConfirmedToolsContext = await (0, $54793c520b6b8872$export$32a54ad404e10819)(chatContextStoreActions, isFirstPrompt, addCurrentPageAsContextUserPreference, contentContextValue, productKey, sendAnalyticsEvent, isEmptyStagingArea);
            } catch (error) {
                (0, $1yaYZ.addSentryBreadcrumb)({
                    message: 'Failed to populate full context for sendMessageConfirmedTools; falling back to slim context',
                    data: {
                        conversationId: conversationId
                    }
                });
            }
            // Call the BE endpoint
            trackingAttributes.initiatedTimestamp = new Date().toISOString();
            const response = await assistanceService.sendMessageConfirmedTools({
                conversationId: conversationId,
                agentId: agentId,
                confirmed_tools: confirmed_tools,
                controller: abortController,
                optInSSEStream: true,
                storeMessage: storeUserMessages,
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                fastModeEnabled: fastModeEnabled,
                ...taskModeEnabled ? {
                    planModeEnabled: taskModeEnabled
                } : {},
                ...includeAIFeatureContext && {
                    aiFeatureContext: chatContextStoreActions.getAIFeatureContext()
                },
                ...fullConfirmedToolsContext ? {
                    editorContext: fullConfirmedToolsContext.editorContext,
                    whiteboardContext: fullConfirmedToolsContext.whiteboardContext,
                    slidesContext: fullConfirmedToolsContext.slidesContext,
                    databaseContext: fullConfirmedToolsContext.databaseContext,
                    dashboardEditorContext: fullConfirmedToolsContext.dashboardEditorContext,
                    browserContext: fullConfirmedToolsContext.browserContext,
                    additionalContext: fullConfirmedToolsContext.additionalContext,
                    // aiFeatureContext is intentionally NOT spread here — it stays owned by the
                    // `includeAIFeatureContext` guard above so callers that opt out are respected.
                    jiraWorkflowContext: fullConfirmedToolsContext.jiraWorkflowContext,
                    dashboardContext: fullConfirmedToolsContext.dashboardContext,
                    useCurrentBrowsingContext: fullConfirmedToolsContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer
                } : {},
                ...resolvedAgentVersion ? {
                    agentVersion: resolvedAgentVersion
                } : {},
                optInToDeepResearchV2: true,
                optInThinkDeeperMessages: true,
                optInAnsNow: true,
                optInNewToolTraces: true,
                optInNewTeamworkTraceIcons: (0, $dh538.fg)('rovo_chat_enable_twg_trace_team26'),
                capabilities: capabilities
            });
            generator = response.generator;
            responseData = response.responseData;
            // Update action invocation statuses based on the confirmed_tools payload
            if ((0, $dh538.fg)('rovo_chat_enable_tasks')) dispatch($0b6866794de633f9$var$updateConfirmedToolsActionStatuses({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'fromResolution'
            }));
            /**
     * --------
     * Stream processing START
     * --------
     */ updateCurrentConversation({
                status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse
            });
            // Research store state shared across stream messages
            const researchState = {
                clientRoundCounter: 0,
                hasAccumulatedAnswerContent: false
            };
            const processStreamMarkdown = (0, $cteoa.createStreamMarkdownProcessor)();
            const isFullContextOnConfirmedToolsEnabled = (0, $c6GJD.default).getExperimentValue('rovo-include-full-context-on-confirmed-tools', 'isEnabled', false);
            // Tracks whether an AIFC action has started streaming. Mutated in place by
            // processAifcActionStreamMessage.
            const streamActionInfo = {
                isAction: false
            };
            const streamToIterate = (0, $be423051027308ae$export$29bad1ab941da7cb)({
                generator: generator,
                conversationId: conversationId,
                abortController: abortController,
                assistanceService: assistanceService,
                sendAnalyticsEvent: sendAnalyticsEvent,
                experienceTracker: experienceTracker,
                getMessageId: ()=>agentMessageId,
                canReconnect: ()=>!!(agentMessageId && isReconnectSupported),
                updateCurrentConversation: updateCurrentConversation,
                getIsChatMounted: getIsChatMounted,
                analyticsAttributes: {
                    isDeepResearch: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    fastModeEnabled: fastModeEnabled
                },
                onBeforeFirstReconnect: ()=>{
                    if (agentMessageId) {
                        const chat = getMessages(conversationId);
                        const alreadySwapped = (0, $cteoa.findStoreMessageIndex)(chat, agentMessageId) >= 0;
                        if (!alreadySwapped) {
                            // Swap the tmp message ID → real agent message ID in the
                            // message store so addAnswerPart/replaceAnswerData ID
                            // validation doesn't throw on the replayed stream chunks.
                            setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                                chat: chat,
                                oldId: tmpAssistantMessageId,
                                newId: agentMessageId
                            }));
                            updateResearchMessageId({
                                messageId: tmpAssistantMessageId,
                                newMessageId: agentMessageId
                            });
                        }
                        // Reassign so subsequent processResearchStreamMessage calls
                        // and addAnswerPart/replaceAnswerData use the real agent
                        // message ID as the key.
                        tmpAssistantMessageId = agentMessageId;
                    }
                }
            });
            for await (const streamObj of streamToIterate){
                const streamMessage = (0, $ljUdP.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
                /**
       * Research store processing — handles think-deeper traces, implicit round
       * detection, and research plan updates for all message types.
       */ (0, $54793c520b6b8872$export$5a07e6227eed9665)({
                    streamMessage: streamMessage,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    conversationId: conversationId,
                    deepResearchEnabled: deepResearchEnabled,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    processStreamResearch: processStreamResearch,
                    addImplicitResearchPlan: addImplicitResearchPlan,
                    resetHasReceivedAnswerPart: resetHasReceivedAnswerPart,
                    researchState: researchState
                });
                /**
       * Conversation channel data processing (usually the first stream part)
       */ if ((0, $ljUdP.isConversationChannelDataMessage)(streamMessage)) {
                    agentMessageId = streamMessage.assistant_message_id;
                    trackingAttributes.instrumentationId = agentMessageId;
                    trackingAttributes.messageId = agentMessageId;
                    analyticsTrackers.initiated({
                        timestamp: trackingAttributes.initiatedTimestamp
                    });
                    hasLoggedInitiatedEvent = true;
                    // Update the research store with the real message ID once we have it
                    updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: agentMessageId
                    });
                }
                /**
       * Reconnect support detection
       */ if ((0, $ljUdP.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
                /**
       * Trace processing
       */ if ((0, $ljUdP.isStreamTrace)(streamMessage)) {
                    if (!trackingAttributes.requestId) trackingAttributes.requestId = streamMessage.metadata?.request_id;
                    updateCurrentConversation({
                        traces: (0, $cteoa.dedupeTraceMessagesWithLatest)([
                            ...getState().conversations[conversationId]?.traces ?? [],
                            (0, $cteoa.getTraceFromStreamMessage)(streamMessage)
                        ])
                    });
                }
                /**
       * AIFC action processing — streams generated content into the page via the
       * editor bridge and emits AIFC experiences. Shared with the send-message
       * flow. Gated behind the confirmed-tools full-context experiment.
       */ if (isFullContextOnConfirmedToolsEnabled) (0, $aa1291e40260ba05$export$baa645f348bcec07)({
                    streamMessage: streamMessage,
                    conversationId: conversationId,
                    tmpAssistantMessageId: tmpAssistantMessageId,
                    traceId: responseData?.traceId,
                    productKey: productKey,
                    deepResearchEnabled: deepResearchEnabled,
                    storeUserMessages: storeUserMessages,
                    streamActionInfo: streamActionInfo,
                    trackingAttributes: {
                        requestId: trackingAttributes.requestId,
                        instrumentationId: trackingAttributes.instrumentationId,
                        forcedContentType: undefined
                    },
                    experienceTracker: experienceTracker,
                    chatContextStoreActions: chatContextStoreActions,
                    getMessages: getMessages,
                    setMessages: setMessages,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    getIsChatMounted: getIsChatMounted,
                    processMessageStreamAction: processMessageStreamAction,
                    processMessageStreamComplete: processMessageStreamComplete,
                    processMessageStreamActionClassification: processMessageStreamActionClassification,
                    promptStreamHook: undefined,
                    openChat: undefined,
                    messageSources: messageSources,
                    creationContextParams: undefined,
                    agentId: agentId,
                    agentName: undefined,
                    agentIdentityAccountId: null,
                    stopInteractionMetricsTimeToFirstActionPart: ()=>{}
                });
                /**
       * Answer part processing
       */ if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                    expAndPerfTrackers.firstAnswerPartReceived();
                    (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    let processedStreamMessage = streamMessage;
                    const processedStreamResult = processStreamMarkdown(processedStreamMessage);
                    processedStreamMessage = processedStreamResult.processedStreamMessage;
                    if (processedStreamResult.markdownData) setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownData)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        markdownData: processedStreamResult.markdownData,
                        useIndex: answerIndex
                    }));
                    else setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: processedStreamMessage,
                        useIndex: answerIndex
                    }));
                }
                /**
       * Final response processing
       */ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                    trackingAttributes.interactionModeExecuted = streamMessage.message?.message?.message_metadata?.interaction_mode_executed;
                    hasReceivedFinalResponse = true;
                    const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                    const finalAgentMessageId = streamMessage?.message?.message?.id.toString();
                    (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    const { processedStreamMessage: processedFinalMessage, markdownData: markdownData } = (0, $cteoa.processStreamResponseMarkdown)({
                        streamMessage: streamMessage,
                        messageId: finalAgentMessageId,
                        conversationId: conversationId,
                        sendAnalyticsEvent: sendAnalyticsEvent
                    });
                    setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        content: processedFinalMessage,
                        useIndex: answerIndex,
                        humanMessageId: humanMessageId,
                        markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                        onMessageIdChanged: isFullContextOnConfirmedToolsEnabled ? onTempMessageIdReplaced : undefined
                    }));
                    // Update the research store key so rounds persist after the message ID changes
                    if (finalAgentMessageId && finalAgentMessageId !== tmpAssistantMessageId) updateResearchMessageId({
                        messageId: tmpAssistantMessageId,
                        newMessageId: finalAgentMessageId
                    });
                    trackingAttributes.humanMessageId = humanMessageId;
                    trackingAttributes.scenarioId = streamMessage.message.message?.scenario?.id;
                    if (!hasLoggedInitiatedEvent) {
                        trackingAttributes.messageId = finalAgentMessageId;
                        trackingAttributes.instrumentationId = finalAgentMessageId;
                    }
                }
                /**
       * Follow up processing
       */ if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                    const messages = getMessages(conversationId);
                    (0, $cteoa.clearTracesIfNotEmpty)(getState, conversationId, updateCurrentConversation);
                    setMessages(conversationId, [
                        ...messages,
                        {
                            type: 'FOLLOW_UP',
                            content: streamMessage,
                            id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                            agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                            humanMessageId: trackingAttributes.humanMessageId
                        }
                    ]);
                }
                /**
       * Task status processing
       */ if ((0, $ljUdP.isStreamTaskStatus)(streamMessage)) {
                    if (unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) (0, $4bca5e7215eb7baa$export$89a4ab1dea43d7ee)({
                        conversationId: conversationId,
                        taskMessage: streamMessage.message,
                        messageId: trackingAttributes.messageId,
                        target: (0, $4bca5e7215eb7baa$export$6b58e85d865a8eef)(unifiedTasksActions)
                    });
                }
                /**
       * Todo snapshot processing
       */ if ((0, $ljUdP.isStreamTodoSnapshot)(streamMessage)) {
                    if (unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskTodoSnapshot({
                        conversationId: conversationId,
                        todoSnapshot: {
                            todos: streamMessage.message.todos
                        }
                    });
                }
                /**
       * Error processing
       */ if ((0, $ljUdP.isStreamError)(streamMessage)) {
                    const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                    // AUP violations are still considered successful
                    if ((0, $ljUdP.isStreamAUPError)(streamMessage)) expAndPerfTrackers.aupError();
                    throw new (0, $eu7N9.StreamErrorException)(message?.content || 'Unknown', {
                        detail: {
                            message: message,
                            metadata: metadata,
                            millisOffset: millisOffset,
                            type: type
                        },
                        traceId: response.responseData?.traceId
                    });
                }
            }
        } catch (error) {
            const isAgentDeactivated = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
            const isNoAgentPermission = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
            if (isAgentDeactivated || isNoAgentPermission) {
                expAndPerfTrackers.agentDeactivated({
                    error: error
                });
                updateCurrentConversation({
                    status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
                    traces: [],
                    errorCode: (0, $dh538.fg)('convo-ai-enable-agents-use-permission') ? error.errorAttributes.errorCode : undefined
                });
                // Mark all confirmed tool actions as errored
                if ((0, $dh538.fg)('rovo_chat_enable_tasks')) dispatch($0b6866794de633f9$var$updateConfirmedToolsActionStatuses({
                    conversationId: conversationId,
                    messageId: confirmed_tools.message_id,
                    tools: confirmed_tools.tools,
                    status: 'errored'
                }));
                !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                    timestamp: trackingAttributes.initiatedTimestamp
                });
                analyticsTrackers.error();
                return;
            }
            if (error instanceof Error && error.name === 'AbortError') {
                handleAbort();
                return;
            }
            // Mark all confirmed tool actions as errored
            if ((0, $dh538.fg)('rovo_chat_enable_tasks')) dispatch($0b6866794de633f9$var$updateConfirmedToolsActionStatuses({
                conversationId: conversationId,
                messageId: confirmed_tools.message_id,
                tools: confirmed_tools.tools,
                status: 'errored'
            }));
            expAndPerfTrackers.fail({
                error: error instanceof Error ? error : new Error(String(error))
            });
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        } finally{
            updateCurrentConversation((0, $cteoa.clearStatus)({}));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
        /**
   * --------
   * Stream processing END
   * --------
   */ // Handle programmatic abort — the generator may exit cleanly without throwing AbortError
        // when the abort controller is signalled. Check the signal to detect this case.
        if (abortController.signal.aborted) {
            handleAbort();
            return;
        }
        // if stream finishes without FINAL_RESPONSE, BE is hanging
        if (!hasReceivedFinalResponse) {
            const error = new (0, $0244aa38c72c69e0$export$cdcaebd3b25a3ac3)('The response took too long and timed out. Try refreshing the page.', {
                traceId: responseData?.traceId
            });
            experienceTracker.fail({
                name: confirmedToolsExperienceName,
                error: error
            });
            markIncompleteResearchesErrored({
                messageId: tmpAssistantMessageId
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        }
        !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
            timestamp: trackingAttributes.initiatedTimestamp
        });
        analyticsTrackers.viewed();
        expAndPerfTrackers.succeed();
        if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) //If user is viewing a different conversation or not viewing ConversationAssitant, optimistically set conversation to unread
        {
            if (getState().currentConversationId !== conversationId) dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    readStatus: false
                }
            }));
        }
    });
const $0b6866794de633f9$var$removeMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).removeMessage, ({ messageId: messageId, conversationId: conversationIdParam })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>{
            if ((0, $bPHr8.isStoreError)(message) || (0, $bPHr8.isStoreFollowUp)(message)) return message.id !== messageId;
            else if ((0, $bPHr8.isStoreHuman)(message)) return message.content.id !== String(messageId);
            else return true;
        });
        setMessages(conversationId, filteredMessages);
    });
/**
 * Hides the last HUMAN message + everything after it, and returns the removed
 * slice so the caller can pass it as `editRollback.restoreMessages` to
 * `sendMessage` for automatic rollback on terminal failure.
 */ const $0b6866794de633f9$var$truncateFromLastHumanMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).truncateFromLastHumanMessage, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const messages = getMessages(conversationId);
        const lastHumanIdx = (0, $cteoa.findLastIndex)(messages, (0, $bPHr8.isStoreHuman));
        if (lastHumanIdx < 0) return [];
        const tail = messages.slice(lastHumanIdx);
        setMessages(conversationId, messages.slice(0, lastHumanIdx));
        return tail;
    });
/**
 * Reconnects to an in-progress message stream when loading a conversation
 * where the last message has async_status 'IN_PROGRESS'
 */ const $0b6866794de633f9$var$reconnectToInProgressStream = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).reconnectToInProgressStream, ({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, isDeepResearch: isDeepResearch, abortCurrentRequest: abortCurrentRequest, answerIndex: answerIndex, onComplete: onComplete })=>(0, $f0918ff6cbefa0f7$export$d8454bf5b2ffdf29)({
        conversationId: conversationId,
        messageId: messageId,
        lastEventId: lastEventId,
        isDeepResearch: isDeepResearch,
        abortCurrentRequest: abortCurrentRequest,
        answerIndex: answerIndex,
        onComplete: onComplete,
        setConversationData: $0b6866794de633f9$var$setConversationData
    }), {
    experienceName: ()=>(0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM
});
const $0b6866794de633f9$export$31bb5ed5e2cc3184 = ({ latestMessages: latestMessages, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false })=>{
    const messages = [];
    for (const message of latestMessages){
        if ((0, $ljUdP.isHumanMessage)(message)) {
            // Human messages should only have application/json+a2ui if they have sent an action
            // we skip this message as there is nothing to render but this is persisted for flexibility
            // there should be no cases where a human renders A2UI from their messages
            if (typeof message.content === 'object' && message.content !== null && 'data_parts_mime_type' in message.content && message.content.data_parts_mime_type === 'application/json+a2ui' && (0, $dh538.fg)('jira_ai_rendering_a2ui')) continue;
            messages.push((0, $cteoa.createStoreHumanWithContent)(message));
        } else if ((0, $ljUdP.isStreamResponse)(message)) {
            // Process boundary content for historical assistant messages
            let processedMessage = message;
            const markdownData = {};
            // Rewrite HTML `<details><summary>` blocks into the Rovo-native `▞…▚`
            // boundary before the existing extractor runs so historical messages
            // render identically to their streamed form. Must happen BEFORE the
            // expand extractor below (which consumes `▞…▚`).
            if (shouldPreprocessDetails) processedMessage = (0, $cteoa.preprocessStreamResponseDetails)(processedMessage);
            // Apply the same boundary content extraction logic as streaming messages
            if ((0, $dh538.fg)('rovo_enable_data_sculptor')) {
                const sculptorMsg = (0, $cteoa.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: '[^sculptor:start^]',
                    boundaryEnd: '[^sculptor:end^]',
                    replacementContent: '[^sculptor^]'
                });
                processedMessage = sculptorMsg.processedStreamMessage;
                sculptorMsg.boundaryContents.forEach((content, index)=>{
                    markdownData[`sculptor-${index}`] = content;
                });
            }
            const expandOpenTag = "\u259E";
            const expandCloseTag = "\u259A";
            const expandPlaceholder = '[^expand^]';
            const expandMsg = (0, $cteoa.extractMarkdownContent)({
                streamMessage: processedMessage,
                boundaryStart: expandOpenTag,
                boundaryEnd: expandCloseTag,
                replacementContent: expandPlaceholder
            });
            processedMessage = expandMsg.processedStreamMessage;
            expandMsg.boundaryContents.forEach((content, index)=>{
                markdownData[`expand-${index}`] = content;
            });
            const chartPlaceholder = '[^chart^]';
            // When processing conversation history, process both unicode and non-unicode tags
            // to handle previous conversations that used the non-unicode tag
            // Once di_chat_chart_tag_unicode is rolled out, chartMsg can be removed after 30 days
            let chartIndex = 0;
            const chartMsg = (0, $cteoa.extractMarkdownContent)({
                streamMessage: processedMessage,
                boundaryStart: '[^chart:start^]',
                boundaryEnd: '[^chart:end^]',
                replacementContent: chartPlaceholder
            });
            processedMessage = chartMsg.processedStreamMessage;
            chartMsg.boundaryContents.forEach((content)=>{
                markdownData[`chart-${chartIndex}`] = content;
                chartIndex++;
            });
            if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
                eventType: 'track',
                action: 'extracted',
                actionSubject: 'vizPluginChartNonUnicode',
                attributes: {
                    messageId: message?.message?.message?.id.toString(),
                    conversationId: conversationId,
                    chartCount: chartMsg.boundaryContents.length,
                    timestamp: new Date().toISOString()
                }
            });
            const unicodeChartMsg = (0, $cteoa.extractMarkdownContent)({
                streamMessage: processedMessage,
                boundaryStart: "\u25F4",
                boundaryEnd: "\u25F6",
                replacementContent: chartPlaceholder
            });
            processedMessage = unicodeChartMsg.processedStreamMessage;
            unicodeChartMsg.boundaryContents.forEach((content)=>{
                markdownData[`chart-${chartIndex}`] = content;
                chartIndex++;
            });
            if ((0, $dh538.fg)('rovo_chat_enable_inline_lumina')) {
                const luminaMsg = (0, $cteoa.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: "\u25D0",
                    boundaryEnd: "\u25D1",
                    replacementContent: '\n\n[^lumina^]\n\n'
                });
                processedMessage = luminaMsg.processedStreamMessage;
                luminaMsg.boundaryContents.forEach((content, index)=>{
                    markdownData[`lumina-${index}`] = content;
                });
            }
            // Extract actionable follow-ups so history-loaded messages render the
            // same as their streamed form. Without this, the raw `◈<followup>…`
            // marker renders literally when reopening a past conversation. No-ops
            // when the experiment is in the `control` cohort.
            processedMessage = (0, $cteoa.extractActionableFollowUpsMarkdownData)({
                streamMessage: processedMessage,
                markdownData: markdownData
            });
            // When the backend returns structured content (A2UI messages), normalize
            // it back to a plain text string and extract data_parts for A2UI rendering.
            let extractedA2UIMessages;
            if ((0, $dh538.fg)('jira_ai_rendering_a2ui')) {
                const a2uiResult = (0, $cteoa.extractA2UIFromStructuredContent)(processedMessage.message?.message?.content);
                if (a2uiResult) {
                    processedMessage.message.message.content = a2uiResult.textContent;
                    extractedA2UIMessages = a2uiResult.a2uiMessages;
                }
            }
            // Create StoreAssistant with processed boundary data
            const storeAssistant = (0, $cteoa.createStoreAssistantWithContent)(processedMessage);
            if (Object.keys(markdownData).length > 0) storeAssistant.markdownData = markdownData;
            // Mark message as historical since it's loaded from conversation history
            storeAssistant.isHistorical = true;
            if (extractedA2UIMessages) storeAssistant.agenticUiMessages = extractedA2UIMessages;
            messages.push(storeAssistant);
        }
    }
    return messages;
};
const $0b6866794de633f9$export$9c99f879b5701ba2 = (latestMessages)=>{
    if (!(0, $dh538.fg)('rovo_agent_versioning_enabled')) return undefined;
    for (const message of latestMessages)if ((0, $ljUdP.isStreamResponse)(message)) {
        const agentAuthor = message.message?.message?.agent_author;
        if (agentAuthor?.versionId || agentAuthor?.versionType) return {
            versionId: agentAuthor.versionId,
            versionType: agentAuthor.versionType,
            versionNumber: agentAuthor.versionNumber
        };
        return undefined;
    }
    return undefined;
};
const $0b6866794de633f9$var$restoreTaskModeForConversation = ({ conversationId: conversationId, messages: messages })=>(_, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $dh538.fg)('rovo_chat_enable_tasks') || !unifiedTasksActions) return;
        const activeTask = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        const lastAgentMsgId = (0, $cteoa.getLastAgentMessageID)(messages);
        if (activeTask && !(0, $bPHr8.isTerminalTaskState)(activeTask.progressState) && lastAgentMsgId && activeTask.currentMessageId === lastAgentMsgId) setReasoningMode(conversationId, 'task');
    };
const $0b6866794de633f9$var$isForbiddenConversationError = (error)=>error instanceof (0, $flpNp.ApiError) && error.errorAttributes?.statusCode === 403;
const $0b6866794de633f9$var$handleForbiddenConversation = ({ conversationId: conversationId, dispatch: dispatch, sendAnalyticsEvent: sendAnalyticsEvent, showFlag: showFlag })=>{
    const rovoParams = (0, $6FQwA.getRovoParams)();
    const isConversationIdInRovoParams = !!rovoParams?.conversationId;
    sendAnalyticsEvent({
        eventType: 'track',
        action: 'forbidden',
        actionSubject: 'rovoChatFetchConversation',
        attributes: {
            isConversationIdInRovoParams: isConversationIdInRovoParams
        }
    });
    dispatch($0b6866794de633f9$var$removeConversationFromStore({
        conversationId: conversationId
    }));
    dispatch($0b6866794de633f9$var$setSelectedConversation({
        conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
    }));
    if (isConversationIdInRovoParams) (0, $6FQwA.updatePageRovoParams)({
        conversationId: undefined
    });
    showFlag?.((0, $1n44H.StoreErrorFlagId).CONVERSATION_FORBIDDEN);
};
const $0b6866794de633f9$var$fetchConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).fetchConversation, ({ conversationId: conversationIdParam, messageIdSelectedForPreview: messageIdSelectedForPreview, skipIfConversationAlreadyLoaded: skipIfConversationAlreadyLoaded = false })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, showFlag: showFlag, setReasoningMode: setReasoningMode, capabilities: capabilities })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const conversation = getState().conversations[conversationId];
        if (conversation?.status !== (0, $bPHr8.CHAT_STORE_STATUS).idle || (0, $cteoa.isEmptyConversation)(conversationId)) return;
        if (conversation.skipNextFetch) {
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    skipNextFetch: false
                }
            }));
            return;
        }
        if (skipIfConversationAlreadyLoaded && !messageIdSelectedForPreview && conversation.lastAgentMessageStatus !== 'FAILED' && (getMessages(conversationId).length > 0 || conversation.messages.length > 0)) return;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).FETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        if (conversation.storeAbortController) await conversation.storeAbortController?.abort();
        dispatch($0b6866794de633f9$var$resetConversationForLoading({
            conversationId: conversationId,
            traces: messageIdSelectedForPreview && (0, $dh538.fg)('aifc_create_enabled') ? [] : [
                {
                    messageContent: 'Reloading chat',
                    status: 'loading'
                }
            ],
            sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
        }));
        let serviceChat;
        try {
            serviceChat = await assistanceService.getChat(conversationId, capabilities);
        } catch (e) {
            if ((0, $ljUdP.isChannelNotFoundError)(e)) {
                //We succeed this event because in sendMessage, we create a new channel if we receive a 404 response
                // Users will not see this error, so exclude it from Sentry
                //This is a fix due to an incompatible BE API change
                sendAnalyticsEvent({
                    eventType: 'operational',
                    action: 'notFound',
                    actionSubject: 'rovoChatFetchConversation'
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_CHAT
                });
                dispatch($0b6866794de633f9$var$createConversationOptimistically({
                    sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
                }));
                dispatch($0b6866794de633f9$var$removeConversationFromStore({
                    conversationId: conversationId
                }));
                return;
            }
            if ($0b6866794de633f9$var$isForbiddenConversationError(e) && (0, $dh538.fg)('rovo_chat_improved_conversation_403_handling')) {
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).FETCH_CHAT,
                    error: e
                });
                $0b6866794de633f9$var$handleForbiddenConversation({
                    conversationId: conversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                return;
            }
            throw e;
        }
        // There's a bug currently in the playwright pubsub test where when adding in a new
        // async function to sendMessageStream it causes the message to be dropped
        const status = getState().conversations[conversationId]?.status;
        if (status !== (0, $bPHr8.CHAT_STORE_STATUS).loadingChat) return;
        const latestMessages = serviceChat;
        const messages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
            latestMessages: latestMessages,
            conversationId: conversationId,
            sendAnalyticsEvent: sendAnalyticsEvent,
            shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
        });
        const fetchedAgentVersion = $0b6866794de633f9$export$9c99f879b5701ba2(latestMessages);
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                ...(0, $cteoa.clearStatus)({
                    lastAgentMessageStatus: 'SUCCESSFUL'
                }),
                sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId)),
                ...fetchedAgentVersion ? {
                    agentVersion: fetchedAgentVersion
                } : {}
            }
        }));
        // Check if the last message has async_status 'IN_PROGRESS' and reconnect to the stream
        const lastMessage = latestMessages.at(-1);
        const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
        if ((0, $ljUdP.isInProgressStreamResponse)(lastMessage)) {
            const messageId = lastMessage.message.message.id;
            // Clear the "Message is in progress" content of the last agent message
            const updatedMessages = (0, $cteoa.clearStoreAssistantMessageContent)(messages, messageId);
            setMessages(conversationId, updatedMessages);
            dispatch($0b6866794de633f9$var$reconnectToInProgressStream({
                conversationId: conversationId,
                messageId: messageId,
                isDeepResearch: isDeepResearch
            }));
        } else setMessages(conversationId, messages);
        dispatch($0b6866794de633f9$var$restoreTaskModeForConversation({
            conversationId: conversationId,
            messages: messages
        }));
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).FETCH_CHAT
        });
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).FETCH_CHAT
});
// Abort requests for a specific conversation, or ALL conversations if no conversationId is passed
const $0b6866794de633f9$var$abortRequests = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).abortRequests, ({ conversationId: conversationId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, deepResearchEnabled: deepResearchEnabled } = {})=>({ getState: getState, dispatch: dispatch }, { experienceTracker: experienceTracker, setReasoningMode: setReasoningMode, isReconnecting: isReconnecting, unifiedTasksActions: unifiedTasksActions, getMessages: getMessages, setMessages: setMessages })=>{
        const conversations = getState().conversations;
        const abortConversationStream = (conversation)=>{
            if (conversation?.storeAbortController) {
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).ABORT_AGENT_STREAM,
                    id: conversation?.id,
                    attributes: {
                        conversationId: conversation?.id,
                        isReconnecting: isReconnecting(conversation?.id ?? '')
                    }
                });
                conversation.storeAbortController.abort();
                if ((0, $dh538.fg)('cc-cwr-fix-finalizing-cancelled-request') && conversation.id && !isReconnecting(conversation.id)) {
                    const currentMessages = getMessages(conversation.id);
                    const nextMessages = (0, $cteoa.markInFlightActionsAsCancelled)(currentMessages);
                    if (nextMessages !== currentMessages) setMessages(conversation.id, nextMessages);
                }
                experienceTracker.abort({
                    name: $0b6866794de633f9$var$getSendMessageExperienceName({
                        deepResearchEnabled: deepResearchEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        taskModeEnabled: taskModeEnabled,
                        fastModeEnabled: fastModeEnabled
                    }),
                    reason: 'Aborted',
                    attributes: {
                        isProgrammaticAbort: true
                    }
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).ABORT_AGENT_STREAM
                });
                if (taskModeEnabled && conversation?.id && unifiedTasksActions && (0, $dh538.fg)('rovo_chat_enable_tasks')) unifiedTasksActions.setTaskProgressState({
                    conversationId: conversation.id,
                    progressState: 'Cancelled',
                    updatedAt: new Date().toISOString()
                });
            }
        };
        if (conversationId) abortConversationStream(conversations[conversationId]);
        else Object.values(conversations).forEach(abortConversationStream);
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).ABORT_AGENT_STREAM
});
/**
 * Triggers Answer Now functionality to fast-forward extended thinking.
 * This action performs an optimistic update:
 * 1. Sets answerNowStatus to SWITCHING immediately
 * 2. Calls the Answer Now API endpoint
 * 3. Sets status to ERRORED if API call fails (hides button, prevents retry)
 *
 * Note: Research steps and message content are NOT cleared here - they continue
 * to be displayed during SWITCHING. Clearing happens when FAST_MODE_ENABLED is received.
 */ const $0b6866794de633f9$var$answerNow = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).answerNow, ({ conversationId: conversationIdParam, tmpMessageId: tmpMessageId, remoteMessageId: remoteMessageId })=>async ({ getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        // Helper to update conversation traces
        const updateConversationTrace = (traceMessage)=>{
            const state = getState();
            const conversation = state.conversations[conversationId];
            if (conversation) setState({
                conversations: {
                    ...state.conversations,
                    [conversationId]: {
                        ...conversation,
                        traces: [
                            {
                                messageContent: traceMessage
                            }
                        ]
                    }
                }
            });
        };
        // Verify the message exists and has answerNowStatus === AVAILABLE
        // Also prevents duplicate requests if status is already SWITCHING
        const messages = getMessages(conversationId);
        const targetMessage = messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
        if (!targetMessage || !(0, $bPHr8.isStoreAssistant)(targetMessage) || !(0, $bPHr8.isAnswerNowAvailable)(targetMessage.answerNowStatus)) return;
        // Optimistic update: Set SWITCHING status first and update trace message
        const updatedMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpMessageId, {
            type: (0, $bPHr8.AnswerNowStatusType).SWITCHING
        });
        setMessages(conversationId, updatedMessages);
        updateConversationTrace('Generating answer now!');
        // Start experience tracking
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).ANSWER_NOW,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                remoteMessageId: remoteMessageId,
                tmpMessageId: tmpMessageId
            }
        });
        try {
            // Call the Answer Now API with the remote (BE-provided) message ID
            await assistanceService.answerNow(conversationId, remoteMessageId);
            // Only set SWITCHING_REQUESTED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $bPHr8.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $bPHr8.AnswerNowStatusType).SWITCHING) {
                const successMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).SWITCHING_REQUESTED
                });
                setMessages(conversationId, successMessages);
            }
            // Track success
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).ANSWER_NOW
            });
        } catch (error) {
            // Only set ERRORED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $bPHr8.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $bPHr8.AnswerNowStatusType).SWITCHING) {
                const erroredMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).ERRORED
                });
                setMessages(conversationId, erroredMessages);
                updateConversationTrace('Generating faster answer failed, continuing with current mode');
            }
            // Track failure
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).ANSWER_NOW,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    });
const $0b6866794de633f9$var$addErrorMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addErrorMessage, ({ error: error, conversationId: conversationId, errorPrefix: errorPrefix })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreError)(error, errorPrefix),
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$getProcessedConversationChannels = ({ channelsFromAPI: channelsFromAPI, conversations: conversations, conversationsDeletedDuringCall: conversationsDeletedDuringCall = new Set() })=>{
    const localConversationByBackendId = new Map(Object.values(conversations).filter((c)=>Boolean(c.backendConversationId)).map((c)=>[
            c.backendConversationId,
            c
        ]));
    return channelsFromAPI.filter((channel)=>!conversationsDeletedDuringCall.has(channel.id)).reduce((acc, channel)=>{
        const localConversation = conversations[channel.id] ?? localConversationByBackendId.get(channel.id);
        acc[channel.id] = (0, $90c63f46323387a6$export$60a662127f30e1e1)(channel, localConversation);
        return acc;
    }, {});
};
const $0b6866794de633f9$var$mergeConversationChannelTasks = (channelsFromAPI, unifiedTasksActions)=>{
    if (!unifiedTasksActions) return;
    const allChannelTasks = channelsFromAPI.flatMap((channel)=>channel.tasks ?? []);
    if (allChannelTasks.length > 0) unifiedTasksActions.mergeConversationChannelTasks(allChannelTasks);
};
const $0b6866794de633f9$var$fetchConversationChannelsData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).fetchConversationChannelsData, ({ isInitialLoad: isInitialLoad = false, reconcileFirstPage: reconcileFirstPage = false } = {})=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, unifiedTasksActions: unifiedTasksActions })=>{
        const shouldUsePagination = $0b6866794de633f9$var$isConversationListPaginationEnabled();
        if (shouldUsePagination && reconcileFirstPage && !getState().conversationPagination.isConversationListMounted) return;
        // A concurrent load-more may be in flight; skip the first-page reconciliation
        // rather than stomping its cursor/hasMore metadata. Best-effort: the next
        // visibility event will reconcile correctly.
        if (shouldUsePagination && reconcileFirstPage && getState().conversationPagination.isLoadingMore) return;
        if (isInitialLoad) experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD
        });
        else experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
        // Capture conversation IDs before API call to detect changes during the call
        const conversationsBeforeAPICall = new Set(Object.keys(getState().conversations));
        const conversationChannelsResponse = shouldUsePagination ? await assistanceService.getConversationChannels({
            limit: $0b6866794de633f9$var$CONVERSATION_LIST_PAGE_SIZE
        }) : await assistanceService.getConversationChannels();
        const channelsFromAPI = conversationChannelsResponse.items;
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const channelIds = new Set(channelsFromAPI.map((channel)=>channel.id));
        // Identify conversations deleted during the API call (were there before but aren't now)
        const conversationsDeletedDuringCall = new Set(Array.from(conversationsBeforeAPICall).filter((id)=>!conversations[id] && !(0, $cteoa.isEmptyConversation)(id)));
        // Identify conversations created during the API call (exist in state but weren't there before and aren't in API response)
        const conversationsCreatedDuringCall = new Set(Object.keys(conversations).filter((id)=>!conversationsBeforeAPICall.has(id) && !channelIds.has(id)));
        // Preserve all local conversations not yet on the server
        // (they may have just finished processing or be in-flight)
        // e.g. optimistic conversation when URL params are used to open a chat
        const optimisticConversationsToPreserve = new Set(Object.keys(conversations).filter((id)=>!channelIds.has(id) && !(0, $cteoa.isEmptyConversation)(id)));
        const conversationIdsToPreserve = new Set([
            ...conversationsCreatedDuringCall,
            ...optimisticConversationsToPreserve
        ]);
        const conversationsToPreserve = Object.fromEntries(Array.from(conversationIdsToPreserve, (id)=>[
                id,
                conversations[id]
            ]));
        const processedChannels = $0b6866794de633f9$var$getProcessedConversationChannels({
            channelsFromAPI: channelsFromAPI,
            conversations: conversations,
            conversationsDeletedDuringCall: conversationsDeletedDuringCall
        });
        const allChannelTasks = channelsFromAPI.flatMap((channel)=>channel.tasks ?? []);
        $0b6866794de633f9$var$mergeConversationChannelTasks(channelsFromAPI, unifiedTasksActions);
        // Hydrate the store with the fetched conversation channels
        // whilst preserving the empty state and and any conversations created during the API call, so drafts are never lost
        // due to rehydration (e.g window refocus) when this is called
        setState({
            conversations: {
                EMPTY_CONVERSATION_ID: conversations[0, $2CHXX.EMPTY_CONVERSATION_ID],
                ...processedChannels,
                ...conversationsToPreserve
            },
            isConversationsInitialized: true,
            conversationPagination: {
                ...getState().conversationPagination,
                nextCursor: shouldUsePagination ? conversationChannelsResponse.cursor : null,
                hasMore: shouldUsePagination ? conversationChannelsResponse.hasNext : false,
                isLoadingMore: false,
                loadMoreError: null
            }
        });
        const currentConversationDeleted = !(0, $cteoa.isEmptyConversation)(currentConversationId) && !channelIds.has(currentConversationId) && !conversationIdsToPreserve.has(currentConversationId);
        if (currentConversationDeleted && !isInitialLoad) dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
        }));
        const firstChannelTask = allChannelTasks[0];
        const shouldRestoreTaskMode = firstChannelTask !== undefined && !(0, $bPHr8.isTerminalTaskState)((0, $40OEo.mapApiTaskStatusToProgressState)(firstChannelTask.status));
        if (isInitialLoad && (0, $dh538.fg)('rovo_chat_enable_tasks') && shouldRestoreTaskMode) dispatch($0b6866794de633f9$var$restoreTaskModeIfNeeded());
        experienceTracker.succeed({
            name: isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
    }, {
    experienceName: (args)=>args?.[0]?.isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
const $0b6866794de633f9$var$loadMoreConversationChannelsData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).loadMoreConversationChannelsData, ()=>async ({ setState: setState, getState: getState }, { assistanceService: assistanceService, unifiedTasksActions: unifiedTasksActions })=>{
        if (!$0b6866794de633f9$var$isConversationListPaginationEnabled()) return;
        const { conversationPagination: conversationPagination } = getState();
        if (conversationPagination.isLoadingMore || !conversationPagination.hasMore || !conversationPagination.nextCursor) return;
        setState({
            conversationPagination: {
                ...conversationPagination,
                isLoadingMore: true,
                loadMoreError: null
            }
        });
        try {
            const conversationChannelsResponse = await assistanceService.getConversationChannels({
                limit: $0b6866794de633f9$var$CONVERSATION_LIST_PAGE_SIZE,
                cursor: conversationPagination.nextCursor
            });
            const channelsFromAPI = conversationChannelsResponse.items;
            const { conversations: conversations } = getState();
            const processedChannels = $0b6866794de633f9$var$getProcessedConversationChannels({
                channelsFromAPI: channelsFromAPI,
                conversations: conversations
            });
            $0b6866794de633f9$var$mergeConversationChannelTasks(channelsFromAPI, unifiedTasksActions);
            setState({
                conversations: {
                    ...conversations,
                    ...processedChannels
                },
                conversationPagination: {
                    ...getState().conversationPagination,
                    nextCursor: conversationChannelsResponse.cursor,
                    hasMore: conversationChannelsResponse.hasNext,
                    isLoadingMore: false,
                    loadMoreError: null
                }
            });
        } catch (error) {
            setState({
                conversationPagination: {
                    ...getState().conversationPagination,
                    isLoadingMore: false,
                    loadMoreError: (0, $cteoa.createStoreError)(error, undefined, (0, $bPHr8.StoreActionLoggableName).loadMoreConversationChannelsData)
                }
            });
        }
    });
const $0b6866794de633f9$var$setConversationListMounted = (isConversationListMounted)=>({ setState: setState, getState: getState })=>{
        setState({
            conversationPagination: {
                ...getState().conversationPagination,
                isConversationListMounted: isConversationListMounted
            }
        });
    };
const $0b6866794de633f9$var$getTimeoutBeforeExpiration = ()=>{
    return 0, $cBi7Q.SHORTER_TIMEOUT_BEFORE_NEW_CHAT;
};
/*
 * This action runs on initial load to hydrate this in-memory store (chatStore)
 * with data from either URL parameters or LocalStorage. URL parameters take precedence.
 *
 * Setting the currentConversationId (using setSelectedConversation or createConversationOptimistically)
 * may implicitly trigger fetching of conversation messages.
 *
 * Any change to currentConversationId will trigger a useEffect in ChatHistory,
 * which then executes the `fetchConversation` action.
 */ const $0b6866794de633f9$var$hydrateConversationWithExternalParams = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).hydrateConversation, ({ autoSelectConversation: autoSelectConversation })=>async ({ getState: getState, dispatch: dispatch }, { siteId: siteId, experienceTracker: experienceTracker, setChatStatus: setChatStatus, initChatInitiator: initChatInitiator, insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder, setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, getStoreUserMessagesPreference: getStoreUserMessagesPreference })=>{
        experienceTracker.start({
            id: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION,
            name: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
        });
        const rovoParamsUnsanitized = (0, $6FQwA.getRovoParams)();
        const rovoParams = Object.fromEntries(Object.entries(rovoParamsUnsanitized).filter(([, v])=>v !== 'undefined'));
        let initWithParams = autoSelectConversation && rovoParams.pathway === 'chat';
        const { currentConversationId: currentConversationId } = getState();
        if (rovoParams.stagingAreaOpen && (0, $dh538.fg)('aifc_create_enabled')) {
            setStagingAreaMode('inline', 'rovoChat');
            (0, $6FQwA.updatePageRovoParams)({
                stagingAreaOpen: undefined
            });
        }
        if (rovoParams.messageIdSelectedForPreview && (0, $dh538.fg)('aifc_create_enabled')) {
            setMessageIdSelectedForPreview(rovoParams.messageIdSelectedForPreview);
            (0, $6FQwA.updatePageRovoParams)({
                messageIdSelectedForPreview: undefined
            });
        }
        if (rovoParams.triggerOpen) // if the rovo chat was actually open with url param
        initChatInitiator(rovoParams.initiator);
        // Process params as a priority
        if (initWithParams) {
            const localConversation = rovoParams.conversationId ? getState().conversations[rovoParams.conversationId] : undefined;
            if (rovoParams.conversationId && localConversation) {
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: rovoParams.conversationId,
                    sourceAgentId: rovoParams.agentId
                }));
                // Clear conversationId from URL after consuming it so subsequent chat opens
                // don't reuse it and get stuck in the same conversation.
                (0, $6FQwA.updatePageRovoParams)({
                    conversationId: undefined
                });
            } else dispatch($0b6866794de633f9$var$createConversationOptimistically({
                id: rovoParams.conversationId,
                sourceAgentId: rovoParams.agentId
            }));
            if (rovoParams.prompt) {
                // For cases where the prompt is a json string containing ADF, we need to parse it
                const shouldParse = (0, $cteoa.isValidAdfJsonString)(rovoParams.prompt);
                const prompt = shouldParse ? JSON.parse(rovoParams.prompt) : rovoParams.prompt;
                if (rovoParams.insertPrompt === 'highlight-action') // URL-param highlight actions are emitted from the Confluence view-page
                // surface, so this context is intentionally page-only.
                insertHighlightActionsEditorPlaceholder(prompt, $0b6866794de633f9$var$HIGHLIGHT_ACTION_INLINE_VIEW_PAGE_CREATION_CONTEXT_PARAMS);
                else dispatch($0b6866794de633f9$var$sendMessage({
                    prompt: (0, $4pEXC.encodeAdf)(prompt),
                    agentId: rovoParams.agentId,
                    // Use the user's preference for storing messages
                    // TODO(ai_mate_store_messages_be_driven): remove this local storeUserMessages payload
                    // value when BE user settings are fully rolled out; BE overrides it via the capability header.
                    storeUserMessages: getStoreUserMessagesPreference?.() ?? false,
                    messageSources: {
                        interactionSource: 'urlParam'
                    }
                }));
            }
            // for UFO performance tracking dimensions
            (0, $cbc8g.addUFOCustomData)({
                isEmptyConversation: !rovoParams.conversationId,
                hasInitialPrompt: !!rovoParams.prompt
            });
        } else if (autoSelectConversation) {
            const timeoutBeforeNewChat = $0b6866794de633f9$var$getTimeoutBeforeExpiration();
            // HOT-303866: a since-reverted change stored a stringified JSON object under
            // this key instead of a plain conversation ID. If we detect that corrupt object
            // shape, self-heal by overwriting the key and start a new conversation.
            const getSafeStoredConversationId = ()=>{
                const key = (0, $G375e.getChatLoadPreferenceKey)(siteId);
                const raw = localStorage?.getItem(key) ?? null;
                if (!raw) return 0, $2CHXX.EMPTY_CONVERSATION_ID;
                let isCorruptObject = false;
                try {
                    const parsed = JSON.parse(raw);
                    isCorruptObject = typeof parsed === 'object' && parsed !== null;
                } catch  {
                // Not JSON — a plain conversation ID string, use it as-is.
                }
                if (isCorruptObject) {
                    localStorage?.setItem(key, (0, $2CHXX.EMPTY_CONVERSATION_ID));
                    return 0, $2CHXX.EMPTY_CONVERSATION_ID;
                }
                return raw;
            };
            const targetConversationId = (0, $dh538.fg)('rovo_chat_safe_conversation_id_from_ls') ? getSafeStoredConversationId() : localStorage?.getItem((0, $G375e.getChatLoadPreferenceKey)(siteId)) ?? (0, $2CHXX.EMPTY_CONVERSATION_ID);
            const lastMessageSentAt = (0, $9963cc910aac4af3$export$1afac255ab1e880e)();
            const hasTargetChanged = targetConversationId !== currentConversationId;
            const isTargetExpired = lastMessageSentAt && Date.now() - lastMessageSentAt >= timeoutBeforeNewChat;
            const isTargetConversationEmpty = (0, $cteoa.isEmptyConversation)(targetConversationId);
            const hasLocalTargetConversation = Boolean(getState().conversations[targetConversationId]);
            // start new conversation: if recent expired
            if (isTargetExpired) {
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
                }));
                (0, $9963cc910aac4af3$export$589976df4d188aac)(null);
            // start new conversation: if target conversation was set to new (e.g. in another tab)
            } else if (hasTargetChanged && isTargetConversationEmpty) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
            }));
            else if (hasTargetChanged && hasLocalTargetConversation) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: targetConversationId
            }));
            else if (hasTargetChanged) dispatch($0b6866794de633f9$var$createConversationOptimistically({
                id: targetConversationId
            }));
            // for UFO performance tracking dimensions
            (0, $cbc8g.addUFOCustomData)({
                isEmptyConversation: !isTargetExpired && hasTargetChanged
            });
        }
        // Set online status later, to ensure that pubsub listener doesn't race condition with store init state
        setChatStatus('online');
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
        });
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
});
const $0b6866794de633f9$var$addAgentMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addAgentMessage, ({ conversationId: conversationId, agentNamedId: agentNamedId, content: content })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$addAssistantMessage({
            id: (0, $cteoa.generateId)(),
            content: content,
            conversationId: conversationId,
            agentNamedId: agentNamedId
        }));
    });
const $0b6866794de633f9$var$handleChatOpenPubsubAction = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).handleChatOpenPubsubAction, ({ conversationId: conversationId, agentId: agentId })=>async ({ getState: getState, dispatch: dispatch })=>{
        // IF convo id is the current chat
        // refetch the chat, do not create new one
        if (conversationId === getState().currentConversationId) {
            // Keep the agent id from this `chat-new` event. When the new selected-agent
            // identity model is off, preserve the older hydration gate as the kill switch.
            const shouldStoreChatNewAgentId = !!agentId && (0, $dh538.fg)('rovo_chat_agent_selection');
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $dh538.fg)('rovo_chat_agent_selection') ? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(agentId) : undefined;
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch($0b6866794de633f9$var$fetchConversation({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat already exist in conversation
        // switch to that convo -> and it will trigger refetch when ChatHistory is rendered
        if (getState().conversations[conversationId]) {
            // Keep the agent id from this `chat-new` event. When the new selected-agent
            // identity model is off, preserve the older hydration gate as the kill switch.
            const shouldStoreChatNewAgentId = !!agentId && (0, $dh538.fg)('rovo_chat_agent_selection');
            if (shouldStoreChatNewAgentId) {
                const conversationAgentFromChatNew = (0, $dh538.fg)('rovo_chat_agent_selection') ? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(agentId) : undefined;
                const conversationAgentFieldsFromChatNew = conversationAgentFromChatNew ? {
                    agent: conversationAgentFromChatNew
                } : {};
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        sourceAgentId: agentId,
                        ...conversationAgentFieldsFromChatNew
                    }
                }));
            }
            dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat does not exist yet
        // Create conversation optimistically, which will switch to that conversation
        // By switching conversation, it will render ChatHistory
        // ChatHistory will auto fetch the chat data
        // if not found during `sendMessage`, it will auto create one and retry when encountered `404`
        // Create conversation optimistically and store sourceAgentId
        const sourceAgentIdFromChatNew = agentId && (0, $dh538.fg)('rovo_chat_agent_selection') ? agentId : undefined;
        dispatch($0b6866794de633f9$var$createConversationOptimistically({
            id: conversationId,
            sourceAgentId: sourceAgentIdFromChatNew
        }));
    });
const $0b6866794de633f9$var$createConversationOptimistically = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).createConversationOptimistically, (options)=>async ({ dispatch: dispatch }, { setMessages: setMessages })=>{
        const conversationId = options?.id ?? (0, $2CHXX.EMPTY_CONVERSATION_ID);
        const time = new Date().toISOString();
        // Seed `conversation.agent` from the known optimistic conversation identity.
        const agentForOptimisticConversation = $0b6866794de633f9$var$resolveConversationSeedAgent({
            backendAgent: options?.agent,
            agentId: options?.sourceAgentId,
            legacyAgent: options?.agent
        });
        // Under the selected-agent gate the header derives the displayed agent
        // solely from `conversation.agent`. When this optimistic creation re-uses an
        // existing conversation slot (e.g. EMPTY_CONVERSATION_ID) the data is
        // shallow-merged, so omitting the `agent` key would leave a previously-seeded
        // specialist agent in place. Selecting "Chat with Rovo" (no agent id) must
        // therefore explicitly clear `conversation.agent` back to the default Rovo
        // agent rather than silently preserving the stale one.
        const optimisticConversationAgentData = agentForOptimisticConversation ? {
            agent: agentForOptimisticConversation
        } : (0, $dh538.fg)('rovo_chat_agent_selection') ? {
            agent: undefined
        } // explicit clear so "Chat with Rovo" resets a stale specialist
         : {};
        dispatch($0b6866794de633f9$var$initializeConversationData({
            conversationId: conversationId,
            data: {
                id: conversationId,
                lastMessageTimestamp: options.lastMessageTimestamp ?? time,
                name: options.name ?? (0, $99vXA.generateConversationName)(),
                sourceAgentId: options.sourceAgentId,
                sourceId: options.sourceId ?? undefined,
                status: options?.status ?? (0, $bPHr8.CHAT_STORE_STATUS).idle,
                timeCreated: options?.timeCreated ?? time,
                traces: [],
                messages: [],
                lastMessageType: options?.lastMessageType ?? [],
                lastAgentMessageStatus: options?.lastAgentMessageStatus,
                // Explicitly set rovoSpaceId (including undefined) so that re-initialising
                // EMPTY_CONVERSATION_ID without a space clears any stale rovoSpaceId left
                // from a previous space-scoped conversation.
                rovoSpaceId: options?.rovoSpaceId,
                ...optimisticConversationAgentData,
                ...options?.agentVersion ? {
                    agentVersion: options.agentVersion
                } : {},
                ...options?.scopes ? {
                    scopes: options.scopes
                } : {}
            }
        }));
        setMessages(conversationId, []);
        dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$createSeededConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).createSeededConversation, (options)=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, getChatInitiator: getChatInitiator, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL,
            id: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        const createdConversation = await assistanceService.createConversationChannel(options);
        const humanMessage = createdConversation.messages?.find((message)=>(0, $ljUdP.isHumanMessage)(message));
        const assistantMessage = createdConversation.messages?.find((message)=>(0, $ljUdP.isAssistantMessage)(message));
        const humanMessageId = humanMessage ? humanMessage.id : '';
        const assistantMessageId = assistantMessage ? assistantMessage.id : '';
        const conversationTags = createdConversation.tags ?? options.tags;
        // The header reads the displayed agent only from `conversation.agent.agent_id`,
        // so the chat-new/seeded flow must seed it from the known agent id (preferring a
        // backend-returned agent). Without this, a seeded conversation opened with a
        // specific agent shows default Rovo.
        const seededConversationAgent = $0b6866794de633f9$var$resolveConversationSeedAgent({
            backendAgent: createdConversation.agent,
            agentId: options.agentId,
            legacyAgent: createdConversation.agent
        });
        const seededConversationAgentFields = seededConversationAgent ? {
            agent: seededConversationAgent
        } : {};
        dispatch($0b6866794de633f9$var$initializeConversationData({
            conversationId: createdConversation.id,
            data: {
                id: createdConversation.id,
                name: createdConversation.name,
                timeCreated: createdConversation.time_created,
                status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                traces: [],
                sourceId: options.sourceId ?? undefined,
                sourceAgentId: options.agentId,
                agentVersion: options.agentVersion,
                messages: [],
                ...seededConversationAgentFields,
                ...conversationTags !== undefined ? {
                    tags: conversationTags
                } : {},
                ...options.skipNextFetch ? {
                    skipNextFetch: true
                } : {},
                // Scope the seeded conversation to a Rovo Space when applicable so the
                // nav can immediately render it under the correct space and exclude it
                // from the regular conversation list (see ChatListMenuItems filter).
                ...options.rovoSpaceId && (0, $dh538.fg)('rovo_chat_spaces_fe') ? {
                    rovoSpaceId: options.rovoSpaceId
                } : {}
            }
        }));
        const chatInitiator = getChatInitiator();
        // Build synthetic ChatMessage[] from the seeded dialogues and pass directly to
        // processConversationMessages, which handles all boundary content extraction
        // (lumina, chart, expand, sculptor) consistently with fetchConversation —
        // without an extra getChat network call.
        const syntheticMessages = options.dialogues.flatMap((dialogue)=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    messageId: humanMessageId,
                    interactionSource: 'movedOver',
                    followUpSource: options.followUpSource,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    messageId: assistantMessageId,
                    humanMessageId: humanMessageId,
                    pluginsInvoked: [],
                    hasSources: false,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            // When mimeType is 'text/adf', parse the ADF JSON string into a DocNode
            // so encodeAdf's isAdfContent check can pass it through natively.
            let agentContent = dialogue.agent_message.content;
            if (dialogue.agent_message.mimeType === 'text/adf') try {
                agentContent = JSON.parse(dialogue.agent_message.content);
            } catch  {
            // If parsing fails, fall back to raw string content
            }
            // Use raw ChatMessage types (not createStoreHuman/createStoreAssistant) so that
            // processConversationMessages can apply all boundary content extraction
            // (lumina, chart, expand, sculptor) before producing the final StoreChatItem[].
            const humanMessage = {
                role: 'HUMAN',
                id: (0, $cteoa.generateId)(),
                content: dialogue.human_message.content,
                time_created: new Date().toISOString(),
                user_ari: 'unknown',
                plugin_invocations: [],
                isFromSeededConversation: true
            };
            const assistantStreamResponse = {
                type: 'FINAL_RESPONSE',
                message: {
                    message: {
                        role: 'ASSISTANT',
                        id: (0, $cteoa.generateId)(),
                        conversation_channel_id: createdConversation.id,
                        content: agentContent,
                        time_created: new Date().toISOString(),
                        user_ari: 'unknown',
                        plugin_invocations: [],
                        author: {
                            named_id: 'ai_mate_agent',
                            name: 'unknown',
                            actor_type: 'AGENT',
                            ari: null,
                            id: 'unknown'
                        }
                    }
                }
            };
            return [
                humanMessage,
                assistantStreamResponse
            ];
        });
        const processedMessages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
            latestMessages: syntheticMessages,
            conversationId: createdConversation.id,
            sendAnalyticsEvent: sendAnalyticsEvent
        });
        setMessages(createdConversation.id, processedMessages);
        dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: createdConversation.id
        }));
        if (options.mode && onNewConversationStartingWithSendMessage) onNewConversationStartingWithSendMessage(createdConversation.id, options.mode);
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        return createdConversation.id;
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
});
/** Side-nav list items may attach UI-only fields; the chat store `Conversation` type must not persist them. */ const $0b6866794de633f9$var$conversationMetadataForStore = (conversation)=>{
    const { isEmpty: _isEmpty, currentTask: _currentTask, ...storeConversation } = conversation;
    return storeConversation;
};
const $0b6866794de633f9$var$setSelectedConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).setSelectedConversation, ({ conversationId: conversationId, sourceAgentId: sourceAgentId, conversationMetadata: conversationMetadata, targetMessageId: targetMessageId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { siteId: siteId })=>{
        let resolvedConversationId = conversationId;
        if (!getState().conversations[conversationId]) {
            if (conversationMetadata?.id === conversationId) dispatch($0b6866794de633f9$var$initializeConversationData({
                conversationId: conversationId,
                data: {
                    ...$0b6866794de633f9$var$conversationMetadataForStore(conversationMetadata),
                    ...targetMessageId ? {
                        targetTaskMessageId: targetMessageId
                    } : {}
                }
            }));
            else resolvedConversationId = (0, $2CHXX.EMPTY_CONVERSATION_ID);
        } else if (targetMessageId) dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: targetMessageId
            }
        }));
        setState({
            currentConversationId: resolvedConversationId
        });
        // Keep the agent id provided when selecting this conversation; gate-on also seeds `conversation.agent` for the header.
        if (sourceAgentId) {
            const conversationAgentFromSource = (0, $dh538.fg)('rovo_chat_agent_selection') ? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(sourceAgentId) : undefined;
            const conversationAgentSourceData = conversationAgentFromSource ? {
                agent: conversationAgentFromSource
            } : {};
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: resolvedConversationId,
                data: {
                    sourceAgentId: sourceAgentId,
                    ...conversationAgentSourceData
                }
            }));
        }
        // Store preference.
        // For space-scoped conversations, store EMPTY_CONVERSATION_ID instead of the
        // client-generated UUID. The client UUID is never returned by the backend /conversations
        // API, so restoring it on refresh creates an orphaned optimistic entry that has no
        // rovoSpaceId and cannot be matched to any API channel — causing a ghost item to
        // appear in the regular conversation list. Starting fresh (empty chat) on refresh
        // is the correct behaviour for space conversations.
        const conversationForStorage = getState().conversations[resolvedConversationId];
        const localStorageConversationId = conversationForStorage?.rovoSpaceId && (0, $dh538.fg)('rovo_chat_spaces_fe') ? (0, $2CHXX.EMPTY_CONVERSATION_ID) : resolvedConversationId;
        localStorage?.setItem((0, $G375e.getChatLoadPreferenceKey)(siteId), localStorageConversationId);
    });
const $0b6866794de633f9$var$updateActionInvocationStatus = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: {
                ...agentMessage.result.invokedActions,
                [invocationId]: status
            }
        };
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateConfirmedToolsActionStatuses = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, tools: tools, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedInvokedActions = {
            ...agentMessage.result.invokedActions
        };
        for (const tool of tools){
            const resolvedStatus = status === 'fromResolution' ? tool.resolution?.type === 'cancelled' ? 'cancelled' : 'finished' : status;
            updatedInvokedActions[tool.invocation_id] = resolvedStatus;
        }
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: updatedInvokedActions
        };
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateActionData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionData, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, data: data })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        agentMessage.result.content.message.message.actions?.forEach((action)=>{
            if (action.invocationId === invocationId) action.data = {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ...action.data,
                ...data
            };
        });
        updatedMessages[agentMessage.index] = agentMessage.result;
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateConversation = ({ conversationId: conversationId, data: data })=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        let updatedConversation;
        try {
            updatedConversation = await assistanceService?.updateConversationChannel(conversationId, data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                error: error
            });
            throw error;
        }
        const nextData = {
            ...data
        };
        if (updatedConversation) {
            if (updatedConversation.name !== undefined) nextData.name = updatedConversation.name;
            if (updatedConversation.readStatus !== undefined) nextData.readStatus = updatedConversation.readStatus;
            if (typeof updatedConversation.isPinned === 'boolean') nextData.isPinned = updatedConversation.isPinned;
            if (updatedConversation.pinnedAt !== undefined) nextData.pinnedAt = updatedConversation.pinnedAt;
        }
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: nextData
        }));
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL
        });
    };
function $0b6866794de633f9$var$getScheduleRovoChatRuleIdUuidFromExecutionMessage(message) {
    const raw = message.message_metadata?.ruleIdUuid;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}
function $0b6866794de633f9$var$getScheduleRovoChatRRuleFromExecutionMessage(message) {
    const raw = message.message_metadata?.rRule;
    if (raw === undefined || raw === null) return undefined;
    const s = typeof raw === 'string' ? raw.trim() : String(raw);
    return s.length > 0 ? s : undefined;
}
const $0b6866794de633f9$var$resolveConversationAction = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).resolveConversationAction, ({ conversationId: conversationId, messageId: messageId, payload: payload, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false, skipExperienceTracking: skipExperienceTracking = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        let actionCallbackData;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const humanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        const attributes = {
            conversationId: conversationId,
            resolution: payload.context.resolution,
            actionKey: payload.context.key
        };
        if (!skipExperienceTracking) experienceTracker.start({
            name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            id: conversationId,
            attributes: attributes
        });
        try {
            const { invocationId: invocationId } = payload.context;
            // Set actions loading state
            dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                status: 'started'
            }));
            const response = await assistanceService.resolveConversationAction(conversationId, payload);
            const { message: message } = response;
            dispatch($0b6866794de633f9$var$updateActionData({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                data: payload.context.data
            }));
            const ruleIdUuidFromExecution = payload.context.key === (0, $8IKbl.SCHEDULED_CHAT_KEY) && (0, $ljUdP.isAssistantMessage)(message) ? $0b6866794de633f9$var$getScheduleRovoChatRuleIdUuidFromExecutionMessage(message) : undefined;
            const rRuleFromExecution = payload.context.key === (0, $8IKbl.SCHEDULED_CHAT_KEY) && (0, $ljUdP.isAssistantMessage)(message) ? $0b6866794de633f9$var$getScheduleRovoChatRRuleFromExecutionMessage(message) : undefined;
            if (ruleIdUuidFromExecution || rRuleFromExecution) {
                const previousData = payload.context.data;
                const harvested = {
                    ...ruleIdUuidFromExecution ? {
                        ruleIdUuid: ruleIdUuidFromExecution
                    } : {},
                    ...rRuleFromExecution ? {
                        rRule: rRuleFromExecution
                    } : {}
                };
                dispatch($0b6866794de633f9$var$updateActionData({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: typeof previousData === 'object' && previousData !== null ? {
                        ...previousData,
                        ...harvested
                    } : harvested
                }));
            }
            const isMessageWithContent = !!message.content;
            // Display a new agent message from the response to reflect the change in chat history
            if ((0, $ljUdP.isAssistantMessage)(message) && (isMessageWithContent || (0, $ljUdP.isActionExecutedSuccessfully)(message))) {
                if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch($0b6866794de633f9$var$addAssistantMessage({
                    agentNamedId: message.author?.named_id,
                    content: message.content,
                    conversationId: conversationId,
                    id: message.id
                }));
                actionCallbackData = actionContentProcessor?.(message) ?? undefined;
                dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    status: (0, $cteoa.deriveInvocationStatus)(message, payload.context)
                }));
                if ((0, $ljUdP.isActionExecutedSuccessfully)(message)) broadcastConfirmedActions?.(conversationId, [
                    payload.context
                ]);
                sendAnalyticsEvent({
                    eventType: 'ui',
                    action: 'success',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            } else {
                dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: payload.context.invocationId,
                    status: 'errored'
                }));
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'error',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!skipExperienceTracking) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
                error: error,
                attributes: attributes
            });
            trackAIMAUEvent({
                type: 'error',
                userGenerated: true,
                source: 'messageActionsResolver',
                subjectId: payload.context.resolution.type,
                singleInstrumentationID: messageId
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'rovoChatMessageAction',
                attributes: {
                    recipientAgentNamedId: payload.context.recipient_agent_named_id,
                    actionKey: payload.context.key,
                    resolutionType: payload.context.resolution.type,
                    featureArea: featureArea,
                    humanMessageId: humanMessageId,
                    messageId: messageId
                }
            });
            dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            throw new (0, $9TBZq.MessageActionError)({
                message: `Message action error: ${error.message} for actionKey: ${payload.context.key}`,
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                actionKey: payload.context.key,
                cause: error
            });
        }
        if (!skipExperienceTracking) experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            attributes: attributes
        });
        return actionCallbackData;
    }, {
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
const $0b6866794de633f9$var$bulkResolveConversationActions = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).bulkResolveConversationActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { experienceTracker: experienceTracker })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Execute all actions sequentially
        const actionCallbackResults = [];
        const successfulActions = [];
        let hasErrors = false;
        let successCount = 0;
        for (const payload of payloads){
            const result = await dispatch($0b6866794de633f9$var$resolveConversationAction({
                conversationId: conversationId,
                messageId: messageId,
                payload: payload,
                actionContentProcessor: actionContentProcessor,
                skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse,
                skipExperienceTracking: true
            }));
            actionCallbackResults.push(result);
            // Track success: result is defined means action succeeded
            if (result !== undefined) {
                successCount++;
                successfulActions.push(payload.context);
            } else if (!actionContentProcessor) // Action with no processor returns undefined on success
            successCount++;
            else // Action with processor returned undefined = failure
            hasErrors = true;
        }
        if (hasErrors) experienceTracker.fail({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            error: new Error('Some bulk actions failed'),
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length,
                successCount: successCount,
                failureCount: payloads.length - successCount
            }
        });
        else experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        return actionCallbackResults;
    });
const $0b6866794de633f9$var$bulkResolveConversationUIActions = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).bulkResolveConversationUIActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        const humanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Set all invocation statuses to 'started'
        for (const payload of payloads)dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
            conversationId: conversationId,
            messageId: messageId,
            invocationId: payload.context.invocationId,
            status: 'started'
        }));
        try {
            const responses = await assistanceService.bulkResolveConversationUIActions(conversationId, messageId, {
                items: payloads
            });
            const actionCallbackResults = [];
            const successfulActions = [];
            let hasErrors = false;
            let successCount = 0;
            // Process each response paired with its corresponding payload
            for(let i = 0; i < payloads.length; i++){
                const payload = payloads[i];
                const response = responses[i];
                const { invocationId: invocationId } = payload.context;
                if (!response) {
                    // No response for this item - mark as errored
                    dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                    continue;
                }
                const { message: message } = response;
                dispatch($0b6866794de633f9$var$updateActionData({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    data: payload.context.data
                }));
                const isMessageWithContent = !!message.content;
                if ((0, $ljUdP.isAssistantMessage)(message) && (isMessageWithContent || (0, $ljUdP.isActionExecutedSuccessfully)(message))) {
                    if (isMessageWithContent && !skipSuccessOptimisticAssistantResponse) dispatch($0b6866794de633f9$var$addAssistantMessage({
                        agentNamedId: message.author?.named_id,
                        content: message.content,
                        conversationId: conversationId,
                        id: message.id
                    }));
                    const callbackData = actionContentProcessor?.(message) ?? undefined;
                    actionCallbackResults.push(callbackData);
                    dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: (0, $cteoa.deriveInvocationStatus)(message, payload.context)
                    }));
                    if ((0, $ljUdP.isActionExecutedSuccessfully)(message)) successfulActions.push(payload.context);
                    successCount++;
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'success',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                } else {
                    dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                        conversationId: conversationId,
                        messageId: messageId,
                        invocationId: invocationId,
                        status: 'errored'
                    }));
                    hasErrors = true;
                    actionCallbackResults.push(undefined);
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'error',
                        actionSubject: 'rovoChatMessageAction',
                        attributes: {
                            recipientAgentNamedId: payload.context.recipient_agent_named_id,
                            actionKey: payload.context.key,
                            resolutionType: payload.context.resolution.type,
                            featureArea: featureArea,
                            humanMessageId: humanMessageId,
                            messageId: messageId
                        }
                    });
                }
            }
            // Broadcast all successful confirmed actions at once
            if (successfulActions.length > 0) broadcastConfirmedActions?.(conversationId, successfulActions);
            if (hasErrors) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: new Error('Some bulk actions failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: successCount,
                    failureCount: payloads.length - successCount
                }
            });
            else experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length
                }
            });
            return actionCallbackResults;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If the entire bulk request fails, mark all invocations as errored
            for (const payload of payloads)dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
                error: error instanceof Error ? error : new Error('Bulk resolve failed'),
                attributes: {
                    conversationId: conversationId,
                    actionCount: payloads.length,
                    successCount: 0,
                    failureCount: payloads.length
                }
            });
            throw error;
        }
    });
const $0b6866794de633f9$var$deleteConversation = ({ conversationId: conversationId })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).CLEAR_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        await getState().conversations[conversationId]?.storeAbortController?.abort();
        try {
            await assistanceService.deleteChat(conversationId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).CLEAR_CHAT,
                error: error
            });
            throw error;
        }
        // Remove the deleted conversation from the local store prior to refetching channels.
        // fetchConversationChannelsData preserves any local conversation whose ID is missing
        // from the API response (to keep optimistic / in-flight conversations alive). Without
        // this explicit removal, the just-deleted conversation would be treated as
        // "optimistic" and re-added to the store, causing it to reappear in the UI.
        dispatch($0b6866794de633f9$var$removeConversationFromStore({
            conversationId: conversationId
        }));
        await dispatch($0b6866794de633f9$var$fetchConversationChannelsData({
            reconcileFirstPage: true
        }));
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).CLEAR_CHAT
        });
    };
const $0b6866794de633f9$var$warmConversationCache = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).warmConversationCache, ({ conversation: conversationParams, forceRefresh: forceRefresh, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, capabilities: capabilities })=>{
        const conversationId = conversationParams.id;
        const existingConversation = getState().conversations[conversationId];
        // Skip if conversation is actively in-flight
        if (existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).loadingChat || existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse || existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).typingResponse) return;
        // Skip if conversation is already loaded (idle with messages) unless forceRefresh
        if (existingConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).idle && !forceRefresh) return;
        try {
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    forceRefresh: Boolean(forceRefresh)
                }
            });
            // Bootstrap conversation in store with provided metadata or client defaults.
            // rovo_chat_agent_selection cleanup: remove the gate when selected-agent identity
            // is fully launched. Preserve existing metadata during this loading reset,
            // or provisionally seed the agent id provided by the URL/pubsub flow so the header can hydrate it.
            const conversationAgentForWarmLoadingReset = (0, $dh538.fg)('rovo_chat_agent_selection') ? existingConversation?.agent ?? (0, $ce0ec8f0bfa0c691$export$fc6a9cdad8ea90e0)(conversationParams.agentId ?? existingConversation?.sourceAgentId) : undefined;
            const conversationAgentFieldsForWarmLoadingReset = conversationAgentForWarmLoadingReset ? {
                agent: conversationAgentForWarmLoadingReset
            } : {};
            dispatch($0b6866794de633f9$var$initializeConversationData({
                conversationId: conversationId,
                data: {
                    id: conversationId,
                    name: conversationParams.name ?? existingConversation?.name ?? '',
                    timeCreated: conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                    status: (0, $bPHr8.CHAT_STORE_STATUS).loadingChat,
                    traces: [],
                    sourceAgentId: conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                    ...conversationAgentFieldsForWarmLoadingReset,
                    messages: []
                }
            }));
            // If metadata params not fully provided, fetch from API in parallel (silent failure)
            const hasFullMetadata = conversationParams.name != null && conversationParams.timeCreated != null;
            const metadataPromise = hasFullMetadata ? Promise.resolve() : assistanceService.fetchConversationMetadata(conversationId).then((metadata)=>{
                // rovo_chat_agent_selection cleanup: remove the gate and always keep
                // backend conversation-agent metadata from fetched channels.
                const fetchedConversationAgentFields = metadata.agent && (0, $dh538.fg)('rovo_chat_agent_selection') ? {
                    agent: metadata.agent
                } : {};
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        name: metadata.name ?? conversationParams.name ?? '',
                        timeCreated: metadata.time_created ?? conversationParams.timeCreated ?? existingConversation?.timeCreated ?? new Date().toISOString(),
                        sourceAgentId: metadata.agent?.agent_named_id ?? conversationParams.agentId ?? existingConversation?.sourceAgentId ?? '',
                        ...fetchedConversationAgentFields,
                        ...metadata.tags !== undefined ? {
                            tags: metadata.tags
                        } : {}
                    }
                }));
            }).catch(()=>{
            // Silent failure — keep client defaults
            });
            // Run messages fetch and metadata fetch in parallel; wait for both
            const chatPromise = assistanceService.getChat(conversationId, capabilities);
            const [chatResult] = await Promise.allSettled([
                chatPromise,
                metadataPromise
            ]);
            if (chatResult.status === 'rejected') {
                const normalizedError = chatResult.reason instanceof Error ? chatResult.reason : new Error(String(chatResult.reason));
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
                    error: normalizedError
                });
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: (0, $cteoa.clearStatus)({})
                }));
                onError?.(normalizedError);
                return;
            }
            const serviceChat = chatResult.value;
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $bPHr8.CHAT_STORE_STATUS).loadingChat) return;
            const messages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
            });
            const fetchedAgentVersion = $0b6866794de633f9$export$9c99f879b5701ba2(serviceChat);
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    ...(0, $cteoa.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {}
                }
            }));
            setMessages(conversationId, messages);
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE
            });
            onSuccess?.();
        } catch (e) {
            const normalizedError = e instanceof Error ? e : new Error(String(e));
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
                error: normalizedError
            });
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).WARM_CONVERSATION_CACHE,
    actionErrorHandler: ()=>{
        // Suppress all default error handling for cache warming
        return;
    }
});
/**
 * Imperative warm-path messages prefetch
 */ const $0b6866794de633f9$var$prefetchConversationMessages = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).prefetchConversationMessages, ({ conversationId: conversationId, skipNextFetch: skipNextFetch = false, onStart: onStart, onSuccess: onSuccess, onError: onError })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, showFlag: showFlag, capabilities: capabilities })=>{
        const conversation = getState().conversations[conversationId];
        // Bail without emitting if the conversation isn't selectable, is
        // in flight, or is already loaded
        if ((0, $cteoa.isEmptyConversation)(conversationId) || !conversation || conversation.status !== (0, $bPHr8.CHAT_STORE_STATUS).idle || conversation.messages.length > 0) return;
        onStart?.();
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).PREFETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        dispatch($0b6866794de633f9$var$resetConversationForLoading({
            conversationId: conversationId,
            traces: [],
            sourceAgentId: conversation.sourceAgentId ?? ''
        }));
        try {
            const serviceChat = await assistanceService.getChat(conversationId, capabilities);
            const status = getState().conversations[conversationId]?.status;
            if (status !== (0, $bPHr8.CHAT_STORE_STATUS).loadingChat) // Something else (e.g. a user-initiated send or an explicit
            // `fetchConversation`) raced ahead; surrender the response.
            return;
            const messages = $0b6866794de633f9$export$31bb5ed5e2cc3184({
                latestMessages: serviceChat,
                conversationId: conversationId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                shouldPreprocessDetails: (0, $cteoa.shouldPreprocessDetailsForConversation)(getState(), conversationId)
            });
            const fetchedAgentVersion = $0b6866794de633f9$export$9c99f879b5701ba2(serviceChat);
            // Mirror fetchConversation's reconnect check.
            const lastMessage = serviceChat.at(-1);
            const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
            const shouldReconnect = (0, $ljUdP.isInProgressStreamResponse)(lastMessage);
            if (shouldReconnect) {
                const messageId = lastMessage.message.message.id;
                const updatedMessages = (0, $cteoa.clearStoreAssistantMessageContent)(messages, messageId);
                dispatch($0b6866794de633f9$var$setConversationData({
                    conversationId: conversationId,
                    data: {
                        ...(0, $cteoa.clearStatus)({
                            lastAgentMessageStatus: 'SUCCESSFUL'
                        }),
                        sourceAgentId: (0, $cteoa.getSourceAgentId)(messages, (0, $cteoa.getConversation)(getState(), conversationId)),
                        ...fetchedAgentVersion ? {
                            agentVersion: fetchedAgentVersion
                        } : {}
                    }
                }));
                setMessages(conversationId, updatedMessages);
                dispatch($0b6866794de633f9$var$restoreTaskModeForConversation({
                    conversationId: conversationId,
                    messages: messages
                }));
                dispatch($0b6866794de633f9$var$reconnectToInProgressStream({
                    conversationId: conversationId,
                    messageId: messageId,
                    isDeepResearch: isDeepResearch
                }));
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).PREFETCH_CHAT
                });
                onSuccess?.();
                return;
            }
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: {
                    ...(0, $cteoa.clearStatus)({
                        lastAgentMessageStatus: 'SUCCESSFUL'
                    }),
                    sourceAgentId: (0, $cteoa.getSourceAgentId)(messages, (0, $cteoa.getConversation)(getState(), conversationId)),
                    ...fetchedAgentVersion ? {
                        agentVersion: fetchedAgentVersion
                    } : {},
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            }));
            setMessages(conversationId, messages);
            dispatch($0b6866794de633f9$var$restoreTaskModeForConversation({
                conversationId: conversationId,
                messages: messages
            }));
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).PREFETCH_CHAT
            });
            onSuccess?.();
        } catch (error) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).PREFETCH_CHAT,
                error: normalizedError
            });
            if ($0b6866794de633f9$var$isForbiddenConversationError(error) && (0, $dh538.fg)('rovo_chat_improved_conversation_403_handling')) {
                $0b6866794de633f9$var$handleForbiddenConversation({
                    conversationId: conversationId,
                    dispatch: dispatch,
                    sendAnalyticsEvent: sendAnalyticsEvent,
                    showFlag: showFlag
                });
                onError?.(normalizedError);
                return;
            }
            // Roll back warm loading state; do not set `skipNextFetch` on failure.
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: (0, $cteoa.clearStatus)({})
            }));
            onError?.(normalizedError);
        }
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).PREFETCH_CHAT,
    actionErrorHandler: ()=>{
        // Errors are surfaced via `onError`; keep the silent warm path silent.
        return;
    }
});
/**
 * Seeds a conversation into the store without going through createSafeAction.
 *
 * This is used by the template-smartCreate flow where createConversationChannel
 * has already created a real backend conversation. We need to:
 *   1. Register it in state.conversations (so setSelectedConversation can find it)
 *   2. Set it as the active conversation
 *
 * Unlike createConversationOptimistically, this does NOT use createSafeAction,
 * so it works even when ChatStoreContainer is not mounted (e.g. template gallery page).
 */ const $0b6866794de633f9$var$seedConversation = ({ conversationId: conversationId, skipNextFetch: skipNextFetch })=>({ getState: getState, setState: setState })=>{
        const time = new Date().toISOString();
        // Register in conversations map
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    id: conversationId,
                    name: (0, $99vXA.generateConversationName)(),
                    status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                    timeCreated: time,
                    lastMessageTimestamp: time,
                    traces: [],
                    messages: [],
                    lastMessageType: [],
                    ...skipNextFetch ? {
                        skipNextFetch: true
                    } : {}
                }
            },
            // Also set as active conversation
            currentConversationId: conversationId
        });
    };
const $0b6866794de633f9$var$stopTask = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).stopTask, ({ conversationId: conversationId })=>({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, unifiedTasksActions: unifiedTasksActions })=>{
        if (!(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
        const conversation = getState().conversations[conversationId];
        if (conversation?.storeAbortController) {
            dispatch($0b6866794de633f9$var$abortRequests({
                conversationId: conversationId,
                taskModeEnabled: true
            }));
            return;
        }
        if (!unifiedTasksActions) return;
        const task = unifiedTasksActions.getActiveTaskForConversation(conversationId);
        if (!task?.taskId || (0, $bPHr8.isTerminalTaskState)(task.progressState)) return;
        unifiedTasksActions.setTaskProgressState({
            taskId: task.taskId,
            progressState: 'Cancelled',
            updatedAt: new Date().toISOString()
        });
        assistanceService.cancelTask(task.taskId).catch((err)=>{
            (0, $1yaYZ.logException)({
                name: 'rovoCancelTaskFromStopTask',
                exception: err,
                tags: {
                    taskId: task.taskId
                }
            });
        });
    });
const $0b6866794de633f9$var$clearTargetTaskMessageId = ({ conversationId: conversationId })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                targetTaskMessageId: null
            }
        }));
    };
/**
 * Checks the selected conversation's unified task after conversations are loaded.
 * If the active task is not in a terminal state (Completed/Cancelled/Failed),
 * restores the chat mode to 'task' so the user resumes in task mode.
 */ const $0b6866794de633f9$var$restoreTaskModeIfNeeded = ()=>({ getState: getState }, { setReasoningMode: setReasoningMode, unifiedTasksActions: unifiedTasksActions })=>{
        if (!unifiedTasksActions || !(0, $dh538.fg)('rovo_chat_enable_tasks')) return;
        const { currentConversationId: currentConversationId } = getState();
        const task = unifiedTasksActions.getActiveTaskForConversation(currentConversationId);
        if (task && !(0, $bPHr8.isTerminalTaskState)(task.progressState)) setReasoningMode(currentConversationId, 'task');
    };
const $0b6866794de633f9$var$actions = {
    abortRequests: $0b6866794de633f9$var$abortRequests,
    addAgentMessage: $0b6866794de633f9$var$addAgentMessage,
    addErrorMessage: $0b6866794de633f9$var$addErrorMessage,
    answerNow: $0b6866794de633f9$var$answerNow,
    bulkResolveConversationActions: $0b6866794de633f9$var$bulkResolveConversationActions,
    bulkResolveConversationUIActions: $0b6866794de633f9$var$bulkResolveConversationUIActions,
    clearFollowUpMessages: $0b6866794de633f9$var$clearFollowUpMessages,
    stopTask: $0b6866794de633f9$var$stopTask,
    clearTargetTaskMessageId: $0b6866794de633f9$var$clearTargetTaskMessageId,
    createConversationOptimistically: $0b6866794de633f9$var$createConversationOptimistically,
    createSeededConversation: $0b6866794de633f9$var$createSeededConversation,
    deleteConversation: $0b6866794de633f9$var$deleteConversation,
    getChat: $0b6866794de633f9$var$fetchConversation,
    handleChatOpenPubsubAction: $0b6866794de633f9$var$handleChatOpenPubsubAction,
    hydrateConversationWithExternalParams: $0b6866794de633f9$var$hydrateConversationWithExternalParams,
    fetchConversationChannelsData: $0b6866794de633f9$var$fetchConversationChannelsData,
    loadMoreConversationChannelsData: $0b6866794de633f9$var$loadMoreConversationChannelsData,
    setConversationListMounted: $0b6866794de633f9$var$setConversationListMounted,
    setConversationData: $0b6866794de633f9$var$setConversationData,
    removeMessage: $0b6866794de633f9$var$removeMessage,
    truncateFromLastHumanMessage: $0b6866794de633f9$var$truncateFromLastHumanMessage,
    resolveConversationAction: $0b6866794de633f9$var$resolveConversationAction,
    sendMessage: $0b6866794de633f9$var$sendMessage,
    sendMessageConfirmedTools: $0b6866794de633f9$var$sendMessageConfirmedTools,
    setSelectedConversation: $0b6866794de633f9$var$setSelectedConversation,
    updateConversation: $0b6866794de633f9$var$updateConversation,
    removeConversationFromStore: $0b6866794de633f9$var$removeConversationFromStore,
    reconnectToInProgressStream: $0b6866794de633f9$var$reconnectToInProgressStream,
    restoreTaskModeIfNeeded: $0b6866794de633f9$var$restoreTaskModeIfNeeded,
    warmConversationCache: $0b6866794de633f9$var$warmConversationCache,
    prefetchConversationMessages: $0b6866794de633f9$var$prefetchConversationMessages,
    seedConversation: $0b6866794de633f9$var$seedConversation
};
const $0b6866794de633f9$var$chatStore = (0, $2CHXX.createChatStore)($0b6866794de633f9$var$actions);
/**
 * ************************************************************
 * Container
 * ************************************************************
 */ const $0b6866794de633f9$var$storeInit = ()=>async ({ dispatch: dispatch }, { setChatStatus: setChatStatus, skipAutoConversationSelection: skipAutoConversationSelection })=>{
        (0, $1yaYZ.addSentryBreadcrumb)('ChatStoreContainer: storeInit');
        setChatStatus('launching');
        // Init conversation hydrates the chat store with conversation from URL or Storage
        // and fetches conversations list (however, fetching conversations list is performed "in the background")
        // conversations list is fetched to be later on displayed in the sidebar/conversation list to remove/minimize
        // visual delay when user opens the side-navigation; or in full-screen mode to fetch conversations as early as possible;
        const initConversation = async ()=>{
            dispatch($0b6866794de633f9$var$hydrateConversationWithExternalParams({
                autoSelectConversation: !skipAutoConversationSelection
            }));
            (0, $7UNrw.interactionMetrics).initializeChannels.start();
            await dispatch($0b6866794de633f9$var$fetchConversationChannelsData({
                isInitialLoad: true
            }));
            (0, $7UNrw.interactionMetrics).initializeChannels.stop();
        };
        initConversation();
        (0, $1yaYZ.addSentryBreadcrumb)('ChatStoreContainer: storeInit completed');
    };
const $0b6866794de633f9$var$storeInitOnUpdate = ()=>{
    return ()=>{};
};
const $0b6866794de633f9$var$chatStoreContainerOptions = {
    onInit: $0b6866794de633f9$var$storeInit,
    onUpdate: $0b6866794de633f9$var$storeInitOnUpdate
};
const $0b6866794de633f9$export$9b7b433b0520b82b = (0, $FOT9i.createContainer)($0b6866794de633f9$var$chatStore, $0b6866794de633f9$var$chatStoreContainerOptions);
/**
 * ************************************************************
 * Main Hook
 * ************************************************************
 */ const $0b6866794de633f9$var$publicStateSelector = (state)=>{
    return {
        ...state,
        checkActiveConversationMatchesSource: (id)=>{
            return (0, $cteoa.checkActiveConversationMatchesSource)(state, id);
        }
    };
};
const $0b6866794de633f9$export$e5fca4e502afbbf1 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.currentConversationId
});
const $0b6866794de633f9$export$69f8a6521b059b65 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.conversations[state.currentConversationId]
});
const $0b6866794de633f9$export$409e508fe0e24613 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state, { conversationId: conversationId })=>state.conversations[conversationId]
});
const $0b6866794de633f9$export$32ab7ff538e75ef1 = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.conversations
});
const $0b6866794de633f9$export$ec4a3a5c0e5ad91e = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.isConversationsInitialized
});
const $0b6866794de633f9$export$c4d016c466f1b6da = (0, $9zUhf.createStateHook)($0b6866794de633f9$var$chatStore, {
    selector: (state)=>state.conversationPagination
});
const $0b6866794de633f9$export$5ca9bbfceeb3b458 = (0, $9zUhf.createHook)($0b6866794de633f9$var$chatStore, {
    selector: $0b6866794de633f9$var$publicStateSelector
});
const $0b6866794de633f9$export$b8d7540a5f22fede = (0, $9zUhf.createActionsHook)($0b6866794de633f9$var$chatStore);
module.exports["processConversationMessages"] = $0b6866794de633f9$export$31bb5ed5e2cc3184;
module.exports["ChatStoreContainer"] = $0b6866794de633f9$export$9b7b433b0520b82b;
module.exports["useCurrentConversationId"] = $0b6866794de633f9$export$e5fca4e502afbbf1;
module.exports["useCurrentConversation"] = $0b6866794de633f9$export$69f8a6521b059b65;
module.exports["useConversationById"] = $0b6866794de633f9$export$409e508fe0e24613;
module.exports["useChatStore"] = $0b6866794de633f9$export$5ca9bbfceeb3b458;
module.exports["useChatStoreActions"] = $0b6866794de633f9$export$b8d7540a5f22fede;

});

parcelRegister("G375e", function(module, exports) {

var $cBi7Q = parcelRequire("cBi7Q");

const $0b74afae0018d5cd$export$e5a3af287978673c = (siteId)=>siteId ? `${0, $cBi7Q.LS_CHAT_LOAD_PREFERENCE_KEY}_${siteId}` : (0, $cBi7Q.LS_CHAT_LOAD_PREFERENCE_KEY);
module.exports["getChatLoadPreferenceKey"] = $0b74afae0018d5cd$export$e5a3af287978673c;

});

parcelRegister("1n44H", function(module, exports) {
var $4fea052affee096d$export$33c7ec07de4be904 = /*#__PURE__*/ function(StoreErrorFlagId) {
    StoreErrorFlagId["CONVERSATION_FORBIDDEN"] = "conversationForbidden";
    return StoreErrorFlagId;
}({});
module.exports["StoreErrorFlagId"] = $4fea052affee096d$export$33c7ec07de4be904;

});

parcelRegister("7UNrw", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");

const $059dc312e4dfb8d0$export$86db56030b57ba34 = {
    initializeChannels: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.initialize-channels'
    }),
    timeToRenderMessageContent: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.time-to-render-message-content'
    }),
    timeToRenderFinalResponse: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.time-to-render-final-response'
    }),
    sendConfirmedToolsTimeToFinishStream: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-finish-stream'
    }),
    sendConfirmedToolsTimeToFirstAnswerPart: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-first-answer-part'
    }),
    messageCompositionTime: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.message-composition-time'
    })
};
module.exports["interactionMetrics"] = $059dc312e4dfb8d0$export$86db56030b57ba34;

});

parcelRegister("jJK7o", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");

/**
 * Tasks SSE Connection Manager
 *
 * A plain TS module (no React, no store) that manages a single shared SSE connection
 * to the Tasks stream endpoint (`GET /rovo/v1/tasks/stream`).
 *
 * Key design properties:
 * - **Single connection**: only one SSE connection is open at a time, regardless of
 *   how many consumers are subscribed.
 * - **Reference-counted**: connection opens when the first subscriber arrives,
 *   closes when the last subscriber leaves.
 * - **Tab-visibility aware**: connection is dropped when the tab becomes hidden and
 *   re-established when the tab becomes visible again. This is fully managed here,
 *   not by any React component.
 * - **Decoupled from React lifecycle**: module-level state survives component
 *   mount/unmount cycles.
 * - **External trigger support**: can subscribe
 *  by providing `getService` explicitly — no component mounting required.
 */ 
var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");


var $1yaYZ = parcelRequire("1yaYZ");


var $ljUdP = parcelRequire("ljUdP");

// ─── Module-level state (singleton) ──────────────────────────────────────────
/** Active SSE fetch abort controller. Null when disconnected. */ let $2c48c7577059a1a6$var$abortController = null;
/** The AssistanceService instance used for the current (or next) connection. */ let $2c48c7577059a1a6$var$serviceRef = null;
/** All active subscribers. Connection is open iff this Set is non-empty. */ const $2c48c7577059a1a6$var$subscribers = new Set();
/** Cleanup function for the visibilitychange listener. Null when unbound. */ let $2c48c7577059a1a6$var$visibilityUnbind = null;
// ─── Internal helpers ─────────────────────────────────────────────────────────
/**
 * Opens the SSE connection using the stored `serviceRef`.
 * Fans out each incoming event to all current subscribers.
 * Safe to call if a connection is already open (no-op guard via abortController).
 */ async function $2c48c7577059a1a6$var$openConnection() {
    if (!$2c48c7577059a1a6$var$serviceRef) return;
    // Prevent duplicate connections
    if ($2c48c7577059a1a6$var$abortController) return;
    $2c48c7577059a1a6$var$abortController = new AbortController();
    const localAbort = $2c48c7577059a1a6$var$abortController;
    try {
        const { generator: generator } = await $2c48c7577059a1a6$var$serviceRef.getTasksStream(localAbort);
        for await (const message of generator){
            // Bail out if connection was closed while we were iterating
            if (localAbort.signal.aborted) break;
            // The SSE stream yields ParsedSSEMessage<ApiTaskSSEUpdate> wrappers.
            // The event_type is carried in the SSE `event:` envelope line → message.eventType.
            if (!(0, $ljUdP.isSSEMessage)(message)) continue;
            const event = message.data;
            const eventType = message.eventType ?? 'task_status';
            if (event) $2c48c7577059a1a6$var$subscribers.forEach((listener)=>listener(event, eventType));
        }
    } catch (error) {
        // AbortError is expected on intentional disconnect — swallow it silently
        if (error instanceof DOMException && error.name === 'AbortError') return;
        // Report unexpected errors to Sentry. We deliberately do NOT re-throw:
        // `openConnection` is invoked via `void openConnection()` at every call
        // site, so a thrown error would surface as an unhandled promise rejection
        // — which can crash strict hosts and would otherwise tear down the chat
        // session for what is only a side-channel failure.
        (0, $1yaYZ.logException)({
            name: 'rovoTasksSSEConnection',
            exception: error
        });
    } finally{
        // Ensure controller is cleared once the loop exits for any reason
        if ($2c48c7577059a1a6$var$abortController === localAbort) $2c48c7577059a1a6$var$abortController = null;
    }
}
/**
 * Aborts the current SSE connection.
 * Safe to call when already disconnected.
 */ function $2c48c7577059a1a6$var$closeConnection() {
    if ($2c48c7577059a1a6$var$abortController) {
        $2c48c7577059a1a6$var$abortController.abort();
        $2c48c7577059a1a6$var$abortController = null;
    }
}
/**
 * Binds a `visibilitychange` listener on the document.
 * - Tab hidden  → close connection
 * - Tab visible → re-open connection (reuses stored serviceRef)
 *
 * Binding is done once per subscriber session (first subscriber triggers it).
 */ function $2c48c7577059a1a6$var$bindVisibility() {
    if ($2c48c7577059a1a6$var$visibilityUnbind) // Already bound — nothing to do
    return;
    const doc = (0, $hTKp4.getDocument)();
    if (!doc) return;
    $2c48c7577059a1a6$var$visibilityUnbind = (0, $fFa3V.bind)(doc, {
        type: 'visibilitychange',
        listener: ()=>{
            if (doc.hidden) $2c48c7577059a1a6$var$closeConnection();
            else // Re-open connection when tab becomes visible again
            $2c48c7577059a1a6$var$openConnection();
        }
    });
}
/**
 * Removes the `visibilitychange` listener.
 * Called when the last subscriber unsubscribes.
 */ function $2c48c7577059a1a6$var$unbindVisibility() {
    $2c48c7577059a1a6$var$visibilityUnbind?.();
    $2c48c7577059a1a6$var$visibilityUnbind = null;
}
function $2c48c7577059a1a6$export$285816b4ea71cce1(getService, onEvent) {
    $2c48c7577059a1a6$var$subscribers.add(onEvent);
    if ($2c48c7577059a1a6$var$subscribers.size === 1) {
        // First subscriber — resolve service, open connection, bind visibility
        $2c48c7577059a1a6$var$serviceRef = getService();
        $2c48c7577059a1a6$var$bindVisibility();
        // Only open connection if tab is currently visible
        const doc = (0, $hTKp4.getDocument)();
        if (!doc || !doc.hidden) $2c48c7577059a1a6$var$openConnection();
    }
    return function unsubscribe() {
        $2c48c7577059a1a6$var$subscribers.delete(onEvent);
        if ($2c48c7577059a1a6$var$subscribers.size === 0) {
            // Last subscriber left — tear everything down
            $2c48c7577059a1a6$var$closeConnection();
            $2c48c7577059a1a6$var$unbindVisibility();
            $2c48c7577059a1a6$var$serviceRef = null;
        }
    };
}



var $40OEo = parcelRequire("40OEo");

const $96184017db79a818$var$initialState = {
    tasksByTaskId: new Map(),
    allTasksNextCursor: null,
    hasLoadedAllTasksPage: false,
    activeConversationId: null,
    activeConversationLastAgentMessageId: null,
    activeConversationStatus: null,
    sseSubscriberCount: 0,
    sseConnected: false
};
// ─── Terminal status constants ────────────────────────────────────────────────
const $96184017db79a818$var$TERMINAL_STATUSES = new Set([
    'COMPLETED',
    'FAILED',
    'CANCELLED'
]);
const $96184017db79a818$var$TERMINAL_PROGRESS_STATES = new Set([
    'Completed',
    'Failed',
    'Cancelled'
]);
const $96184017db79a818$var$isTerminalStatus = (status)=>$96184017db79a818$var$TERMINAL_STATUSES.has(status);
const $96184017db79a818$var$isTerminalProgressState = (state)=>$96184017db79a818$var$TERMINAL_PROGRESS_STATES.has(state);
// ─── Status mapping ───────────────────────────────────────────────────────────
// Sourced from the shared `tasks-shared/task-helpers` module.
// ─── Merge helpers ────────────────────────────────────────────────────────────
/**
 * Returns true if `incoming` should overwrite `existing` for the same taskId.
 *
 * Monotonic rules:
 *   1. No existing → always accept incoming.
 *   2. Existing is terminal → only accept a strictly newer terminal update.
 *   3. Otherwise → accept if incoming.updated_at >= existing.updated_at.
 */ function $96184017db79a818$var$shouldOverwrite(existing, incomingUpdatedAt, incomingStatus) {
    if (!existing) return true;
    if ($96184017db79a818$var$isTerminalStatus(existing.rawStatus)) return $96184017db79a818$var$isTerminalStatus(incomingStatus) && incomingUpdatedAt > existing.updatedAt;
    return incomingUpdatedAt >= existing.updatedAt;
}
function $96184017db79a818$export$609ffd14cb121e86(raw) {
    if (!raw) return null;
    try {
        return Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                startedAt: parsed.startedAt,
                ...parsed.endedAt ? {
                    endedAt: parsed.endedAt
                } : {}
            };
        });
    } catch  {
        return null;
    }
}
function $96184017db79a818$export$27c41772233f8b90(raw) {
    if (!raw) return undefined;
    try {
        const todos = Object.values(raw).map((value)=>{
            const parsed = JSON.parse(value);
            return {
                id: parsed.id,
                content: parsed.content,
                status: parsed.status,
                priority: parsed.priority,
                active_form: parsed.activeForm ?? parsed.active_form
            };
        });
        return {
            todos: todos
        };
    } catch  {
        return undefined;
    }
}
// ─── Module-level SSE deduplication ──────────────────────────────────────────
/**
 * Reference-equality dedup tracker. Since subscribeToTasksSSE fans the same
 * event object reference to every subscriber, we track the last ingested
 * reference to avoid writing to the store N times for N mounted subscribers.
 */ let $96184017db79a818$var$lastIngestedSSEEvent = null;
const $96184017db79a818$var$store = (0, $1P1Tu.createStore)({
    name: 'tasks',
    initialState: $96184017db79a818$var$initialState,
    actions: {
        // ─── SSE Lifecycle ────────────────────────────────────────────────────
        mountSSESubscriber: (getService)=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = sseSubscriberCount + 1;
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 1) {
                    // First subscriber — open SSE connection via existing ref-counted manager.
                    // The module-level subscribeToTasksSSE handles tab-visibility and reconnect.
                    const unsubscribe = (0, $2c48c7577059a1a6$export$285816b4ea71cce1)(getService, (event, eventType)=>{
                        // Deduplicate store ingestion across multiple mounted subscribers
                        if ($96184017db79a818$var$lastIngestedSSEEvent?.event !== event) {
                            (0, $4HDYO.defaultRegistry).getStore($96184017db79a818$var$store).actions.ingestTasksSSEEvent(event, eventType);
                            $96184017db79a818$var$lastIngestedSSEEvent = {
                                event: event,
                                eventType: eventType
                            };
                        }
                    });
                    // Store the unsubscribe fn at module level so unmountSSESubscriber can call it
                    $96184017db79a818$var$sseUnsubscribe = unsubscribe;
                }
            },
        unmountSSESubscriber: ()=>({ getState: getState, setState: setState })=>{
                const { sseSubscriberCount: sseSubscriberCount } = getState();
                const newCount = Math.max(0, sseSubscriberCount - 1);
                setState({
                    sseSubscriberCount: newCount
                });
                if (newCount === 0 && $96184017db79a818$var$sseUnsubscribe) {
                    $96184017db79a818$var$sseUnsubscribe();
                    $96184017db79a818$var$sseUnsubscribe = null;
                    $96184017db79a818$var$lastIngestedSSEEvent = null;
                }
            },
        _setSSEConnected: (connected)=>({ setState: setState })=>{
                setState({
                    sseConnected: connected
                });
            },
        // ─── Active Conversation Context ──────────────────────────────────────
        setActiveConversationContext: ({ conversationId: conversationId, lastAgentMessageId: lastAgentMessageId, status: status })=>({ setState: setState })=>{
                setState({
                    activeConversationId: conversationId,
                    activeConversationLastAgentMessageId: lastAgentMessageId,
                    activeConversationStatus: status
                });
            },
        // ─── SSE Ingestion ────────────────────────────────────────────────────
        ingestTasksSSEEvent: (event, eventType)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                if (eventType === 'connected') {
                    setState({
                        sseConnected: true
                    });
                    return;
                }
                if (eventType === 'task_snapshot') {
                    const snapshot = event;
                    const tasks = snapshot.tasks ?? [];
                    if (tasks.length === 0) return;
                    const next = new Map(state.tasksByTaskId);
                    let changed = false;
                    for (const incoming of tasks){
                        const existing = next.get(incoming.task_id);
                        if (!$96184017db79a818$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                        next.set(incoming.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, incoming));
                        changed = true;
                    }
                    if (changed) setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_status') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A: reject if the owning conversation is actively streaming
                    // (CHAT_STORE_STATUS.idle = 0; non-idle means streaming/loading)
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B: reject stale SSE reconnect replays by currentMessageId mismatch
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    const progressState = (0, $40OEo.mapApiTaskStatusToProgressState)(update.status);
                    // Skip if already applied (same state from stream)
                    if (existing && existing.progressState === progressState && existing.currentMessageId === (update.current_message_id ?? null) && existing.updatedAt >= update.updated_at) return;
                    if (!$96184017db79a818$var$shouldOverwrite(existing, update.updated_at, update.status)) return;
                    const next = new Map(state.tasksByTaskId);
                    if (!existing) // Create-if-missing: task arrived via SSE before stream
                    next.set(update.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(undefined, update));
                    else next.set(update.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, update));
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                if (eventType === 'task_todo_update') {
                    const update = event;
                    const conversationId = update.conversation_id ?? null;
                    // Guard A (parity with task_status): reject if the owning conversation
                    // is actively streaming. The in-flight stream will deliver a fresher
                    // todo snapshot momentarily.
                    if (conversationId && conversationId === state.activeConversationId && state.activeConversationStatus !== null && state.activeConversationStatus !== 0 // CHAT_STORE_STATUS.idle
                    ) return;
                    // Guard B (parity with task_status): reject stale SSE reconnect
                    // replays by currentMessageId mismatch.
                    if (conversationId && conversationId === state.activeConversationId && update.current_message_id && state.activeConversationLastAgentMessageId && update.current_message_id !== state.activeConversationLastAgentMessageId) return;
                    const existing = state.tasksByTaskId.get(update.task_id);
                    if (!existing || $96184017db79a818$var$isTerminalProgressState(existing.progressState)) return;
                    const todoSnapshot = $96184017db79a818$export$27c41772233f8b90(update.todo_list ?? undefined);
                    if (!todoSnapshot) return;
                    const next = new Map(state.tasksByTaskId);
                    next.set(update.task_id, {
                        ...existing,
                        todoSnapshot: todoSnapshot
                    });
                    setState({
                        tasksByTaskId: next
                    });
                }
            },
        // ─── Task Mutations from Stream ───────────────────────────────────────
        createTaskFromStream: ({ taskId: taskId, conversationId: conversationId, title: title, updatedAt: updatedAt, messageId: messageId, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                // Idempotency guard — skip if task already exists
                if (tasksByTaskId.has(taskId)) return;
                const newTask = {
                    taskId: taskId,
                    conversationId: conversationId,
                    agentId: null,
                    triggerType: null,
                    progressState: 'Draft',
                    rawStatus: 'DRAFT',
                    title: title,
                    plan: null,
                    resultSummary: null,
                    errorMessage: null,
                    todoSnapshot: undefined,
                    currentStep: null,
                    executionSegments: executionSegments ?? null,
                    messageId: messageId ?? null,
                    completionMessageId: null,
                    currentMessageId: currentMessageId ?? null,
                    seekingCompletedAck: false,
                    createdAt: createdAt ?? null,
                    startedAt: startedAt ?? null,
                    // Prefer the supplied updatedAt, then fall back to createdAt so the
                    // initial monotonic comparison in `shouldOverwrite` doesn't reject a
                    // real BE update that arrives with an older timestamp than `Date.now()`.
                    updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                    completedAt: completedAt ?? null
                };
                const next = new Map(tasksByTaskId);
                next.set(taskId, newTask);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskProgressState: ({ taskId: taskId, conversationId: conversationId, progressState: progressState, title: title, seekingCompletedAck: seekingCompletedAck, messageId: messageId, completionMessageId: completionMessageId, updatedAt: updatedAt, currentMessageId: currentMessageId, createdAt: createdAt, startedAt: startedAt, completedAt: completedAt, executionSegments: executionSegments, currentStep: currentStep, resultSummary: resultSummary, errorMessage: errorMessage })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $96184017db79a818$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                // Auto-create when there is no active task yet for the conversation.
                // Allows the chat-store to drive optimistic state changes
                // (e.g. AwaitingPlanConfirmation) before
                // the BE has issued a real task_id.
                if (!resolvedTaskId) {
                    if (!conversationId) return;
                    const localTaskId = `task-${Date.now()}`;
                    const newTask = {
                        taskId: localTaskId,
                        conversationId: conversationId,
                        agentId: null,
                        triggerType: null,
                        progressState: progressState,
                        rawStatus: $96184017db79a818$var$progressStateToApiStatus(progressState),
                        title: title ?? '',
                        plan: null,
                        resultSummary: resultSummary ?? null,
                        errorMessage: errorMessage ?? null,
                        todoSnapshot: undefined,
                        currentStep: currentStep ?? null,
                        executionSegments: executionSegments ?? null,
                        messageId: messageId ?? null,
                        completionMessageId: completionMessageId ?? null,
                        currentMessageId: currentMessageId ?? null,
                        seekingCompletedAck: seekingCompletedAck ?? false,
                        createdAt: createdAt ?? new Date().toISOString(),
                        startedAt: startedAt ?? null,
                        updatedAt: updatedAt ?? createdAt ?? new Date().toISOString(),
                        completedAt: completedAt ?? null
                    };
                    const next = new Map(tasksByTaskId);
                    next.set(localTaskId, newTask);
                    setState({
                        tasksByTaskId: next
                    });
                    return;
                }
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing) return;
                // Terminal state protection
                if ($96184017db79a818$var$isTerminalProgressState(existing.progressState)) return;
                const merged = {
                    ...existing,
                    progressState: progressState,
                    rawStatus: $96184017db79a818$var$progressStateToApiStatus(progressState),
                    ...title !== undefined ? {
                        title: title
                    } : {},
                    ...seekingCompletedAck !== undefined ? {
                        seekingCompletedAck: seekingCompletedAck
                    } : {},
                    ...messageId !== undefined ? {
                        messageId: messageId
                    } : {},
                    ...completionMessageId !== undefined ? {
                        completionMessageId: completionMessageId
                    } : {},
                    ...updatedAt !== undefined ? {
                        updatedAt: updatedAt
                    } : {},
                    ...currentMessageId !== undefined ? {
                        currentMessageId: currentMessageId
                    } : {},
                    ...createdAt !== undefined ? {
                        createdAt: createdAt
                    } : {},
                    ...startedAt !== undefined ? {
                        startedAt: startedAt
                    } : {},
                    ...completedAt !== undefined ? {
                        completedAt: completedAt
                    } : {},
                    ...executionSegments !== undefined ? {
                        executionSegments: (0, $40OEo.mergeExecutionSegments)(existing.executionSegments, executionSegments)
                    } : {},
                    // `null` is meaningful — explicit clear; `undefined` leaves field unchanged.
                    ...currentStep !== undefined ? {
                        currentStep: currentStep
                    } : {},
                    ...resultSummary !== undefined ? {
                        resultSummary: resultSummary
                    } : {},
                    ...errorMessage !== undefined ? {
                        errorMessage: errorMessage
                    } : {}
                };
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, merged);
                setState({
                    tasksByTaskId: next
                });
            },
        setTaskTodoSnapshot: ({ taskId: taskId, conversationId: conversationId, todoSnapshot: todoSnapshot })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const resolvedTaskId = taskId ?? (conversationId ? $96184017db79a818$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) : undefined);
                if (!resolvedTaskId) return;
                const existing = tasksByTaskId.get(resolvedTaskId);
                if (!existing || $96184017db79a818$var$isTerminalProgressState(existing.progressState)) return;
                const next = new Map(tasksByTaskId);
                next.set(resolvedTaskId, {
                    ...existing,
                    todoSnapshot: todoSnapshot
                });
                setState({
                    tasksByTaskId: next
                });
            },
        ackTaskCompleted: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    seekingCompletedAck: false
                });
                setState({
                    tasksByTaskId: next
                });
            },
        clearTask: ({ taskId: taskId })=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── REST Merge ───────────────────────────────────────────────────────
        mergeConversationChannelTasks: (remoteTasks)=>({ getState: getState, setState: setState })=>{
                if (!remoteTasks || remoteTasks.length === 0) return;
                // Sort ascending by created_at (oldest first, newest last = active)
                const sorted = [
                    ...remoteTasks
                ].sort((a, b)=>new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const remote of sorted){
                    const existing = next.get(remote.task_id);
                    const merged = $96184017db79a818$var$mergeChannelTaskIntoUnified(existing, remote);
                    next.set(remote.task_id, merged);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        mergeAllTasksSnapshot: (tasks)=>({ getState: getState, setState: setState })=>{
                if (!tasks) return;
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                // 1. Upsert all tasks from the snapshot (REST is authoritative for tasks it returns).
                const snapshotIds = new Set();
                for (const incoming of tasks){
                    snapshotIds.add(incoming.task_id);
                    const existing = next.get(incoming.task_id);
                    if (!$96184017db79a818$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                    next.set(incoming.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, incoming));
                    changed = true;
                }
                // 2. Reconcile: remove any task absent from the REST snapshot **only** when
                //    it's already in a terminal state. Non-terminal (in-flight) tasks may
                //    legitimately be present locally but not yet visible in REST (race), so
                //    we preserve them and rely on SSE to deliver their final state.
                for (const [taskId, task] of tasksByTaskId){
                    if (snapshotIds.has(taskId)) continue;
                    if ($96184017db79a818$var$isTerminalProgressState(task.progressState)) {
                        next.delete(taskId);
                        changed = true;
                    }
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        mergeAllTasksPage: (tasks, nextCursor)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const incoming of tasks){
                    const existing = next.get(incoming.task_id);
                    if (!$96184017db79a818$var$shouldOverwrite(existing, incoming.updated_at, incoming.status)) continue;
                    next.set(incoming.task_id, $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, incoming));
                    changed = true;
                }
                if (changed || nextCursor !== undefined) setState({
                    ...changed ? {
                        tasksByTaskId: next
                    } : {},
                    ...nextCursor !== undefined ? {
                        allTasksNextCursor: nextCursor,
                        hasLoadedAllTasksPage: true
                    } : {}
                });
            },
        // ─── Optimistic mutations from UI (tasks-list, etc.) ─────────────────
        /**
     * Removes a single task by taskId. Used for optimistic delete from
     * the tasks-list screen before the API call resolves.
     */ removeTaskById: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                if (!tasksByTaskId.has(taskId)) return;
                const next = new Map(tasksByTaskId);
                next.delete(taskId);
                setState({
                    tasksByTaskId: next
                });
            },
        /**
     * Optimistically marks a task as Cancelled (terminal state). Used by the
     * tasks-list stop action before the API call resolves.
     */ markTaskCancelled: (taskId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing) return;
                const now = new Date().toISOString();
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    progressState: 'Cancelled',
                    rawStatus: 'CANCELLED',
                    updatedAt: now,
                    completedAt: existing.completedAt ?? now
                });
                setState({
                    tasksByTaskId: next
                });
            },
        /**
     * Optimistically updates a task's title. Used by the tasks-list rename
     * action before the API call resolves.
     */ setTaskTitle: (taskId, title)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const existing = tasksByTaskId.get(taskId);
                if (!existing || existing.title === title) return;
                const next = new Map(tasksByTaskId);
                next.set(taskId, {
                    ...existing,
                    title: title,
                    updatedAt: new Date().toISOString()
                });
                setState({
                    tasksByTaskId: next
                });
            },
        // ─── Conversation cleanup ─────────────────────────────────────────────
        removeTasksForConversation: (conversationId)=>({ getState: getState, setState: setState })=>{
                const { tasksByTaskId: tasksByTaskId } = getState();
                const next = new Map(tasksByTaskId);
                let changed = false;
                for (const [taskId, task] of tasksByTaskId)if (task.conversationId === conversationId) {
                    next.delete(taskId);
                    changed = true;
                }
                if (changed) setState({
                    tasksByTaskId: next
                });
            },
        // Read-only accessor — used by chat-store actions that need the latest
        // active task synchronously without going through React.
        getActiveTaskForConversation: (conversationId)=>({ getState: getState })=>{
                return $96184017db79a818$var$findActiveTaskForConversation(getState().tasksByTaskId, conversationId);
            },
        // Read-only accessor — single-task lookup by id. Same imperative shape as
        // `getActiveTaskForConversation` so chat-store callers don't need any
        // React state plumbing.
        getTaskById: (taskId)=>({ getState: getState })=>{
                return getState().tasksByTaskId.get(taskId);
            }
    }
});
// ─── Module-level SSE unsubscribe reference ───────────────────────────────────
// Stored outside the store state (not serializable, not reactive).
let $96184017db79a818$var$sseUnsubscribe = null;
/**
 * Finds the active task for a conversation.
 * Prefers the most recent **non-terminal** task; falls back to the most recent
 * task overall if all tasks for the conversation are in terminal state.
 *
 * "Active" semantics: a conversation has at most one in-flight task at any
 * point in time. Older tasks (terminal) remain associated with the conversation
 * for history but should not be treated as the current active task.
 */ /**
 * Internal selector helper. Use the `useActiveTaskForConversation` /
 * `useActiveTasksForConversations` hooks (React) or the
 * `getActiveTaskForConversation` action (non-React) instead.
 */ function $96184017db79a818$var$findActiveTaskForConversation(tasksByTaskId, conversationId) {
    let latestNonTerminal;
    let latestAny;
    for (const task of tasksByTaskId.values()){
        if (task.conversationId !== conversationId) continue;
        if (!latestAny || (task.createdAt ?? '') > (latestAny.createdAt ?? '')) latestAny = task;
        if (!$96184017db79a818$var$isTerminalProgressState(task.progressState)) {
            if (!latestNonTerminal || (task.createdAt ?? '') > (latestNonTerminal.createdAt ?? '')) latestNonTerminal = task;
        }
    }
    return latestNonTerminal ?? latestAny;
}
function $96184017db79a818$var$findActiveTaskIdForConversation(tasksByTaskId, conversationId) {
    return $96184017db79a818$var$findActiveTaskForConversation(tasksByTaskId, conversationId)?.taskId;
}
// ─── Internal merge helpers ───────────────────────────────────────────────────
function $96184017db79a818$var$progressStateToApiStatus(state) {
    const map = {
        Draft: 'DRAFT',
        Queued: 'QUEUED',
        Running: 'RUNNING',
        AwaitingDisambiguation: 'AWAITING_DISAMBIGUATION',
        AwaitingPlanConfirmation: 'AWAITING_PLAN_CONFIRMATION',
        AwaitingActionConfirmation: 'AWAITING_ACTION_CONFIRMATION',
        Completed: 'COMPLETED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED'
    };
    return map[state];
}
function $96184017db79a818$var$mergeSSEUpdateIntoTask(existing, incoming) {
    const progressState = (0, $40OEo.mapApiTaskStatusToProgressState)(incoming.status);
    // `current_step` only exists on the SSE shape; REST snapshots don't carry it.
    const incomingCurrentStep = 'current_step' in incoming ? incoming.current_step ?? null : existing?.currentStep ?? null;
    // `agent_id` and `trigger_type` are on the REST shape but not on every SSE update.
    const incomingAgentId = 'agent_id' in incoming ? incoming.agent_id : existing?.agentId ?? null;
    const incomingTriggerType = 'trigger_type' in incoming ? incoming.trigger_type : existing?.triggerType ?? null;
    const incomingPlan = 'plan' in incoming ? incoming.plan ?? null : existing?.plan ?? null;
    const incomingCompletedAt = 'completed_at' in incoming ? incoming.completed_at ?? existing?.completedAt ?? null : existing?.completedAt ?? null;
    return {
        taskId: incoming.task_id,
        conversationId: incoming.conversation_id ?? existing?.conversationId ?? null,
        agentId: incomingAgentId,
        triggerType: incomingTriggerType,
        progressState: progressState,
        rawStatus: incoming.status,
        title: incoming.title,
        plan: incomingPlan,
        resultSummary: incoming.result_summary,
        errorMessage: incoming.error_message,
        todoSnapshot: existing?.todoSnapshot,
        currentStep: incomingCurrentStep,
        executionSegments: $96184017db79a818$export$609ffd14cb121e86(incoming.execution_segments ?? undefined),
        messageId: incoming.message_id ?? existing?.messageId ?? null,
        completionMessageId: incoming.completion_message_id ?? existing?.completionMessageId ?? null,
        currentMessageId: incoming.current_message_id ?? existing?.currentMessageId ?? null,
        // Local-only UI state: preserve from existing
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: incoming.created_at ?? existing?.createdAt ?? null,
        startedAt: incoming.started_at ?? existing?.startedAt ?? null,
        updatedAt: incoming.updated_at,
        completedAt: incomingCompletedAt
    };
}
function $96184017db79a818$var$mergeChannelTaskIntoUnified(existing, remote) {
    const progressState = (0, $40OEo.mapApiTaskStatusToProgressState)(remote.status);
    const remoteExecutionSegments = $96184017db79a818$export$609ffd14cb121e86(remote.execution_segments ?? undefined);
    const remoteTodoSnapshot = $96184017db79a818$export$27c41772233f8b90(remote.todo_list ?? undefined);
    // Local wins for progressState and todoSnapshot when local is strictly newer
    const localIsNewer = existing?.updatedAt && existing.updatedAt > remote.updated_at;
    return {
        taskId: remote.task_id,
        conversationId: remote.conversation_id,
        agentId: remote.agent_id,
        triggerType: remote.trigger_type,
        progressState: localIsNewer ? existing?.progressState ?? progressState : progressState,
        rawStatus: localIsNewer ? existing?.rawStatus ?? remote.status : remote.status,
        title: remote.title,
        plan: remote.plan,
        resultSummary: remote.result_summary,
        errorMessage: remote.error_message,
        todoSnapshot: localIsNewer ? existing?.todoSnapshot : remoteTodoSnapshot ?? existing?.todoSnapshot,
        currentStep: existing?.currentStep ?? null,
        executionSegments: (0, $40OEo.mergeExecutionSegments)(existing?.executionSegments, remoteExecutionSegments),
        messageId: remote.message_id,
        completionMessageId: remote.completion_message_id,
        currentMessageId: remote.current_message_id,
        // Local-only: seekingCompletedAck NEVER overwritten by REST
        seekingCompletedAck: existing?.seekingCompletedAck ?? false,
        createdAt: remote.created_at,
        startedAt: remote.started_at,
        updatedAt: remote.updated_at,
        completedAt: remote.completed_at
    };
}
const $96184017db79a818$export$c2ad39067c031726 = (0, $9zUhf.createHook)($96184017db79a818$var$store);
const $96184017db79a818$export$e398e9c82ae1ea3e = (0, $9zUhf.createActionsHook)($96184017db79a818$var$store);
const $96184017db79a818$export$4a89b1af24c66aec = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state, conversationId)=>{
        if (!conversationId) return undefined;
        return $96184017db79a818$var$findActiveTaskForConversation(state.tasksByTaskId, conversationId);
    }
});
const $96184017db79a818$export$37ef8d89dd7c4479 = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state)=>Array.from(state.tasksByTaskId.values())
});
const $96184017db79a818$export$294781cac1da1fda = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state)=>({
            allTasksNextCursor: state.allTasksNextCursor,
            hasLoadedAllTasksPage: state.hasLoadedAllTasksPage
        })
});
const $96184017db79a818$export$86ae895223d55438 = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state, conversationIds)=>{
        const result = new Map();
        for (const id of conversationIds)result.set(id, $96184017db79a818$var$findActiveTaskForConversation(state.tasksByTaskId, id));
        return result;
    }
});
const $96184017db79a818$export$8adc54d746bc9a7f = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state, taskId)=>state.tasksByTaskId.get(taskId)
});
const $96184017db79a818$export$2a84773e9f93301a = (0, $9zUhf.createHook)($96184017db79a818$var$store, {
    selector: (state)=>state.sseConnected
});
const $96184017db79a818$export$f68962e2c5dae5a0 = (task)=>({
        task_id: task.taskId,
        title: task.title,
        status: task.rawStatus,
        current_step: task.currentStep,
        result_summary: task.resultSummary,
        error_message: task.errorMessage,
        conversation_id: task.conversationId,
        message_id: task.messageId,
        completion_message_id: task.completionMessageId,
        current_message_id: task.currentMessageId,
        created_at: task.createdAt,
        started_at: task.startedAt,
        updated_at: task.updatedAt,
        // Preserve raw shape for execution_segments and todo_list (Record<string,string>).
        // We do not have the raw representation any more after parsing, so leave as null.
        execution_segments: null,
        todo_list: null
    });
module.exports["parseExecutionSegments"] = $96184017db79a818$export$609ffd14cb121e86;
module.exports["useTasksStoreActions"] = $96184017db79a818$export$e398e9c82ae1ea3e;
module.exports["useActiveTaskForConversation"] = $96184017db79a818$export$4a89b1af24c66aec;
module.exports["useAllTasks"] = $96184017db79a818$export$37ef8d89dd7c4479;
module.exports["useAllTasksPaginationState"] = $96184017db79a818$export$294781cac1da1fda;
module.exports["useActiveTasksForConversations"] = $96184017db79a818$export$86ae895223d55438;
module.exports["unifiedTaskToApiSSE"] = $96184017db79a818$export$f68962e2c5dae5a0;

});

parcelRegister("9likX", function(module, exports) {
const $e89354fc9dc00005$export$9f198c0729e6b053 = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled })=>{
    if (deepResearchEnabled) return 'deep_research';
    if (thinkDeeperEnabled || alphaExtendedThinkingMode) return 'think_deeper';
    if (taskModeEnabled) return 'max';
    if (fastModeEnabled) return 'fast';
    return 'auto';
};
const $e89354fc9dc00005$export$3ac8b179c5bae1cb = (metadata)=>metadata?.interaction_mode_executed ?? undefined;
const $e89354fc9dc00005$export$41ee2caec24cebc0 = (message)=>$e89354fc9dc00005$export$3ac8b179c5bae1cb(message?.message_metadata);
const $e89354fc9dc00005$export$c13c17c66364de2d = (streamResponse)=>$e89354fc9dc00005$export$41ee2caec24cebc0(streamResponse?.message?.message);
const $e89354fc9dc00005$export$bab8a3e4fa0b7d89 = (storeAssistant)=>$e89354fc9dc00005$export$c13c17c66364de2d(storeAssistant?.content);
const $e89354fc9dc00005$export$2f438a4a7bbfabc = (interactionModeRequested)=>interactionModeRequested ? {
        interactionModeRequested: interactionModeRequested
    } : {};
const $e89354fc9dc00005$export$420f5414c6aecb85 = (interactionModeExecuted)=>interactionModeExecuted ? {
        interactionModeExecuted: interactionModeExecuted
    } : {};
module.exports["getInteractionModeRequested"] = $e89354fc9dc00005$export$9f198c0729e6b053;
module.exports["getInteractionModeExecutedFromStreamResponse"] = $e89354fc9dc00005$export$c13c17c66364de2d;
module.exports["getInteractionModeExecutedFromStoreAssistant"] = $e89354fc9dc00005$export$bab8a3e4fa0b7d89;
module.exports["interactionModeRequestedAttributes"] = $e89354fc9dc00005$export$2f438a4a7bbfabc;
module.exports["interactionModeExecutedAttributes"] = $e89354fc9dc00005$export$420f5414c6aecb85;

});

parcelRegister("4eSde", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $28y4B = parcelRequire("28y4B");


var $dqGqE = parcelRequire("dqGqE");

const $487e3aa6cdc75eb3$export$24a03a39abc3110e = ()=>{
    const additionalAttributes = {
        isInitialDataReceived: null
    };
    const subExperienceCollect = (0, $28y4B.collectAllWithSubExperienceAttributes)([
        (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
    ], additionalAttributes);
    return (events, experience)=>{
        for (const event of events)if (event.name === (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED) {
            if (event.action === 'taskSuccess') additionalAttributes.isInitialDataReceived = true;
            else if (event.action === 'taskFail') additionalAttributes.isInitialDataReceived = false;
        }
        // If AIFC_INITIAL_DATA_RECEIVED fails, fail AIFC_GENERATE_CONTENT
        (0, $dqGqE.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED, experience, events, additionalAttributes);
        subExperienceCollect(events, experience);
    };
};
module.exports["createAifcExperienceCollect"] = $487e3aa6cdc75eb3$export$24a03a39abc3110e;

});

parcelRegister("cteoa", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $bOrYy = parcelRequire("bOrYy");


var $1oCLl = parcelRequire("1oCLl");


var $deF0K = parcelRequire("deF0K");


var $3vCSA = parcelRequire("3vCSA");


var $4pEXC = parcelRequire("4pEXC");


var $7KWEi = parcelRequire("7KWEi");

/**
 * Rewrites HTML `<details>` / `<summary>` collapsed sections embedded in
 * markdown into the Rovo-native boundary format that the rest of the stream
 * pipeline already understands.
 *
 *   <details><summary>Title</summary>Body</details>  →  ▞Title\nBody▚
 *
 * Downstream, the existing `expand` streamable component (see
 * `getStreamableComponents` in `chat-store/utils.ts`) picks up `▞…▚`, swaps
 * in the `[^expand^]` placeholder, and renders the body out-of-band through
 * `markdownData`.
 *
 * Spec reference: the HTML `<details>` element (rendered as a disclosure
 * widget) and its `<summary>` child, as documented by MDN and supported by
 * common markdown renderers.
 *
 * Known limitations (V1):
 *  - Code-fence aware rewriting is not implemented. A `<details>` block
 *    embedded inside a ``` code fence will still be rewritten. Agents
 *    producing collapsed sections generally don't do this, but if it becomes
 *    a real problem the fence-tracking state machine from
 *    `sanitize-markdown.ts` can be ported here.
 *  - Nested `<details>` are passed through unchanged.
 */ const $534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY = "\u259E";
const $534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY = "\u259A";
const $534f3b959a2e27b2$var$DEFAULT_TITLE = 'Details';
// Complete-tag matchers. Case-insensitive, allow attributes on open tags.
const $534f3b959a2e27b2$var$DETAILS_OPEN_RE = /^<details(?:\s[^>]*)?>$/i;
const $534f3b959a2e27b2$var$SUMMARY_OPEN_RE = /^<summary(?:\s[^>]*)?>$/i;
const $534f3b959a2e27b2$var$SUMMARY_CLOSE_RE = /^<\/summary\s*>$/i;
const $534f3b959a2e27b2$var$DETAILS_CLOSE_RE = /^<\/details\s*>$/i;
// Fast-path probe: if the text cannot possibly contain a relevant tag, skip
// the scan entirely.
const $534f3b959a2e27b2$var$HAS_RELEVANT_TAG_RE = /<\/?(?:details|summary)\b/i;
/**
 * Shared scan used by both the streaming and one-shot paths.
 *
 * When `allowBuffer` is `true`, a trailing incomplete tag (i.e. a `<` with
 * no subsequent `>`) is stashed on `state.buffer` for the next call instead
 * of being emitted. When `false` (flush / one-shot), the partial text is
 * emitted as literal.
 */ const $534f3b959a2e27b2$var$scan = (input, state, allowBuffer)=>{
    let out = '';
    let i = 0;
    const emitText = (text)=>{
        if (state.mode === 'IN_DETAILS_PRE_SUMMARY') // Silently discard text between `<details>` and `<summary>` (in
        // practice this is whitespace / newlines the agent formats for
        // readability).
        return;
        if (state.mode === 'IN_SUMMARY') {
            // Collapse newlines inside the summary so the downstream
            // `splitHeaderAndContent` (first-newline split) still sees a
            // single-line title.
            out += text.replace(/\r?\n/g, ' ');
            return;
        }
        out += text;
    };
    while(i < input.length){
        const lt = input.indexOf('<', i);
        if (lt === -1) {
            emitText(input.slice(i));
            break;
        }
        if (lt > i) emitText(input.slice(i, lt));
        const gt = input.indexOf('>', lt);
        if (gt === -1) {
            if (allowBuffer) {
                state.buffer = input.slice(lt);
                return out;
            }
            // One-shot path: emit the dangling partial tag as literal.
            emitText(input.slice(lt));
            break;
        }
        const tag = input.slice(lt, gt + 1);
        if ($534f3b959a2e27b2$var$DETAILS_OPEN_RE.test(tag)) {
            if (state.mode === 'NORMAL') state.mode = 'IN_DETAILS_PRE_SUMMARY';
            else // Nested or unexpected — pass through so we don't eat user text.
            emitText(tag);
        } else if ($534f3b959a2e27b2$var$SUMMARY_OPEN_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                state.mode = 'IN_SUMMARY';
                out += $534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY;
            } else emitText(tag);
        } else if ($534f3b959a2e27b2$var$SUMMARY_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_SUMMARY') {
                state.mode = 'IN_DETAILS_BODY';
                out += '\n';
            } else emitText(tag);
        } else if ($534f3b959a2e27b2$var$DETAILS_CLOSE_RE.test(tag)) {
            if (state.mode === 'IN_DETAILS_BODY') {
                state.mode = 'NORMAL';
                out += $534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY;
            } else if (state.mode === 'IN_DETAILS_PRE_SUMMARY') {
                // `<details>…</details>` with no `<summary>`. Synthesise a
                // default header so the renderer has something to show.
                state.mode = 'NORMAL';
                out += `${$534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY}${$534f3b959a2e27b2$var$DEFAULT_TITLE}\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
            } else if (state.mode === 'IN_SUMMARY') {
                // Malformed: `</details>` while still inside `<summary>`. Close
                // the summary implicitly and close the details.
                state.mode = 'NORMAL';
                out += `\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
            } else emitText(tag);
        } else // Unrelated tag (e.g. `<span>`, `<a href=…>`) — pass through.
        emitText(tag);
        i = gt + 1;
    }
    state.buffer = '';
    return out;
};
const $534f3b959a2e27b2$var$synthesiseClosers = (state)=>{
    let out = '';
    if (state.mode === 'IN_DETAILS_PRE_SUMMARY') out += `${$534f3b959a2e27b2$var$DETAILS_OPEN_BOUNDARY}${$534f3b959a2e27b2$var$DEFAULT_TITLE}\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_SUMMARY') out += `\n${$534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY}`;
    else if (state.mode === 'IN_DETAILS_BODY') out += $534f3b959a2e27b2$var$DETAILS_CLOSE_BOUNDARY;
    state.mode = 'NORMAL';
    return out;
};
const $534f3b959a2e27b2$export$c00e46a308694bc9 = (text)=>{
    if (!text || !$534f3b959a2e27b2$var$HAS_RELEVANT_TAG_RE.test(text)) return text;
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    let out = $534f3b959a2e27b2$var$scan(text, state, /* allowBuffer */ false);
    out += $534f3b959a2e27b2$var$synthesiseClosers(state);
    return out;
};
const $534f3b959a2e27b2$export$88c7624283baadd3 = ()=>{
    const state = {
        mode: 'NORMAL',
        buffer: ''
    };
    return {
        process (chunk) {
            const combined = state.buffer + (chunk ?? '');
            state.buffer = '';
            // Fast-path: when we are not inside a details block and the combined
            // text contains no `<` at all, a tag is impossible — skip the scan.
            // We deliberately do NOT use a name-level regex here: a partial tag
            // like `<det` spanning a chunk boundary must still be buffered for
            // the next chunk to complete it.
            if (!combined || state.mode === 'NORMAL' && !combined.includes('<')) return combined;
            return $534f3b959a2e27b2$var$scan(combined, state, /* allowBuffer */ true);
        },
        flush () {
            let out = '';
            if (state.buffer) {
                const leftover = state.buffer;
                state.buffer = '';
                out += $534f3b959a2e27b2$var$scan(leftover, state, /* allowBuffer */ false);
            }
            out += $534f3b959a2e27b2$var$synthesiseClosers(state);
            return out;
        }
    };
};



var $7yZ5y = parcelRequire("7yZ5y");


var $bQGO7 = parcelRequire("bQGO7");


var $16lEl = parcelRequire("16lEl");


var $8IKbl = parcelRequire("8IKbl");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $aclUh = parcelRequire("aclUh");


var $2CHXX = parcelRequire("2CHXX");


var $bPHr8 = parcelRequire("bPHr8");


var $9vgbT = parcelRequire("9vgbT");


var $52Fo2 = parcelRequire("52Fo2");

const $6bf7a89ae376c5c9$export$ed5572b558d71438 = (ari)=>{
    if (!ari) return null;
    // see go/ari for possible values
    // Example:
    // ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
    // -> amplitude
    const ariParts = ari.split(':');
    if (ariParts.length < 3) return null;
    return ariParts[2];
};



var $lgNBC = parcelRequire("lgNBC");


var $9TBZq = parcelRequire("9TBZq");


var $3HubT = parcelRequire("3HubT");

class $cb98028e732bb0c1$export$17fb3253ebc25334 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.errorAttributes = {
            traceId: params.traceId ?? `NoActionInvoked-${(0, $3HubT.generateTraceId)()}`
        };
    }
}



var $eu7N9 = parcelRequire("eu7N9");


var $5yETg = parcelRequire("5yETg");

// Only these classifications get the softer "no content" hint screen.
// Everything else (including missing or unknown) falls through to the error screen.
const $658a05ad0cb6a20b$var$ABORT_CLASSIFICATIONS = new Set([
    'BAD_USER_PROMPT',
    'GOOD_REPLY_NO_CREATE',
    'EXTERNAL_ERROR'
]);
const $658a05ad0cb6a20b$export$567fc7097e064344 = ()=>String(Math.floor(Math.random() * 1000000));
const $658a05ad0cb6a20b$export$b043b11900276452 = ({ broadcastStreamStatus: broadcastStreamStatus, chatContextStoreActions: chatContextStoreActions, contentContextValue: contentContextValue, targetId: targetId, assistantMessageId: assistantMessageId })=>{
    return (status)=>{
        let contentTarget;
        if ((0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            // Use targetId from sendMessage if provided, otherwise fall back to currentTargetId
            const activeTargetId = targetId ?? chatContextStoreActions.getCurrentTargetId();
            contentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
        } else contentTarget = chatContextStoreActions.getTarget(contentContextValue, targetId);
        broadcastStreamStatus?.(status, assistantMessageId, contentTarget ? {
            id: contentTarget.id,
            type: contentTarget.type
        } : undefined);
    };
};
const $658a05ad0cb6a20b$export$9c657fdfae6b2020 = (messages, messageId)=>{
    const assistantMessage = messages.find((chatItem)=>(0, $bPHr8.isStoreAssistant)(chatItem) && (0, $aclUh.getId)(chatItem.content) === messageId);
    if (!assistantMessage) return '';
    const content = assistantMessage.content.message.message.content;
    return typeof content === 'string' ? content : '';
};
const $658a05ad0cb6a20b$export$bb0ca99caffb8502 = (messages, messageId)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message,
                        content: ''
                    }
                },
                streamingComplete: false
            }
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$d812e3ec408e3b14 = (messages, messageId, answerGenerationType)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message
                    }
                },
                streamingComplete: false
            },
            answerGenerationType: answerGenerationType
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$14aeb537f795ee1a = (messages, messageId, answerNowStatus)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            answerNowStatus: answerNowStatus
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$ed23852026f99b3a = (conversationId, messageId, getMessages, setMessages)=>{
    const currentMessages = getMessages(conversationId);
    const assistantMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && $658a05ad0cb6a20b$var$getStoreMessageId(msg) === messageId);
    if (assistantMessage && 'answerNowStatus' in assistantMessage && assistantMessage.answerNowStatus) setMessages(conversationId, $658a05ad0cb6a20b$export$14aeb537f795ee1a(currentMessages, messageId, undefined));
};
const $658a05ad0cb6a20b$export$f9095c96f8c4be7e = (messages, messageId, subAgentMessage)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message
                    }
                },
                streamingComplete: false
            },
            dynamicLayoutSubAgentMessages: [
                ...chatItem.dynamicLayoutSubAgentMessages || [],
                subAgentMessage
            ]
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$a89606c68db527fb = (streamMessage)=>{
    return {
        messageContent: streamMessage.message?.content,
        messageTemplate: streamMessage.message?.message_template
    };
};
const $658a05ad0cb6a20b$export$5782d74d68fa92c6 = (error, prefix = '', actionLoggableNameIfActionExecutionFailed)=>{
    let status_code, message_template, timeout;
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error';
    let prefixedMessage = prefix ? `${prefix}: ${message}` : message;
    let errorType;
    let traceId;
    if (error instanceof (0, $eu7N9.StreamErrorException)) {
        status_code = error.detail.message.status_code;
        message_template = error.detail.message.message_template;
        timeout = error.detail.metadata?.timeout;
        errorType = 'StreamErrorException';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $flpNp.ApiError)) {
        status_code = error.errorAttributes.statusCode;
        message_template = error.errorAttributes.errorCode;
        errorType = 'ApiError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $9TBZq.MessageActionError)) {
        // Prefer showing only the raw API error message (without codes) to end users
        const rawErrorMessage = error.cause && 'errorAttributes' in error.cause && typeof error.cause.errorAttributes === 'object' && error.cause.errorAttributes !== null && 'rawErrorMessage' in error.cause.errorAttributes ? error.cause.errorAttributes.rawErrorMessage : undefined;
        if (typeof rawErrorMessage === 'string') prefixedMessage = prefix ? `${prefix}: ${rawErrorMessage}` : rawErrorMessage;
    }
    if (error instanceof (0, $5yETg.StreamGeneratorError)) {
        errorType = 'StreamGeneratorError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $lgNBC.DeepResearchError)) {
        message_template = error.message_template;
        errorType = 'DeepResearchError';
        traceId = error.errorAttributes.traceId;
    }
    return {
        type: 'ERROR',
        content: prefixedMessage,
        time_created: new Date().toLocaleString(),
        status_code: status_code,
        message_template: message_template,
        timeout: timeout,
        id: $658a05ad0cb6a20b$export$567fc7097e064344(),
        errorType: errorType,
        traceId: traceId,
        storeActionExecutionError: actionLoggableNameIfActionExecutionFailed ? {
            actionLoggableName: actionLoggableNameIfActionExecutionFailed
        } : undefined
    };
};
const $658a05ad0cb6a20b$export$fa05b63813f8a225 = (content)=>({
        type: 'HUMAN',
        content: content
    });
const $658a05ad0cb6a20b$export$2250e3c2fe6e53e5 = (...args)=>({
        type: 'HUMAN',
        content: (0, $aclUh.createHumanMessage)(...args)
    });
const $658a05ad0cb6a20b$export$bd3c429f5e3d2c3e = (content)=>({
        type: 'ASSISTANT',
        content: content
    });
const $658a05ad0cb6a20b$export$f509fd4645870a6e = (args)=>{
    const authorNamedId = args.agentAuthorId ? undefined : args.agentNamedId;
    return {
        type: 'ASSISTANT',
        content: {
            type: 'FINAL_RESPONSE',
            message: {
                message: {
                    role: 'ASSISTANT',
                    id: args.id,
                    conversation_channel_id: args.conversationId,
                    content: args.content,
                    time_created: new Date().toISOString(),
                    user_ari: 'unknown',
                    plugin_invocations: [],
                    ...args.agentAuthorId ? {
                        agent_author: {
                            id: args.agentAuthorId
                        }
                    } : {},
                    author: {
                        named_id: authorNamedId || 'ai_mate_agent',
                        name: 'unknown',
                        actor_type: 'AGENT',
                        ari: null,
                        id: 'unknown'
                    }
                }
            }
        }
    };
};
const $658a05ad0cb6a20b$var$getStoreMessageId = (storeMessage)=>{
    if ((0, $bPHr8.isStoreAssistant)(storeMessage)) return (0, $aclUh.getId)(storeMessage.content);
    return storeMessage.content.id;
};
const $658a05ad0cb6a20b$export$64b557ae352795d6 = (chat, messageId)=>chat.findIndex((storeMessage)=>(0, $bPHr8.isStoreMessage)(storeMessage) && (messageId ? $658a05ad0cb6a20b$var$getStoreMessageId(storeMessage) === messageId : true));
const $658a05ad0cb6a20b$var$updateStoreMessage = ({ chat: chat, messageId: messageId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>{
    // If the chat is empty, return it as is - prevents the 'in' of 'undefined' errors we were seeing
    // TODO: Take this into account with upcoming refactor
    if (!chat.length) return chat;
    const targetIndex = useIndex || $658a05ad0cb6a20b$export$64b557ae352795d6(chat, messageId);
    const targetStoreMessage = chat[targetIndex];
    if (targetIndex < 0 || !(0, $bPHr8.isStoreMessage)(targetStoreMessage)) throw new Error(`Attempting to update a non StoreMessage (${updateType})`);
    if ($658a05ad0cb6a20b$var$getStoreMessageId(targetStoreMessage) !== messageId) throw new Error(`Attempting to update a store message at the wrong index (${updateType})`);
    const newStoreMessage = updateFunction(targetStoreMessage);
    const newChat = [
        ...chat
    ];
    newChat.splice(targetIndex, 1, newStoreMessage);
    return newChat;
};
const $658a05ad0cb6a20b$var$updateStoreAssistant = ({ chat: chat, promptId: promptId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>$658a05ad0cb6a20b$var$updateStoreMessage({
        chat: chat,
        messageId: promptId,
        updateFunction: (storeMessage)=>{
            if (!(0, $bPHr8.isStoreAssistant)(storeMessage)) throw new Error(`Attempting to update a non StoreAssistant (${updateType})`);
            return updateFunction(storeMessage);
        },
        updateType: updateType,
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$6e5609c05ab74cc7 = ({ chat: chat, answerId: answerId, answerPart: answerPart, useIndex: useIndex })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                }
            }),
        updateType: 'Add Answer Part',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$4287833726c64095 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    const { key: key, content: content, loading: loading } = markdownData;
    const loadingKey = `${key}-loading`;
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: {
                    ...storeAssistant.markdownData,
                    [key]: (storeAssistant.markdownData?.[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                }
            }),
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};
const $658a05ad0cb6a20b$export$679615d953ba31c3 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>{
            const updatedMarkdownData = Object.entries(markdownData).reduce((acc, [key, { content: content, loading: loading }])=>{
                const loadingKey = `${key}-loading`;
                return {
                    ...acc,
                    [key]: (acc[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                };
            }, {
                ...storeAssistant.markdownData
            });
            return {
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: updatedMarkdownData
            };
        },
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};
const $658a05ad0cb6a20b$export$13b6a4e4e3704011 = ({ chat: chat, messageId: messageId, actionPart: actionPart, useIndex: useIndex, actionUpdaterOverride: actionUpdaterOverride })=>{
    const findMessage = chat.findIndex((message)=>(0, $bPHr8.isStoreAssistant)(message) && (0, $aclUh.getId)(message.content) === messageId);
    const actionIndex = findMessage > 0 ? findMessage : chat.length - 1;
    const index = useIndex || actionIndex;
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: messageId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addActionPart)(storeAssistant.content, actionPart, actionUpdaterOverride)
                }
            }),
        updateType: 'Add Action Part',
        useIndex: index
    });
};
const $658a05ad0cb6a20b$export$1c0805bd5fc59c20 = (content)=>{
    if (content == null || typeof content !== 'object' || !('structured' in content)) return null;
    const { text_parts: text_parts, data_parts: data_parts } = content;
    const textContent = text_parts?.map((part)=>part.text ?? '').join('').trim() || '';
    const a2uiMessages = data_parts?.filter((part)=>part?.metadata?.mimeType === 'application/json+a2ui' && part?.data != null).map((part)=>part.data);
    return {
        textContent: textContent,
        a2uiMessages: a2uiMessages && a2uiMessages.length > 0 ? a2uiMessages : undefined
    };
};
const $658a05ad0cb6a20b$export$3a4ed3ae96502e9e = (messages, messageId, agenticUiMessage)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            agenticUiMessages: [
                ...chatItem.agenticUiMessages || [],
                ...agenticUiMessage.message.content
            ]
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$41f43752e3744795 = (messages, messageId, text)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) {
            const currentContent = chatItem.content?.message?.message?.content ?? '';
            return {
                ...chatItem,
                content: {
                    ...chatItem.content,
                    message: {
                        ...chatItem.content.message,
                        message: {
                            ...chatItem.content.message.message,
                            content: currentContent + text
                        }
                    }
                }
            };
        }
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$4499bf045ea6bd06 = ({ markdownData: markdownData, type: type, index: index })=>{
    return markdownData?.[`${type}-${index}`];
};
const $658a05ad0cb6a20b$export$60e170089d1b35dd = ({ chat: chat, answerId: answerId, content: content, useIndex: useIndex, humanMessageId: humanMessageId, markdownData: markdownData, onMessageIdChanged: onMessageIdChanged })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeMessage)=>{
            const oldId = $658a05ad0cb6a20b$var$getStoreMessageId(storeMessage);
            const newId = content.message.message.id;
            if (oldId !== newId) onMessageIdChanged?.(oldId, newId);
            return {
                ...storeMessage,
                content: {
                    ...content,
                    streamingComplete: false
                },
                humanMessageId: humanMessageId,
                markdownData: markdownData
            };
        },
        updateType: 'Replace Answer Data',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$ba29913b663b084c = ({ chat: chat, oldId: oldId, newId: newId, parentMessageId: parentMessageId })=>chat.map((message)=>{
        if ((0, $bPHr8.isStoreHuman)(message) && message.content.id === oldId) return {
            ...message,
            content: {
                ...message.content,
                id: newId,
                ...parentMessageId && {
                    parent_message_id: parentMessageId
                }
            }
        };
        return message;
    });
const $658a05ad0cb6a20b$export$f279e50afd80e7d8 = ({ chat: chat, oldId: oldId, newId: newId })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: oldId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...storeAssistant.content,
                    message: {
                        ...storeAssistant.content.message,
                        message: {
                            ...storeAssistant.content.message.message,
                            id: newId
                        }
                    }
                }
            }),
        updateType: 'Update Store Assistant Message ID'
    });
const $658a05ad0cb6a20b$export$680d2bb5b9579c57 = (chat)=>chat.map((message)=>{
        if ((0, $bPHr8.isStoreAssistant)(message) && !message.content.streamingComplete) return {
            ...message,
            content: {
                ...message.content,
                streamingComplete: true
            },
            // Clear answerNowStatus when streaming completes (success, error, or abort)
            answerNowStatus: undefined
        };
        return message;
    });
const $658a05ad0cb6a20b$export$304863f72794c019 = (chat)=>{
    const isInFlight = (action)=>{
        const lower = action.status?.toLowerCase();
        return lower === 'streaming' || lower === 'preparing';
    };
    const hasInFlightAction = chat.some((message)=>(0, $bPHr8.isStoreAssistant)(message) && message.content.message.message.actions?.some(isInFlight));
    if (!hasInFlightAction) return chat;
    return chat.map((message)=>{
        if (!(0, $bPHr8.isStoreAssistant)(message) || !message.content.message.message.actions?.some(isInFlight)) return message;
        return {
            ...message,
            content: {
                ...message.content,
                message: {
                    ...message.content.message,
                    message: {
                        ...message.content.message.message,
                        actions: message.content.message.message.actions.map((action)=>isInFlight(action) ? {
                                ...action,
                                status: 'cancelled'
                            } : action)
                    }
                }
            }
        };
    });
};
const $658a05ad0cb6a20b$export$24d2e7dc410ce2e5 = (chat, startFromMessageId, messageCount = 1)=>{
    const messageIndex = $658a05ad0cb6a20b$export$64b557ae352795d6(chat, startFromMessageId);
    if (messageIndex < 0) return [];
    const messageHistory = chat.slice(Math.max(0, messageIndex - messageCount), messageIndex + 1);
    return messageHistory;
};
const $658a05ad0cb6a20b$export$b53f205a52449551 = ({ lastAgentMessageStatus: lastAgentMessageStatus })=>({
        status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
        traces: [],
        storeAbortController: undefined,
        ...lastAgentMessageStatus !== undefined && {
            lastAgentMessageStatus: lastAgentMessageStatus
        }
    });
const $658a05ad0cb6a20b$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        content: (0, $aclUh.removeSensitiveData)(message.content)
    });
const $658a05ad0cb6a20b$export$a2ff1144002a6147 = (state, id)=>{
    return state.conversations[id];
};
const $658a05ad0cb6a20b$export$de552dcf26f1e520 = (state, conversationId)=>{
    const creatorType = $658a05ad0cb6a20b$export$a2ff1144002a6147(state, conversationId)?.agent?.creator_type;
    return !!creatorType && (0, $bOrYy.isForgeAgentByCreatorType)(creatorType);
};
const $658a05ad0cb6a20b$export$80b847bfebcaa3fd = (state, id)=>{
    return !!id && state.conversations[state.currentConversationId]?.sourceId === id;
};
const $658a05ad0cb6a20b$export$d9047a7a8ec8ea5c = (messages)=>{
    return $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreHuman));
};
const $658a05ad0cb6a20b$export$2813a13604911e2d = (messages)=>{
    try {
        const last = $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreAssistant));
        return last?.content.message.message.id;
    } catch  {
        return undefined;
    }
};
const $658a05ad0cb6a20b$export$1ba374c59efc126c = (messages)=>{
    return $658a05ad0cb6a20b$export$d9047a7a8ec8ea5c(messages)?.content.requestId;
};
const $658a05ad0cb6a20b$export$7fd69d5cdd838542 = (messages, messageId)=>{
    let index = -1;
    const result = messages.find((item, i)=>{
        index = i;
        return (0, $bPHr8.isStoreAssistant)(item) && (0, $aclUh.getId)(item.content) === messageId;
    });
    return result ? {
        result: result,
        index: index
    } : {
        result: false,
        index: index
    };
};
const $658a05ad0cb6a20b$export$3dfca8d0ecaaf31f = ({ messages: messages, messageId: messageId, searchType: searchType })=>{
    const startIndex = messages.findIndex((item)=>{
        switch(item.type){
            case 'HUMAN':
                return item.content.id === messageId;
            case 'ASSISTANT':
                return item.content.message.message.id === messageId;
            case 'FOLLOW_UP':
                return String(item.id) === messageId;
            default:
                return false;
        }
    });
    for(let i = startIndex; i >= 0; i--){
        if (messages[i].type === searchType) return messages[i];
    }
    return undefined;
};
const $658a05ad0cb6a20b$export$1a288f9aecfed8b4 = (messages, agentMessageId)=>{
    try {
        const agentMessage = $658a05ad0cb6a20b$export$7fd69d5cdd838542(messages, agentMessageId).result;
        if (agentMessage && (0, $bPHr8.isStoreAssistant)(agentMessage)) {
            const foundId = $658a05ad0cb6a20b$export$3dfca8d0ecaaf31f({
                messages: messages,
                messageId: agentMessageId,
                searchType: 'HUMAN'
            })?.content.id;
            return foundId ? String(foundId) : undefined;
        }
    } catch  {
        return undefined;
    }
};
const $658a05ad0cb6a20b$export$1cdaa2c4089128bd = (chat, requestId)=>{
    const lastHumanMessage = $658a05ad0cb6a20b$export$296de88ccac4bedb(chat, (0, $bPHr8.isStoreHuman));
    // Skip if there is no last human message or if the requestId is already set
    if (!lastHumanMessage || !requestId || !!lastHumanMessage.content.requestId) return chat;
    const newHumanMessage = {
        ...lastHumanMessage,
        content: {
            ...lastHumanMessage.content,
            requestId: requestId
        }
    };
    const newChat = [
        ...chat
    ];
    newChat[newChat.lastIndexOf(lastHumanMessage)] = newHumanMessage;
    return newChat;
};
const $658a05ad0cb6a20b$export$b178621992ef9541 = (conversationId)=>conversationId === (0, $2CHXX.EMPTY_CONVERSATION_ID) || conversationId === undefined;
const $658a05ad0cb6a20b$export$3902b208060a7183 = (chatStatus, conversationStatus)=>{
    return chatStatus === 'launching' || conversationStatus === (0, $bPHr8.CHAT_STORE_STATUS).loadingChat;
};
const $658a05ad0cb6a20b$export$2126c56dcace27e4 = ({ chat: chat, type: type, index: index })=>{
    for(let currentIndex = chat.length - 1; currentIndex >= 0; currentIndex--){
        if (chat[currentIndex].type === type) return currentIndex === index;
    }
    return false;
};
const $658a05ad0cb6a20b$export$d669251a312339ff = (chat, type)=>{
    const lastIndex = chat.map((item)=>item.type).indexOf(type);
    if (lastIndex >= 0) return chat[lastIndex];
};
const $658a05ad0cb6a20b$export$adcb9a09d2b33fd = (chat, type)=>$658a05ad0cb6a20b$export$296de88ccac4bedb(chat, (item)=>item.type === type);
function $658a05ad0cb6a20b$export$296de88ccac4bedb(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return array[i];
    }
    return undefined;
}
const $658a05ad0cb6a20b$export$8855a8be7bd3e9f8 = (array, predicate)=>{
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return i;
    }
    return -1;
};
const $658a05ad0cb6a20b$export$ab93cd1ecacda8ec = (messages, conversation)=>{
    const assistantMessage = messages.find((message)=>(0, $bPHr8.isStoreAssistant)(message));
    if ((0, $dh538.fg)('rovo_chat_fix_agent_selection_after_cancel')) // fixing the fallback to correctly select an agent if a user cancels a session
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id ?? conversation?.agent?.agent_id;
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id;
};
const $658a05ad0cb6a20b$export$25a2389a84d1a0a0 = (timeStamp, conversationId)=>{
    // More detail on djb2 hash function https://theartincode.stanis.me/008-djb2/
    let hash = 5381;
    if (!timeStamp || !conversationId) return hash;
    const concat = conversationId + timeStamp;
    for(let i = 0; i < concat.length; i++)// Update the hash value
    hash = (hash << 5) + hash + concat.charCodeAt(i); // hash * 33 + c
    // Ensure the hash is a positive integer
    return hash >>> 0;
};
const $658a05ad0cb6a20b$export$eca740b13a7a3080 = (conversationId)=>String($658a05ad0cb6a20b$export$25a2389a84d1a0a0(new Date().toISOString(), conversationId));
const $658a05ad0cb6a20b$export$9de2c1973de15b05 = (sources)=>{
    if (!sources) return {};
    const citedProductList = {};
    sources.forEach((source)=>{
        const productName = (0, $6bf7a89ae376c5c9$export$ed5572b558d71438)(source.ari);
        if (productName) citedProductList[productName] = (citedProductList[productName] ?? 0) + 1;
    });
    return citedProductList;
};
const $658a05ad0cb6a20b$export$823ed9c8e3d751f5 = (streamMessage)=>{
    const content = streamMessage.message.message.content;
    if (typeof content !== 'string') return streamMessage;
    return {
        ...streamMessage,
        message: {
            ...streamMessage.message,
            message: {
                ...streamMessage.message.message,
                content: (0, $534f3b959a2e27b2$export$c00e46a308694bc9)(content)
            }
        }
    };
};
const $658a05ad0cb6a20b$export$66fc5003b23b7a8c = (sources)=>{
    if (!sources) return {};
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
const $658a05ad0cb6a20b$export$bb73d89e7217c465 = ({ streamMessage: streamMessage, boundaryStart: boundaryStart, boundaryEnd: boundaryEnd, replacementContent: replacementContent })=>{
    const messageContent = (0, $ljUdP.isStreamResponse)(streamMessage) ? streamMessage.message.message.content : streamMessage.message.content;
    if (!messageContent || typeof messageContent !== 'string') return {
        processedStreamMessage: streamMessage,
        boundaryContents: []
    };
    const { processedText: processedText, boundaryContents: boundaryContents } = (0, $7yZ5y.extractMarkdownText)(messageContent, boundaryStart, boundaryEnd, replacementContent);
    if (boundaryContents.length > 0) {
        if ((0, $ljUdP.isStreamResponse)(streamMessage)) streamMessage.message.message.content = processedText;
        else streamMessage.message.content = processedText;
    }
    return {
        processedStreamMessage: streamMessage,
        boundaryContents: boundaryContents
    };
};
const $658a05ad0cb6a20b$export$b77ba8e4ec693266 = (jsonString)=>{
    try {
        const parsed = JSON.parse(jsonString);
        if ((0, $4pEXC.isAdfContent)(parsed)) return true;
        return false;
    } catch  {
        return false;
    }
};
const $658a05ad0cb6a20b$var$serviceDeskSourceRegex = /https:\/\/[a-zA-Z0-9_.-]+\/servicedesk\/customer\//g;
const $658a05ad0cb6a20b$export$b9ac6250c4aba7c6 = (pluginOutput)=>{
    return $658a05ad0cb6a20b$var$serviceDeskSourceRegex.test(pluginOutput);
};
/**
 * Component key for actionable follow-up questions. Combined with the streaming
 * counter (`${key}-N`) it produces status localIds prefixed with
 * `ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX`.
 */ const $658a05ad0cb6a20b$var$ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY = (0, $7KWEi.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX).replace(/-$/, '');
const $658a05ad0cb6a20b$export$b7cc8b01149baaeb = ({ streamMessage: streamMessage, markdownData: markdownData })=>{
    if (!(0, $dh538.fg)('rovo_chat_actionable_followups_enabled')) return streamMessage;
    const followUpsMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
        streamMessage: streamMessage,
        boundaryStart: (0, $7KWEi.ACTIONABLE_FOLLOW_UPS_MARKER),
        boundaryEnd: '',
        replacementContent: `\n\n[^${$658a05ad0cb6a20b$var$ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}^]\n\n`
    });
    followUpsMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`${$658a05ad0cb6a20b$var$ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}-${index}`] = content;
    });
    return followUpsMsg.processedStreamMessage;
};
const $658a05ad0cb6a20b$export$c37d58cb6fcaff84 = ()=>[
        {
            key: 'expand',
            startTag: "\u259E",
            endTag: "\u259A",
            placeholderTag: '[^expand^]',
            isEnabled: true
        },
        {
            key: 'chart',
            startTag: "\u25F4",
            endTag: "\u25F6",
            placeholderTag: '[^chart^]',
            isEnabled: true
        },
        {
            key: 'lumina',
            startTag: "\u25D0",
            endTag: "\u25D1",
            placeholderTag: '\n\n[^lumina^]\n\n',
            isEnabled: (0, $dh538.fg)('rovo_chat_enable_inline_lumina')
        },
        {
            // Actionable follow-up questions: a single start marker with no end marker —
            // everything after `◈` to the end of the message is the follow-ups payload.
            // An empty endTag tells the parser to capture to end-of-message.
            key: $658a05ad0cb6a20b$var$ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY,
            startTag: (0, $7KWEi.ACTIONABLE_FOLLOW_UPS_MARKER),
            endTag: '',
            placeholderTag: `\n\n[^${$658a05ad0cb6a20b$var$ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}^]\n\n`,
            isEnabled: (0, $dh538.fg)('rovo_chat_actionable_followups_enabled')
        }
    ];
const $658a05ad0cb6a20b$export$11d94ded1c502e7b = ({ streamMessage: streamMessage, currentLoadingKey: currentLoadingKey, previousKey: previousKey, componentType: componentType })=>{
    const componentConfig = $658a05ad0cb6a20b$export$c37d58cb6fcaff84().find((c)=>c.key === componentType);
    if (!componentConfig) return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: currentLoadingKey,
        previousKey: previousKey,
        markdownData: null
    };
    const messageContent = streamMessage.message.content;
    if (typeof messageContent !== 'string') return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: currentLoadingKey,
        previousKey: previousKey,
        markdownData: null
    };
    const result = (0, $7yZ5y.processMarkdownComponent)(messageContent, currentLoadingKey, previousKey, componentConfig);
    streamMessage.message.content = result.processedText;
    return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: result.currentLoadingKey,
        previousKey: result.previousKey,
        markdownData: result.markdownData
    };
};
const $658a05ad0cb6a20b$export$f0a9473b2d3b8f30 = (options)=>{
    // We pass a lazy supplier so the processor reads current feature flag values on each call.
    // createMarkdownProcessor keeps state (currentLoadingKeys / previousKeys) across calls,
    // while components are re-evaluated every invocation to reflect live flag values.
    const processor = (0, $7yZ5y.createMarkdownProcessor)($658a05ad0cb6a20b$export$c37d58cb6fcaff84);
    // Per-message preprocessor that rewrites HTML `<details><summary>` blocks
    // into the Rovo-native `▞…▚` boundary before they reach the component
    // extractor. Maintains its own cross-chunk buffer so partial tags spanning
    // chunk boundaries resolve correctly. The caller decides whether to enable
    // it (typically gated on 3P agents via
    // `shouldPreprocessDetailsForConversation`).
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $534f3b959a2e27b2$export$88c7624283baadd3)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData, processedComponentType: processedComponentType } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
const $658a05ad0cb6a20b$export$95c0abd604a2cca2 = (options)=>{
    // handles multiple tags in a single chunk (e.g. close tag + new open tag)
    // Returns markdownData as a MarkdownDataMap (keyed by component instance).
    const processor = (0, $7yZ5y.createMarkdownProcessorMultiTags)($658a05ad0cb6a20b$export$c37d58cb6fcaff84);
    // Optional <details>/<summary> rewriter that runs upstream of the
    // multi-tag extractor so the existing `▞…▚` boundary-driven `expand`
    // component picks them up. See createStreamMarkdownProcessor.
    const detailsPreprocessor = options?.shouldPreprocessDetails ? (0, $534f3b959a2e27b2$export$88c7624283baadd3)() : null;
    return (streamMessage)=>{
        const messageContent = streamMessage.message.content;
        const text = typeof messageContent === 'string' ? messageContent : '';
        const preprocessedText = detailsPreprocessor ? detailsPreprocessor.process(text) : text;
        const { processedText: processedText, markdownData: markdownData } = processor(preprocessedText);
        streamMessage.message.content = processedText;
        return {
            processedStreamMessage: streamMessage,
            markdownData: markdownData
        };
    };
};
function $658a05ad0cb6a20b$export$5ab2d78f2e4dba11(message, context) {
    if (!(0, $ljUdP.isActionExecutedSuccessfully)(message)) return 'errored';
    return (0, $ljUdP.isActionResolutionCancelled)(context) ? 'cancelled' : 'finished';
}
const $658a05ad0cb6a20b$export$886a0387c1c465f5 = (error)=>{
    if (!error) return false;
    // Server-sent error chunks are wrapped as StreamErrorException and should be excluded
    if (error instanceof (0, $eu7N9.StreamErrorException)) return false;
    // Any ApiError (or object exposing errorAttributes.statusCode) comes from the HTTP layer, so exclude
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (error instanceof (0, $flpNp.ApiError) || error?.errorAttributes?.statusCode) return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const message = error?.message;
    // When the backend terminates the stream abruptly we get a JSON parsing error, so we treat it as server-side
    // See onversation-assistant-service/src/services/assistance-service/read-json-stream/index.ts
    if (typeof message === 'string' && message.startsWith('Error Processing Stream Data')) return false;
    // Whatever remains is considered a client/network error
    return true;
};
const $658a05ad0cb6a20b$export$24c718731d9a7b6a = (messages, predicate)=>{
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg)) {
            const actionParts = msg.content.message?.message?.actions ?? [];
            const action = $658a05ad0cb6a20b$export$296de88ccac4bedb(actionParts, predicate);
            if (action) return action;
        }
    }
    return undefined;
};
const $658a05ad0cb6a20b$export$acbf6433e9af643f = (allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, commonExperienceAttributes, productKey, minionOutputs)=>{
    // Some products do not require first response to be an action,
    // so exit early when we're not within Confluence
    if (productKey !== 'confluence') return true;
    const humanMessageCount = allMessages.filter((0, $bPHr8.isStoreHuman)).length;
    // Only execute on the first human message within the staging area
    if (chatContextStoreActions.getIsStagingArea() && humanMessageCount === 1) {
        const firstAssistantResponse = allMessages.find((0, $bPHr8.isStoreAssistant));
        const firstAction = firstAssistantResponse?.content?.message?.message?.actions?.[0];
        const hasCreatableAction = firstAction ? (0, $deF0K.isCreatableAction)(firstAction) : false;
        // An ask_question action is a valid first response (the agent is asking the user a
        // clarifying/disambiguation question), not a failed content creation. Treat it as
        // valid so the FINAL_RESPONSE is not misclassified as "no content created".
        const isAskQuestionAction = firstAction?.key === (0, $8IKbl.ASK_QUESTION_KEY) && (0, $1oCLl.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true);
        const authUrl = (0, $9vgbT.extractOutboundAuthLink)(firstAssistantResponse?.content?.message?.message?.content ?? '');
        // this experience has a timeout. since ask_question waits for the user, we cannot
        // bound the time. so we abort it now.
        // AIFC_GENERATE_CONTENT and its other sub experiences are intentionally left open.
        // content creation is still what we're waiting for, it just happens on a later turn.
        if (isAskQuestionAction) experienceTracker.abort({
            name: (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
            reason: 'ask_question - awaiting user response, cannot bound time',
            attributes: commonExperienceAttributes
        });
        // Experience handling for the scenario where there
        // should be an action returned but there was not
        if (!hasCreatableAction && !isAskQuestionAction) {
            // If authUrl is present, abort the experience
            if (authUrl) {
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                    reason: 'authentication-required',
                    attributes: commonExperienceAttributes
                });
                (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, 'AIFC_GENERATE_CONTENT aborted - authentication required', commonExperienceAttributes);
            } else {
                // This error should have a user-friendly message, as it will be shown to the user.
                const noActionError = new (0, $cb98028e732bb0c1$export$17fb3253ebc25334)("Something went wrong on Rovo's end. Please try sending your message again.", {
                    traceId: traceId
                });
                const hasConfluenceCreationTool = minionOutputs?.flat().some((output)=>output.minion_id === 'ConfluenceCreationTool');
                const messageMetadata = firstAssistantResponse?.content?.message?.message?.message_metadata;
                const orchestratorDepthLimitReached = messageMetadata?.orchestrator_depth_limit_reached ?? false;
                const orchestratorContextWindowUsage = messageMetadata?.orchestrator_context_window_usage;
                const classification = messageMetadata?.aifc_no_create_classification;
                const noContentCreatedAttributes = {
                    orchestratorContextWindowUsage: orchestratorContextWindowUsage,
                    orchestratorDepthLimitReached: orchestratorDepthLimitReached,
                    hasConfluenceCreationTool: hasConfluenceCreationTool,
                    noContentCreatedClassification: classification ?? 'NO_CLASSIFICATION_PROVIDED'
                };
                if (!classification || !$658a05ad0cb6a20b$var$ABORT_CLASSIFICATIONS.has(classification)) {
                    experienceTracker.fail({
                        name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                        error: noActionError,
                        attributes: {
                            ...commonExperienceAttributes,
                            ...noContentCreatedAttributes
                        }
                    });
                    (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, classification ?? 'NO_CLASSIFICATION_PROVIDED', commonExperienceAttributes);
                    const messages = getMessages(conversationId);
                    setMessages(conversationId, [
                        ...messages,
                        $658a05ad0cb6a20b$export$5782d74d68fa92c6(noActionError)
                    ]);
                    sendMessageLatencyMetrics.cancel();
                    cancelStreamingMetrics();
                    return false;
                }
                // Abort: user prompt or external issue — nudge user to fix the problem
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                    reason: classification,
                    attributes: {
                        ...commonExperienceAttributes,
                        ...noContentCreatedAttributes
                    }
                });
                (0, $52Fo2.abortGenerateContentChildExperiences)(experienceTracker, classification, commonExperienceAttributes);
                // GOOD_REPLY_NO_CREATE is symptomatic of the user prompting non-creation, which we can also treat as a bad prompt
                const hintVariant = classification === 'EXTERNAL_ERROR' ? 'EXTERNAL_ERROR' : 'BAD_USER_INPUT';
                const messages = getMessages(conversationId);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'USAGE_HINT',
                        topic: 'NoActionInvokedError',
                        variant: hintVariant
                    }
                ]);
                return true;
            }
        }
    }
    return true;
};
const $658a05ad0cb6a20b$export$82b32799d0ea512c = ({ streamMessage: streamMessage, messageId: messageId, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent, shouldPreprocessDetails: shouldPreprocessDetails = false })=>{
    let processedStreamMessage = streamMessage;
    const markdownData = {};
    // Applies to the final-response path (non-streaming) and to reconnect replay.
    if (shouldPreprocessDetails) processedStreamMessage = $658a05ad0cb6a20b$export$823ed9c8e3d751f5(processedStreamMessage);
    if ((0, $dh538.fg)('rovo_enable_data_sculptor')) {
        const dataSculptorMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
            streamMessage: processedStreamMessage,
            boundaryStart: '[^sculptor:start^]',
            boundaryEnd: '[^sculptor:end^]',
            replacementContent: '[^sculptor^]'
        });
        processedStreamMessage = dataSculptorMsg.processedStreamMessage;
        dataSculptorMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`sculptor-${index}`] = content;
        });
    }
    const expandOpenTag = "\u259E";
    const expandCloseTag = "\u259A";
    const expandPlaceholder = '[^expand^]';
    const expandMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
        streamMessage: processedStreamMessage,
        boundaryStart: expandOpenTag,
        boundaryEnd: expandCloseTag,
        replacementContent: expandPlaceholder
    });
    processedStreamMessage = expandMsg.processedStreamMessage;
    expandMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`expand-${index}`] = content;
    });
    if (expandMsg?.boundaryContents && expandMsg.boundaryContents.length > 0) sendAnalyticsEvent({
        eventType: 'track',
        action: 'viewed',
        actionSubject: 'expandComponent',
        attributes: {
            messageId: messageId,
            conversationId: conversationId,
            expandCount: expandMsg.boundaryContents.length,
            timestamp: new Date().toISOString(),
            isFinalResponse: true
        }
    });
    const chartOpenTag = "\u25F4";
    const chartCloseTag = "\u25F6";
    const chartPlaceholder = '[^chart^]';
    const chartMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
        streamMessage: processedStreamMessage,
        boundaryStart: chartOpenTag,
        boundaryEnd: chartCloseTag,
        replacementContent: chartPlaceholder
    });
    processedStreamMessage = chartMsg.processedStreamMessage;
    chartMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`chart-${index}`] = content;
    });
    if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
        eventType: 'track',
        action: 'extracted',
        actionSubject: 'vizPluginChart',
        attributes: {
            messageId: messageId,
            conversationId: conversationId,
            chartCount: chartMsg.boundaryContents.length,
            timestamp: new Date().toISOString()
        }
    });
    if ((0, $dh538.fg)('rovo_chat_enable_inline_lumina')) {
        const luminaMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
            streamMessage: processedStreamMessage,
            boundaryStart: "\u25D0",
            boundaryEnd: "\u25D1",
            replacementContent: '\n\n[^lumina^]\n\n'
        });
        processedStreamMessage = luminaMsg.processedStreamMessage;
        luminaMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`lumina-${index}`] = content;
        });
    }
    processedStreamMessage = $658a05ad0cb6a20b$export$b7cc8b01149baaeb({
        streamMessage: processedStreamMessage,
        markdownData: markdownData
    });
    return {
        processedStreamMessage: processedStreamMessage,
        markdownData: markdownData
    };
};
const $658a05ad0cb6a20b$export$e3f334fc6effa531 = ({ chat: chat, answerId: answerId, useIndex: useIndex, memory: memory })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                memory: memory
            }),
        updateType: 'Add memory',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$2244b7838be162ca = (response, skillSelectionSource, includeDynamicUIData)=>{
    const sources = response.message?.message?.sources;
    const pluginInvocations = response.message?.message?.plugin_invocations;
    const minionOutputs = response.message?.message?.minion_outputs;
    const actions = response.message?.message?.actions;
    const humanMessageId = response.message?.human_message?.id.toString();
    const pluginsInvoked = [];
    const skillsInvoked = [];
    let usesJsm = false;
    pluginInvocations?.forEach((pi)=>{
        if (pi.plugin_name) pluginsInvoked.push(pi.plugin_name);
        if (pi.plugin_output && $658a05ad0cb6a20b$export$b9ac6250c4aba7c6(pi.plugin_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    const flatMinionOutputs = minionOutputs?.flat() ?? [];
    const executedStratusSkill = flatMinionOutputs.some((output)=>output.skill_type === 'STRATUS') ?? false;
    flatMinionOutputs.forEach((output)=>{
        pluginsInvoked.push(output.minion_id);
        const isExplicit = output.directly_invoked;
        skillsInvoked.push({
            minionId: output.minion_id,
            skillName: output.skill_alias,
            skillType: output.skill_type,
            invocationType: isExplicit ? 'explicit' : 'implicit',
            internalTools: output.internal_tools?.map((tool)=>({
                    name: tool.name,
                    isConsequential: tool.is_consequential
                })) ?? [],
            skillSelectionSource: isExplicit ? skillSelectionSource : undefined
        });
        if (output.minion_output && $658a05ad0cb6a20b$export$b9ac6250c4aba7c6(output.minion_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    return {
        humanMessageId: humanMessageId,
        citedProductList: $658a05ad0cb6a20b$export$9de2c1973de15b05(sources),
        sourceProducts: $658a05ad0cb6a20b$export$66fc5003b23b7a8c(sources),
        hasSources: !!sources?.length,
        pluginsInvoked: pluginsInvoked,
        skillsInvoked: skillsInvoked,
        executedStratusSkill: executedStratusSkill,
        messageActions: actions?.map((action)=>action.key),
        messageDynamicUIData: includeDynamicUIData ? actions?.map((action)=>({
                subtype: action.data?.dynamicUiSubtype
            })) : undefined,
        invokedFrom: $658a05ad0cb6a20b$export$a0e3245ee56765fd({
            messageActionKey: actions?.[0]?.key,
            messageActionData: actions?.[0]?.data
        }),
        responseSources: (0, $dh538.fg)('rovo_chat_analytics_source_extended') ? sources?.map((x)=>x.ari).filter(Boolean) : undefined,
        usesJsm: (0, $dh538.fg)('rovo_chat_analytics_source_extended') ? usesJsm : undefined,
        scenarioId: response.message?.message?.scenario?.id,
        interactionModeExecuted: response.message?.message?.message_metadata?.interaction_mode_executed
    };
};
const $658a05ad0cb6a20b$var$WHITEBOARD_ACTION_KEYS = new Set([
    (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY),
    (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)
]);
const $658a05ad0cb6a20b$var$DIAGRAM_UI_SUBTYPES = new Set([
    'flowchart',
    'mindmap'
]);
const $658a05ad0cb6a20b$export$f3b7160b60840213 = (actionKey, source, dynamicUiSubtype)=>{
    if (actionKey && $658a05ad0cb6a20b$var$WHITEBOARD_ACTION_KEYS.has(actionKey)) {
        if (source === 'remix') return `${actionKey}-maui`;
        if (dynamicUiSubtype && $658a05ad0cb6a20b$var$DIAGRAM_UI_SUBTYPES.has(dynamicUiSubtype)) return `${actionKey}-diagram`;
    }
    return actionKey;
};
const $658a05ad0cb6a20b$export$43489e04a87de7d0 = 'Create a Confluence page from this response';
const $658a05ad0cb6a20b$export$9f870233a176c1a0 = 'Create a Confluence page with the exact, verbatim text of your previous response.';
function $658a05ad0cb6a20b$var$getLastAssistantActions(messages) {
    const lastAssistant = $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreAssistant));
    return lastAssistant?.content?.message?.message?.actions ?? [];
}
function $658a05ad0cb6a20b$export$12e85b2979bdbb52(messages) {
    return $658a05ad0cb6a20b$var$getLastAssistantActions(messages).some((action)=>(0, $3vCSA.isConfluenceCreatableAction)({
            key: action.key
        }) || (0, $3vCSA.isConfluenceUpdatableAction)({
            key: action.key
        }) || action.key === (0, $8IKbl.CONFLUENCE_PAGE_CREATE_KEY));
}
function $658a05ad0cb6a20b$export$daae0e815c1fe242(messages) {
    return $658a05ad0cb6a20b$var$getLastAssistantActions(messages).some((action)=>action.key === (0, $8IKbl.ASK_QUESTION_KEY));
}
const $658a05ad0cb6a20b$export$7fd604660ea8b00b = 200;
function $658a05ad0cb6a20b$export$d8415dc9fe63acbe(messages, minLength = $658a05ad0cb6a20b$export$7fd604660ea8b00b) {
    const lastAssistant = $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreAssistant));
    const content = lastAssistant?.content?.message?.message?.content;
    if (content == null) // No assistant response yet — nothing to create a page from.
    return false;
    if (typeof content !== 'string') // Rich/structured content can't be cheaply measured — treat as substantive.
    return true;
    return content.trim().length >= minLength;
}
function $658a05ad0cb6a20b$export$a5165b6c5017830(messages, productKey, isSmartCreationModalOpen = false) {
    if (productKey !== 'confluence' || !(0, $1oCLl.expValEquals)('confluence_fe_create_page_suggestion', 'isEnabled', true)) return false;
    // Already in a content-creation surface — the suggestion would be redundant.
    if (isSmartCreationModalOpen) return false;
    // An `ask_question` response is an interim clarifying step, not a final
    // answer, so there is nothing to "create a page from" yet — don't synthesize
    // the create-page follow-up for it.
    if ($658a05ad0cb6a20b$export$daae0e815c1fe242(messages) && (0, $1oCLl.expValEquals)('cc-disambiguation-in-cwr', 'isEnabled', true)) return false;
    if (!$658a05ad0cb6a20b$export$d8415dc9fe63acbe(messages)) return false;
    return !$658a05ad0cb6a20b$export$12e85b2979bdbb52(messages);
}
function $658a05ad0cb6a20b$export$c2722b1ddbddcce5(messages, streamFollowUp, productKey, isSmartCreationModalOpen = false) {
    if (!$658a05ad0cb6a20b$export$a5165b6c5017830(messages, productKey, isSmartCreationModalOpen)) return streamFollowUp;
    const existingFollowUps = streamFollowUp.message.follow_ups ?? [];
    if (existingFollowUps.some((f)=>f.text === $658a05ad0cb6a20b$export$43489e04a87de7d0)) return streamFollowUp;
    return {
        ...streamFollowUp,
        message: {
            ...streamFollowUp.message,
            follow_ups: [
                ...existingFollowUps,
                {
                    type: 'SYNTHETIC',
                    text: $658a05ad0cb6a20b$export$43489e04a87de7d0
                }
            ]
        }
    };
}
function $658a05ad0cb6a20b$export$b323db724925d16f() {
    return {
        type: 'FOLLOW_UP_QUERIES',
        message: {
            follow_ups: [
                {
                    type: 'SYNTHETIC',
                    text: $658a05ad0cb6a20b$export$43489e04a87de7d0
                }
            ]
        },
        millisOffset: 0
    };
}
const $658a05ad0cb6a20b$export$a0e3245ee56765fd = ({ messageActionKey: messageActionKey, messageActionData: messageActionData })=>{
    // WARNING: Changing the logic here can affect AIFC MAU and other AI metrics.
    // Please consult with the Create with Rovo team before making any changes.
    if (!messageActionKey) return undefined;
    if ((0, $3vCSA.isDynamicUiCreatableAction)({
        key: messageActionKey
    }) || (0, $3vCSA.isImageCreatableAction)({
        key: messageActionKey
    }) || (0, $3vCSA.isRemixGeneratedAction)(messageActionData)) return 'remix';
    if ((0, $3vCSA.isConfluenceCreatableAction)({
        key: messageActionKey
    })) // TODO All creatable actions should be as AIFC MAU here,
    // but we are temporarily changing this to Confluence only due to HOT-122605
    return 'AIFC';
    else if ((0, $3vCSA.isConfluencePageUpdateAction)({
        key: messageActionKey
    })) return 'Editor AI';
    else if ((0, $3vCSA.isConfluenceWhiteboardUpdateAction)({
        key: messageActionKey
    })) return 'Whiteboard AI';
    else if ((0, $3vCSA.isConfluenceSlidesUpdateAction)({
        key: messageActionKey
    })) return 'Slide AI';
    else if ((0, $3vCSA.isConfluenceDatabaseUpdateAction)({
        key: messageActionKey
    })) return 'Database AI';
    return undefined;
};
const $658a05ad0cb6a20b$export$9f2ec1867195888b = (interactionSource)=>{
    if (interactionSource !== undefined && (0, $bQGO7.REMIX_INTERACTION_SOURCES).has(interactionSource)) return 'remix';
    return undefined;
};
const $658a05ad0cb6a20b$export$9ac25e0768639c5d = (traces)=>{
    const messages = traces.map((trace)=>trace.messageContent);
    return traces.filter((trace, i)=>messages.lastIndexOf(trace.messageContent) === i);
};
const $658a05ad0cb6a20b$export$8567b8b6b4d41b2f = (state, conversationId)=>state.conversations[conversationId]?.traces ?? [];
const $658a05ad0cb6a20b$export$d30a5acf6cceb893 = (getState, conversationId, updateCurrentConversation)=>{
    const currentTraces = $658a05ad0cb6a20b$export$8567b8b6b4d41b2f(getState(), conversationId);
    if (currentTraces.length > 0) updateCurrentConversation({
        traces: []
    });
};
module.exports["generateId"] = $658a05ad0cb6a20b$export$567fc7097e064344;
module.exports["createBroadcastStreamLifecycle"] = $658a05ad0cb6a20b$export$b043b11900276452;
module.exports["getStoreAssistantMessageContent"] = $658a05ad0cb6a20b$export$9c657fdfae6b2020;
module.exports["clearStoreAssistantMessageContent"] = $658a05ad0cb6a20b$export$bb0ca99caffb8502;
module.exports["updateStoreAssistantMessageAnswerGenerationType"] = $658a05ad0cb6a20b$export$d812e3ec408e3b14;
module.exports["updateStoreAssistantMessageAnswerNowStatus"] = $658a05ad0cb6a20b$export$14aeb537f795ee1a;
module.exports["clearAnswerNowStatusForMessageIfSet"] = $658a05ad0cb6a20b$export$ed23852026f99b3a;
module.exports["addSubAgentMessageToStoreAssistantMessage"] = $658a05ad0cb6a20b$export$f9095c96f8c4be7e;
module.exports["getTraceFromStreamMessage"] = $658a05ad0cb6a20b$export$a89606c68db527fb;
module.exports["createStoreError"] = $658a05ad0cb6a20b$export$5782d74d68fa92c6;
module.exports["createStoreHumanWithContent"] = $658a05ad0cb6a20b$export$fa05b63813f8a225;
module.exports["createStoreHuman"] = $658a05ad0cb6a20b$export$2250e3c2fe6e53e5;
module.exports["createStoreAssistantWithContent"] = $658a05ad0cb6a20b$export$bd3c429f5e3d2c3e;
module.exports["createStoreAssistant"] = $658a05ad0cb6a20b$export$f509fd4645870a6e;
module.exports["findStoreMessageIndex"] = $658a05ad0cb6a20b$export$64b557ae352795d6;
module.exports["addAnswerPart"] = $658a05ad0cb6a20b$export$6e5609c05ab74cc7;
module.exports["addAnswerPartWithMarkdownData"] = $658a05ad0cb6a20b$export$4287833726c64095;
module.exports["addAnswerPartWithMarkdownDataMap"] = $658a05ad0cb6a20b$export$679615d953ba31c3;
module.exports["addActionPart"] = $658a05ad0cb6a20b$export$13b6a4e4e3704011;
module.exports["extractA2UIFromStructuredContent"] = $658a05ad0cb6a20b$export$1c0805bd5fc59c20;
module.exports["addAgenticUiMessage"] = $658a05ad0cb6a20b$export$3a4ed3ae96502e9e;
module.exports["appendTextToAssistantMessage"] = $658a05ad0cb6a20b$export$41f43752e3744795;
module.exports["getMarkdownDataByType"] = $658a05ad0cb6a20b$export$4499bf045ea6bd06;
module.exports["replaceAnswerData"] = $658a05ad0cb6a20b$export$60e170089d1b35dd;
module.exports["updateHumanMessageId"] = $658a05ad0cb6a20b$export$ba29913b663b084c;
module.exports["updateStoreAssistantMessageId"] = $658a05ad0cb6a20b$export$f279e50afd80e7d8;
module.exports["markStreamingMessagesAsComplete"] = $658a05ad0cb6a20b$export$680d2bb5b9579c57;
module.exports["markInFlightActionsAsCancelled"] = $658a05ad0cb6a20b$export$304863f72794c019;
module.exports["getMessageHistory"] = $658a05ad0cb6a20b$export$24d2e7dc410ce2e5;
module.exports["clearStatus"] = $658a05ad0cb6a20b$export$b53f205a52449551;
module.exports["removeSensitiveData"] = $658a05ad0cb6a20b$export$efd4f6b5d168b654;
module.exports["getConversation"] = $658a05ad0cb6a20b$export$a2ff1144002a6147;
module.exports["shouldPreprocessDetailsForConversation"] = $658a05ad0cb6a20b$export$de552dcf26f1e520;
module.exports["checkActiveConversationMatchesSource"] = $658a05ad0cb6a20b$export$80b847bfebcaa3fd;
module.exports["findLast"] = $658a05ad0cb6a20b$export$296de88ccac4bedb;
module.exports["getLastAgentMessageID"] = $658a05ad0cb6a20b$export$2813a13604911e2d;
module.exports["getAgentMessageById"] = $658a05ad0cb6a20b$export$7fd69d5cdd838542;
module.exports["getAssociatedHumanMessageId"] = $658a05ad0cb6a20b$export$1a288f9aecfed8b4;
module.exports["addRequestIdToLatestHumanMessage"] = $658a05ad0cb6a20b$export$1cdaa2c4089128bd;
module.exports["isEmptyConversation"] = $658a05ad0cb6a20b$export$b178621992ef9541;
module.exports["isChatLoading"] = $658a05ad0cb6a20b$export$3902b208060a7183;
module.exports["getFirstMessageOfType"] = $658a05ad0cb6a20b$export$d669251a312339ff;
module.exports["findLastIndex"] = $658a05ad0cb6a20b$export$8855a8be7bd3e9f8;
module.exports["getSourceAgentId"] = $658a05ad0cb6a20b$export$ab93cd1ecacda8ec;
module.exports["generateTmpMessageId"] = $658a05ad0cb6a20b$export$eca740b13a7a3080;
module.exports["preprocessStreamResponseDetails"] = $658a05ad0cb6a20b$export$823ed9c8e3d751f5;
module.exports["extractMarkdownContent"] = $658a05ad0cb6a20b$export$bb73d89e7217c465;
module.exports["isValidAdfJsonString"] = $658a05ad0cb6a20b$export$b77ba8e4ec693266;
module.exports["extractActionableFollowUpsMarkdownData"] = $658a05ad0cb6a20b$export$b7cc8b01149baaeb;
module.exports["createStreamMarkdownProcessor"] = $658a05ad0cb6a20b$export$f0a9473b2d3b8f30;
module.exports["createStreamMarkdownMultiTagProcessor"] = $658a05ad0cb6a20b$export$95c0abd604a2cca2;
module.exports["deriveInvocationStatus"] = $658a05ad0cb6a20b$export$5ab2d78f2e4dba11;
module.exports["isClientSideStreamingError"] = $658a05ad0cb6a20b$export$886a0387c1c465f5;
module.exports["findLastAssistantAction"] = $658a05ad0cb6a20b$export$24c718731d9a7b6a;
module.exports["handleStagingAreaActionValidation"] = $658a05ad0cb6a20b$export$acbf6433e9af643f;
module.exports["processStreamResponseMarkdown"] = $658a05ad0cb6a20b$export$82b32799d0ea512c;
module.exports["addMemorytoLatestAssistantMessage"] = $658a05ad0cb6a20b$export$e3f334fc6effa531;
module.exports["extractStreamMeta"] = $658a05ad0cb6a20b$export$2244b7838be162ca;
module.exports["getInvokedFrom"] = $658a05ad0cb6a20b$export$a0e3245ee56765fd;
module.exports["getActionPartKeyForMetrics"] = $658a05ad0cb6a20b$export$f3b7160b60840213;
module.exports["CREATE_CONFLUENCE_PAGE_FOLLOWUP_TEXT"] = $658a05ad0cb6a20b$export$43489e04a87de7d0;
module.exports["CREATE_CONFLUENCE_PAGE_FOLLOWUP_PROMPT"] = $658a05ad0cb6a20b$export$9f870233a176c1a0;
module.exports["shouldAppendCreatePageFollowUp"] = $658a05ad0cb6a20b$export$a5165b6c5017830;
module.exports["appendCreatePageFollowUpIfNeeded"] = $658a05ad0cb6a20b$export$c2722b1ddbddcce5;
module.exports["createSyntheticCreatePageFollowUp"] = $658a05ad0cb6a20b$export$b323db724925d16f;
module.exports["getInvokedFromInteractionSource"] = $658a05ad0cb6a20b$export$9f2ec1867195888b;
module.exports["dedupeTraceMessagesWithLatest"] = $658a05ad0cb6a20b$export$9ac25e0768639c5d;
module.exports["getConversationTraces"] = $658a05ad0cb6a20b$export$8567b8b6b4d41b2f;
module.exports["clearTracesIfNotEmpty"] = $658a05ad0cb6a20b$export$d30a5acf6cceb893;

});

parcelRegister("7yZ5y", function(module, exports) {
/**
 * Generic, dependency-free markdown stream parsing utilities.
 *
 * These utilities handle the extraction and processing of special-tag content
 * from streaming markdown text (e.g., `<lumina>...</lumina>`, `◴...◶`).
 * They operate on plain strings only — no conversation-assistant-specific
 * types or store dependencies.
 */ function $1baacd3a3b5cccce$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const $1baacd3a3b5cccce$export$1edc769cb607aa0f = (text, boundaryStart, boundaryEnd, replacementContent = '')=>{
    const boundaryContents = [];
    if (!text) return {
        processedText: text,
        boundaryContents: boundaryContents
    };
    // An empty boundaryEnd denotes an open-ended component: everything from the
    // start tag to the end of the message is captured (e.g. actionable follow-ups,
    // which have a start marker but no end marker).
    const regex = boundaryEnd === '' ? new RegExp(`${$1baacd3a3b5cccce$var$escapeRegExp(boundaryStart)}([\\s\\S]*)$`, 'g') : new RegExp(`${$1baacd3a3b5cccce$var$escapeRegExp(boundaryStart)}(.*?)${$1baacd3a3b5cccce$var$escapeRegExp(boundaryEnd)}`, 'gs');
    let newText = text;
    let match;
    let found = false;
    while((match = regex.exec(text)) !== null){
        boundaryContents.push(match[1]);
        newText = newText.replace(match[0], replacementContent);
        found = true;
    }
    return {
        processedText: found ? newText : text,
        boundaryContents: boundaryContents
    };
};
const $1baacd3a3b5cccce$export$c6f5269a29d1a6df = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let streamingMarkdownContent = '';
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    if (typeof text === 'string') {
        // An empty endTag denotes an open-ended component (start tag, no end tag):
        // content is captured until the stream ends, so a close tag is never matched
        // mid-stream. `text.includes('')` is always true, hence the explicit guard.
        const hasCloseTag = endTag !== '' && text.includes(endTag);
        if (hasCloseTag && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const [contentBeforeCloseTag, contentAfterCloseTag] = text.split(endTag);
            streamingMarkdownContent = contentBeforeCloseTag;
            processedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const [contentBeforeOpenTag, contentAfterOpenTag] = text.split(startTag);
            processedText = contentBeforeOpenTag + placeholderTag;
            streamingMarkdownContent = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            streamingMarkdownContent = text;
            processedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1baacd3a3b5cccce$export$1fc44797755f1907 = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    return (text)=>{
        let processedText = text;
        let newCurrentLoadingKeys = {
            ...currentLoadingKeys
        };
        let newPreviousKeys = {
            ...previousKeys
        };
        let markdownData = null;
        let processedComponentType = null;
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] || null;
            const previousKey = previousKeys[component.key] || null;
            const result = $1baacd3a3b5cccce$export$c6f5269a29d1a6df(processedText, currentLoadingKey, previousKey, component);
            if (result.markdownData) {
                processedText = result.processedText;
                newCurrentLoadingKeys[component.key] = result.currentLoadingKey;
                newPreviousKeys[component.key] = result.previousKey;
                markdownData = result.markdownData;
                processedComponentType = component.key;
                break; // Only process one component type per call
            }
        }
        currentLoadingKeys = newCurrentLoadingKeys;
        previousKeys = newPreviousKeys;
        return {
            processedText: processedText,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
const $1baacd3a3b5cccce$export$87723f8a010c233f = (text, currentLoadingKey, previousKey, componentConfig)=>{
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    let processedText = text;
    let unprocessedText = '';
    if (typeof text === 'string') {
        // An empty endTag denotes an open-ended component (start tag, no end tag):
        // content is captured until the stream ends, so a close tag is never matched
        // mid-stream. `''.indexOf` returns 0, hence the explicit guard.
        const closeTagIndex = endTag === '' ? -1 : text.indexOf(endTag);
        if (closeTagIndex !== -1 && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const contentBeforeCloseTag = text.substring(0, closeTagIndex);
            const contentAfterCloseTag = text.substring(closeTagIndex + endTag.length);
            processedText = '';
            unprocessedText = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: contentBeforeCloseTag,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (text.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const openTagIndex = text.indexOf(startTag);
            const contentBeforeOpenTag = text.substring(0, openTagIndex);
            const contentAfterOpenTag = text.substring(openTagIndex + startTag.length);
            processedText = contentBeforeOpenTag + placeholderTag;
            unprocessedText = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: '',
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            // Mid-stream branch: no boundary in this chunk; the whole text is
            // streamed content for the active component.
            processedText = '';
            unprocessedText = '';
            markdownData = {
                key: currentLoadingKey,
                content: text,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedText: processedText,
        unprocessedText: unprocessedText,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $1baacd3a3b5cccce$export$e234f678a7b6108d = (getComponents)=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    const processRecursive = (text, markdownData)=>{
        for (const component of getComponents()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] ?? null;
            const prevKey = previousKeys[component.key] ?? null;
            const result = $1baacd3a3b5cccce$export$87723f8a010c233f(text, currentLoadingKey, prevKey, component);
            if (!result.markdownData) continue;
            const { key: key, content: content, loading: loading } = result.markdownData;
            currentLoadingKeys[component.key] = result.currentLoadingKey;
            previousKeys[component.key] = result.previousKey;
            const existing = markdownData[key];
            markdownData[key] = {
                content: (existing?.content ?? '') + content,
                loading: loading
            };
            if (result.unprocessedText) {
                const inner = processRecursive(result.unprocessedText, markdownData);
                return {
                    ...inner,
                    processedText: result.processedText + inner.processedText
                };
            }
            return {
                processedText: result.processedText,
                markdownData: markdownData
            };
        }
        // No component matched — return text unchanged.
        return {
            processedText: text,
            markdownData: markdownData
        };
    };
    return (text)=>{
        return processRecursive(text, {});
    };
};
module.exports["extractMarkdownText"] = $1baacd3a3b5cccce$export$1edc769cb607aa0f;
module.exports["processMarkdownComponent"] = $1baacd3a3b5cccce$export$c6f5269a29d1a6df;
module.exports["createMarkdownProcessor"] = $1baacd3a3b5cccce$export$1fc44797755f1907;
module.exports["createMarkdownProcessorMultiTags"] = $1baacd3a3b5cccce$export$e234f678a7b6108d;

});

parcelRegister("9vgbT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $jEzab = parcelRequire("jEzab");


var $72hrp = parcelRequire("72hrp");

const $842f00fe6a20cb59$export$4124b3cbf6d26820 = ({ useSmartCreationChatStoreApi: useSmartCreationChatStoreApi })=>{
    const { activeConversation: activeConversation } = useSmartCreationChatStoreApi();
    const [chatMessages] = (0, $jEzab.useChatMessages)({
        conversationId: activeConversation?.id
    });
    return (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('aifc_show_connected_apps_auth_login_screen')) return null;
        if (chatMessages.length === 0) return null;
        const lastAssistantMessage = (0, $72hrp.findLastAssistantMessage)(chatMessages);
        if (!lastAssistantMessage) return null;
        return $842f00fe6a20cb59$export$74c2c8fe0412025(lastAssistantMessage?.content?.message?.message?.content ?? '');
    }, [
        chatMessages
    ]);
};
function $842f00fe6a20cb59$export$74c2c8fe0412025(content) {
    if (!content) return null;
    let textContent;
    if (typeof content === 'object') textContent = JSON.stringify(content);
    else textContent = content;
    const regex = /https:\/\/id\.(stg\.internal\.)?atlassian\.com\/outboundAuth\/start[^\s)"]*/g;
    const matches = textContent.match(regex);
    return matches ? matches[0] : null;
}
module.exports["useLastAssistantMessageAuthLink"] = $842f00fe6a20cb59$export$4124b3cbf6d26820;
module.exports["extractOutboundAuthLink"] = $842f00fe6a20cb59$export$74c2c8fe0412025;

});

parcelRegister("gdLsu", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");


var $6qzcc = parcelRequire("6qzcc");

const $6aeae0d70038ede7$export$d6a1a695ea643f8e = (fragmentNodes)=>fragmentNodes.reduce((total, node)=>(0, $1A9t2.reduce)(node, (count, n)=>n.type === 'text' ? count + (0, $6qzcc.wordCount)(n.text) : count, total), 0);
module.exports["countFragmentWords"] = $6aeae0d70038ede7$export$d6a1a695ea643f8e;

});

parcelRegister("cWLC4", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");


var $ij2FZ = parcelRequire("ij2FZ");


var $6qzcc = parcelRequire("6qzcc");

const $b9a66e501bb280c2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            const linkCount = node.marks?.some((mark)=>mark.type === 'link') ? currentValue.linkCount + 1 : currentValue.linkCount;
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + (0, $6qzcc.wordCount)(node.text),
                linkCount: linkCount
            };
        case 'mention':
            return {
                ...currentValue,
                mentionCount: currentValue.mentionCount + 1
            };
        case 'inlineCard':
        case 'embedCard':
            return {
                ...currentValue,
                linkCount: currentValue.linkCount + 1
            };
        case 'inlineExtension':
            if (node.attrs?.extensionKey === (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.parameters?.slug) return {
                ...currentValue,
                explicitSkills: [
                    ...currentValue.explicitSkills,
                    node.attrs.parameters.slug
                ]
            };
            return currentValue;
    }
    return currentValue;
};
const $b9a66e501bb280c2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        adfLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        linkCount: 0,
        mentionCount: 0,
        explicitSkills: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$b9a66e501bb280c2$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $b9a66e501bb280c2$export$a148305df2eb5487;

});

parcelRegister("9lwku", function(module, exports) {
/**
 * Checks whether a top-level adf block has a given localId anywhere in its subtree.
 */ const $97775657d0fc637c$var$containsLocalId = (node, localId)=>{
    if (node.attrs?.localId === localId) return true;
    return (node.content ?? []).some((child)=>$97775657d0fc637c$var$containsLocalId(child, localId));
};
const $97775657d0fc637c$var$EXTENSION_NODE_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension',
    'multiBodiedExtension'
]);
const $97775657d0fc637c$var$getTopLevelNodeAnatomy = (node)=>{
    if (!$97775657d0fc637c$var$EXTENSION_NODE_TYPES.has(node.type)) return node.type;
    const extensionKey = node.attrs?.extensionKey;
    if (typeof extensionKey !== 'string' || !extensionKey) return node.type;
    const extensionType = node.attrs?.extensionType;
    const isMacro = typeof extensionType === 'string' && extensionType.includes('macro');
    return `${isMacro ? 'macro' : 'extension'}:${extensionKey}`;
};
const $97775657d0fc637c$export$1e86d752377e082a = (fullAdf, startLocalId, endLocalId)=>{
    if (!startLocalId || !endLocalId) return [];
    try {
        const topLevelNodes = fullAdf?.content ?? [];
        // A selection anchor can be anywhere in the doc tree, not just at the top level. We need to know which top-level ADF component the selection belongs to.
        let startNodeIndex;
        let endNodeIndex;
        for(let i = 0; i < topLevelNodes.length; i++){
            if (startNodeIndex === undefined && $97775657d0fc637c$var$containsLocalId(topLevelNodes[i], startLocalId)) startNodeIndex = i;
            if (endNodeIndex === undefined && $97775657d0fc637c$var$containsLocalId(topLevelNodes[i], endLocalId)) endNodeIndex = i;
            if (startNodeIndex !== undefined && endNodeIndex !== undefined) break;
        }
        if (startNodeIndex === undefined || endNodeIndex === undefined) return [];
        // The editor gives IDs in selection direction (can be right-to-left), so we use
        // min/max to get everything between the two anchors regardless of order.
        const from = Math.min(startNodeIndex, endNodeIndex);
        const to = Math.max(startNodeIndex, endNodeIndex);
        return [
            ...new Set(topLevelNodes.slice(from, to + 1).map($97775657d0fc637c$var$getTopLevelNodeAnatomy).filter((nodeAnatomy)=>Boolean(nodeAnatomy)))
        ];
    } catch  {
        // swallow the error and return nothing since this is just for analytics.
        return [];
    }
};
module.exports["getTopLevelNodeTypes"] = $97775657d0fc637c$export$1e86d752377e082a;

});

parcelRegister("eSGKy", function(module, exports) {
const $e80864b000993d34$var$HARD_COOLDOWN_MS = 2592000000;
const $e80864b000993d34$var$SOFT_COOLDOWN_MS = 604800000;
const $e80864b000993d34$export$5aaadd2e417f4743 = (data)=>{
    const now = Date.now();
    if (data.lastInteractedAt && now - data.lastInteractedAt < $e80864b000993d34$var$HARD_COOLDOWN_MS) return true;
    if (data.lastShownAt && now - data.lastShownAt < $e80864b000993d34$var$SOFT_COOLDOWN_MS) return true;
    return false;
};
module.exports["isInCooldown"] = $e80864b000993d34$export$5aaadd2e417f4743;

});

parcelRegister("iX75u", function(module, exports) {
// Minimum number of qualifying new conversations (after any cooldown ends)
// before the CSAT survey becomes eligible to show.
const $ea77f4a9ca69d2d8$export$2e112147d8be0194 = 3;
module.exports["MIN_QUALIFYING_CONVERSATIONS"] = $ea77f4a9ca69d2d8$export$2e112147d8be0194;

});

parcelRegister("gFVEK", function(module, exports) {

var $c4TO3 = parcelRequire("c4TO3");


var $5XZGw = parcelRequire("5XZGw");

const $51f6bcd41794eae4$var$DEFAULTS = {
    lastShownAt: 0,
    lastInteractedAt: 0,
    qualifyingConversations: 0
};
const $51f6bcd41794eae4$var$isPlainObject = (value)=>{
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};
const $51f6bcd41794eae4$var$isCsatEligibilityData = (value)=>{
    return $51f6bcd41794eae4$var$isPlainObject(value) && typeof value.lastShownAt === 'number' && typeof value.lastInteractedAt === 'number' && typeof value.qualifyingConversations === 'number';
};
const $51f6bcd41794eae4$export$cb9c82dc91ab7587 = ()=>{
    try {
        const raw = (0, $c4TO3.AtlBrowserStorageLocal).getItem((0, $5XZGw.STORAGE_KEY));
        if (raw) {
            const parsed = JSON.parse(raw);
            if ($51f6bcd41794eae4$var$isCsatEligibilityData(parsed)) return parsed;
        }
    } catch  {
    // Storage unavailable or JSON corrupt — fall through to defaults.
    }
    return $51f6bcd41794eae4$var$DEFAULTS;
};
module.exports["readFromStorage"] = $51f6bcd41794eae4$export$cb9c82dc91ab7587;

});

parcelRegister("eku5V", function(module, exports) {

var $c4TO3 = parcelRequire("c4TO3");


var $5XZGw = parcelRequire("5XZGw");

const $132cf006f53143f4$export$f8d2a9e770514970 = (data)=>{
    try {
        (0, $c4TO3.AtlBrowserStorageLocal).setItem((0, $5XZGw.STORAGE_KEY), JSON.stringify(data));
    } catch  {
    // Best-effort: storage might be denied (no consent) or full.
    }
};
module.exports["writeToStorage"] = $132cf006f53143f4$export$f8d2a9e770514970;

});

parcelRegister("1cjt9", function(module, exports) {
const $5f7f03ab221db6a4$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC',
    actor_type: 'AGENT',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
module.exports["DEFAULT_AGENT"] = $5f7f03ab221db6a4$export$48783720d93c2d26;

});

parcelRegister("eWKku", function(module, exports) {

var $1yaYZ = parcelRequire("1yaYZ");


var $fgOJ7 = parcelRequire("fgOJ7");


var $l30d8 = parcelRequire("l30d8");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");


var $hHa70 = parcelRequire("hHa70");


var $gdg5T = parcelRequire("gdg5T");


var $15h8H = parcelRequire("15h8H");

var $75cf7fb40a3fb800$export$680ab500cb1105eb = /*#__PURE__*/ function(StreamLifecycleState) {
    StreamLifecycleState["SEND_CONTEXT_READY"] = "send-context-ready";
    StreamLifecycleState["COMPLETED"] = "completed";
    StreamLifecycleState["ERRORED"] = "errored";
    StreamLifecycleState["ABORTED"] = "aborted";
    return StreamLifecycleState;
}({});
const $75cf7fb40a3fb800$export$ff6a2981a5436d75 = (status, streamId, content)=>{
    if (!content) return;
    const api = (0, $15h8H.getBrowserBridgeAPI)();
    const id = String(content.id);
    const receiverId = (()=>{
        switch(content.type){
            case 'page':
                return (0, $eL1ct.getConfluenceEditorClientId)(id);
            case 'database':
                return (0, $fgOJ7.getConfluenceDatabaseClientId)(id);
            case 'whiteboard':
                return (0, $6nGJw.getConfluenceWhiteboardClientId)(id);
            case 'slide':
                return (0, $l30d8.getConfluenceSlidesClientId)(id);
            default:
                return undefined;
        }
    })();
    try {
        if (!receiverId) return;
        switch(status){
            case "send-context-ready":
                api.send((0, $gdg5T.RovoSendContextReadyCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case "completed":
                api.send((0, $gdg5T.RovoStreamCompletedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case "errored":
                api.send((0, $gdg5T.RovoStreamErroredCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case "aborted":
                api.send((0, $gdg5T.RovoStreamAbortedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            default:
                (0, $1yaYZ.logException)({
                    exception: new Error(`Unknown stream lifecycle state: ${status}`),
                    name: 'UnknownStreamLifecycleState'
                });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $1yaYZ.logException)({
            exception: error,
            name: 'SendStreamLifecycleCommandError'
        });
    }
};
module.exports["StreamLifecycleState"] = $75cf7fb40a3fb800$export$680ab500cb1105eb;
module.exports["broadcastStreamStatus"] = $75cf7fb40a3fb800$export$ff6a2981a5436d75;

});

parcelRegister("ceMRi", function(module, exports) {
/**
 * Minimum interval threshold in milliseconds.
 * Intervals at or below this threshold are excluded from dead air tracking.
 */ const $c9147b3ca7c52e0c$export$a47f8ff651baafd3 = 20;
const $c9147b3ca7c52e0c$export$1dad78007a379433 = (intervalMs)=>{
    return intervalMs <= $c9147b3ca7c52e0c$export$a47f8ff651baafd3;
};
module.exports["shouldExcludeInterval"] = $c9147b3ca7c52e0c$export$1dad78007a379433;

});

parcelRegister("40OEo", function(module, exports) {
// ─── API status → progress state mapping ──────────────────────────────────────
const $8d688fc2641b04e9$var$API_STATUS_TO_PROGRESS_STATE = {
    DRAFT: 'Draft',
    QUEUED: 'Queued',
    RUNNING: 'Running',
    AWAITING_DISAMBIGUATION: 'AwaitingDisambiguation',
    AWAITING_PLAN_CONFIRMATION: 'AwaitingPlanConfirmation',
    AWAITING_ACTION_CONFIRMATION: 'AwaitingActionConfirmation',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled'
};
const $8d688fc2641b04e9$export$f0ca788f58c1a6a9 = (status)=>$8d688fc2641b04e9$var$API_STATUS_TO_PROGRESS_STATE[status];
const $8d688fc2641b04e9$export$d5ce4d18fe97a26a = (existing, incoming)=>{
    if (!incoming || incoming.length === 0) return existing ?? null;
    if (!existing || existing.length === 0) return incoming;
    const toMs = (iso)=>new Date(iso).getTime();
    const incomingRanges = incoming.map((seg)=>({
            start: toMs(seg.startedAt),
            end: seg.endedAt ? toMs(seg.endedAt) : Date.now()
        }));
    const overlaps = (seg)=>{
        const start = toMs(seg.startedAt);
        const end = seg.endedAt ? toMs(seg.endedAt) : Date.now();
        return incomingRanges.some((r)=>start < r.end && end > r.start);
    };
    const retained = existing.filter((seg)=>!overlaps(seg));
    const merged = [
        ...retained,
        ...incoming
    ];
    return merged.sort((a, b)=>toMs(a.startedAt) - toMs(b.startedAt));
};
module.exports["mapApiTaskStatusToProgressState"] = $8d688fc2641b04e9$export$f0ca788f58c1a6a9;
module.exports["mergeExecutionSegments"] = $8d688fc2641b04e9$export$d5ce4d18fe97a26a;

});

parcelRegister("28y4B", function(module, exports) {
const $1625172e58c31376$export$da415d22ae15cf08 = (subExperiences, additionalAttributes)=>{
    const subExperienceNameSet = new Set(subExperiences);
    const mergedAttributes = {};
    return (events, experience)=>{
        // all subExperiences must succeed for the parent experience to succeed
        // a failure/abort to any subExperience will fail/abort the parent experience
        events.forEach((event)=>{
            if (subExperienceNameSet.has(event.name)) switch(event.action){
                case 'taskSuccess':
                    if (subExperienceNameSet.delete(event.name)) Object.assign(mergedAttributes, event.attributes ?? {});
                    break;
                case 'taskFail':
                    if ('error' in event) experience.fail({
                        error: event.error,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes
                        }
                    });
                    break;
                case 'taskAbort':
                    experience.abort({
                        reason: `${event.name} aborted`,
                        attributes: {
                            ...additionalAttributes,
                            ...event.attributes,
                            childAbortReason: event.reason
                        }
                    });
                    break;
            }
        });
        if (subExperienceNameSet.size === 0) experience.succeed({
            ...additionalAttributes,
            ...mergedAttributes
        });
    };
};
module.exports["collectAllWithSubExperienceAttributes"] = $1625172e58c31376$export$da415d22ae15cf08;

});

parcelRegister("dqGqE", function(module, exports) {
const $a7372b1a5fc906e5$export$51ee55de82fed0a0 = (subExperienceNameToCheck, mainExperienceToFail, events, additionalAttributes)=>{
    const subExperienceFailEvent = events.find((event)=>event.action === 'taskFail' && event.name === subExperienceNameToCheck);
    if (subExperienceFailEvent) mainExperienceToFail.fail({
        error: subExperienceFailEvent.error,
        attributes: {
            ...additionalAttributes,
            ...subExperienceFailEvent.attributes
        }
    });
};
module.exports["failExperienceOnSubExperienceFail"] = $a7372b1a5fc906e5$export$51ee55de82fed0a0;

});

parcelRegister("52Fo2", function(module, exports) {

var $16lEl = parcelRequire("16lEl");

const $fed287a888253e80$export$a9ffe3cc687b4144 = (experienceTracker, reason, attributes)=>{
    [
        (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
        (0, $16lEl.ExperienceName).AIFC_MESSAGE
    ].forEach((experienceName)=>{
        experienceTracker.abort({
            name: experienceName,
            reason: reason,
            attributes: attributes
        });
    });
};
module.exports["abortGenerateContentChildExperiences"] = $fed287a888253e80$export$a9ffe3cc687b4144;

});

parcelRegister("lgNBC", function(module, exports) {

var $3HubT = parcelRequire("3HubT");

class $364de55ccdd705f9$export$f2869f2905168ef1 extends Error {
    constructor(message, params = {}){
        super(message);
        this.errorAttributes = void 0;
        this.message_template = void 0;
        this.name = this.constructor.name;
        this.message_template = 'DEEP_RESEARCH_ERROR';
        this.errorAttributes = {
            errorCode: 'DEEP_RESEARCH_ERROR',
            traceId: params.traceId ?? `DeepResearch-${(0, $3HubT.generateTraceId)()}`,
            requestId: params.requestId
        };
    }
}
module.exports["DeepResearchError"] = $364de55ccdd705f9$export$f2869f2905168ef1;

});

parcelRegister("9TBZq", function(module, exports) {
class $ad3f5d8a8932b656$export$a4ff042cd5c23500 extends Error {
    constructor(params){
        super(params.message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            conversationId: params.conversationId,
            messageId: params.messageId,
            invocationId: params.invocationId,
            actionKey: params.actionKey
        };
        if (params.cause) this.cause = params.cause;
    }
}
module.exports["MessageActionError"] = $ad3f5d8a8932b656$export$a4ff042cd5c23500;

});

parcelRegister("3HubT", function(module, exports) {
const $9341d4be61152104$export$dc6d7ea554bcce10 = ()=>`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
module.exports["generateTraceId"] = $9341d4be61152104$export$dc6d7ea554bcce10;

});

parcelRegister("eu7N9", function(module, exports) {

var $3HubT = parcelRequire("3HubT");

class $e8bea48e81642759$export$7ed16f132715a198 extends Error {
    constructor(message, params){
        const { detail: detail, traceId: traceId } = params;
        super(message);
        this.detail = void 0;
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.detail = detail;
        this.errorAttributes = {
            errorCode: this.detail.message.message_template,
            statusCode: this.detail.message.status_code,
            rawErrorMessage: this.detail.message.content,
            // in case there is no traceId, we generate one in FE
            // and make it distinguishable from BE generated traceId
            // appended by random 5 digit number
            traceId: traceId ?? `StreamError-${(0, $3HubT.generateTraceId)()}`,
            requestId: this.detail.metadata?.request_id,
            latestStreamMessageType: this.detail.type,
            latestStreamMessageMillisOffset: this.detail.millisOffset
        };
    }
}
module.exports["StreamErrorException"] = $e8bea48e81642759$export$7ed16f132715a198;

});

parcelRegister("5yETg", function(module, exports) {

var $3HubT = parcelRequire("3HubT");

class $4e121057dee046d4$export$7a01d8a5a5a1ae0a extends Error {
    constructor(message, params, cause){
        super(message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.cause = cause;
        this.errorAttributes = {
            traceId: params.traceId ?? `StreamGenerator-${(0, $3HubT.generateTraceId)()}`,
            latestStreamMessageType: params.detail?.type,
            latestStreamMessageMillisOffset: params.detail?.millisOffset
        };
    }
}
module.exports["StreamGeneratorError"] = $4e121057dee046d4$export$7a01d8a5a5a1ae0a;

});

parcelRegister("6qzcc", function(module, exports) {

var $2DSGu = parcelRequire("2DSGu");

const $654714b3b83ef386$export$24d5ff955141c347 = (text)=>{
    if (!text) return 0;
    // We use Intl here since it is locale-aware and accurately handles word counts across all languages. The regex will undercount non-English languages.
    if (0, $2DSGu.segmenter) return [
        ...(0, $2DSGu.segmenter).segment(text)
    ].filter((s)=>s.isWordLike).length;
    return text.match(/\S+/g)?.length ?? 0;
};
module.exports["wordCount"] = $654714b3b83ef386$export$24d5ff955141c347;

});

parcelRegister("5XZGw", function(module, exports) {
// localStorage key for the Rovo Chat CSAT survey eligibility record. Kept
// private to this directory (not the flat common/utils/STORAGE_KEY) to avoid a
// name collision with the auto-conversation storage key.
const $1ac83a76a8a68d4b$export$86880b4b2e1a2384 = 'rovoChatCsatEligibility';
module.exports["STORAGE_KEY"] = $1ac83a76a8a68d4b$export$86880b4b2e1a2384;

});

parcelRegister("2DSGu", function(module, exports) {

var $2T0rT = parcelRequire("2T0rT");

const $644405c723f8495f$export$2057cd6e00c107b4 = (0, $2T0rT.createSegmenter)();
module.exports["segmenter"] = $644405c723f8495f$export$2057cd6e00c107b4;

});

parcelRegister("2T0rT", function(module, exports) {
const $75513e3ff770ca34$export$aa9d968a842359fd = ()=>{
    try {
        return Intl?.Segmenter ? new Intl.Segmenter(undefined, {
            granularity: 'word'
        }) : null;
    } catch  {
        return null;
    }
};
module.exports["createSegmenter"] = $75513e3ff770ca34$export$aa9d968a842359fd;

});


//# sourceMappingURL=SessionRightPanel.eea41f54.js.map
